var _defs, _path, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _path2, _path3, _g12, _g13, _path4, _path5, _g14, _path6, _path7, _g15, _path8, _path9, _g16, _path0, _path1, _g17, _path10, _path11, _path12, _path13, _g18, _g19, _g20, _path14, _path15, _g21, _path16, _path17, _path18, _path19, _g22, _path20, _path21, _path22, _path23, _path24, _path25, _g23, _path26, _path27, _g24, _path28, _path29, _path30, _path31, _g25, _g26, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _g27, _path44, _path45, _g28, _path46, _path47, _path48, _path49, _g29, _g30, _g31, _path50, _path51, _g32, _g33, _g34, _g35, _g36, _g37, _g38, _g39, _g40, _g41, _g42, _g43, _g44, _g45, _g46, _g47, _g48, _g49, _g50, _g51, _g52, _g53, _g54, _g55, _g56, _g57, _g58, _g59, _g60, _g61, _g62, _g63, _g64, _g65, _g66, _g67, _g68, _g69, _g70, _g71, _g72, _g73, _g74, _g75, _g76, _g77, _g78, _g79, _g80, _g81, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _g82, _g83, _g84, _g85, _g86, _g87, _g88, _g89, _g90, _g91, _g92, _g93, _g94, _g95, _g96, _g97, _g98, _g99, _path63, _g100, _g101, _path64, _g102, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _g103, _g104, _g105, _g106, _g107, _g108, _g109, _g110, _g111, _g112, _g113, _g114, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _g115, _g116, _g117, _g118, _g119, _g120, _g121, _g122, _g123, _g124, _g125, _g126, _g127, _g128, _g129, _g130, _g131, _g132, _g133, _g134, _g135, _g136, _g137, _g138, _g139, _g140, _g141, _g142, _g143, _path95, _path96, _path97, _path98, _g144, _g145, _g146, _g147, _g148, _g149, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _g150, _g151, _g152, _g153;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg500503(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 451,
    height: 240,
    viewBox: "0 0 451 240",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11212",
    "data-name": "Rectangle 11212",
    width: 433.531,
    height: 229.53,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11058",
    "data-name": "Rectangle 11058",
    width: 199.291,
    height: 136.002,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11059",
    "data-name": "Rectangle 11059",
    width: 266.62,
    height: 147.509,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11060",
    "data-name": "Rectangle 11060",
    width: 18.612,
    height: 7.388,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11061",
    "data-name": "Rectangle 11061",
    width: 9.237,
    height: 3.817,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11062",
    "data-name": "Rectangle 11062",
    width: 18.452,
    height: 7.381,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11063",
    "data-name": "Rectangle 11063",
    width: 17.087,
    height: 6.998,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11064",
    "data-name": "Rectangle 11064",
    width: 8.309,
    height: 4.531,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11065",
    "data-name": "Rectangle 11065",
    width: 11.33,
    height: 3.233,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11066",
    "data-name": "Rectangle 11066",
    width: 11.058,
    height: 4.152,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11067",
    "data-name": "Rectangle 11067",
    width: 17.533,
    height: 6.002,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11068",
    "data-name": "Rectangle 11068",
    width: 17.532,
    height: 6.002,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-14"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11069",
    "data-name": "Rectangle 11069",
    width: 9.709,
    height: 4.386,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-15"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11070",
    "data-name": "Rectangle 11070",
    width: 289.311,
    height: 78.199,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-16"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11071",
    "data-name": "Rectangle 11071",
    width: 17.117,
    height: 5.626,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-17"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11072",
    "data-name": "Rectangle 11072",
    width: 22.282,
    height: 6.121,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-18"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11073",
    "data-name": "Rectangle 11073",
    width: 32.624,
    height: 6.984,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-19"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11074",
    "data-name": "Rectangle 11074",
    width: 21.507,
    height: 6.744,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-20"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11075",
    "data-name": "Rectangle 11075",
    width: 12.516,
    height: 3.948,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-21"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11076",
    "data-name": "Rectangle 11076",
    width: 18.611,
    height: 6.157,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-22"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11077",
    "data-name": "Rectangle 11077",
    width: 18.446,
    height: 6.368,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-23"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11078",
    "data-name": "Rectangle 11078",
    width: 7.35,
    height: 2.08,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-24"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11079",
    "data-name": "Rectangle 11079",
    width: 7.351,
    height: 2.08,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-25"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11080",
    "data-name": "Rectangle 11080",
    width: 16.965,
    height: 5.767,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-26"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11081",
    "data-name": "Rectangle 11081",
    width: 11.286,
    height: 3.025,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-27"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11082",
    "data-name": "Rectangle 11082",
    width: 10.953,
    height: 3.871,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-28"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11083",
    "data-name": "Rectangle 11083",
    width: 17.458,
    height: 5.626,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-29"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11084",
    "data-name": "Rectangle 11084",
    width: 9.396,
    height: 4.059,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-30"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11085",
    "data-name": "Rectangle 11085",
    width: 7.413,
    height: 1.904,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-31"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11086",
    "data-name": "Rectangle 11086",
    width: 29.453,
    height: 6.782,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-32"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11087",
    "data-name": "Rectangle 11087",
    width: 9.984,
    height: 12.186,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-33"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11088",
    "data-name": "Rectangle 11088",
    width: 234.196,
    height: 59.293,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-34"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11089",
    "data-name": "Rectangle 11089",
    width: 186.934,
    height: 20.135,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-35"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11090",
    "data-name": "Rectangle 11090",
    width: 29.848,
    height: 9.217,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-36"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11091",
    "data-name": "Rectangle 11091",
    width: 7.847,
    height: 3.972,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-37"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11092",
    "data-name": "Rectangle 11092",
    width: 4.887,
    height: 8.276,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-38"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11093",
    "data-name": "Rectangle 11093",
    width: 3.759,
    height: 6.719,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-39"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11094",
    "data-name": "Rectangle 11094",
    width: 5.616,
    height: 4.085,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-40"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31771",
    "data-name": "Path 31771",
    d: "M182.7,61.43a22.79,22.79,0,0,0-4.568,1.255c-1.408.439-2.814.875-4.258,1.236a44.065,44.065,0,0,1-5.151.782,54.433,54.433,0,0,0-9.036,2.326c-1.336.414-2.689.784-4.042,1.162A2.673,2.673,0,0,0,153.86,69.3a3.915,3.915,0,0,0-.19,2.678c.145.632.484,1.221.647,1.848a11.164,11.164,0,0,1,.293,2.371,44.36,44.36,0,0,1-.739,7.814,14.384,14.384,0,0,0-.122,1.894c0,.559.13.614.712.972a24.949,24.949,0,0,0,4.072,1.855c3.082,1.178,6.244,2.228,9.338,3.384,4.074,1.525,7.992,3.226,11.96,4.912.825.349,1.66.715,2.5,1.066a4.163,4.163,0,0,1,1.747-.575s-.006-.006-.012-.006c.019-.007.038-.018.057-.024.349-.147.68-.306,1.028-.448a.243.243,0,0,1,.11-.042c.086-.035.171-.068.258-.1a.378.378,0,0,0,.116-.067c.017.1.03.2.038.3a.239.239,0,0,1,.253.038,5.951,5.951,0,0,1,.913,1.281c.171.2.348.411.535.619a.7.7,0,0,0,.238-.02c.143.134.292.268.452.391,1.139.89,3.052.992,4.553,1.127a71.806,71.806,0,0,0,7.6.139c1.359-.022,2.715-.044,4.067-.027q6.3.082,12.585.372a36.06,36.06,0,0,0,6,.062,17.656,17.656,0,0,1,3.35-1.453.256.256,0,0,1,.263.09c.053.1.106.194.151.29a1.808,1.808,0,0,1,.494.2c.243.057.489.116.742.167a20.8,20.8,0,0,0,3.582.394c3.036.084,6.073.135,9.109.212,5.967.148,11.937.33,17.907.4q4.254.054,8.508-.035c3.047-.061,6.156-.356,9.2-.19a10.8,10.8,0,0,0,3.3-.177c.551-.141,1.071-.427,1.588-.615v.017a1.193,1.193,0,0,1,.647-.135c0-.017,0-.032,0-.048a1.83,1.83,0,0,1,.523,0,6.676,6.676,0,0,1,2.708,1.2c.311,0,.625-.023.868-.013.024,0,.049,0,.072,0,.482-.051.963-.09,1.451-.127,1.137-.093,2.271-.237,3.412-.27a.336.336,0,0,1,.062-.012c.124-.007.233-.011.337-.01.437-.024.9-.067,1.339-.053,2.587-.268,5.175-.521,7.771-.74q5.3-.45,10.622-.684a27.917,27.917,0,0,1,4.795.1c.73.1,1.464.148,2.188.257a4.9,4.9,0,0,0,1.554.115l.051-.011a10.152,10.152,0,0,0,1.116-1.021,1.142,1.142,0,0,1,.535-.434,4.294,4.294,0,0,1,1.525.067c.326.033.65.059.975.067a3.63,3.63,0,0,0,1.148-.584,23.06,23.06,0,0,1,3.09-2.145c1.33-.7,2.72-1.31,4.017-2.053,2.816-1.621,5.6-3.272,8.526-4.768,1.278-.654,2.682-1.157,3.955-1.824a1.216,1.216,0,0,0,.709-1.66c-.207-.479-.514-.918-.706-1.4a6.316,6.316,0,0,1-.366-2.215,16.8,16.8,0,0,1,.63-4.155c.049-.209.093-.416.14-.625.141-1.489.09-2.987.24-4.477.088-.869.337-1.709.443-2.571.06-.482.1-.966.137-1.45a6.612,6.612,0,0,0-2.862-1.159c-4.011-.9-8.165-1.441-12.211-2.24a73.071,73.071,0,0,1-9.134-2.492.416.416,0,0,0-.062-.059c-.137-.03-.274-.061-.41-.088-.093.007-.185.013-.276.017l.01.006c-1.4.139-2.828.106-4.237.208-1.785.13-3.549.343-5.331.489-3.607.3-7.243.347-10.836.748s-7.139,1.045-10.707,1.566c-1.64.238-3.265.435-4.88.762l-.6.121c0-.039,0-.078,0-.117-.092.029-.183.053-.276.076,0,.032,0,.065,0,.1l-.547.106a.294.294,0,0,1,.012-.065c-.122.024-.244.044-.369.057-.007.026-.012.051-.017.079-.27.049-.541.1-.813.142-.03.006-.609.065-1.131.109.033-.161-.053-.314-.335-.36a36.883,36.883,0,0,0-6.617-.218c-1.184.031-2.364.062-3.517.033-3.73-.09-7.454-.319-11.177-.51-3.634-.189-7.255-.219-10.894-.251-1.862-.016-3.711-.151-5.572-.2a30.16,30.16,0,0,1-4.742-.293.148.148,0,0,0-.068.007,9.781,9.781,0,0,0-1.31.01c-.264.014-.506.029-.693.027-1.4-.006-2.792,0-4.19-.019-2.743-.032-5.477-.075-8.213-.272-2.785-.2-5.49-.648-8.233-1.048a75.029,75.029,0,0,0-7.794-.621,21.728,21.728,0,0,0-3.633-.241,30.464,30.464,0,0,1-3.755.3,68.793,68.793,0,0,1-8.19-.375,36.876,36.876,0,0,1-4.428-.76,10.749,10.749,0,0,0-2.707-.7,8.229,8.229,0,0,0-1.685-.209c-.145,0-.29.006-.44.019",
    transform: "translate(-153.524 -61.411)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 0.459,
    cy: -1.06,
    r: 3.094,
    gradientTransform: "matrix(0.231, 0.02, 0.004, -0.788, -0.738, 6.353)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#08080b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.015,
    stopColor: "#08080b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.598,
    stopColor: "#414243"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1d201b"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-41"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31773",
    "data-name": "Path 31773",
    d: "M296.024,63.445h-.011a5.945,5.945,0,0,1-1.622.1c-.921-.022-1.821.065-2.738.125-1.921.131-3.826.351-5.747.47-2.008.123-4.024.213-6.035.336,1.493.71,2.89,1.617,4.247,2.427,1.989,1.183,4.131,2.143,6.173,3.258a52.467,52.467,0,0,1,5.568,3.505c.843.614,1.858,1.084,2.667,1.722.337.264.583.563.874.8a5.253,5.253,0,0,1,.582.35,2.02,2.02,0,0,0,.612.134.213.213,0,0,1,.123.043,13.233,13.233,0,0,0,3.337-1.27c1.592-.754,3.2-1.488,4.8-2.224,1.9-.872,3.849-1.609,5.868-2.3a29.9,29.9,0,0,0,5.163-2.1,11.373,11.373,0,0,0-3.351-1.064c-1.891-.341-3.769-.716-5.65-1.091-2.507-.5-5-1.03-7.432-1.734-.392-.112-2.1-.564-3.837-1.121l-.02.008a4.834,4.834,0,0,1-2.568-.408,2.846,2.846,0,0,1-.747-.029.825.825,0,0,1-.257.053",
    transform: "translate(-279.871 -63.392)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: -2.673,
    cy: -0.532,
    r: 8.607,
    gradientTransform: "matrix(0.353, 0.02, 0.005, -0.788, -5.395, 19.444)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5c5d60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.446,
    stopColor: "#5c5d60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.733,
    stopColor: "#525453"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#474a43"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-42"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31775",
    "data-name": "Path 31775",
    d: "M278.2,64.725c-3.851.452-7.661,1.085-11.524,1.456-1.262.123-2.513.355-3.769.528-.044,2.273-.149,4.546-.4,6.812-.183,1.637-.57,3.261-.743,4.9a.16.16,0,0,1,.072,0,5.08,5.08,0,0,0,1.2.093,7.137,7.137,0,0,1,.92.038,16.73,16.73,0,0,0,2.78.093q2.461-.077,4.917-.149c3.166-.094,6.295-.447,9.417-.841a52.616,52.616,0,0,1,9.806.118,35.747,35.747,0,0,0,5.324.218,12.842,12.842,0,0,1,2.1.185,7.409,7.409,0,0,0,2.372-.218.258.258,0,0,1,.247.043c-.008-.011-.013-.022-.021-.032-.571-.731-1.935-1.213-2.787-1.733s-1.66-1.064-2.465-1.619c-1.745-1.208-3.488-2.394-5.146-3.676-1.617-1.254-3.036-2.677-4.706-3.882-.743-.535-1.511-1.056-2.226-1.619-.462-.361-.913-.736-1.411-1.064-1.322.092-2.64.2-3.952.357",
    transform: "translate(-261.76 -64.368)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-3",
    cx: -2.183,
    cy: -0.576,
    r: 8.071,
    gradientTransform: "matrix(0.384, 0.02, 0.006, -0.788, -4.907, 18.097)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-43"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31777",
    "data-name": "Path 31777",
    d: "M226.469,65.49c.29.172.059.063-.188.057-.307-.011-.614-.014-.921-.017-.679-.006-1.36-.007-2.04-.007-.29,0-.575,0-.865,0-.667,1.031-1.684,1.917-2.463,2.9-1.092,1.37-2.117,2.773-3.159,4.166a36.666,36.666,0,0,1-3.088,3.743c-.484.492-1.171.948-1.649,1.468a6.955,6.955,0,0,1,3.355-.047,41.22,41.22,0,0,0,5.5.216c.556,0,1.11-.006,1.666,0,2.641.016,5.282.054,7.922-.039a54.634,54.634,0,0,1,7.557.513,148.649,148.649,0,0,0,16.337.215c2.469-.025,4.876-.452,7.337-.472,2.174-.018,4.317.2,6.485.2a19.117,19.117,0,0,1,.667-2.572c.4-1.548.962-3.062,1.409-4.6.433-1.486.66-2.987.956-4.486-.114.011-.228.023-.343.031a10.456,10.456,0,0,1-1.856.057l-.023.008.017-.011h0l-.016.01h0l-.016,0a.566.566,0,0,1-.276.053,8.55,8.55,0,0,1-1.521-.084c-1.016-.048-2.03-.048-3.046-.029-1.715.029-3.425.039-5.14-.006-3.872-.1-7.737-.33-11.6-.531s-7.73-.155-11.588-.362c-1.715-.091-3.417-.267-5.129-.384a21.708,21.708,0,0,1-3.272-.4.715.715,0,0,1-1,.41",
    transform: "translate(-212.096 -65.08)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-4",
    cx: -0.458,
    cy: -0.612,
    r: 8.03,
    gradientTransform: "matrix(0.257, 0.02, 0.004, -0.788, -3.19, 17.863)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-44"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31779",
    "data-name": "Path 31779",
    d: "M198.291,64.874c-1.312.776-2.5,1.6-3.751,2.427-1,.654-2.131,1.132-3.186,1.715a37.535,37.535,0,0,0-3.388,2.161c-1.077.751-2.278,1.378-3.353,2.128-.908.638-1.742,1.335-2.639,1.983a8.3,8.3,0,0,1-1.156.7c1.243.117,2.373.588,3.644.624.917.026,1.837.012,2.755,0,.626-.01,1.254-.019,1.88-.017,3.043.013,6.039.255,9.066.431,3.194.185,6.4.7,9.615.565a16.93,16.93,0,0,1,3.843.069c.847.161,2.1.737,2.952.4a.342.342,0,0,1,.276,0,6.452,6.452,0,0,1,.877-.86c.637-.568.89-1.454,1.448-2.09.52-.6,1.076-1.168,1.662-1.725,2.624-2.487,5.409-4.948,7.769-7.6q-1.172-.011-2.344-.024c-2.544-.032-5.091-.122-7.62-.359-2.634-.245-5.2-.724-7.809-1.061-1.353-.176-2.71-.325-4.076-.4-1.219-.069-2.465-.02-3.668-.194-.25-.035-.513-.082-.78-.123a9.146,9.146,0,0,1-2.017,1.25",
    transform: "translate(-180.818 -63.624)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-5",
    cx: 0.216,
    cy: -0.492,
    r: 7.747,
    gradientTransform: "matrix(0.343, 0.02, 0.005, -0.788, -3.111, 17.423)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-45"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31781",
    "data-name": "Path 31781",
    d: "M180.551,62.188c-1.464.46-2.9.964-4.351,1.445a42.368,42.368,0,0,1-4.257,1.229c-1.507.33-3.056.466-4.571.766-3.165.623-6.148,1.646-9.19,2.55-.429.129-.86.252-1.293.375.513.036,1.024.088,1.536.151a16.8,16.8,0,0,1,3.3.562c1.056.353,2.005.847,3.014,1.273a30.561,30.561,0,0,0,3.6,1.151c2.647.745,5.319,1.429,7.971,2.16a52.881,52.881,0,0,1,6.2,1.918c.19-.141.385-.277.583-.4.066-.054.137-.109.215-.161a2.456,2.456,0,0,1,.533-.251,6.285,6.285,0,0,1,.782-.306,30.621,30.621,0,0,0,2.818-1.909c1.71-1.151,3.561-2.146,5.321-3.243a109.06,109.06,0,0,1,10.822-5.58h-.013c-.621.074-1.243.147-1.867.194-1.171.085-2.333.057-3.5.041a43.413,43.413,0,0,1-7.545-.618,31.372,31.372,0,0,1-3.259-.768,12.291,12.291,0,0,1-1.821-.609l-.237-.123c-.7-.081-1.395-.232-2.1-.274-.109-.006-.214-.008-.319-.008a7.681,7.681,0,0,0-2.369.44",
    transform: "translate(-156.888 -61.748)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-6",
    cx: 0.817,
    cy: -0.367,
    r: 8.124,
    gradientTransform: "matrix(0.321, 0.02, 0.005, -0.788, -2.743, 18.517)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-46"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31783",
    "data-name": "Path 31783",
    d: "M156.215,67.722a4.916,4.916,0,0,0-1.282.424,1.632,1.632,0,0,0-.486,1.184,4.747,4.747,0,0,0,.347,2.088,15.694,15.694,0,0,1,.381,7.537c-.2,1.359-.507,2.713-.6,4.084-.039.6-.294,1.517.418,1.886.639.333,1.294.643,1.974.915,2.983,1.2,6.119,2.162,9.158,3.269,3.136,1.146,6.285,2.291,9.318,3.6,2.359,1.015,4.789,1.967,7.136,3a13.574,13.574,0,0,1-.265-1.5,41.975,41.975,0,0,1-.417-6.569,41.062,41.062,0,0,1,.252-7.371,21.437,21.437,0,0,0,.4-3.184,5.03,5.03,0,0,0-.167-1.784q-.3-.081-.6-.153c-4.825-1.172-9.634-2.583-14.28-4.149a22.055,22.055,0,0,1-3.014-1.184,20.271,20.271,0,0,0-2.627-1.256,19.171,19.171,0,0,0-3.505-.7c-.608-.086-1.218-.17-1.832-.221l-.316.086",
    transform: "translate(-154.432 -67.636)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-7",
    cx: 1.427,
    cy: -0.446,
    r: 4.281,
    gradientTransform: "matrix(0.978, 0.02, 0.015, -0.788, -0.216, 9.388)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#999b9e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.206,
    stopColor: "#8d8f91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.588,
    stopColor: "#6e706e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#474a43"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-48"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11096",
    "data-name": "Rectangle 11096",
    width: 28.081,
    height: 19.896,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-49"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31785",
    "data-name": "Path 31785",
    d: "M181.889,86.306a41.172,41.172,0,0,1,.251-7.371,21.283,21.283,0,0,0,.4-3.184,7,7,0,0,0-.044-1.273c-1.048,1.068-.21,2.849-1.139,4a2.714,2.714,0,0,1-.978.749c-.313.145-.745.246-.914.523-.51.838-.229,1.653-.448,2.512-.36,1.4-2.8,2.5-4.458,2.7a2.82,2.82,0,0,1-2.293-.678,2.445,2.445,0,0,1-.394-2.209c.142-1.162-.549-1.705-1.778-2.137a21.821,21.821,0,0,0-2.871-.844c-1.5-.3-1.922.656-2.357,1.578a3.557,3.557,0,0,1-1.457,1.616c-.74.436-1.316.174-2.162.208a10.411,10.411,0,0,1-3.249-.12,5.727,5.727,0,0,1-2.548-1.9c-.216-.228-.433-.458-.655-.679-.1.63-.19,1.261-.232,1.9-.039.6-.294,1.517.419,1.886.638.332,1.293.643,1.973.915,2.983,1.2,6.119,2.161,9.159,3.27,3.135,1.145,6.284,2.29,9.317,3.6,2.359,1.015,4.789,1.967,7.136,3a13.574,13.574,0,0,1-.265-1.5,41.831,41.831,0,0,1-.417-6.569",
    transform: "translate(-154.49 -74.478)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-8",
    cx: 1.438,
    cy: -1.02,
    r: 5.981,
    gradientTransform: "matrix(0.708, 0.02, 0.011, -0.788, -1.925, 12.359)",
    xlinkHref: "#radial-gradient-7"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-50"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11097",
    "data-name": "Rectangle 11097",
    width: 18.998,
    height: 31.284,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-51"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31787",
    "data-name": "Path 31787",
    d: "M180.748,95.713a3.484,3.484,0,0,0-1.128.384c-.292.1-.617.16-.925.239-.118-.4-.221-.874-.251-.981a12.432,12.432,0,0,1-.308-1.825,66.352,66.352,0,0,1-.35-7.748c0-1.165-.016-2.327.039-3.491.054-1.14.325-2.26.477-3.4a9.617,9.617,0,0,0,.114-1.876,1.1,1.1,0,0,0,.082-.152c.123-.284-.117-.878.2-1.086a18.842,18.842,0,0,0,1.561-1.226,4.1,4.1,0,0,0,.525-.189,13.743,13.743,0,0,0,2.42-1.549c1.75-1.327,3.851-2.373,5.76-3.548,1.833-1.126,3.667-2.182,5.636-3.162.718-.357,1.45-.705,2.181-1.054-1.22.754-2.307,1.617-3.61,2.295-1.1.575-2.192,1.113-3.22,1.776-1.151.743-2.231,1.548-3.4,2.279-.942.589-1.873,1.192-2.748,1.844a12.7,12.7,0,0,1-2.957,2,.856.856,0,0,0-.574.746c-.01-.007-.02-.011-.03-.017a3.217,3.217,0,0,1,.129,1.184c.031.822-.047,1.655-.068,2.476-.02.758-.05,1.515-.081,2.273-.159,1.241-.283,2.479-.372,3.739a37.22,37.22,0,0,0-.119,5.689,15.678,15.678,0,0,0,.623,2.866c.135.484.331,1,.462,1.518a.656.656,0,0,0-.073-.007",
    transform: "translate(-177.784 -65.052)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-9",
    cx: 0.691,
    cy: -0.31,
    r: 3.878,
    gradientTransform: "matrix(1.568, 0.02, 0.024, -0.788, 5.827, 8.767)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-52"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31789",
    "data-name": "Path 31789",
    d: "M180.688,74.511a.127.127,0,0,1,.016.023.037.037,0,0,1-.006.05c.021.174.051.351.068.484a.255.255,0,0,1,.033.047c.356.613.063,1.451-.01,2.085-.019.16-.039.319-.063.478-.011.253-.022.5-.03.756-.082,2.293-.307,4.6-.223,6.9.08,2.234.529,4.442.637,6.671a4.387,4.387,0,0,0,.637,2.222,3.8,3.8,0,0,0,.74,1.316,1.838,1.838,0,0,0,1.174,1.127.323.323,0,0,0,.1.007c.085.038.17.076.257.109a17.76,17.76,0,0,0,5.172.624c2.026.054,4.057.023,6.087-.01,1.682-.024,3.365-.05,5.048-.029,3.676.047,7.345.169,11.018.294a31.814,31.814,0,0,0,6.67-.024,20.563,20.563,0,0,1-.854-3.788c-.439-1.827-.507-3.712-.823-5.555-.307-1.791-.563-3.6-.912-5.383a17.15,17.15,0,0,1-.339-2.209c-.053-.776.183-1.549.12-2.321-.049-.612-.66-1.18-.558-1.8a4.5,4.5,0,0,1-2.082-.106,15.609,15.609,0,0,0-4.373-.165,69.927,69.927,0,0,1-9.493-.449c-3.371-.292-6.71-.583-10.1-.713-1.513-.061-3.1.01-4.6-.185-1.154-.152-2.175-.619-3.325-.758a2.847,2.847,0,0,0,.017.3",
    transform: "translate(-180.455 -74.211)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-10",
    cx: -0.331,
    cy: 0.058,
    r: 2.527,
    gradientTransform: "matrix(0.642, 0.02, 0.01, -0.788, -2.057, 10.322)",
    xlinkHref: "#radial-gradient-7"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-54"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11099",
    "data-name": "Rectangle 11099",
    width: 37.552,
    height: 21.402,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-55"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31791",
    "data-name": "Path 31791",
    d: "M217.153,93.489c-.439-1.827-.507-3.712-.823-5.556-.287-1.674-.532-3.362-.849-5.035a1.268,1.268,0,0,1-1.435-.05c-.526-.433-2.816-2.365-3.612-1.7-1.438,1.206.229,2.409.319,3.731.007.1-.117.185-.239.183-1.017-.011-3.249-.029-3.208,1.187a2.025,2.025,0,0,1-.146,1.217,3.864,3.864,0,0,1-2.25,1.858,9.925,9.925,0,0,1-2.979.258,12.846,12.846,0,0,0-3.575.084,2.689,2.689,0,0,0-1.787,1.318,1.6,1.6,0,0,1-.528.655,1.744,1.744,0,0,1-1.506.14c-.722-.127-1.482-.215-2.189-.378-.313-.072-1.024-.28-1.191-.549a3.809,3.809,0,0,1-.49-1.873c0-.85.108-1.684-1.358-1.557-1.821.154-3.9,1.7-5.788,1.129a2.466,2.466,0,0,1-1.693-1.507c-.25-.684.337-1.448.685-2.042a1.85,1.85,0,0,0,.118-2.146c-.3-.461-.65-.892-.966-1.343a3.2,3.2,0,0,1-.734-2.068c.059-1.062.439-2.382-.013-3.369-.044.265-.1.528-.127.761-.019.16-.039.319-.063.478-.011.253-.022.5-.03.755-.084,2.293-.307,4.6-.223,6.9.081,2.234.531,4.443.636,6.671a4.381,4.381,0,0,0,.639,2.22,3.751,3.751,0,0,0,.739,1.317,1.839,1.839,0,0,0,1.172,1.127.329.329,0,0,0,.1.007c.086.038.171.076.258.109a17.724,17.724,0,0,0,5.172.623c3.707.1,7.423-.086,11.135-.037,3.676.047,7.345.169,11.018.294a31.814,31.814,0,0,0,6.67-.024,20.66,20.66,0,0,1-.854-3.788",
    transform: "translate(-180.455 -76.075)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-11",
    cx: -0.333,
    cy: -0.035,
    r: 2.778,
    gradientTransform: "matrix(0.585, 0.02, 0.009, -0.788, -2.377, 11.156)",
    xlinkHref: "#radial-gradient-7"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-56"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11100",
    "data-name": "Rectangle 11100",
    width: 13.132,
    height: 33.814,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-57"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31793",
    "data-name": "Path 31793",
    d: "M214.736,98.505c-.115.068-.234.129-.355.189a1.9,1.9,0,0,1-1.186.555.211.211,0,0,1-.161-.054l-.023.006c-.008-.02-.013-.039-.022-.061a.173.173,0,0,1-.024-.068,34.372,34.372,0,0,1-.851-3.69c-.441-1.705-.482-3.487-.786-5.213-.282-1.588-.653-3.168-.931-4.76-.143-.822-.33-1.636-.455-2.462a9.591,9.591,0,0,1,.117-2.621,2.1,2.1,0,0,0-.362-1.35c-.636-1.082.63-1.5,1.135-2.317a15.683,15.683,0,0,1,1.34-1.995,28.819,28.819,0,0,1,2.091-2.115,68.6,68.6,0,0,0,6.953-7.112c.478.006.958.01,1.438.012-.761,1.073-1.907,2-2.75,3.026-1.2,1.454-2.3,2.952-3.449,4.43a23.925,23.925,0,0,1-3.785,4.09,2.776,2.776,0,0,0-1.138,3.294,27.078,27.078,0,0,1,.7,4.764,48.877,48.877,0,0,0,.932,5.243c.341,1.716.636,3.443,1.024,5.154.17.74.376,1.462.476,2.21.041.31.05.58.085.841l-.014.006",
    transform: "translate(-209.523 -65.436)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-12",
    cx: -1.57,
    cy: -0.304,
    r: 3.605,
    gradientTransform: "matrix(2.288, 0.02, 0.035, -0.788, 21.357, 8.26)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-58"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31795",
    "data-name": "Path 31795",
    d: "M211.994,75.968c-.031.042-.063.08-.091.123-.583.89-.088,1.68.024,2.591.2,1.63.288,3.258.448,4.888a21.76,21.76,0,0,0,1.164,4.864c.531,1.563.933,3.129,1.373,4.707a13.653,13.653,0,0,1,.5,2.2c.055.488.047,1.037.139,1.534.167.019.341.043.521.071a28,28,0,0,0,4.227.325c3.044.013,6.088.056,9.134.114,6.064.109,12.131.261,18.2.274q4.693.005,9.386-.11c2.885-.075,5.746-.253,8.631-.143a6.516,6.516,0,0,0,2.524-.231c.476-.18.926-.409,1.413-.568.029-.007.056-.018.085-.025-.075-1.208-.184-2.416-.2-3.63q-.036-2.58-.115-5.162c-.109-3.4,0-6.834-.923-10.176a3.012,3.012,0,0,1-.109-.811,22.613,22.613,0,0,1-3.848-.019c-.882-.055-1.766-.11-2.657-.094-2.33.038-4.6.427-6.933.428-5.068.008-10.15.111-15.211-.172-2.758-.153-5.453-.8-8.233-.694-2.5.092-5,.074-7.508.036-2.339-.035-4.711.013-7.039-.213a32.577,32.577,0,0,0-3.424-.449,2.663,2.663,0,0,0-1.475.343",
    transform: "translate(-211.625 -75.625)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-13",
    cx: 0.326,
    cy: -0.97,
    r: 2.625,
    gradientTransform: "matrix(0.396, 0.02, 0.006, -0.788, -2.608, 10.743)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5c5d60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.076,
    stopColor: "#5c5d60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.446,
    stopColor: "#6a6a6e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.654,
    stopColor: "#5f6061"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#474a43"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-60"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11102",
    "data-name": "Rectangle 11102",
    width: 3.339,
    height: 31.854,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-61"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31797",
    "data-name": "Path 31797",
    d: "M261.766,97.2c.006.274-.012.611-.006.957a4.123,4.123,0,0,0-.774.063c-.048-1.061-.173-2.132-.188-3.187-.023-1.613-.042-3.224-.082-4.839a61.6,61.6,0,0,0-.483-9.432,20.132,20.132,0,0,1-.555-2.226,6.294,6.294,0,0,1,.459-2.3c.5-1.5.834-3.051,1.272-4.563a29.74,29.74,0,0,0,.892-4.538c.026-.232.061-.461.1-.692.206-.023.409-.045.614-.073-.129,2.277-.319,4.55-.649,6.816-.24,1.662-.654,3.3-.951,4.955-.282,1.556.147,3.082.238,4.641.186,3.216.282,6.452.247,9.674-.017,1.58-.164,3.169-.13,4.748",
    transform: "translate(-259.672 -66.362)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-14",
    cx: -18.084,
    cy: -0.363,
    r: 3.854,
    gradientTransform: "matrix(6.891, 0.02, 0.107, -0.788, 393.132, 9.727)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-62"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31799",
    "data-name": "Path 31799",
    d: "M300.774,76.1a7.928,7.928,0,0,1-2.219.323,12.626,12.626,0,0,1-2.1-.026,12.4,12.4,0,0,0-2.823.033c-.854.047-1.705.056-2.56.053-1.738,0-3.481-.208-5.215-.287a40.243,40.243,0,0,0-5.275.137,86.4,86.4,0,0,1-9.874.387c-.917-.023-1.834,0-2.75.025-.829.022-1.658.042-2.485.029-.7-.01-1.353-.147-2.039-.194-.165-.008-.318-.016-.47-.018a.217.217,0,0,1-.134.044c-.086,0-.172,0-.258.006a5.121,5.121,0,0,0-.845.238c-.019,1.236.249,2.449.326,3.692.195,3.112.21,6.237.131,9.354-.043,1.589-.091,3.18-.13,4.771a15.719,15.719,0,0,0-.03,1.746,1.812,1.812,0,0,1,.255.094c.492.213.9.528,1.378.746a11.38,11.38,0,0,0,1.362.382,12.106,12.106,0,0,0,1.507.326c.66-.033,1.323-.114,1.95-.2,2.43-.321,4.852-.625,7.3-.872q5.342-.54,10.716-.853c1.753-.1,3.522-.231,5.283-.233,1.437,0,2.8.16,4.219.294a9.784,9.784,0,0,0,2.2.272,1.9,1.9,0,0,0,.838-.494,7.032,7.032,0,0,0,.261-1.362.229.229,0,0,1,.024-.225c.07-.881.043-1.774.081-2.666.079-1.906.247-3.809.435-5.709s.255-3.769.385-5.654a12.663,12.663,0,0,1,.3-2.413c.141-.532.736-1.469.442-2.027a.23.23,0,0,1-.186.276",
    transform: "translate(-261.73 -75.821)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-15",
    cx: -0.624,
    cy: -1.198,
    r: 3.636,
    gradientTransform: "matrix(0.572, 0.02, 0.009, -0.788, -3.365, 10.941)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5c5d60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.446,
    stopColor: "#5c5d60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#4f5152"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#30322f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#171a14"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-64"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11104",
    "data-name": "Rectangle 11104",
    width: 20.54,
    height: 33.29,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-65"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31801",
    "data-name": "Path 31801",
    d: "M298.32,97.105l-.017-.01c-.006.111-.01.223-.012.335s-.111.177-.239.182a6.726,6.726,0,0,1-1.129-.063.2.2,0,0,1-.161-.13,2.426,2.426,0,0,1,.062-1.523c.063-.7.1-1.4.112-2.106.036-2.009.067-4.018.16-6.024.094-1.983.153-4.012.44-5.981a14.671,14.671,0,0,1,.722-2.71,1.73,1.73,0,0,0-.074-1.46c-.269-.51-1.209-.823-1.747-1.11-1.079-.576-2.117-1.2-3.122-1.854-1.889-1.227-3.711-2.518-5.484-3.849-1.74-1.309-3.288-2.78-5.073-4.047-.838-.6-1.723-1.146-2.556-1.746-.323-.233-.639-.458-.974-.662.1-.008.192-.016.289-.02,1.735.921,3.34,2.078,4.939,3.11,2.038,1.317,4.3,2.388,6.409,3.627,2.045,1.2,3.75,2.708,5.846,3.847a12.2,12.2,0,0,1,2.426,1.848,1.249,1.249,0,0,0,.616.3,2.372,2.372,0,0,1-.145.963,8.971,8.971,0,0,0-.3,2.843,34.8,34.8,0,0,1-.136,6.15c-.239,1.875-.858,3.737-.991,5.621-.057.851.249,1.7.232,2.555a7.729,7.729,0,0,1-.091,1.919",
    transform: "translate(-279.227 -64.325)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-16",
    cx: -4.897,
    cy: -0.265,
    r: 3.643,
    gradientTransform: "matrix(1.543, 0.02, 0.024, -0.788, 8.159, 8.387)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-66"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31803",
    "data-name": "Path 31803",
    d: "M311.422,70.453c-2.354.8-4.571,1.722-6.793,2.728-1.545.7-3.081,1.471-4.684,2.091a10.342,10.342,0,0,1-2.255.685.257.257,0,0,1-.142.149.5.5,0,0,1-.074.029c.179.649-.4,1.862-.423,2.292-.069,1.162.038,2.309-.088,3.46-.134,1.207-.185,2.418-.357,3.622-.16,1.1-.533,2.175-.685,3.279-.081.594.018,1.193-.09,1.783a4.385,4.385,0,0,0-.133,1.678,16.207,16.207,0,0,1,.366,2.881,5.19,5.19,0,0,1-.048,1.257c.994-.582,1.734-1.426,2.751-2.007,1.182-.674,2.469-1.214,3.681-1.85,2.852-1.491,5.511-3.2,8.351-4.709,1.441-.764,2.967-1.407,4.457-2.112.621-.3,1.361-.5,1.163-1.178-.146-.491-.369-.97-.49-1.466-.58-2.381,0-4.741.441-7.1a39.524,39.524,0,0,0,.366-7.534,39,39,0,0,1-5.313,2.023",
    transform: "translate(-295.655 -68.43)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-17",
    cx: -2.004,
    cy: 0.146,
    r: 2.327,
    gradientTransform: "matrix(1.274, 0.02, 0.02, -0.788, 4.214, 9.603)",
    xlinkHref: "#radial-gradient-15"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-68"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11106",
    "data-name": "Rectangle 11106",
    width: 56.546,
    height: 14.009,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-69"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31805",
    "data-name": "Path 31805",
    d: "M269.108,86.481c-.043-1.38-.053-2.763-.11-4.141a3.874,3.874,0,0,1-.809,1.2,6.49,6.49,0,0,1-2.432,1.354c-1.127.443-1.181,1.391-1.36,2.267-.147.728-.243,1.519-1.367,1.561-.937.035-1.881-.048-2.818-.049a9.028,9.028,0,0,1-2.127-.05,1.013,1.013,0,0,1-.73-.656c-.265-.648-.485-1.309-.717-1.965a2.552,2.552,0,0,0-3.208-1.238,7.728,7.728,0,0,0-2.285,1.47,3.768,3.768,0,0,1-2.15.839c-1.267.016-2.763-.747-3.97-.22-.84.365-1.7,1.089-2.757,1.024-1.264-.076-2.316-.691-3.552-.831a2.516,2.516,0,0,1-1.987,2.185,5.994,5.994,0,0,1-1.952.514,6.061,6.061,0,0,0-2.536.62c-2.926.811-4.317-2.118-6.422-3.046a3.043,3.043,0,0,0-2.874.109,6.182,6.182,0,0,1-1.821.877,16.6,16.6,0,0,1-3.018.1,10.5,10.5,0,0,1-1.91-.1,4.639,4.639,0,0,1-3.315-2.47c.129.43.269.862.415,1.294.529,1.563.933,3.128,1.373,4.707a13.521,13.521,0,0,1,.5,2.2c.055.488.048,1.037.14,1.534.167.019.341.043.521.071a27.842,27.842,0,0,0,4.227.325c3.044.012,6.088.056,9.134.114,6.064.109,12.131.261,18.2.274q4.693.007,9.386-.11c2.885-.075,5.745-.253,8.632-.143a6.489,6.489,0,0,0,2.523-.231c.474-.18.926-.409,1.413-.568.029-.007.056-.018.085-.026-.076-1.207-.185-2.415-.2-3.628q-.036-2.58-.115-5.162",
    transform: "translate(-212.88 -82.34)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-18",
    cx: 0.303,
    cy: -2,
    r: 4,
    gradientTransform: "matrix(0.27, 0.02, 0.004, -0.788, -3.287, 15.4)",
    xlinkHref: "#radial-gradient-7"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-70"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11107",
    "data-name": "Rectangle 11107",
    width: 38.55,
    height: 20.25,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-71"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31807",
    "data-name": "Path 31807",
    d: "M299.549,78.5a7.844,7.844,0,0,0,.05,1.219,3.164,3.164,0,0,1-.54,2.394c-.447.519-1.432.562-2.041.912-.546.311-1.28.743-.767,1.255a1.525,1.525,0,0,1,.433.69c.268,1.274-1.438,3.167-3.161,3.228-2.164.076-2.126-1.373-2.961-2.529a1.412,1.412,0,0,0-1.775-.592,2.526,2.526,0,0,1-1.055.283c-1.058-.109-2.027-.644-3.145-.341a5.572,5.572,0,0,0-2.469,1.684,2.937,2.937,0,0,1-1.751.459c-1.431.008-2.691-.669-4.146-.3a6.576,6.576,0,0,0-2.534,1.364,7.259,7.259,0,0,1-4.828,2.008c-1.527-.03-2.58-.517-2.739-1.775-.2-1.631.165-3.394-1.812-4.445a11.207,11.207,0,0,1-2.179-1.323c.08,2.3.074,4.6.014,6.9-.042,1.589-.091,3.18-.13,4.77a16.051,16.051,0,0,0-.03,1.747,2.054,2.054,0,0,1,.256.093c.491.214.894.531,1.377.747a11.607,11.607,0,0,0,1.362.382,12.106,12.106,0,0,0,1.507.326c.66-.032,1.323-.114,1.95-.2,2.431-.321,4.852-.625,7.3-.874q5.34-.538,10.718-.852c1.751-.1,3.521-.231,5.282-.234,1.437,0,2.8.161,4.219.3a9.786,9.786,0,0,0,2.2.272,1.9,1.9,0,0,0,.838-.494,7.293,7.293,0,0,0,.261-1.362.221.221,0,0,1,.023-.223c.072-.882.043-1.775.08-2.667.08-1.906.247-3.808.436-5.709.186-1.885.256-3.768.385-5.655a12.674,12.674,0,0,1,.3-2.412c.012-.043.025-.09.043-.139a1.383,1.383,0,0,0-.966,1.1",
    transform: "translate(-261.965 -77.401)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-19",
    cx: -0.648,
    cy: -1.396,
    r: 3.964,
    gradientTransform: "matrix(0.538, 0.02, 0.008, -0.788, -3.722, 11.758)",
    xlinkHref: "#radial-gradient-7"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-72"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31809",
    "data-name": "Path 31809",
    d: "M261.731,76.7a18.328,18.328,0,0,0,.217,2.568,7.539,7.539,0,0,0,.215-1.42c.018-.433.022-.864.022-1.3-.152.049-.3.1-.454.149",
    transform: "translate(-261.73 -76.555)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-20",
    cx: -44.393,
    cy: -10.641,
    r: 30.765,
    gradientTransform: "matrix(4.742, 0.02, 0.074, -0.788, 2030.229, 101.13)",
    xlinkHref: "#radial-gradient-15"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-74"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11109",
    "data-name": "Rectangle 11109",
    width: 21.095,
    height: 26.226,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-75"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31811",
    "data-name": "Path 31811",
    d: "M316.747,69.88c-.751.124-1.342.473-1.434,1.262a12.983,12.983,0,0,0,.155,2.489,1.979,1.979,0,0,1-.563,1.907,7.373,7.373,0,0,1-2.958.783c-.705.122-1.6.332-1.621,1.028-.025.716.423,1.146,1.015,1.65.721.617,1.606,1.318,1.236,2.22a1.238,1.238,0,0,1-1,.7,9.436,9.436,0,0,0-2.748.483c-1.578.666-3.1,1.654-4.954,1.7-.172.007-.3-.167-.2-.28a3.805,3.805,0,0,0,.323-4.37c-1.139.486-1.793,1.211-3.23,1.091a14.872,14.872,0,0,1-3.454-.675c-.17-.056-.216-.195-.1-.31,1.128-1.065.843-2.591.572-3.906-.032,0-.066.013-.1.016a.262.262,0,0,1-.141.149.645.645,0,0,1-.075.029c.179.649-.4,1.862-.423,2.292-.069,1.162.038,2.309-.09,3.461-.133,1.206-.184,2.416-.356,3.621-.16,1.1-.534,2.174-.686,3.279-.08.593.019,1.193-.088,1.783a4.385,4.385,0,0,0-.133,1.678,16.207,16.207,0,0,1,.366,2.881,5.071,5.071,0,0,1-.049,1.257c1-.582,1.735-1.426,2.752-2.007,1.182-.674,2.469-1.214,3.681-1.85,2.852-1.491,5.511-3.2,8.353-4.709,1.441-.764,2.966-1.405,4.455-2.112.623-.3,1.361-.5,1.163-1.178-.146-.491-.369-.97-.49-1.466-.58-2.381,0-4.742.441-7.1a30.446,30.446,0,0,0,.378-5.8",
    transform: "translate(-295.655 -69.88)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-21",
    cx: -2.018,
    cy: 0.09,
    r: 2.478,
    gradientTransform: "matrix(1.204, 0.02, 0.019, -0.788, 3.137, 10.092)",
    xlinkHref: "#radial-gradient-7"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-76"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11110",
    "data-name": "Rectangle 11110",
    width: 22.692,
    height: 10.286,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-77"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31813",
    "data-name": "Path 31813",
    d: "M181.009,84.737c0-.625-.017-1.257-.027-1.894a10.474,10.474,0,0,1-1.879,2.5c-1.007,1.068-2.314,2.513-4.047,2.865a3.545,3.545,0,0,1-1.794-.4,21.747,21.747,0,0,1-2.511-1.233c-1.235-.7-2.293-1.208-2.593-2.439a2.018,2.018,0,0,0-.572-1.245c-.4-.292-1.592-.609-1.96-.117-.306.412-.32.976-.758,1.333-1.108.9-3.583.495-4.908.18-.317-.075-.637-.159-.961-.253,2.072.737,4.177,1.42,6.24,2.173,3.135,1.145,6.284,2.29,9.317,3.6,2.359,1.015,4.789,1.967,7.136,3a13.574,13.574,0,0,1-.265-1.5,41.831,41.831,0,0,1-.417-6.569",
    transform: "translate(-158.999 -82.519)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-22",
    cx: 1.559,
    cy: -2.748,
    r: 11.116,
    gradientTransform: "matrix(0.479, 0.02, 0.007, -0.788, -4.366, 21.377)",
    xlinkHref: "#radial-gradient-7"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-78"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11111",
    "data-name": "Rectangle 11111",
    width: 1.818,
    height: 1.018,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-79"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31815",
    "data-name": "Path 31815",
    d: "M154.622,81.844a.839.839,0,0,0,.338.31c.483.251.975.489,1.48.709a17.483,17.483,0,0,1-1.818-1.018",
    transform: "translate(-154.622 -81.844)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-23",
    cx: 22.094,
    cy: -28.3,
    r: 115.74,
    gradientTransform: "matrix(0.572, 0.02, 0.009, -0.788, -43.685, 223.642)",
    xlinkHref: "#radial-gradient-7"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-80"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11112",
    "data-name": "Rectangle 11112",
    width: 36.981,
    height: 7.833,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-81"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31817",
    "data-name": "Path 31817",
    d: "M216.488,87.54a.671.671,0,0,0-.663-.038,4.3,4.3,0,0,0-.86.691,2.058,2.058,0,0,0-.592,1.454,1.384,1.384,0,0,1-.147.514,1.409,1.409,0,0,1-1.2.807c-.782-.049-1.693-.551-2.363.011-.839.706-.495,2.261-2.015,2.489a10.61,10.61,0,0,1-3.04-.19,11.181,11.181,0,0,1-3.153-.753,3.125,3.125,0,0,1-1.178-.907c-.275-.38-.443-.816-1.131-.69a8.713,8.713,0,0,0-2.165.565,5.3,5.3,0,0,0-1.311,1.114c-.636.627-1.166.551-2.072.7a24.041,24.041,0,0,1-7.208.425c-1.385-.177-1.456-1.054-1.2-2.032.2-.757.907-1.269,1.378-1.918.435-.6.356-1.134-.448-1.518a2.835,2.835,0,0,0-2.427-.018,5.812,5.812,0,0,1-3.759.047c.035.375.065.751.082,1.128a4.381,4.381,0,0,0,.639,2.22,3.751,3.751,0,0,0,.739,1.317,1.839,1.839,0,0,0,1.172,1.127.329.329,0,0,0,.1.007c.086.038.171.076.258.109a17.724,17.724,0,0,0,5.172.623c3.707.1,7.423-.086,11.135-.037,3.676.047,7.345.169,11.018.294a31.814,31.814,0,0,0,6.67-.024,20.66,20.66,0,0,1-.854-3.788,31.571,31.571,0,0,1-.571-3.733",
    transform: "translate(-180.933 -87.429)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-24",
    cx: -0.367,
    cy: -1.593,
    r: 6.962,
    gradientTransform: "matrix(0.241, 0.02, 0.004, -0.788, -4.451, 25.108)",
    xlinkHref: "#radial-gradient-7"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-82"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11113",
    "data-name": "Rectangle 11113",
    width: 54.814,
    height: 5.936,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-83"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31819",
    "data-name": "Path 31819",
    d: "M267.583,90.228c-.936-.553-2.578-1.237-3.045.161-.186.55-.259,1.217-.908,1.574a4.3,4.3,0,0,1-1.754.47,36.494,36.494,0,0,1-5.794-.085,10.036,10.036,0,0,1-4.1-.778,4.8,4.8,0,0,1-1.409-1.337c-.307-.415-.635-.988-1.3-1.1a4.33,4.33,0,0,0-1.742.145c-.365.092-1.1.227-1.293.478-.18.229-.361.455-.553.676-.241.278-.39.607-.85.672-.513.069-1.025-.133-1.5-.068-.716.1-1.4-.349-2.12-.079a3.728,3.728,0,0,0-1.457,1.034,5.217,5.217,0,0,1-1.871,1.6,6.768,6.768,0,0,1-3.4.069c-1.343-.237-2.675-.5-4.012-.741-2.45-.433-5.1-.33-7.435-1.128-1.808-.615-3.851-3.37-5.632-1.189a.268.268,0,0,1-.268.08.708.708,0,0,1-.3-.14,4.655,4.655,0,0,1-2.509-.238c.018.069.038.139.056.21a13.521,13.521,0,0,1,.5,2.2c.055.488.048,1.037.14,1.534.167.019.341.043.521.071a27.843,27.843,0,0,0,4.227.325c3.044.012,6.088.056,9.134.114,6.064.109,12.131.261,18.2.274q4.693.007,9.386-.11c2.885-.075,5.745-.253,8.632-.143a6.489,6.489,0,0,0,2.523-.231c.474-.18.926-.409,1.413-.568.029-.007.056-.018.085-.026-.072-1.158-.174-2.32-.2-3.484a2.441,2.441,0,0,1-1.362-.241",
    transform: "translate(-214.329 -89.095)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-25",
    cx: 0.281,
    cy: -4.806,
    r: 7.744,
    gradientTransform: "matrix(0.144, 0.02, 0.002, -0.788, -4.012, 28.062)",
    xlinkHref: "#radial-gradient-7"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-84"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11114",
    "data-name": "Rectangle 11114",
    width: 37.508,
    height: 8.365,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-85"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31821",
    "data-name": "Path 31821",
    d: "M299.473,87.346a4.333,4.333,0,0,1-2.43,1.481c-1,.184-2.524-.232-3.3.387A5.12,5.12,0,0,1,291.7,90.57c-2.315.519-4.733-.268-7.025-.5-.163-.016-.255-.109-.222-.239.124-.517.351-1.612-.736-1.157a11.5,11.5,0,0,0-1.921,1.115,5.058,5.058,0,0,1-1.131.709,8,8,0,0,1-2.952.3c-1.26-.066-3.319.085-3.784,1.254-.3.761-.326,1.384-1.274,1.817A3.317,3.317,0,0,1,270.4,93.8a13.257,13.257,0,0,1-2.355-1.451,9.626,9.626,0,0,0-3.137-.851c-.655-.167-1.593-.484-1.676-1.109a2.584,2.584,0,0,1,.094-.9,1.693,1.693,0,0,0,.054-.852.556.556,0,0,0-.98-.222,3.288,3.288,0,0,0-.292.421c-.032,1.194-.067,2.389-.1,3.582a16.051,16.051,0,0,0-.03,1.747,2.053,2.053,0,0,1,.256.093c.491.214.894.531,1.377.747a11.607,11.607,0,0,0,1.362.382,12.1,12.1,0,0,0,1.507.326c.66-.032,1.323-.114,1.95-.2,2.431-.321,4.852-.625,7.3-.874q5.34-.538,10.718-.852c1.751-.1,3.521-.231,5.282-.234,1.437,0,2.8.161,4.219.3a9.786,9.786,0,0,0,2.2.272,1.9,1.9,0,0,0,.838-.494,7.293,7.293,0,0,0,.261-1.362.221.221,0,0,1,.023-.223c.072-.882.043-1.775.08-2.667.031-.678.073-1.353.12-2.029",
    transform: "translate(-261.965 -87.346)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-26",
    cx: -0.68,
    cy: -4.47,
    r: 9.051,
    gradientTransform: "matrix(0.245, 0.02, 0.004, -0.788, -6.289, 24.364)",
    xlinkHref: "#radial-gradient-7"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-86"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11115",
    "data-name": "Rectangle 11115",
    width: 20.796,
    height: 14.441,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-87"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31823",
    "data-name": "Path 31823",
    d: "M315.928,80.861a7.921,7.921,0,0,1-.19-1.12,11,11,0,0,1-1.067,1.053c-1.789,1.551-3.925,3.635-6.671,4.1a21.033,21.033,0,0,1-6.456-.026c-1.612-.24-3.716-.642-4.684-1.806-.09.063-.171.125-.251.194,0,.014,0,.029,0,.045-.16,1.1-.534,2.174-.686,3.279-.08.593.019,1.193-.088,1.783a4.385,4.385,0,0,0-.133,1.678,16.207,16.207,0,0,1,.366,2.881,5.071,5.071,0,0,1-.049,1.257c1-.582,1.735-1.426,2.752-2.007,1.182-.674,2.469-1.214,3.681-1.85,2.852-1.491,5.511-3.2,8.353-4.709,1.441-.764,2.966-1.405,4.455-2.112.623-.3,1.361-.5,1.163-1.178-.146-.491-.369-.97-.49-1.466",
    transform: "translate(-295.655 -79.741)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-27",
    cx: -2.086,
    cy: -0.627,
    r: 4.431,
    gradientTransform: "matrix(0.692, 0.02, 0.011, -0.788, -5.128, 16.401)",
    xlinkHref: "#radial-gradient-7"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-88"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11116",
    "data-name": "Rectangle 11116",
    width: 40.015,
    height: 13.329,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-89"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31825",
    "data-name": "Path 31825",
    d: "M285.906,64.141c1.923-.118,3.827-.338,5.747-.468.917-.062,1.815-.148,2.738-.127a5.9,5.9,0,0,0,1.622-.1h.01a.8.8,0,0,0,.258-.051,2.844,2.844,0,0,0,.747.029,4.822,4.822,0,0,0,2.568.408l.02-.01c1.736.558,3.445,1.01,3.837,1.122,2.428.7,4.925,1.235,7.432,1.734,1.881.375,3.76.751,5.65,1.091a11.3,11.3,0,0,1,3.351,1.064,29.847,29.847,0,0,1-5.163,2.1c-2.02.692-3.963,1.428-5.868,2.3-1.6.736-3.211,1.47-4.8,2.225a13.323,13.323,0,0,1-3.337,1.269.226.226,0,0,0-.124-.043,2.048,2.048,0,0,1-.611-.134,5.362,5.362,0,0,0-.582-.35c-.292-.241-.538-.539-.874-.8-.809-.637-1.824-1.108-2.669-1.721a52.336,52.336,0,0,0-5.567-3.506c-2.041-1.116-4.184-2.075-6.173-3.258-1.358-.809-2.753-1.717-4.246-2.427,2.01-.123,4.026-.213,6.034-.336",
    transform: "translate(-279.872 -63.392)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-28",
    cx: -2.673,
    cy: -0.532,
    r: 8.607,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-90"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11117",
    "data-name": "Rectangle 11117",
    width: 39.157,
    height: 14.286,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-91"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31827",
    "data-name": "Path 31827",
    d: "M262.5,73.521c.255-2.266.36-4.539.4-6.812,1.256-.173,2.507-.405,3.768-.527,3.865-.372,7.675-1.005,11.525-1.457,1.312-.154,2.63-.265,3.952-.357.5.326.949.7,1.41,1.065.717.562,1.484,1.082,2.229,1.618,1.67,1.2,3.089,2.628,4.705,3.882,1.658,1.284,3.4,2.468,5.147,3.676.806.557,1.617,1.1,2.464,1.619s2.216,1,2.787,1.733c.008.011.013.022.021.032a.255.255,0,0,0-.247-.042,7.447,7.447,0,0,1-2.373.216,12.686,12.686,0,0,0-2.1-.185,35.741,35.741,0,0,1-5.324-.218,52.513,52.513,0,0,0-9.806-.117c-3.123.393-6.251.746-9.416.84q-2.46.072-4.918.149a16.993,16.993,0,0,1-2.78-.093,20.814,20.814,0,0,1-2.119-.131.166.166,0,0,0-.073,0c.174-1.634.562-3.258.743-4.9",
    transform: "translate(-261.759 -64.368)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-29",
    cx: -2.183,
    cy: -0.576,
    r: 8.072,
    gradientTransform: "matrix(0.384, 0.02, 0.006, -0.788, -4.907, 18.098)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-92"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11118",
    "data-name": "Rectangle 11118",
    width: 59.189,
    height: 13.685,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-93"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31829",
    "data-name": "Path 31829",
    d: "M223.32,65.523c.68,0,1.36,0,2.04.007.307,0,.614.006.921.017.246.006.479.115.186-.057a.715.715,0,0,0,1.005-.41,21.708,21.708,0,0,0,3.272.4c1.711.117,3.414.292,5.129.384,3.858.207,7.729.161,11.588.362s7.731.428,11.6.531c1.715.045,3.424.035,5.14.006,1.016-.019,2.03-.019,3.045.029a8.569,8.569,0,0,0,1.523.084.559.559,0,0,0,.275-.053l.017,0h0l.016-.01h0l-.017.01.023-.008a10.456,10.456,0,0,0,1.856-.057c.115-.008.229-.02.342-.031-.3,1.5-.522,3-.954,4.485-.448,1.542-1.006,3.055-1.41,4.6a19.114,19.114,0,0,0-.668,2.572c-2.167-.006-4.31-.222-6.483-.2-2.461.02-4.868.446-7.337.473a148.681,148.681,0,0,1-16.338-.218,54.429,54.429,0,0,0-7.555-.51c-2.639.093-5.281.054-7.922.038a58.728,58.728,0,0,1-7.167-.215,6.955,6.955,0,0,0-3.355.048c.479-.519,1.166-.975,1.649-1.468a36.783,36.783,0,0,0,3.088-3.742c1.042-1.395,2.066-2.8,3.159-4.168.779-.979,1.8-1.864,2.463-2.895.289,0,.576,0,.865,0",
    transform: "translate(-212.096 -65.08)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-30",
    cx: -0.458,
    cy: -0.612,
    r: 8.03,
    gradientTransform: "matrix(0.257, 0.02, 0.004, -0.788, -3.19, 17.863)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-94"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11119",
    "data-name": "Rectangle 11119",
    width: 45.788,
    height: 14.544,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-95"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31831",
    "data-name": "Path 31831",
    d: "M200.309,63.624c.268.041.531.088.78.123,1.2.173,2.449.123,3.667.194,1.367.079,2.725.228,4.076.4,2.614.338,5.176.816,7.81,1.062,2.53.237,5.074.326,7.62.357q1.172.016,2.344.025c-2.36,2.657-5.144,5.117-7.77,7.6-.586.557-1.142,1.129-1.661,1.726-.558.635-.811,1.521-1.448,2.089a6.384,6.384,0,0,0-.877.86.342.342,0,0,0-.276,0c-.853.333-2.106-.244-2.952-.405a17.01,17.01,0,0,0-3.845-.068c-3.209.131-6.42-.38-9.613-.566-3.027-.176-6.024-.416-9.066-.43-1.543-.008-3.092.063-4.633.018-1.272-.035-2.4-.506-3.645-.623a8.3,8.3,0,0,0,1.156-.7c.9-.649,1.73-1.344,2.64-1.983,1.074-.751,2.275-1.378,3.351-2.127a37.288,37.288,0,0,1,3.388-2.162c1.056-.584,2.191-1.061,3.187-1.716,1.255-.825,2.438-1.649,3.753-2.427a9.115,9.115,0,0,0,2.016-1.249",
    transform: "translate(-180.818 -63.624)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-96"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11120",
    "data-name": "Rectangle 11120",
    width: 46.692,
    height: 14.018,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-97"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31833",
    "data-name": "Path 31833",
    d: "M158.181,68.179c3.043-.907,6.026-1.93,9.19-2.553,1.515-.3,3.064-.435,4.571-.765a41.947,41.947,0,0,0,4.256-1.229c1.452-.48,2.889-.985,4.353-1.445a7.239,7.239,0,0,1,2.688-.431c.7.042,1.4.191,2.1.274.078.039.155.081.237.122a12.063,12.063,0,0,0,1.821.609,31.3,31.3,0,0,0,3.259.77,43.291,43.291,0,0,0,7.546.618c1.17.016,2.333.044,3.5-.042.625-.045,1.246-.118,1.868-.192h.012a109.173,109.173,0,0,0-10.82,5.58c-1.76,1.1-3.612,2.094-5.319,3.243a30.967,30.967,0,0,1-2.819,1.909,6.473,6.473,0,0,0-.782.3,2.516,2.516,0,0,0-.533.252c-.078.053-.149.108-.215.161-.2.124-.393.262-.583.4a52.951,52.951,0,0,0-6.2-1.918c-2.653-.73-5.324-1.415-7.971-2.16a30.561,30.561,0,0,1-3.6-1.151c-1.009-.425-1.958-.92-3.014-1.273a16.974,16.974,0,0,0-3.3-.562c-.512-.062-1.023-.115-1.536-.152.431-.122.863-.245,1.293-.373",
    transform: "translate(-156.888 -61.747)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-32",
    cx: 0.817,
    cy: -0.363,
    r: 8.098,
    gradientTransform: "matrix(0.322, 0.02, 0.005, -0.788, -2.739, 18.464)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-98"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11121",
    "data-name": "Rectangle 11121",
    width: 34.705,
    height: 9.959,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-99"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11122",
    "data-name": "Rectangle 11122",
    width: 33.516,
    height: 11.463,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-100"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11123",
    "data-name": "Rectangle 11123",
    width: 55.641,
    height: 12.259,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-101"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11124",
    "data-name": "Rectangle 11124",
    width: 40.218,
    height: 13.999,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-102"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11125",
    "data-name": "Rectangle 11125",
    width: 25.782,
    height: 8.795,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-103"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11129",
    "data-name": "Rectangle 11129",
    width: 184.726,
    height: 26.115,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-104"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31840",
    "data-name": "Path 31840",
    d: "M170.544,83.863l-.125.025c-.2.042-.331.284-.167.409a.364.364,0,0,0,.51-.148q.018-.048.036-.093c.053-.137-.091-.226-.253-.192",
    transform: "translate(-170.176 -83.856)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-33",
    cx: 0.529,
    cy: 0.46,
    r: 0.512,
    gradientTransform: "matrix(0.784, 0.02, 0.012, -0.788, -58.479, 380.447)",
    xlinkHref: "#radial-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-105"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31842",
    "data-name": "Path 31842",
    d: "M173.619,81.354a.373.373,0,0,0-.429.036.412.412,0,0,0-.164.308l0,0a.194.194,0,0,0,.026.283.357.357,0,0,0,.361.011.638.638,0,0,0,.265-.2.484.484,0,0,0,.084-.21c.017-.1-.056-.171-.139-.234",
    transform: "translate(-172.972 -81.301)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-34",
    cx: 0.505,
    cy: 0.506,
    r: 0.528,
    gradientTransform: "matrix(0.957, 0.02, 0.015, -0.788, -12.758, 294.042)",
    xlinkHref: "#radial-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-106"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31844",
    "data-name": "Path 31844",
    d: "M175.681,85.842a.962.962,0,0,0-.6-.166.416.416,0,0,0-.324,0,.433.433,0,0,1-.066-.006c.038,0-.051-.02-.063-.024a.307.307,0,0,0-.234-.042.2.2,0,0,0-.155.212.531.531,0,0,0,.062.166.816.816,0,0,0-.292.529.563.563,0,0,0,0,.078c-.128.125-.192.321-.019.431.075.049.133.108.2.158a1.346,1.346,0,0,0,.276.135.341.341,0,0,0,.32-.06.238.238,0,0,0,.059-.069l.048,0a1.18,1.18,0,0,0,.693-.276.83.83,0,0,0,.322-.555.573.573,0,0,0-.235-.51",
    transform: "translate(-173.889 -85.59)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-35",
    cx: 0.514,
    cy: 0.501,
    r: 0.577,
    gradientTransform: "matrix(0.839, 0.02, 0.013, -0.788, -16.244, 126.253)",
    xlinkHref: "#radial-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-107"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31846",
    "data-name": "Path 31846",
    d: "M173.6,83.324c-.13.011-.233.114-.21.216,0,.027.011.054.017.081.012.063.091.1.169.094a.208.208,0,0,0,.194-.16c.007-.031.014-.059.02-.087.021-.087-.09-.151-.189-.145",
    transform: "translate(-173.39 -83.324)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-36",
    cx: 0.5,
    cy: 0.5,
    r: 0.549,
    gradientTransform: "matrix(0.9, 0.02, 0.014, -0.788, -49.343, 570.757)",
    xlinkHref: "#radial-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-108"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31848",
    "data-name": "Path 31848",
    d: "M169.587,79.031a7.944,7.944,0,0,1-.5-.115.436.436,0,0,0-.141.023.946.946,0,0,1-.108-.06.739.739,0,0,0-.287-.055.532.532,0,0,0-.6.379.438.438,0,0,0-.068.048.456.456,0,0,0-.1.1c-.021-.012-.044-.025-.067-.036A1.128,1.128,0,0,0,167,79.3a1.2,1.2,0,0,0-.637.419.7.7,0,0,0-.143.589.645.645,0,0,0,.428.441,2.028,2.028,0,0,0,.38.081,2,2,0,0,0,.483-.036.839.839,0,0,0,.184.024.553.553,0,0,0,.532-.313.575.575,0,0,0,.278-.546.37.37,0,0,0,.173-.4c0-.013-.006-.023-.01-.037V79.5a.917.917,0,0,0,.1-.032h0a.245.245,0,0,0,.1.151.506.506,0,0,0,.581-.047c.036-.031.072-.059.108-.09a.28.28,0,0,0,.036-.452",
    transform: "translate(-166.198 -78.822)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-37",
    cx: 0.495,
    cy: 0.504,
    r: 0.718,
    gradientTransform: "matrix(0.58, 0.02, 0.009, -0.788, -23.33, 114.917)",
    xlinkHref: "#radial-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-109"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31850",
    "data-name": "Path 31850",
    d: "M171.039,79.334c-.339,0-.428.443-.037.449.339,0,.427-.445.037-.449",
    transform: "translate(-170.745 -79.334)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-38",
    cx: 0.5,
    cy: 0.502,
    r: 0.587,
    gradientTransform: "matrix(0.572, 0.02, 0.009, -0.788, -107.062, 509.148)",
    xlinkHref: "#radial-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-110"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31852",
    "data-name": "Path 31852",
    d: "M169.083,81.75a.331.331,0,0,0-.385.031l-.1.08a.183.183,0,0,0-.024.3.324.324,0,0,0,.375-.029c.036-.026.069-.05.105-.074a.187.187,0,0,0,.025-.3",
    transform: "translate(-168.512 -81.701)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-39",
    cx: 0.503,
    cy: 0.497,
    r: 0.534,
    gradientTransform: "matrix(0.806, 0.02, 0.012, -0.788, -55.395, 399.577)",
    xlinkHref: "#radial-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-111"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31854",
    "data-name": "Path 31854",
    d: "M163.368,82.231c-.158-.1-.314-.2-.483-.287a.524.524,0,0,0-.21-.574l-.006,0-.01-.012a.374.374,0,0,0-.106-.134.629.629,0,0,0-.4-.1,1.15,1.15,0,0,0-.752.355.892.892,0,0,0-.262.344.586.586,0,0,0-.029.361.529.529,0,0,0,.185.277.558.558,0,0,0,0,.118c.012.134.184.235.336.255a.609.609,0,0,0,.2-.011.41.41,0,0,0,.223.153.962.962,0,0,0,.186.029l.037.012a.791.791,0,0,0,1.033-.312.386.386,0,0,0,.02-.21c.112-.069.171-.18.039-.259",
    transform: "translate(-161.09 -81.12)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-40",
    cx: 0.492,
    cy: 0.496,
    r: 0.593,
    gradientTransform: "matrix(0.82, 0.02, 0.013, -0.788, -14.719, 117.243)",
    xlinkHref: "#radial-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-112"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31856",
    "data-name": "Path 31856",
    d: "M172.92,76.562c-.293,0-.37.385-.031.39.294,0,.37-.385.031-.39",
    transform: "translate(-172.665 -76.562)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-41",
    cx: 0.5,
    cy: 0.5,
    r: 0.587,
    gradientTransform: "matrix(0.571, 0.02, 0.009, -0.788, -125.002, 601.659)",
    xlinkHref: "#radial-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-113"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31858",
    "data-name": "Path 31858",
    d: "M174.293,77.468c-.384,0-.483.5-.039.509.384,0,.483-.5.039-.509",
    transform: "translate(-173.961 -77.468)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-42",
    cx: 0.5,
    cy: 0.5,
    r: 0.586,
    gradientTransform: "matrix(0.572, 0.02, 0.009, -0.788, -96.246, 456.772)",
    xlinkHref: "#radial-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-114"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31860",
    "data-name": "Path 31860",
    d: "M157.056,77.033c-.4,0-.5.523-.043.529.4.006.5-.523.043-.529",
    transform: "translate(-156.71 -77.033)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-43",
    cx: 0.5,
    cy: 0.497,
    r: 0.587,
    gradientTransform: "matrix(0.572, 0.02, 0.009, -0.788, -83.637, 440.802)",
    xlinkHref: "#radial-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-115"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31862",
    "data-name": "Path 31862",
    d: "M157.483,78.425c-.376,0-.473.492-.041.5.378,0,.474-.494.041-.5",
    transform: "translate(-157.157 -78.425)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-44",
    cx: 0.5,
    cy: 0.5,
    r: 0.587,
    gradientTransform: "matrix(0.572, 0.02, 0.009, -0.788, -88.988, 462.155)",
    xlinkHref: "#radial-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-116"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31864",
    "data-name": "Path 31864",
    d: "M173.894,85.537a.806.806,0,0,0-.586.105.357.357,0,0,0-.166.464c.091.147.359.08.44-.036,0-.006.022-.033.037-.057l0,0,0-.008.114-.054c-.054.026.075-.014.059-.014a.309.309,0,0,0,.256-.169c.042-.1-.024-.208-.16-.228",
    transform: "translate(-173.104 -85.523)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-45",
    cx: 0.514,
    cy: 0.474,
    r: 0.584,
    gradientTransform: "matrix(0.718, 0.02, 0.011, -0.788, -55.822, 297.146)",
    xlinkHref: "#radial-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-117"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31866",
    "data-name": "Path 31866",
    d: "M175.108,87.1a.436.436,0,0,0-.523.212.242.242,0,0,0,.241.317l.017.011a.393.393,0,0,0,.22.065c.141.007.284-.073.29-.191a.374.374,0,0,0-.245-.412",
    transform: "translate(-174.57 -87.076)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-46",
    cx: 0.522,
    cy: 0.528,
    r: 0.564,
    gradientTransform: "matrix(0.814, 0.02, 0.013, -0.788, -47.415, 325.813)",
    xlinkHref: "#radial-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-118"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31868",
    "data-name": "Path 31868",
    d: "M163.633,82.951a.2.2,0,0,0,.1-.191c-.017-.094-.109-.164-.124-.252-.031-.2-.416-.092-.413.074a.33.33,0,0,0,.029.137c.007.017.022.039.033.061a.55.55,0,0,0-.33.114c-.1.086-.18.246-.088.359.055.068.11.134.165.2a.5.5,0,0,0,.67.016.369.369,0,0,0,.145-.251c.011-.122-.062-.2-.182-.269",
    transform: "translate(-162.794 -82.4)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-47",
    cx: 0.521,
    cy: 0.512,
    r: 0.474,
    gradientTransform: "matrix(1.201, 0.02, 0.019, -0.788, 32.617, 175.329)",
    xlinkHref: "#radial-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-119"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31870",
    "data-name": "Path 31870",
    d: "M159.26,72.157c-.246.019-.39.221-.306.394a.322.322,0,0,0,.16.189.288.288,0,0,0,.268-.05.581.581,0,0,0,.158-.246c.069-.149-.08-.3-.28-.287",
    transform: "translate(-158.93 -72.156)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-48",
    cx: 0.504,
    cy: 0.491,
    r: 0.53,
    gradientTransform: "matrix(0.862, 0.02, 0.013, -0.788, -37.199, 393.991)",
    xlinkHref: "#radial-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-120"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31872",
    "data-name": "Path 31872",
    d: "M160.225,74.067c.118-.166.06-.411-.262-.413a.414.414,0,0,0-.2.045.354.354,0,0,0,.068-.059c.269-.088.3-.473-.084-.479a.418.418,0,0,0-.112.016h0a1.353,1.353,0,0,0-.73.106c-.018.007-.036.018-.053.025a.6.6,0,0,0-.235-.366,1.087,1.087,0,0,0-.691-.174,1.256,1.256,0,0,0-.729.29.867.867,0,0,0-.338.586.6.6,0,0,0,.247.537,1.086,1.086,0,0,0,.691.174,1.012,1.012,0,0,0,.419-.1c.178.094.516.039.706.081a3.1,3.1,0,0,1,.557.183.864.864,0,0,0,.619-.013c.209-.057.362-.336.124-.437m-.9-.007a.634.634,0,0,1-.213,0,.876.876,0,0,0,.121-.048.589.589,0,0,0,.21-.18l.012-.006.019-.006c.021-.008.116-.022.011-.006a.637.637,0,0,0,.228-.078A.3.3,0,0,0,159.6,74c-.092.018-.185.043-.276.061",
    transform: "translate(-156.858 -72.768)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-49",
    cx: 0.488,
    cy: 0.489,
    r: 0.761,
    gradientTransform: "matrix(0.524, 0.02, 0.008, -0.788, -24.766, 132.801)",
    xlinkHref: "#radial-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-121"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31874",
    "data-name": "Path 31874",
    d: "M207.107,83.012c-.018-.045-.061-.1-.057-.152.008-.264-.5-.16-.453.082a.672.672,0,0,0,.212.294c.065.063.214.014.252-.045s.069-.122.047-.179",
    transform: "translate(-206.593 -82.705)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-50",
    cx: 0.525,
    cy: 0.552,
    r: 0.435,
    gradientTransform: "matrix(1.175, 0.02, 0.018, -0.788, 67.511, 333.62)",
    xlinkHref: "#radial-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-122"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31876",
    "data-name": "Path 31876",
    d: "M184.056,84.93a.833.833,0,0,0-.538-.136.972.972,0,0,0-.568.227.68.68,0,0,0-.266.457.47.47,0,0,0,.195.418.844.844,0,0,0,.539.136.983.983,0,0,0,.569-.226.68.68,0,0,0,.263-.457.467.467,0,0,0-.194-.419",
    transform: "translate(-182.683 -84.794)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-51",
    cx: 0.5,
    cy: 0.5,
    r: 0.611,
    gradientTransform: "matrix(0.782, 0.02, 0.012, -0.788, -30.199, 181.318)",
    xlinkHref: "#radial-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-123"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31878",
    "data-name": "Path 31878",
    d: "M184.19,82.319c-.331,0-.417.434-.033.439.33,0,.416-.434.033-.439",
    transform: "translate(-183.903 -82.319)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-52",
    cx: 0.5,
    cy: 0.5,
    r: 0.586,
    gradientTransform: "matrix(0.572, 0.02, 0.009, -0.788, -117.48, 506.757)",
    xlinkHref: "#radial-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-124"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31880",
    "data-name": "Path 31880",
    d: "M185.225,84.573c-.2,0-.256.265-.022.266.2,0,.256-.264.022-.266",
    transform: "translate(-185.049 -84.573)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-53",
    cx: 0.5,
    cy: 0.5,
    r: 0.586,
    gradientTransform: "matrix(0.57, 0.02, 0.009, -0.788, -193.692, 812.872)",
    xlinkHref: "#radial-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-125"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31882",
    "data-name": "Path 31882",
    d: "M187.914,89.2c-.123-.31-.549-.3-.792-.112a.123.123,0,0,0-.011-.031.584.584,0,0,0-.1-.209.839.839,0,0,0-.379-.282,1.191,1.191,0,0,0-.527-.069,1.561,1.561,0,0,0-.55.155,1.177,1.177,0,0,0-.578.613.682.682,0,0,0,.054.63.9.9,0,0,0,.631.35,1.428,1.428,0,0,0,.815-.151,1.186,1.186,0,0,0,.18-.114.172.172,0,0,0,.068.069.715.715,0,0,0,.468.112.859.859,0,0,0,.492-.25.641.641,0,0,0,.189-.337.591.591,0,0,0,.036-.375",
    transform: "translate(-184.929 -88.491)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-54",
    cx: 0.5,
    cy: 0.498,
    r: 0.709,
    gradientTransform: "matrix(0.596, 0.02, 0.009, -0.788, -29.064, 119.792)",
    xlinkHref: "#radial-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-126"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31884",
    "data-name": "Path 31884",
    d: "M190.345,87.54c-.436,0-.55.574-.045.58.436.006.55-.572.045-.58",
    transform: "translate(-189.967 -87.54)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-55",
    cx: 0.5,
    cy: 0.5,
    r: 0.586,
    gradientTransform: "matrix(0.572, 0.02, 0.009, -0.788, -91.973, 366.705)",
    xlinkHref: "#radial-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-127"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31886",
    "data-name": "Path 31886",
    d: "M190.756,89.53c-.379,0-.476.5-.042.5.379,0,.474-.5.042-.5",
    transform: "translate(-190.428 -89.53)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-56",
    cx: 0.5,
    cy: 0.5,
    r: 0.59,
    gradientTransform: "matrix(0.571, 0.02, 0.009, -0.788, -107.177, 418.204)",
    xlinkHref: "#radial-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-128"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31888",
    "data-name": "Path 31888",
    d: "M193.006,83.618c-.525-.006-.663.692-.056.7.527.007.664-.692.056-.7",
    transform: "translate(-192.551 -83.618)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-57",
    cx: 0.5,
    cy: 0.5,
    r: 0.586,
    gradientTransform: "matrix(0.572, 0.02, 0.009, -0.788, -77.29, 315.279)",
    xlinkHref: "#radial-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-129"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31890",
    "data-name": "Path 31890",
    d: "M199.12,89.339c-.14-.355-.731-.4-1.109-.251a1.2,1.2,0,0,0-.21.106,2.023,2.023,0,0,0-.369-.032,1.3,1.3,0,0,0-.747.3.892.892,0,0,0-.348.6.625.625,0,0,0,.255.552,1.109,1.109,0,0,0,.709.178,1.27,1.27,0,0,0,.746-.3.878.878,0,0,0,.348-.6.609.609,0,0,0-.03-.235,2.658,2.658,0,0,0,.276.076c.246.017.566-.177.48-.4",
    transform: "translate(-196.334 -89.009)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-58",
    cx: 0.489,
    cy: 0.516,
    r: 0.662,
    gradientTransform: "matrix(0.65, 0.02, 0.01, -0.788, -28.412, 116.179)",
    xlinkHref: "#radial-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-130"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31892",
    "data-name": "Path 31892",
    d: "M199.519,91.058c-.293,0-.37.384-.031.388.293,0,.369-.384.031-.388",
    transform: "translate(-199.264 -91.058)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-59",
    cx: 0.5,
    cy: 0.502,
    r: 0.589,
    gradientTransform: "matrix(0.568, 0.02, 0.009, -0.788, -144.471, 530.813)",
    xlinkHref: "#radial-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-131"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31894",
    "data-name": "Path 31894",
    d: "M196.843,91.953c-.316,0-.4.415-.033.418.318,0,.4-.413.033-.418",
    transform: "translate(-196.57 -91.953)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-60",
    cx: 0.5,
    cy: 0.5,
    r: 0.586,
    gradientTransform: "matrix(0.571, 0.02, 0.009, -0.788, -131.565, 486.416)",
    xlinkHref: "#radial-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-132"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31896",
    "data-name": "Path 31896",
    d: "M191.551,91.8c-.987-.013-1.242,1.294-.105,1.309.987.011,1.243-1.3.105-1.309",
    transform: "translate(-190.696 -91.804)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-61",
    cx: 0.5,
    cy: 0.5,
    r: 0.586,
    gradientTransform: "matrix(0.572, 0.02, 0.009, -0.788, -40.831, 155.958)",
    xlinkHref: "#radial-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-133"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31898",
    "data-name": "Path 31898",
    d: "M190.145,91.74c-.294,0-.369.384-.03.387.3,0,.368-.385.03-.387",
    transform: "translate(-189.891 -91.74)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-62",
    cx: 0.5,
    cy: 0.5,
    r: 0.59,
    gradientTransform: "matrix(0.569, 0.02, 0.009, -0.788, -137.722, 527.003)",
    xlinkHref: "#radial-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-134"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31900",
    "data-name": "Path 31900",
    d: "M192.924,90.606c-.31,0-.39.408-.033.411.31,0,.39-.405.033-.411",
    transform: "translate(-192.656 -90.606)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-63",
    cx: 0.5,
    cy: 0.498,
    r: 0.588,
    gradientTransform: "matrix(0.571, 0.02, 0.009, -0.788, -131.996, 504.043)",
    xlinkHref: "#radial-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-135"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31902",
    "data-name": "Path 31902",
    d: "M186.654,90.964c-.7-.01-.882.918-.075.927.7.007.883-.918.075-.927",
    transform: "translate(-186.047 -90.964)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-64",
    cx: 0.5,
    cy: 0.501,
    r: 0.587,
    gradientTransform: "matrix(0.57, 0.02, 0.009, -0.788, -56.318, 221.825)",
    xlinkHref: "#radial-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-136"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31904",
    "data-name": "Path 31904",
    d: "M199.438,88.339l-.105,0c-.321.017-.6.378-.335.578a.485.485,0,0,0,.718-.287c0-.026.007-.051.01-.078.018-.135-.128-.226-.288-.219",
    transform: "translate(-198.893 -88.339)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-65",
    cx: 0.568,
    cy: 0.424,
    r: 0.508,
    gradientTransform: "matrix(0.791, 0.02, 0.012, -0.788, -49.455, 273.453)",
    xlinkHref: "#radial-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-137"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31906",
    "data-name": "Path 31906",
    d: "M204.936,83.567c-.126-.105-.3-.023-.4.065-.014.016-.065.074-.073.087l0,0-.011,0c-.21.092-.313.36-.124.5a.486.486,0,0,0,.631-.118c.109-.174.166-.39-.023-.544",
    transform: "translate(-204.228 -83.518)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-66",
    cx: 0.512,
    cy: 0.492,
    r: 0.491,
    gradientTransform: "matrix(0.911, 0.02, 0.014, -0.788, -23.168, 253.918)",
    xlinkHref: "#radial-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-138"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31908",
    "data-name": "Path 31908",
    d: "M204.476,83.626l.014-.012c.006-.008.006-.008-.014.012",
    transform: "translate(-204.476 -83.609)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-67",
    cx: 97.59,
    cy: 43.341,
    r: 0.004,
    gradientTransform: "matrix(0.985, 0.02, 0.015, -0.788, 0, 0.884)",
    xlinkHref: "#radial-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-139"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31910",
    "data-name": "Path 31910",
    d: "M206.352,82.542c-.093-.145-.323-.08-.423.019a.681.681,0,0,0-.121.106c.054-.057.008-.008-.006,0a.219.219,0,0,0-.029.353.391.391,0,0,0,.446-.035c.154-.123.235-.288.133-.447",
    transform: "translate(-205.696 -82.457)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-68",
    cx: 0.496,
    cy: 0.511,
    r: 0.502,
    gradientTransform: "matrix(0.889, 0.02, 0.014, -0.788, -34.964, 320.762)",
    xlinkHref: "#radial-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-140"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31912",
    "data-name": "Path 31912",
    d: "M206.561,83.14h0",
    transform: "translate(-206.533 -83.133)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-69",
    cx: 57.376,
    cy: 88.167,
    r: 0.011,
    gradientTransform: "matrix(0.28, 0.02, 0.004, -0.788, 0.358, 0.884)",
    xlinkHref: "#radial-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-141"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31914",
    "data-name": "Path 31914",
    d: "M208.592,84.126a1.185,1.185,0,0,0-.636-.219c-.02,0-.039-.011-.06-.016a2.069,2.069,0,0,0-.347-.065.19.19,0,0,0-.08-.169.3.3,0,0,0-.163-.055c.016-.122-.068-.245-.28-.247-.023,0-.042.006-.063.007a.219.219,0,0,0-.073-.088.215.215,0,0,0-.1-.051.543.543,0,0,1-.056-.012.421.421,0,0,0-.149-.013c.111-.179.035-.43-.307-.435a.4.4,0,0,0-.361.189c-.3.088-.373.476-.067.577a.867.867,0,0,1,.165.385c.011.078.117.123.208.117a.256.256,0,0,0,.234-.179.317.317,0,0,0,.062.045,1.144,1.144,0,0,0,.27.121.663.663,0,0,0-.188.011c-.043.007-.085.017-.128.025-.294.055-.471.409-.24.583a.427.427,0,0,0,.233.076.762.762,0,0,0,.039.773,1.274,1.274,0,0,0,1.38.356A1.32,1.32,0,0,0,208.9,84.8a.765.765,0,0,0-.311-.676",
    transform: "translate(-205.651 -82.764)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-70",
    cx: 0.511,
    cy: 0.489,
    r: 0.551,
    gradientTransform: "matrix(0.943, 0.02, 0.015, -0.788, -4.582, 72.026)",
    xlinkHref: "#radial-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-142"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31916",
    "data-name": "Path 31916",
    d: "M206.29,88.92a.482.482,0,0,0-.208-.074c-.195-.007-.428.1-.423.28a.371.371,0,0,0,.1.231.419.419,0,0,0,.57.014.25.25,0,0,0-.039-.451",
    transform: "translate(-205.659 -88.846)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-71",
    cx: 0.473,
    cy: 0.472,
    r: 0.566,
    gradientTransform: "matrix(0.804, 0.02, 0.012, -0.788, -57.107, 318.714)",
    xlinkHref: "#radial-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-143"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31918",
    "data-name": "Path 31918",
    d: "M205.607,89.388c-.307,0-.387.405-.032.409.308,0,.39-.4.032-.409",
    transform: "translate(-205.341 -89.388)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-72",
    cx: 0.5,
    cy: 0.497,
    r: 0.587,
    gradientTransform: "matrix(0.57, 0.02, 0.009, -0.788, -140.999, 511.832)",
    xlinkHref: "#radial-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-144"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31920",
    "data-name": "Path 31920",
    d: "M204.5,89.23a.426.426,0,0,0-.551.1.805.805,0,0,0-.056.074.2.2,0,0,0,.026.3.384.384,0,0,0,.375.007l.1-.042c.184-.081.276-.314.11-.437",
    transform: "translate(-203.846 -89.167)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-73",
    cx: 0.47,
    cy: 0.529,
    r: 0.53,
    gradientTransform: "matrix(0.802, 0.02, 0.012, -0.788, -57.052, 317.811)",
    xlinkHref: "#radial-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-145"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31922",
    "data-name": "Path 31922",
    d: "M234.14,85.49a.839.839,0,0,0-.539-.135.952.952,0,0,0-.565.226.67.67,0,0,0-.265.455.461.461,0,0,0,.192.419.86.86,0,0,0,.539.136.986.986,0,0,0,.569-.226.693.693,0,0,0,.265-.455.475.475,0,0,0-.2-.421",
    transform: "translate(-232.768 -85.355)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-74",
    cx: 0.5,
    cy: 0.5,
    r: 0.612,
    gradientTransform: "matrix(0.782, 0.02, 0.012, -0.788, -38.266, 181.268)",
    xlinkHref: "#radial-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-146"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31924",
    "data-name": "Path 31924",
    d: "M234.274,82.877c-.33,0-.417.436-.035.442.332,0,.417-.436.035-.442",
    transform: "translate(-233.987 -82.877)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-75",
    cx: 0.5,
    cy: 0.5,
    r: 0.587,
    gradientTransform: "matrix(0.574, 0.02, 0.009, -0.788, -148.314, 504.405)",
    xlinkHref: "#radial-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-147"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31926",
    "data-name": "Path 31926",
    d: "M235.308,85.131c-.2,0-.255.269-.02.271.2,0,.255-.269.02-.271",
    transform: "translate(-235.132 -85.131)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-76",
    cx: 0.5,
    cy: 0.5,
    r: 0.585,
    gradientTransform: "matrix(0.576, 0.02, 0.009, -0.788, -242.219, 804.511)",
    xlinkHref: "#radial-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-148"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31928",
    "data-name": "Path 31928",
    d: "M238,89.76c-.123-.312-.546-.3-.79-.112a.224.224,0,0,1-.01-.031.614.614,0,0,0-.1-.208.868.868,0,0,0-.379-.286,1.267,1.267,0,0,0-.528-.069,1.542,1.542,0,0,0-.549.159,1.164,1.164,0,0,0-.578.611.685.685,0,0,0,.054.631.9.9,0,0,0,.632.348,1.421,1.421,0,0,0,.815-.148,1.718,1.718,0,0,0,.18-.115.181.181,0,0,0,.067.072.74.74,0,0,0,.471.112.883.883,0,0,0,.49-.251.635.635,0,0,0,.188-.338A.564.564,0,0,0,238,89.76",
    transform: "translate(-235.014 -89.05)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-77",
    cx: 0.5,
    cy: 0.498,
    r: 0.708,
    gradientTransform: "matrix(0.597, 0.02, 0.009, -0.788, -36.735, 119.453)",
    xlinkHref: "#radial-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-149"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31930",
    "data-name": "Path 31930",
    d: "M240.431,88.1c-.437,0-.55.575-.048.581.439,0,.55-.575.048-.581",
    transform: "translate(-240.052 -88.1)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-78",
    cx: 0.5,
    cy: 0.5,
    r: 0.587,
    gradientTransform: "matrix(0.573, 0.02, 0.009, -0.788, -115.692, 365.913)",
    xlinkHref: "#radial-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-150"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31932",
    "data-name": "Path 31932",
    d: "M240.839,90.091c-.376,0-.474.494-.041.5.376,0,.476-.492.041-.5",
    transform: "translate(-240.513 -90.091)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-79",
    cx: 0.5,
    cy: 0.5,
    r: 0.586,
    gradientTransform: "matrix(0.57, 0.02, 0.009, -0.788, -134.877, 417.188)",
    xlinkHref: "#radial-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-151"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31934",
    "data-name": "Path 31934",
    d: "M243.092,84.179c-.527-.006-.663.69-.056.7.528.006.664-.691.056-.7",
    transform: "translate(-242.635 -84.179)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-80",
    cx: 0.5,
    cy: 0.5,
    r: 0.588,
    gradientTransform: "matrix(0.57, 0.02, 0.009, -0.788, -97.412, 315.581)",
    xlinkHref: "#radial-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-152"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31936",
    "data-name": "Path 31936",
    d: "M249.2,89.9c-.142-.359-.733-.4-1.109-.253a1.139,1.139,0,0,0-.212.109,1.815,1.815,0,0,0-.37-.031,1.282,1.282,0,0,0-.745.3.88.88,0,0,0-.348.6.618.618,0,0,0,.255.55,1.112,1.112,0,0,0,.707.179,1.286,1.286,0,0,0,.747-.3.9.9,0,0,0,.349-.6.622.622,0,0,0-.032-.234,2.685,2.685,0,0,0,.277.073c.246.018.569-.174.48-.393",
    transform: "translate(-246.419 -89.568)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-81",
    cx: 0.489,
    cy: 0.515,
    r: 0.662,
    gradientTransform: "matrix(0.649, 0.02, 0.01, -0.788, -35.526, 115.948)",
    xlinkHref: "#radial-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-153"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31938",
    "data-name": "Path 31938",
    d: "M249.6,91.617c-.294,0-.37.386-.031.391.294,0,.369-.387.031-.391",
    transform: "translate(-249.348 -91.617)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-82",
    cx: 0.5,
    cy: 0.499,
    r: 0.587,
    gradientTransform: "matrix(0.572, 0.02, 0.009, -0.788, -178.782, 526.51)",
    xlinkHref: "#radial-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-154"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31940",
    "data-name": "Path 31940",
    d: "M246.929,92.512c-.317,0-.4.415-.035.419.317,0,.4-.413.035-.419",
    transform: "translate(-246.654 -92.512)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-83",
    cx: 0.5,
    cy: 0.498,
    r: 0.589,
    gradientTransform: "matrix(0.567, 0.02, 0.009, -0.788, -165.248, 486.408)",
    xlinkHref: "#radial-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-155"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31942",
    "data-name": "Path 31942",
    d: "M241.636,92.365c-.987-.013-1.243,1.292-.1,1.305.985.012,1.242-1.293.1-1.305",
    transform: "translate(-240.781 -92.365)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-84",
    cx: 0.5,
    cy: 0.5,
    r: 0.587,
    gradientTransform: "matrix(0.57, 0.02, 0.009, -0.788, -51.49, 155.837)",
    xlinkHref: "#radial-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-156"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31944",
    "data-name": "Path 31944",
    d: "M240.232,92.3c-.294,0-.372.386-.032.39.294,0,.369-.385.032-.39",
    transform: "translate(-239.976 -92.298)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-85",
    cx: 0.5,
    cy: 0.5,
    r: 0.587,
    gradientTransform: "matrix(0.572, 0.02, 0.009, -0.788, -172.136, 522.694)",
    xlinkHref: "#radial-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-157"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31946",
    "data-name": "Path 31946",
    d: "M243.008,91.167c-.308,0-.388.406-.033.411.31,0,.391-.406.033-.411",
    transform: "translate(-242.74 -91.167)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-86",
    cx: 0.5,
    cy: 0.5,
    r: 0.586,
    gradientTransform: "matrix(0.573, 0.02, 0.009, -0.788, -165.075, 501.467)",
    xlinkHref: "#radial-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-158"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31948",
    "data-name": "Path 31948",
    d: "M236.738,91.524c-.7-.01-.881.918-.073.929.7.008.88-.919.073-.929",
    transform: "translate(-236.132 -91.524)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-87",
    cx: 0.5,
    cy: 0.5,
    r: 0.586,
    gradientTransform: "matrix(0.573, 0.02, 0.009, -0.788, -70.952, 220.785)",
    xlinkHref: "#radial-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-159"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31950",
    "data-name": "Path 31950",
    d: "M249.523,88.9l-.106,0c-.32.016-.6.379-.335.577a.484.484,0,0,0,.718-.286c0-.027.007-.051.012-.079.018-.134-.13-.226-.289-.217",
    transform: "translate(-248.977 -88.9)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-88",
    cx: 0.567,
    cy: 0.424,
    r: 0.507,
    gradientTransform: "matrix(0.792, 0.02, 0.012, -0.788, -61.301, 272.726)",
    xlinkHref: "#radial-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-160"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31952",
    "data-name": "Path 31952",
    d: "M255.02,84.127a.316.316,0,0,0-.4.063c-.013.017-.065.076-.072.087l0,0-.011,0c-.209.094-.31.362-.123.5a.494.494,0,0,0,.633-.118c.1-.174.164-.391-.025-.545",
    transform: "translate(-254.314 -84.078)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-89",
    cx: 0.511,
    cy: 0.491,
    r: 0.492,
    gradientTransform: "matrix(0.911, 0.02, 0.014, -0.788, -28.494, 254.449)",
    xlinkHref: "#radial-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-161"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31954",
    "data-name": "Path 31954",
    d: "M254.561,84.187l.013-.014c.007-.006.006-.006-.013.014",
    transform: "translate(-254.561 -84.169)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-90",
    cx: 117.874,
    cy: 42.045,
    r: 0.004,
    gradientTransform: "matrix(0.986, 0.02, 0.015, -0.788, -0.001, 0.884)",
    xlinkHref: "#radial-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-162"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31956",
    "data-name": "Path 31956",
    d: "M256.437,83.1c-.093-.145-.323-.078-.424.023a.64.64,0,0,0-.118.1c.053-.057.01-.008,0,.007a.216.216,0,0,0-.031.351.39.39,0,0,0,.447-.037c.153-.122.232-.286.131-.447",
    transform: "translate(-255.781 -83.017)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-91",
    cx: 0.496,
    cy: 0.511,
    r: 0.5,
    gradientTransform: "matrix(0.897, 0.02, 0.014, -0.788, -40.165, 319.129)",
    xlinkHref: "#radial-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-163"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31958",
    "data-name": "Path 31958",
    d: "M256.647,83.7h0",
    transform: "translate(-256.618 -83.693)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-92",
    cx: 71.841,
    cy: 82.359,
    r: 0.011,
    gradientTransform: "matrix(0.302, 0.02, 0.005, -0.788, 0.347, 0.884)",
    xlinkHref: "#radial-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-164"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31960",
    "data-name": "Path 31960",
    d: "M258.676,84.686a1.181,1.181,0,0,0-.636-.218c-.019,0-.041-.01-.061-.016a2.558,2.558,0,0,0-.345-.068.179.179,0,0,0-.08-.164.287.287,0,0,0-.161-.059c.014-.12-.067-.241-.281-.245-.022,0-.042,0-.063.006a.236.236,0,0,0-.069-.091.33.33,0,0,0-.1-.048.371.371,0,0,0-.056-.012.433.433,0,0,0-.152-.012c.11-.183.036-.435-.307-.437a.4.4,0,0,0-.361.189c-.3.09-.374.474-.065.575a.962.962,0,0,1,.164.386c.011.079.117.124.208.118a.264.264,0,0,0,.235-.178c.019.014.037.033.059.047a1.334,1.334,0,0,0,.271.118.617.617,0,0,0-.186.011c-.042.008-.086.016-.129.025-.294.055-.47.409-.24.583a.407.407,0,0,0,.235.076.753.753,0,0,0,.037.774,1.273,1.273,0,0,0,1.379.356,1.319,1.319,0,0,0,1.021-1.042.76.76,0,0,0-.312-.676",
    transform: "translate(-255.735 -83.324)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-93",
    cx: 0.511,
    cy: 0.489,
    r: 0.55,
    gradientTransform: "matrix(0.942, 0.02, 0.015, -0.788, -5.599, 71.945)",
    xlinkHref: "#radial-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-165"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31962",
    "data-name": "Path 31962",
    d: "M256.374,89.481a.426.426,0,0,0-.207-.073c-.2-.008-.429.1-.423.277a.347.347,0,0,0,.1.231.419.419,0,0,0,.571.016.251.251,0,0,0-.042-.451",
    transform: "translate(-255.744 -89.408)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-94",
    cx: 0.474,
    cy: 0.472,
    r: 0.565,
    gradientTransform: "matrix(0.804, 0.02, 0.012, -0.788, -70.468, 318.353)",
    xlinkHref: "#radial-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-166"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31964",
    "data-name": "Path 31964",
    d: "M255.694,89.95c-.31,0-.388.4-.033.408.31,0,.39-.4.033-.408",
    transform: "translate(-255.426 -89.95)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-95",
    cx: 0.5,
    cy: 0.5,
    r: 0.589,
    gradientTransform: "matrix(0.569, 0.02, 0.009, -0.788, -175.425, 512.026)",
    xlinkHref: "#radial-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-167"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31966",
    "data-name": "Path 31966",
    d: "M254.589,89.789a.431.431,0,0,0-.552.1c-.018.024-.037.05-.056.074a.2.2,0,0,0,.03.293.376.376,0,0,0,.374.011c.031-.013.063-.029.1-.041.182-.084.272-.316.108-.441",
    transform: "translate(-253.93 -89.727)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-96",
    cx: 0.47,
    cy: 0.529,
    r: 0.53,
    gradientTransform: "matrix(0.802, 0.02, 0.012, -0.788, -70.711, 317.996)",
    xlinkHref: "#radial-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-168"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31968",
    "data-name": "Path 31968",
    d: "M239.392,87.534a.788.788,0,0,0,.506.195,1.028,1.028,0,0,0,.6-.159.742.742,0,0,0,.345-.422.448.448,0,0,0-.114-.436.814.814,0,0,0-.509-.2,1.028,1.028,0,0,0-.6.161.752.752,0,0,0-.347.419.447.447,0,0,0,.117.439",
    transform: "translate(-239.259 -86.51)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-97",
    cx: 0.5,
    cy: 0.5,
    r: 0.604,
    gradientTransform: "matrix(0.768, 0.02, 0.012, -0.788, -40.185, 175.91)",
    xlinkHref: "#radial-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-169"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31970",
    "data-name": "Path 31970",
    d: "M238.622,89.965c.327.042.492-.384.115-.431-.326-.041-.491.382-.115.431",
    transform: "translate(-238.406 -89.531)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-98",
    cx: 0.5,
    cy: 0.499,
    r: 0.515,
    gradientTransform: "matrix(0.602, 0.02, 0.009, -0.788, -129.701, 415.918)",
    xlinkHref: "#radial-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-170"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31972",
    "data-name": "Path 31972",
    d: "M237.979,87.588c.2.025.3-.235.07-.263-.2-.029-.3.233-.07.263",
    transform: "translate(-237.846 -87.323)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-99",
    cx: 0.5,
    cy: 0.505,
    r: 0.513,
    gradientTransform: "matrix(0.604, 0.02, 0.009, -0.788, -209.689, 689.253)",
    xlinkHref: "#radial-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-171"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31974",
    "data-name": "Path 31974",
    d: "M236.578,82.968c.066.32.488.356.761.2,0,.011,0,.022,0,.031a.576.576,0,0,0,.057.218.777.777,0,0,0,.326.325,1.193,1.193,0,0,0,.507.127,1.561,1.561,0,0,0,.572-.093,1.274,1.274,0,0,0,.684-.54.667.667,0,0,0,.063-.626.815.815,0,0,0-.562-.421,1.46,1.46,0,0,0-.832.056,1.232,1.232,0,0,0-.2.093.156.156,0,0,0-.054-.076.686.686,0,0,0-.443-.165.929.929,0,0,0-.533.19.7.7,0,0,0-.247.314.6.6,0,0,0-.1.366",
    transform: "translate(-236.572 -82.098)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-100",
    cx: 0.496,
    cy: 0.501,
    r: 0.716,
    gradientTransform: "matrix(0.587, 0.02, 0.009, -0.788, -37.48, 128.048)",
    xlinkHref: "#radial-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-172"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31976",
    "data-name": "Path 31976",
    d: "M233.514,84.122c.431.055.649-.507.153-.568-.433-.057-.651.5-.153.568",
    transform: "translate(-233.228 -83.551)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-101",
    cx: 0.5,
    cy: 0.501,
    r: 0.513,
    gradientTransform: "matrix(0.603, 0.02, 0.009, -0.788, -95.913, 332.337)",
    xlinkHref: "#radial-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-173"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31978",
    "data-name": "Path 31978",
    d: "M233.457,82.091c.373.047.562-.435.134-.489-.372-.048-.562.434-.134.489",
    transform: "translate(-233.212 -81.599)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-102",
    cx: 0.5,
    cy: 0.5,
    r: 0.515,
    gradientTransform: "matrix(0.6, 0.02, 0.009, -0.788, -112.131, 394.224)",
    xlinkHref: "#radial-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-174"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31980",
    "data-name": "Path 31980",
    d: "M230.183,87.721c.521.067.784-.609.185-.685-.521-.067-.785.609-.185.685",
    transform: "translate(-229.839 -87.031)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-103",
    cx: 0.5,
    cy: 0.5,
    r: 0.514,
    gradientTransform: "matrix(0.602, 0.02, 0.009, -0.788, -78.539, 267.273)",
    xlinkHref: "#radial-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-175"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31982",
    "data-name": "Path 31982",
    d: "M225.494,81.548c.073.372.65.478,1.05.379a1.318,1.318,0,0,0,.229-.084,1.954,1.954,0,0,0,.36.073,1.368,1.368,0,0,0,.794-.21.979.979,0,0,0,.454-.553.59.59,0,0,0-.154-.576,1.039,1.039,0,0,0-.667-.255,1.334,1.334,0,0,0-.794.209.976.976,0,0,0-.453.553.631.631,0,0,0-.013.237c-.091-.024-.158-.087-.261-.106-.241-.044-.59.108-.546.333",
    transform: "translate(-225.49 -80.316)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-104",
    cx: 0.502,
    cy: 0.491,
    r: 0.7,
    gradientTransform: "matrix(0.594, 0.02, 0.009, -0.788, -36.534, 133.518)",
    xlinkHref: "#radial-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-176"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31984",
    "data-name": "Path 31984",
    d: "M225.046,79.566c.289.036.436-.339.1-.382-.288-.036-.436.339-.1.382",
    transform: "translate(-224.854 -79.181)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-105",
    cx: 0.5,
    cy: 0.5,
    r: 0.517,
    gradientTransform: "matrix(0.599, 0.02, 0.009, -0.788, -139.123, 516.853)",
    xlinkHref: "#radial-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-177"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31986",
    "data-name": "Path 31986",
    d: "M227.861,78.99c.312.039.471-.366.11-.411-.312-.042-.47.365-.11.411",
    transform: "translate(-227.654 -78.575)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-106",
    cx: 0.5,
    cy: 0.503,
    r: 0.513,
    gradientTransform: "matrix(0.603, 0.02, 0.009, -0.788, -129.481, 479.508)",
    xlinkHref: "#radial-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-178"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31988",
    "data-name": "Path 31988",
    d: "M233.237,79.892c.975.124,1.466-1.138.343-1.281-.975-.124-1.465,1.139-.343,1.281",
    transform: "translate(-232.592 -78.602)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-107",
    cx: 0.5,
    cy: 0.5,
    r: 0.515,
    gradientTransform: "matrix(0.601, 0.02, 0.009, -0.788, -42.567, 154.432)",
    xlinkHref: "#radial-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-179"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31990",
    "data-name": "Path 31990",
    d: "M234.444,79.958c.29.036.436-.339.1-.381-.29-.039-.436.338-.1.381",
    transform: "translate(-234.252 -79.574)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-108",
    cx: 0.5,
    cy: 0.504,
    r: 0.513,
    gradientTransform: "matrix(0.602, 0.02, 0.009, -0.788, -143.667, 512.85)",
    xlinkHref: "#radial-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-180"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31992",
    "data-name": "Path 31992",
    d: "M231.492,80.765c.3.038.458-.356.108-.4-.3-.039-.458.355-.108.4",
    transform: "translate(-231.291 -80.361)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-109",
    cx: 0.5,
    cy: 0.5,
    r: 0.514,
    gradientTransform: "matrix(0.603, 0.02, 0.009, -0.788, -135.043, 485.136)",
    xlinkHref: "#radial-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-181"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31994",
    "data-name": "Path 31994",
    d: "M237.859,81.214c.692.087,1.04-.809.244-.909-.693-.088-1.042.809-.244.909",
    transform: "translate(-237.4 -80.299)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-110",
    cx: 0.5,
    cy: 0.5,
    r: 0.515,
    gradientTransform: "matrix(0.601, 0.02, 0.009, -0.788, -61.264, 214.476)",
    xlinkHref: "#radial-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-182"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31996",
    "data-name": "Path 31996",
    d: "M224.685,82.309l.105.007c.321.02.66-.306.436-.532a.509.509,0,0,0-.765.2l-.023.073c-.043.134.085.243.246.25",
    transform: "translate(-224.43 -81.677)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-111",
    cx: 0.447,
    cy: 0.569,
    r: 0.514,
    gradientTransform: "matrix(0.753, 0.02, 0.012, -0.788, -63.029, 293.923)",
    xlinkHref: "#radial-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-183"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31998",
    "data-name": "Path 31998",
    d: "M218.366,86.428c.105.116.3.057.406-.019.016-.016.076-.066.087-.076l0,0,.011,0c.226-.068.376-.32.214-.483a.5.5,0,0,0-.647.044c-.136.163-.233.367-.075.543",
    transform: "translate(-218.285 -85.742)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-112",
    cx: 0.492,
    cy: 0.506,
    r: 0.515,
    gradientTransform: "matrix(0.824, 0.02, 0.013, -0.788, -44.43, 261.012)",
    xlinkHref: "#radial-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-184"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32000",
    "data-name": "Path 32000",
    d: "M218.709,86.291l-.016.011.016-.011",
    transform: "translate(-218.689 -86.291)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-113",
    cx: 87.017,
    cy: 49.001,
    r: 0.005,
    gradientTransform: "matrix(0.705, 0.02, 0.011, -0.788, 0.142, 0.884)",
    xlinkHref: "#radial-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-185"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32002",
    "data-name": "Path 32002",
    d: "M216.759,87.255c.066.153.3.115.422.027a.623.623,0,0,0,.137-.091c-.062.05-.011.007.008,0,.129-.076.2-.237.093-.347a.39.39,0,0,0-.448-.013c-.173.1-.286.256-.213.427",
    transform: "translate(-216.736 -86.764)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-114",
    cx: 0.498,
    cy: 0.49,
    r: 0.533,
    gradientTransform: "matrix(0.807, 0.02, 0.013, -0.788, -60.044, 327.738)",
    xlinkHref: "#radial-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-186"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32004",
    "data-name": "Path 32004",
    d: "M216.559,86.533h0",
    transform: "translate(-216.559 -86.533)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-115",
    cx: 63.196,
    cy: 58.542,
    r: 0.008,
    gradientTransform: "matrix(0.431, 0.02, 0.007, -0.788, 0.281, 0.884)",
    xlinkHref: "#radial-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-187"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32006",
    "data-name": "Path 32006",
    d: "M215.2,85.869a1.085,1.085,0,0,0,.587.286l.057.024a2.486,2.486,0,0,0,.332.105.169.169,0,0,0,.047.172.288.288,0,0,0,.152.076c-.039.118.02.249.229.275a.4.4,0,0,0,.066,0,.233.233,0,0,0,.146.158.522.522,0,0,0,.055.019.4.4,0,0,0,.146.029c-.142.167-.115.423.225.467a.434.434,0,0,0,.391-.146c.316-.053.457-.428.171-.562a.844.844,0,0,1-.092-.4c0-.081-.094-.136-.184-.14a.281.281,0,0,0-.265.148.307.307,0,0,0-.053-.051,1.041,1.041,0,0,0-.245-.149.608.608,0,0,0,.188.01c.044,0,.087-.006.13-.007.3-.024.543-.354.345-.552a.38.38,0,0,0-.218-.1.76.76,0,0,0,.1-.77,1.206,1.206,0,0,0-1.3-.51,1.45,1.45,0,0,0-1.2.915.721.721,0,0,0,.188.705",
    transform: "translate(-214.982 -84.228)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-116",
    cx: 0.488,
    cy: 0.505,
    r: 0.528,
    gradientTransform: "matrix(1.043, 0.02, 0.016, -0.788, 2.735, 69.126)",
    xlinkHref: "#radial-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-188"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32008",
    "data-name": "Path 32008",
    d: "M218,80.951a.458.458,0,0,0,.191.1c.191.029.445-.055.471-.229a.328.328,0,0,0-.056-.238.412.412,0,0,0-.564-.081c-.194.118-.226.319-.042.449",
    transform: "translate(-217.878 -80.429)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-117",
    cx: 0.529,
    cy: 0.511,
    r: 0.558,
    gradientTransform: "matrix(0.799, 0.02, 0.012, -0.788, -61.104, 341.572)",
    xlinkHref: "#radial-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-189"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32010",
    "data-name": "Path 32010",
    d: "M218.717,80.527c.3.039.458-.355.108-.4-.3-.038-.459.357-.108.4",
    transform: "translate(-218.515 -80.124)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-118",
    cx: 0.5,
    cy: 0.5,
    r: 0.515,
    gradientTransform: "matrix(0.601, 0.02, 0.009, -0.788, -128.258, 486.901)",
    xlinkHref: "#radial-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-190"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32012",
    "data-name": "Path 32012",
    d: "M219.817,80.84a.436.436,0,0,0,.565-.039.731.731,0,0,0,.069-.066.2.2,0,0,0,.026-.3.369.369,0,0,0-.369-.051l-.1.031c-.2.06-.327.281-.19.421",
    transform: "translate(-219.76 -80.363)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-119",
    cx: 0.524,
    cy: 0.466,
    r: 0.559,
    gradientTransform: "matrix(0.729, 0.02, 0.011, -0.788, -80.209, 364.203)",
    xlinkHref: "#radial-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-191"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32014",
    "data-name": "Path 32014",
    d: "M266.537,82.666A.849.849,0,0,0,266,82.53a.975.975,0,0,0-.571.228.683.683,0,0,0-.264.455.474.474,0,0,0,.2.417.829.829,0,0,0,.539.139.979.979,0,0,0,.566-.228.672.672,0,0,0,.264-.457.464.464,0,0,0-.192-.418",
    transform: "translate(-265.163 -82.53)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-120",
    cx: 0.499,
    cy: 0.5,
    r: 0.612,
    gradientTransform: "matrix(0.782, 0.02, 0.012, -0.788, -43.315, 186.266)",
    xlinkHref: "#radial-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-192"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32016",
    "data-name": "Path 32016",
    d: "M266.67,80.055c-.33,0-.416.434-.033.439.331,0,.416-.434.033-.439",
    transform: "translate(-266.384 -80.055)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-121",
    cx: 0.5,
    cy: 0.5,
    r: 0.589,
    gradientTransform: "matrix(0.57, 0.02, 0.009, -0.788, -170.226, 522.187)",
    xlinkHref: "#radial-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-193"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32018",
    "data-name": "Path 32018",
    d: "M267.7,82.307c-.2,0-.255.268-.02.27.2,0,.255-.268.02-.27",
    transform: "translate(-267.529 -82.307)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-122",
    cx: 0.5,
    cy: 0.501,
    r: 0.588,
    gradientTransform: "matrix(0.574, 0.02, 0.009, -0.788, -276.679, 830.382)",
    xlinkHref: "#radial-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-194"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32020",
    "data-name": "Path 32020",
    d: "M270.4,86.936c-.127-.312-.549-.3-.794-.112a.092.092,0,0,0-.008-.031.594.594,0,0,0-.1-.208.887.887,0,0,0-.38-.288,1.3,1.3,0,0,0-.526-.067,1.509,1.509,0,0,0-.55.158,1.159,1.159,0,0,0-.577.612.671.671,0,0,0,.051.63.9.9,0,0,0,.633.349,1.425,1.425,0,0,0,.813-.148,1.3,1.3,0,0,0,.182-.115.2.2,0,0,0,.067.071.725.725,0,0,0,.468.112.87.87,0,0,0,.492-.251.635.635,0,0,0,.189-.336.577.577,0,0,0,.037-.375",
    transform: "translate(-267.409 -86.226)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-123",
    cx: 0.5,
    cy: 0.498,
    r: 0.709,
    gradientTransform: "matrix(0.596, 0.02, 0.009, -0.788, -41.784, 122.993)",
    xlinkHref: "#radial-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-195"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32022",
    "data-name": "Path 32022",
    d: "M272.825,85.276c-.435-.006-.55.574-.045.58.436,0,.55-.574.045-.58",
    transform: "translate(-272.447 -85.276)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-124",
    cx: 0.5,
    cy: 0.5,
    r: 0.587,
    gradientTransform: "matrix(0.572, 0.02, 0.009, -0.788, -131.194, 376.373)",
    xlinkHref: "#radial-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-196"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32024",
    "data-name": "Path 32024",
    d: "M273.235,87.267c-.378-.006-.473.495-.041.5.378.006.473-.495.041-.5",
    transform: "translate(-272.909 -87.267)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-125",
    cx: 0.5,
    cy: 0.5,
    r: 0.584,
    gradientTransform: "matrix(0.576, 0.02, 0.009, -0.788, -151.328, 426.635)",
    xlinkHref: "#radial-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-197"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32026",
    "data-name": "Path 32026",
    d: "M275.489,81.355c-.528-.007-.664.69-.057.7.527.007.663-.69.057-.7",
    transform: "translate(-275.031 -81.355)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-126",
    cx: 0.5,
    cy: 0.5,
    r: 0.587,
    gradientTransform: "matrix(0.571, 0.02, 0.009, -0.788, -110.004, 323.806)",
    xlinkHref: "#radial-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-198"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32028",
    "data-name": "Path 32028",
    d: "M281.6,87.076c-.14-.357-.73-.4-1.108-.253a1.315,1.315,0,0,0-.213.108,1.89,1.89,0,0,0-.367-.031,1.283,1.283,0,0,0-.748.3.9.9,0,0,0-.347.6.62.62,0,0,0,.255.552,1.13,1.13,0,0,0,.708.177,1.266,1.266,0,0,0,.747-.3.891.891,0,0,0,.349-.6.65.65,0,0,0-.032-.234c.093.013.172.068.277.075.247.018.565-.176.479-.394",
    transform: "translate(-278.815 -86.745)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-127",
    cx: 0.489,
    cy: 0.515,
    r: 0.662,
    gradientTransform: "matrix(0.65, 0.02, 0.01, -0.788, -40.137, 119.422)",
    xlinkHref: "#radial-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-199"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32030",
    "data-name": "Path 32030",
    d: "M282,88.8c-.293,0-.369.384-.032.386.294,0,.37-.382.032-.386",
    transform: "translate(-281.744 -88.795)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-128",
    cx: 0.5,
    cy: 0.501,
    r: 0.585,
    gradientTransform: "matrix(0.571, 0.02, 0.009, -0.788, -202.434, 543.729)",
    xlinkHref: "#radial-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-200"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32032",
    "data-name": "Path 32032",
    d: "M279.325,89.688c-.318,0-.4.415-.035.419.317,0,.4-.415.035-.419",
    transform: "translate(-279.05 -89.688)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-129",
    cx: 0.5,
    cy: 0.499,
    r: 0.587,
    gradientTransform: "matrix(0.574, 0.02, 0.009, -0.788, -185.041, 498.53)",
    xlinkHref: "#radial-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-201"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32034",
    "data-name": "Path 32034",
    d: "M274.032,89.539c-.987-.011-1.242,1.3-.108,1.309.987.013,1.243-1.294.108-1.309",
    transform: "translate(-273.177 -89.539)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-130",
    cx: 0.5,
    cy: 0.5,
    r: 0.587,
    gradientTransform: "matrix(0.572, 0.02, 0.009, -0.788, -58.194, 160.237)",
    xlinkHref: "#radial-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-202"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32036",
    "data-name": "Path 32036",
    d: "M272.625,89.476c-.294,0-.369.382-.03.387.293,0,.37-.382.03-.387",
    transform: "translate(-272.371 -89.476)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-131",
    cx: 0.5,
    cy: 0.502,
    r: 0.587,
    gradientTransform: "matrix(0.569, 0.02, 0.009, -0.788, -195.929, 539.8)",
    xlinkHref: "#radial-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-203"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32038",
    "data-name": "Path 32038",
    d: "M275.4,88.343c-.31,0-.39.405-.035.411.311,0,.39-.408.035-.411",
    transform: "translate(-275.136 -88.343)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-132",
    cx: 0.5,
    cy: 0.503,
    r: 0.587,
    gradientTransform: "matrix(0.573, 0.02, 0.009, -0.788, -186.791, 516.367)",
    xlinkHref: "#radial-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-204"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32040",
    "data-name": "Path 32040",
    d: "M269.135,88.7c-.7-.008-.882.919-.075.929.7.01.882-.919.075-.929",
    transform: "translate(-268.528 -88.699)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-133",
    cx: 0.5,
    cy: 0.5,
    r: 0.587,
    gradientTransform: "matrix(0.572, 0.02, 0.009, -0.788, -80.592, 227.319)",
    xlinkHref: "#radial-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-205"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32042",
    "data-name": "Path 32042",
    d: "M281.918,86.075c-.035,0-.068,0-.105,0-.322.018-.6.38-.335.581a.486.486,0,0,0,.719-.287c0-.027.007-.051.01-.079.018-.135-.128-.227-.289-.219",
    transform: "translate(-281.374 -86.075)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-134",
    cx: 0.567,
    cy: 0.424,
    r: 0.507,
    gradientTransform: "matrix(0.794, 0.02, 0.012, -0.788, -68.327, 280.409)",
    xlinkHref: "#radial-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-206"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32044",
    "data-name": "Path 32044",
    d: "M287.416,81.3a.312.312,0,0,0-.4.066.858.858,0,0,0-.07.085l0,.006-.011,0c-.213.091-.314.359-.125.5a.491.491,0,0,0,.632-.117c.109-.176.165-.391-.024-.545",
    transform: "translate(-286.708 -81.254)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-135",
    cx: 0.513,
    cy: 0.492,
    r: 0.492,
    gradientTransform: "matrix(0.909, 0.02, 0.014, -0.788, -32.537, 261.666)",
    xlinkHref: "#radial-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-207"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32046",
    "data-name": "Path 32046",
    d: "M286.957,81.363l.013-.012c0-.008,0-.008-.013.012",
    transform: "translate(-286.957 -81.346)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-136",
    cx: 142.595,
    cy: 41.328,
    r: 0.004,
    gradientTransform: "matrix(1.109, 0.02, 0.017, -0.788, -0.063, 0.884)",
    xlinkHref: "#radial-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-208"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32048",
    "data-name": "Path 32048",
    d: "M288.832,80.276c-.093-.145-.322-.076-.422.023a.588.588,0,0,0-.12.1c.051-.056.007-.006-.008.006a.217.217,0,0,0-.026.353.386.386,0,0,0,.445-.037c.154-.12.235-.284.132-.447",
    transform: "translate(-288.176 -80.192)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-137",
    cx: 0.496,
    cy: 0.513,
    r: 0.501,
    gradientTransform: "matrix(0.891, 0.02, 0.014, -0.788, -47.364, 328.531)",
    xlinkHref: "#radial-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-209"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32049",
    "data-name": "Path 32049",
    d: "M289.042,80.875h0",
    transform: "translate(-289.013 -80.869)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-138",
    cx: -101.645,
    cy: 77.725,
    r: 0.003,
    gradientTransform: "matrix(-0.033, 1, 3.429, 0.006, -1.198, -0.003)",
    xlinkHref: "#radial-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-210"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32051",
    "data-name": "Path 32051",
    d: "M288.77,86.657a.473.473,0,0,0-.206-.075c-.2-.006-.43.1-.425.281a.365.365,0,0,0,.1.228.423.423,0,0,0,.575.016.251.251,0,0,0-.042-.449",
    transform: "translate(-288.139 -86.582)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-139",
    cx: 0.474,
    cy: 0.47,
    r: 0.565,
    gradientTransform: "matrix(0.805, 0.02, 0.012, -0.788, -78.881, 327.834)",
    xlinkHref: "#radial-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-211"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32053",
    "data-name": "Path 32053",
    d: "M288.089,87.125c-.307,0-.388.4-.032.408.308,0,.388-.4.032-.408",
    transform: "translate(-287.822 -87.125)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-140",
    cx: 0.5,
    cy: 0.502,
    r: 0.587,
    gradientTransform: "matrix(0.57, 0.02, 0.009, -0.788, -196.732, 525.552)",
    xlinkHref: "#radial-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-212"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32055",
    "data-name": "Path 32055",
    d: "M286.984,86.964a.433.433,0,0,0-.552.1c-.018.025-.037.049-.054.074a.2.2,0,0,0,.025.3.384.384,0,0,0,.376.01l.1-.042c.184-.082.274-.316.109-.441",
    transform: "translate(-286.326 -86.903)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-141",
    cx: 0.471,
    cy: 0.528,
    r: 0.529,
    gradientTransform: "matrix(0.805, 0.02, 0.012, -0.788, -78.483, 326.366)",
    xlinkHref: "#radial-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-213"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32057",
    "data-name": "Path 32057",
    d: "M298.126,79.959a.418.418,0,0,0-.392.016c-.111.053-.151.227-.141.368a1,1,0,0,0,.191.506,1.022,1.022,0,0,0,.414.349.437.437,0,0,0,.391-.017c.114-.054.149-.228.14-.37a.993.993,0,0,0-.191-.5.968.968,0,0,0-.411-.347",
    transform: "translate(-297.592 -79.917)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-142",
    cx: 0.5,
    cy: 0.5,
    r: 0.509,
    gradientTransform: "matrix(1.163, 0.02, 0.018, -0.788, 46.288, 176.261)",
    xlinkHref: "#radial-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-214"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32059",
    "data-name": "Path 32059",
    d: "M296.315,77.4c-.183.086.092.525.3.425.183-.082-.093-.523-.3-.425",
    transform: "translate(-296.255 -77.39)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-143",
    cx: 0.5,
    cy: 0.5,
    r: 0.396,
    gradientTransform: "matrix(0.922, 0.02, 0.014, -0.788, -42.734, 393.793)",
    xlinkHref: "#radial-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-215"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32061",
    "data-name": "Path 32061",
    d: "M298.534,79.266c-.111.051.059.321.186.262.111-.053-.059-.324-.186-.262",
    transform: "translate(-298.498 -79.256)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-144",
    cx: 0.5,
    cy: 0.502,
    r: 0.394,
    gradientTransform: "matrix(0.929, 0.02, 0.014, -0.788, -65.086, 629.23)",
    xlinkHref: "#radial-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-216"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32063",
    "data-name": "Path 32063",
    d: "M299.253,85.555c-.3-.263-.514-.135-.511.108a.178.178,0,0,0-.029-.031,1.51,1.51,0,0,0-.2-.17,1,1,0,0,0-.415-.17.447.447,0,0,0-.515.376,1.138,1.138,0,0,0,.135.736,1.589,1.589,0,0,0,.491.584.787.787,0,0,0,.6.165.445.445,0,0,0,.331-.363.675.675,0,0,0,.014-.158.238.238,0,0,0,.087.049c.135.037.259.054.338-.018a.411.411,0,0,0,.08-.372.925.925,0,0,0-.146-.37,1.307,1.307,0,0,0-.255-.367",
    transform: "translate(-297.562 -85.285)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-145",
    cx: 0.502,
    cy: 0.5,
    r: 0.568,
    gradientTransform: "matrix(0.892, 0.02, 0.014, -0.788, -18.166, 118.429)",
    xlinkHref: "#radial-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-217"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32065",
    "data-name": "Path 32065",
    d: "M303.471,80.722c-.239.112.124.693.4.564.24-.114-.124-.693-.4-.564",
    transform: "translate(-303.393 -80.703)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-146",
    cx: 0.5,
    cy: 0.5,
    r: 0.396,
    gradientTransform: "matrix(0.924, 0.02, 0.014, -0.788, -32.508, 290.094)",
    xlinkHref: "#radial-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-218"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32067",
    "data-name": "Path 32067",
    d: "M305.157,82.5c-.208.1.105.6.344.488.209-.1-.105-.6-.344-.488",
    transform: "translate(-305.089 -82.487)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-147",
    cx: 0.5,
    cy: 0.5,
    r: 0.396,
    gradientTransform: "matrix(0.923, 0.02, 0.014, -0.788, -38.234, 330.757)",
    xlinkHref: "#radial-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-219"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32069",
    "data-name": "Path 32069",
    d: "M302.026,76.275c-.29.135.148.837.482.679.289-.136-.147-.838-.482-.679",
    transform: "translate(-301.932 -76.252)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-148",
    cx: 0.5,
    cy: 0.5,
    r: 0.394,
    gradientTransform: "matrix(0.928, 0.02, 0.014, -0.788, -25.544, 248.988)",
    xlinkHref: "#radial-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-220"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32071",
    "data-name": "Path 32071",
    d: "M311.093,76.1c-.339-.3-.687-.184-.785.057a.47.47,0,0,0-.035.158.708.708,0,0,0-.223.072c-.147.069-.194.3-.185.484a1.345,1.345,0,0,0,.253.667,1.328,1.328,0,0,0,.541.454.558.558,0,0,0,.515-.02c.147-.072.2-.3.185-.484a1.308,1.308,0,0,0-.252-.664,1.566,1.566,0,0,0-.19-.216c.061-.011.143.018.206,0,.146-.05.179-.318-.03-.5",
    transform: "translate(-309.863 -75.923)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-149",
    cx: 0.502,
    cy: 0.517,
    r: 0.47,
    gradientTransform: "matrix(1.45, 0.02, 0.022, -0.788, 102.527, 111.304)",
    xlinkHref: "#radial-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-221"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32073",
    "data-name": "Path 32073",
    d: "M311.021,81.591c-.163.076.081.467.269.38.161-.076-.084-.467-.269-.38",
    transform: "translate(-310.967 -81.578)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-150",
    cx: 0.5,
    cy: 0.5,
    r: 0.395,
    gradientTransform: "matrix(0.926, 0.02, 0.014, -0.788, -48.309, 427.062)",
    xlinkHref: "#radial-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-222"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32075",
    "data-name": "Path 32075",
    d: "M303.2,82.126c-.174.082.088.5.289.409.173-.079-.09-.5-.289-.409",
    transform: "translate(-303.141 -82.113)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-151",
    cx: 0.5,
    cy: 0.501,
    r: 0.395,
    gradientTransform: "matrix(0.926, 0.02, 0.014, -0.788, -43.524, 395)",
    xlinkHref: "#radial-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-223"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32077",
    "data-name": "Path 32077",
    d: "M300.195,83.443c-.543.255.28,1.566.9,1.274.541-.255-.278-1.567-.9-1.274",
    transform: "translate(-300.018 -83.401)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-152",
    cx: 0.5,
    cy: 0.5,
    r: 0.396,
    gradientTransform: "matrix(0.925, 0.02, 0.014, -0.788, -14.06, 125.437)",
    xlinkHref: "#radial-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-224"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32079",
    "data-name": "Path 32079",
    d: "M299.422,83.728c-.16.076.082.467.268.379.161-.075-.082-.464-.268-.379",
    transform: "translate(-299.369 -83.716)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-153",
    cx: 0.5,
    cy: 0.498,
    r: 0.396,
    gradientTransform: "matrix(0.927, 0.02, 0.014, -0.788, -45.977, 420.432)",
    xlinkHref: "#radial-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-225"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32081",
    "data-name": "Path 32081",
    d: "M300.091,81.9c-.17.08.087.49.282.4.171-.079-.086-.49-.282-.4",
    transform: "translate(-300.036 -81.89)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-154",
    cx: 0.5,
    cy: 0.5,
    r: 0.395,
    gradientTransform: "matrix(0.925, 0.02, 0.014, -0.788, -44.86, 405.37)",
    xlinkHref: "#radial-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-226"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32083",
    "data-name": "Path 32083",
    d: "M303.978,84.987c-.385.183.2,1.114.642.906.384-.18-.2-1.113-.642-.906",
    transform: "translate(-303.852 -84.957)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-155",
    cx: 0.5,
    cy: 0.5,
    r: 0.396,
    gradientTransform: "matrix(0.927, 0.02, 0.014, -0.788, -19.596, 174.037)",
    xlinkHref: "#radial-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-227"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32085",
    "data-name": "Path 32085",
    d: "M308.968,79.037l-.053.036c-.165.1-.047.52.243.639s.341-.223.178-.466c-.017-.026-.036-.053-.051-.076-.091-.134-.237-.183-.317-.133",
    transform: "translate(-308.84 -79.018)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-156",
    cx: 0.514,
    cy: 0.461,
    r: 0.443,
    gradientTransform: "matrix(1.11, 0.02, 0.017, -0.788, 49.407, 287.665)",
    xlinkHref: "#radial-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-228"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32087",
    "data-name": "Path 32087",
    d: "M308.422,73.012c-.145-.067-.18.06-.169.169,0,.018.02.087.026.1v0l0,.006a.514.514,0,0,0,.3.511c.2.085.324-.091.255-.281a.86.86,0,0,0-.413-.513",
    transform: "translate(-308.251 -72.993)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-157",
    cx: 0.479,
    cy: 0.493,
    r: 0.448,
    gradientTransform: "matrix(1.352, 0.02, 0.021, -0.788, 179.182, 274.829)",
    xlinkHref: "#radial-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-229"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32088",
    "data-name": "Path 32088",
    d: "M308.256,73.165l0-.014c0-.008,0-.008,0,.014",
    transform: "translate(-308.252 -73.146)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-158",
    cx: -37.269,
    cy: 540.554,
    r: 0.012,
    gradientTransform: "matrix(-0.002, 1, 0.181, 0.006, 0.411, -0.003)",
    xlinkHref: "#radial-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-230"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32090",
    "data-name": "Path 32090",
    d: "M308.442,71.65c-.157-.114-.232.012-.214.133a.529.529,0,0,0,.012.133c-.013-.068,0-.011,0,0a.441.441,0,0,0,.245.345c.143.059.218-.038.215-.154a.6.6,0,0,0-.257-.461",
    transform: "translate(-308.226 -71.606)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-159",
    cx: 0.513,
    cy: 0.518,
    r: 0.434,
    gradientTransform: "matrix(1.531, 0.02, 0.024, -0.788, 370.337, 335.953)",
    xlinkHref: "#radial-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-231"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32091",
    "data-name": "Path 32091",
    d: "M305.362,74.987h0c-.029,0-.029,0,0,0",
    transform: "translate(-305.343 -74.987)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-160",
    cx: -253.964,
    cy: 80.839,
    r: 0.002,
    gradientTransform: "matrix(-0.076, 1, 8.27, 0.006, -3.598, -0.003)",
    xlinkHref: "#radial-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-232"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32093",
    "data-name": "Path 32093",
    d: "M307.143,75.411a.693.693,0,0,0-.5-.037c-.013,0-.027,0-.044,0a1.022,1.022,0,0,0-.235.03.371.371,0,0,0-.165-.135.164.164,0,0,0-.129-.012c-.081-.12-.216-.214-.333-.161a.12.12,0,0,0-.028.027.371.371,0,0,0-.106-.068.207.207,0,0,0-.091-.019.292.292,0,0,1-.042,0,.166.166,0,0,0-.087.03c-.074-.2-.3-.422-.489-.332-.093.044-.1.159-.055.275-.1.169.147.555.387.569a2.067,2.067,0,0,1,.372.321.161.161,0,0,0,.2.055c.06-.041.05-.14,0-.229l.067.025a.818.818,0,0,0,.234.041.2.2,0,0,0-.093.061c-.018.02-.033.038-.053.057-.116.13.047.517.3.621a.221.221,0,0,0,.182.007,1.756,1.756,0,0,0,.588.729c.435.3.84.24,1.009-.033a1.234,1.234,0,0,0-.214-1.267,1.6,1.6,0,0,0-.666-.558",
    transform: "translate(-304.808 -74.717)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-161",
    cx: 0.497,
    cy: 0.495,
    r: 0.565,
    gradientTransform: "matrix(0.839, 0.02, 0.013, -0.788, -16.923, 85.36)",
    xlinkHref: "#radial-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-233"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32095",
    "data-name": "Path 32095",
    d: "M310.541,81.718a.242.242,0,0,0-.147-.066.27.27,0,0,0-.213.341.667.667,0,0,0,.11.247.2.2,0,0,0,.365-.031.4.4,0,0,0-.115-.491",
    transform: "translate(-310.174 -81.652)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-162",
    cx: 0.492,
    cy: 0.462,
    r: 0.467,
    gradientTransform: "matrix(1.256, 0.02, 0.019, -0.788, 149.396, 314.521)",
    xlinkHref: "#radial-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-234"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32097",
    "data-name": "Path 32097",
    d: "M308.83,83.05c-.195.022-.166.478.06.455.195-.022.165-.478-.06-.455",
    transform: "translate(-308.701 -83.049)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-163",
    cx: 0.5,
    cy: 0.5,
    r: 0.457,
    gradientTransform: "matrix(1.091, 0.02, 0.017, -0.788, 67.005, 470.778)",
    xlinkHref: "#radial-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-235"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32099",
    "data-name": "Path 32099",
    d: "M309.47,82.2c-.135-.131-.287,0-.329.159-.007.027-.016.056-.02.085a.355.355,0,0,0,.074.323.158.158,0,0,0,.239-.018c.02-.019.036-.038.054-.055a.4.4,0,0,0-.018-.494",
    transform: "translate(-309.111 -82.144)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-164",
    cx: 0.481,
    cy: 0.527,
    r: 0.429,
    gradientTransform: "matrix(1.488, 0.02, 0.023, -0.788, 334.601, 310.14)",
    xlinkHref: "#radial-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-236"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11130",
    "data-name": "Rectangle 11130",
    width: 25.324,
    height: 7.548,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-237"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32101",
    "data-name": "Path 32101",
    d: "M156.119,70.009a1.945,1.945,0,0,1,.919.023,19.755,19.755,0,0,0,2.541.252,7.565,7.565,0,0,1,4.154,1.174c1.44,1.076,2.409,2.506,4.667,2.494a16.98,16.98,0,0,1,4.979.418c.783.229,1.57.592,2.377.748a7.106,7.106,0,0,0,2.769-.232c.418-.084.831-.177,1.231-.249-4.14-1.061-8.253-2.293-12.247-3.639a22.144,22.144,0,0,1-3.014-1.183,20.276,20.276,0,0,0-2.627-1.257,19.09,19.09,0,0,0-3.505-.7c-.608-.087-1.218-.171-1.832-.222-.105.027-.21.057-.316.086a4.976,4.976,0,0,0-1.282.424,1.626,1.626,0,0,0-.486,1.184,4.639,4.639,0,0,0,.311,1.986,2.477,2.477,0,0,1,1.362-1.307",
    transform: "translate(-154.432 -67.636)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-165",
    cx: 1.615,
    cy: -1.552,
    r: 14.866,
    gradientTransform: "matrix(0.323, 0.02, 0.005, -0.788, -4.955, 32.308)",
    xlinkHref: "#radial-gradient-7"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-238"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11131",
    "data-name": "Rectangle 11131",
    width: 30.591,
    height: 4.459,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-239"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32103",
    "data-name": "Path 32103",
    d: "M180.67,74.535a.038.038,0,0,1-.007.049c.021.174.051.351.068.484a.473.473,0,0,1,.035.047,1.811,1.811,0,0,1,.14,1.163,3.086,3.086,0,0,1,1.981.043,6.025,6.025,0,0,0,3.516.056,3.4,3.4,0,0,1,3.846,1.092,2.592,2.592,0,0,0,1.575.9,7.193,7.193,0,0,1,1.114.3c.674-1.282,1.695-1.736,3.512-1.82a37.343,37.343,0,0,1,4.342-.086,5.011,5.011,0,0,1,2.064.673c2.364,1.134,4.76.12,7-.688.451-.163.907-.32,1.367-.463a23.67,23.67,0,0,0-3.076.031,70.131,70.131,0,0,1-9.494-.449c-3.371-.292-6.71-.583-10.1-.715-1.513-.059-3.1.011-4.6-.184-1.153-.152-2.175-.62-3.325-.758a2.543,2.543,0,0,0,.017.3c.007.008.011.017.017.025",
    transform: "translate(-180.636 -74.211)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-166",
    cx: -0.436,
    cy: 0.26,
    r: 12.009,
    gradientTransform: "matrix(0.169, 0.02, 0.003, -0.788, -5.898, 48.652)",
    xlinkHref: "#radial-gradient-7"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-240"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11132",
    "data-name": "Rectangle 11132",
    width: 53.017,
    height: 3.426,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-241"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32105",
    "data-name": "Path 32105",
    d: "M212.523,78.364a26.249,26.249,0,0,1,2.987-.99,3.342,3.342,0,0,1,2.77.277c.425.32.914,1.053,1.622.988a6.733,6.733,0,0,0,2.18-.768c2.51-1.135,5.2-.514,7.912-.839a17.768,17.768,0,0,1,4.516-.381,27.21,27.21,0,0,1,3.674,1.084,5.6,5.6,0,0,0,2.719.308c.6-.141,1.059-.442,1.625-.627a4.663,4.663,0,0,1,2.844.044c.761.22,1.507.5,2.291.672.673.146,1.36.163,2.042.272a20.93,20.93,0,0,0,3.782.645c1.4-.035,2.432-.688,3.738-.926,1.276-.235,2.606-.171,3.883-.448,1.2-.258,2.334-.643,3.533-.882-.938-.059-1.879-.122-2.825-.1-2.329.038-4.6.425-6.932.428-5.068.008-10.15.111-15.212-.172-2.757-.153-5.451-.8-8.232-.694-2.5.092-5,.074-7.508.036-2.339-.035-4.711.013-7.038-.214-1.318-.127-3.749-.875-4.9-.105-.031.043-.065.08-.091.123-.568.865-.116,1.637.013,2.514.2-.09.4-.166.606-.241",
    transform: "translate(-211.624 -75.625)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-167",
    cx: 0.354,
    cy: -4.321,
    r: 11.889,
    gradientTransform: "matrix(0.097, 0.02, 0.002, -0.788, -4.307, 48.5)",
    xlinkHref: "#radial-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-242"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11133",
    "data-name": "Rectangle 11133",
    width: 5.863,
    height: 1.027,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-243"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32107",
    "data-name": "Path 32107",
    d: "M292.521,77.158a7.193,7.193,0,0,0,1.8-.882,9.014,9.014,0,0,1-.979.063,12.626,12.626,0,0,1-2.1-.026,12.029,12.029,0,0,0-2.788.03c1.274.381,2.684,1.213,4.065.815",
    transform: "translate(-288.456 -76.235)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-168",
    cx: -9.725,
    cy: -18.319,
    r: 54.086,
    gradientTransform: "matrix(0.262, 0.02, 0.004, -0.788, -43.336, 160.808)",
    xlinkHref: "#radial-gradient-15"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-244"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11134",
    "data-name": "Rectangle 11134",
    width: 3.695,
    height: 0.397,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-245"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32109",
    "data-name": "Path 32109",
    d: "M285.515,76.6a8.334,8.334,0,0,0,1.4-.2h-.029c-1.219,0-2.444-.106-3.667-.192a7.63,7.63,0,0,0,2.3.393",
    transform: "translate(-283.218 -76.211)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-169",
    cx: -13.83,
    cy: -55.558,
    r: 163.318,
    gradientTransform: "matrix(0.139, 0.02, 0.002, -0.788, -79.129, 483.268)",
    xlinkHref: "#radial-gradient-15"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-246"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11135",
    "data-name": "Rectangle 11135",
    width: 22.095,
    height: 3.684,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-247"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32111",
    "data-name": "Path 32111",
    d: "M262.617,77.565a4.781,4.781,0,0,1,1.6,1.128,2.02,2.02,0,0,1,.284.366c-.041-.072.737-.024.552-.044a2.243,2.243,0,0,0,1.833-.3,3.33,3.33,0,0,1,1.045-.316,5.942,5.942,0,0,1,.918-.3,2.8,2.8,0,0,1,2.046.767,4.448,4.448,0,0,0,3.456.833,7.526,7.526,0,0,0,2.13-1.127,19.684,19.684,0,0,1,5.673-2.005c.507-.134,1.082-.313,1.669-.454-1.077.013-2.151.073-3.24.169a86.4,86.4,0,0,1-9.874.388c-1.744-.044-3.49.08-5.234.054-.7-.011-1.353-.149-2.039-.195-.165-.008-.318-.016-.47-.018a.217.217,0,0,1-.134.044c-.086,0-.172,0-.258.006a5.088,5.088,0,0,0-.845.238c0,.189,0,.375.011.563a2.057,2.057,0,0,1,.875.21",
    transform: "translate(-261.73 -76.106)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-170",
    cx: -1.149,
    cy: -6.34,
    r: 18.859,
    gradientTransform: "matrix(0.2, 0.02, 0.003, -0.788, -11.338, 56.017)",
    xlinkHref: "#radial-gradient-15"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-248"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11136",
    "data-name": "Rectangle 11136",
    width: 14.588,
    height: 9.239,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-249"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32113",
    "data-name": "Path 32113",
    d: "M296.88,77.782a7.139,7.139,0,0,0,.384,1.5,2.339,2.339,0,0,1,.826-1.458,9.307,9.307,0,0,1,2.322-1.129A4.475,4.475,0,0,0,302.3,75.46a3.6,3.6,0,0,1,.924-.938c1.239-.712,2.567.323,3.817-.218,2.056-.894,3.087-2.761,4.43-4.263-.1.033-.194.065-.287.1-2.353.8-4.57,1.725-6.792,2.73-1.545.7-3.082,1.471-4.684,2.093a10.407,10.407,0,0,1-2.255.684.262.262,0,0,1-.141.149.645.645,0,0,1-.075.029,4.656,4.656,0,0,1-.355,1.96",
    transform: "translate(-296.88 -70.041)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-171",
    cx: -3.123,
    cy: 0.224,
    r: 6.906,
    gradientTransform: "matrix(0.642, 0.02, 0.01, -0.788, -8.652, 27.673)",
    xlinkHref: "#radial-gradient-15"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-250"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11137",
    "data-name": "Rectangle 11137",
    width: 0.997,
    height: 15.982,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-251"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11138",
    "data-name": "Rectangle 11138",
    width: 9.154,
    height: 1.035,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-252"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11139",
    "data-name": "Rectangle 11139",
    width: 14.342,
    height: 0.952,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-253"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11140",
    "data-name": "Rectangle 11140",
    width: 14.5,
    height: 0.699,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-254"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32129",
    "data-name": "Path 32129",
    d: "M286.659,75.679a11.833,11.833,0,0,0-3.1.129c-1.229.151-2.453.09-3.69.153-1.207.062-2.409.157-3.62.192-1.3.037-2.595-.067-3.894-.08-.09,0-.137.137-.032.141,2.283.079,4.454.169,6.745.038,1.117-.062,2.235-.022,3.356-.079a32.826,32.826,0,0,1,4.141-.256c.171.013.3-.208.1-.239",
    transform: "translate(-272.262 -75.619)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-172",
    cx: 0.498,
    cy: 0.493,
    r: 4.265,
    gradientTransform: "matrix(0.082, 0.02, 0.001, -0.788, -20.496, 207.458)",
    xlinkHref: "#radial-gradient-15"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-255"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32131",
    "data-name": "Path 32131",
    d: "M311.206,69.552c-.96.363-1.91.731-2.822,1.169a19.968,19.968,0,0,1-3.033,1.466c-1.935.569-3.561,2.026-5.612,2.29-.08.011-.105.122-.011.111a6.686,6.686,0,0,0,2.176-.7c1.043-.494,2.062-1.011,3.172-1.414a24.062,24.062,0,0,0,2.819-1.2c1.1-.557,2.309-.954,3.4-1.52.111-.057.088-.215-.03-.215a.177.177,0,0,0-.061.012",
    transform: "translate(-299.667 -69.54)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-173",
    cx: 0.5,
    cy: 0.5,
    r: 0.882,
    gradientTransform: "matrix(0.446, 0.02, 0.007, -0.788, -16.743, 49.609)",
    xlinkHref: "#radial-gradient-15"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-257"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11142",
    "data-name": "Rectangle 11142",
    width: 24.82,
    height: 9.401,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-258"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32133",
    "data-name": "Path 32133",
    d: "M290.291,70.162c1.476.807,2.94,1.7,4.319,2.63a2.7,2.7,0,0,0,.931-.5,11.869,11.869,0,0,1,1.226-1.056,4.762,4.762,0,0,1,2.751-.65,11.1,11.1,0,0,0,3.742-.337c.674-.208.47-.431.57-.96s.436-1.158.284-1.693a6.634,6.634,0,0,1-.267-.821,1.637,1.637,0,0,1,.844-1.493c-.416-.109-.827-.222-1.238-.341-.392-.112-2.1-.564-3.837-1.122l-.02.01a4.822,4.822,0,0,1-2.568-.408,2.844,2.844,0,0,1-.747-.029.8.8,0,0,1-.258.051h-.01a5.9,5.9,0,0,1-1.622.1c-.923-.022-1.821.065-2.738.127-1.921.13-3.824.35-5.747.468-2.008.123-4.024.213-6.034.336,1.493.71,2.889,1.618,4.246,2.427,1.989,1.183,4.131,2.142,6.173,3.258",
    transform: "translate(-279.872 -63.392)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-174",
    cx: -4.305,
    cy: -0.779,
    r: 12.305,
    gradientTransform: "matrix(0.397, 0.02, 0.006, -0.788, -8.095, 27.794)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-259"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11143",
    "data-name": "Rectangle 11143",
    width: 29.966,
    height: 12.712,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-260"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32135",
    "data-name": "Path 32135",
    d: "M262.814,74.323a4.4,4.4,0,0,1,3.552,1.41,4.53,4.53,0,0,0,.876,1.027,3.94,3.94,0,0,0,2.467.24,11.113,11.113,0,0,0,3.964-1.365,7.96,7.96,0,0,1,2.922-1.009,16.552,16.552,0,0,1,3.614.517,28.655,28.655,0,0,0,3.48.253c1.358,0,3.117-.085,3.853-1.15.427-.617.736-1.413,1.621-1.716a6.674,6.674,0,0,1,3.087-.226c-.629-.449-1.248-.9-1.855-1.373-1.616-1.254-3.036-2.677-4.705-3.882-.745-.537-1.512-1.056-2.229-1.618-.461-.363-.911-.739-1.41-1.065-1.322.092-2.64.2-3.952.357-3.851.452-7.661,1.085-11.525,1.457-1.261.122-2.512.354-3.768.527-.044,2.273-.149,4.546-.4,6.812-.033.3-.075.6-.117.9a4.432,4.432,0,0,1,.531-.1",
    transform: "translate(-262.283 -64.368)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-175",
    cx: -2.867,
    cy: -0.657,
    r: 9.086,
    gradientTransform: "matrix(0.445, 0.02, 0.007, -0.788, -5.786, 20.385)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-261"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11144",
    "data-name": "Rectangle 11144",
    width: 56.651,
    height: 10.877,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-262"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32137",
    "data-name": "Path 32137",
    d: "M220.344,74.258c1.38.125,2.707.453,4.072.636a31.111,31.111,0,0,0,5.224.277,44.519,44.519,0,0,0,5.609-.551c1.613-.262,3.2-.647,4.821-.869a31.244,31.244,0,0,1,7.6-.012,64.308,64.308,0,0,0,7.022.467,28.183,28.183,0,0,0,3.652-.182,4.413,4.413,0,0,0,2.532-.862.278.278,0,0,1,.369-.033c1.662,1.225,3.218,3.008,5.791,2.811a5.3,5.3,0,0,0,1.539-.369c.4-1.466.919-2.9,1.346-4.367.431-1.483.658-2.985.954-4.485-.112.011-.227.023-.342.031a10.456,10.456,0,0,1-1.856.057l-.023.008-.017,0a.559.559,0,0,1-.275.053,8.568,8.568,0,0,1-1.523-.084c-1.015-.048-2.029-.048-3.045-.029-1.716.029-3.425.039-5.14-.006-3.872-.1-7.737-.33-11.6-.531s-7.73-.155-11.588-.362c-1.715-.092-3.418-.267-5.129-.384a21.708,21.708,0,0,1-3.272-.4.715.715,0,0,1-1.005.41c.293.172.06.063-.186.057-.307-.011-.614-.014-.921-.017-.68-.007-1.36-.007-2.04-.007-.289,0-.576,0-.865,0-.667,1.03-1.684,1.916-2.463,2.895-1.092,1.371-2.117,2.774-3.159,4.168-.7.938-1.414,1.876-2.2,2.775,1.99-.459,4.008-1.3,6.124-1.1",
    transform: "translate(-214.22 -65.08)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-176",
    cx: -0.525,
    cy: -0.758,
    r: 9.898,
    gradientTransform: "matrix(0.218, 0.02, 0.003, -0.788, -3.546, 22.001)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-263"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11145",
    "data-name": "Rectangle 11145",
    width: 42.439,
    height: 11.806,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-264"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32139",
    "data-name": "Path 32139",
    d: "M184.415,73.431a18.053,18.053,0,0,1,5.981-.887c2.371.129,4.5,1.01,6.793,1.416a26.4,26.4,0,0,0,7.4.238c2.671-.281,5.07-.765,7.669.051,1.236.386,2.439.794,3.719,1.084.136.033.274.065.414.1a2.76,2.76,0,0,1,.239-.312c.519-.6,1.076-1.169,1.661-1.726,2.627-2.487,5.41-4.948,7.77-7.6q-1.172-.011-2.344-.025c-2.546-.031-5.09-.121-7.62-.357-2.634-.246-5.2-.724-7.81-1.062-1.352-.174-2.709-.324-4.076-.4-1.218-.071-2.464-.02-3.667-.194-.25-.035-.513-.082-.78-.123a9.115,9.115,0,0,1-2.016,1.249c-1.315.778-2.5,1.6-3.753,2.427-1,.655-2.131,1.132-3.187,1.716a37.286,37.286,0,0,0-3.388,2.162c-1.076.749-2.277,1.377-3.351,2.127q-.224.161-.447.325a7.964,7.964,0,0,0,.795-.2",
    transform: "translate(-183.62 -63.624)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-177",
    cx: 0.154,
    cy: -0.612,
    r: 9.589,
    gradientTransform: "matrix(0.299, 0.02, 0.005, -0.788, -3.636, 21.545)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-265"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11146",
    "data-name": "Rectangle 11146",
    width: 35.544,
    height: 12.557,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-266"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32141",
    "data-name": "Path 32141",
    d: "M167.558,65.6c2.341.061,4.662-.194,7-.306a.215.215,0,0,1,.232.188c-.026.52-.105,1.036-.125,1.556-.01.25-.114.678.157.865a5.578,5.578,0,0,0,1.478.633c1.223.4,2.143.991,1.655,2.148-.232.547-1.041,1.459-.762,2.051a2.547,2.547,0,0,0,1.686,1.1,16.033,16.033,0,0,0,4.522.459c.779-.489,1.465-1.052,2.224-1.563,1.708-1.15,3.559-2.146,5.319-3.243a109.173,109.173,0,0,1,10.82-5.58h-.012c-.621.074-1.243.147-1.868.192-1.169.086-2.332.057-3.5.042a43.291,43.291,0,0,1-7.546-.618,31.3,31.3,0,0,1-3.259-.77,12.063,12.063,0,0,1-1.821-.609c-.081-.041-.159-.082-.237-.122-.7-.082-1.395-.232-2.1-.274a7.239,7.239,0,0,0-2.688.431c-1.464.46-2.9.964-4.353,1.445a41.947,41.947,0,0,1-4.256,1.229c-1.287.282-2.605.424-3.907.645.445.048.892.085,1.342.1",
    transform: "translate(-166.216 -61.747)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-178",
    cx: 0.761,
    cy: -0.418,
    r: 9.119,
    gradientTransform: "matrix(0.374, 0.02, 0.006, -0.788, -3.511, 20.806)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-267"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32143",
    "data-name": "Path 32143",
    d: "M260.747,0a6.267,6.267,0,0,0-2.905,1.434,29.888,29.888,0,0,0-4.586,4.957c-.308.4-.625.828-.93,1.275-.011-.055-.02-.11-.033-.164-.129-.549-.587-2.568-1.752-2.35A1.541,1.541,0,0,0,249.454,6.2c-.361.785-.614,1.6-.993,2.382a22.422,22.422,0,0,0-1.01,2.432,9.587,9.587,0,0,0-2.109-4.092c-.636-.712-2.066-1.915-3.349-1.912-.008-.019-.019-.039-.03-.059-.446-.777-1.754-2.739-3.2-2.328-1.633.464-1.012,2.945-.933,3.918.026.324.067.645.111.967a8.1,8.1,0,0,0-2.428-2.177c-1.1-.539-1.689.215-1.866,1.019a17.156,17.156,0,0,0-.071,2.88c-.027.667-.075,1.33-.12,1.995A15.055,15.055,0,0,0,230.5,7.664a3.609,3.609,0,0,0-2.183-.956,1.528,1.528,0,0,0-1.163-.549c-.478,0-.712.368-.834.743-.832-.752-1.719-.992-2.552-.081a7.9,7.9,0,0,0-1.622,3.209,30.038,30.038,0,0,0-2.456-2.8c-.637-.662-1.454-1.87-2.709-1.824a2.775,2.775,0,0,0-2.127,1.331,15.237,15.237,0,0,0-2.37,5.917c-.025.115-.048.229-.069.344a1.708,1.708,0,0,0-2.3-.173,1.511,1.511,0,0,0-.146.145c-.4-.552-.844-1.088-1.243-1.617a3.328,3.328,0,0,0-2.762-1.517,2.581,2.581,0,0,0-2.094.966,5.159,5.159,0,0,0-.927,2.242c-.134.528-.259,1.058-.369,1.588-.851-.821-1.728-1.242-2.362-.342a2.947,2.947,0,0,0-.454,1.278,21.09,21.09,0,0,0-1.791-1.478c-.815-.62-2.354-1.873-3.615-1.764a.483.483,0,0,0-.49.5,6.442,6.442,0,0,0,.188.973c-.292-.195-.6-.38-.915-.558a.593.593,0,0,0-.825.241,6.35,6.35,0,0,0-.079,2.242c-.016.491-.048.982-.085,1.472a6.084,6.084,0,0,0-1.219-.813.6.6,0,0,0-.733.3,8.335,8.335,0,0,0-.123,2.636c0,.145-.01.287-.016.431a12.062,12.062,0,0,0-1.2-1.548c-.919-.988-1.973-2.361-3.465-2.843a.775.775,0,0,0-.929.374,8.871,8.871,0,0,0-.263,3.347,17.456,17.456,0,0,0,.1,1.921,14.34,14.34,0,0,0-1.668-1.42,7.6,7.6,0,0,0-3.738-1.906c-.342-.029-.69.184-.7.462a6.507,6.507,0,0,0,.344,1.646c.158.765.326,1.53.523,2.289a17.089,17.089,0,0,0,.537,1.735,10.951,10.951,0,0,0-2.058-.5.606.606,0,0,0-.692.455,5.474,5.474,0,0,0,1.025,2.64,12.669,12.669,0,0,0-2.949-.9c-.661-.117-5.422-1-4.951.558.466,1.539,1.934,2.984,3.249,4.176a1.9,1.9,0,0,0-1.478.563c-.43.582.441,1.243.893,1.623.278.237.568.494.875.743a7.151,7.151,0,0,0-2.028.038,23.142,23.142,0,0,0-5.023-1,13.4,13.4,0,0,0-4.62-.082,1.661,1.661,0,0,0-1.135,2.448,11.088,11.088,0,0,0,2.659,3.155,13.68,13.68,0,0,0-1.807-.108.648.648,0,0,0-.549.362c-.582,1.151.829,2.4,1.711,3.2.272.247.547.5.827.741a31.045,31.045,0,0,0-5.652,1.034,19.282,19.282,0,0,0-5.211,2.113c-.84.506-2.29,1.538-1.685,2.5.7,1.109,2.767,1.654,4.148,2a38.015,38.015,0,0,0,4.626.759,7.968,7.968,0,0,0-1.665,1.41c-.294.375-.393.7-.091,1.095a1.335,1.335,0,0,0,.87.4,10.244,10.244,0,0,0-2.651,1.023c-1.971,1.128,1.973,2.468,2.926,2.746,1.46.429,2.988.807,4.534,1.114-1.094.537-2.685,1.593-2.428,2.624.292,1.165,2.6,1.126,3.733,1.312.992.165,2.009.349,3.033.478-.445.2-.884.4-1.313.63a10.569,10.569,0,0,0-4.623,4.442.284.284,0,0,0,.094.349c1.551.949,4.226-.091,5.814-.513.662-.177,1.327-.35,1.989-.523a19.738,19.738,0,0,0-1.56,5.352c-.09.666-.312,2.015.531,2.469.7.378,1.63-.05,2.241-.345a17.916,17.916,0,0,0,2.4-1.5c.925-.641,1.944-1.2,2.914-1.8a25.825,25.825,0,0,0,2.33-1.572,5.357,5.357,0,0,0,1.585,3.816,2.718,2.718,0,0,0,3.583.061c-.319.931-.541,2.06.149,2.623.9.733,2.748-.321,3.5-.705.5-.257.374.153.259.561s-.216.808.319.571c-.863,1.692,1.086.7.794,2.526-.032.195.2.368.443.337a24.175,24.175,0,0,0,5.046-1.438c1.184-.416,2.59-.641,3.812-1.061-.392.654-.743,1.322-1.06,1.986-.387.814-.67,1.655-1.005,2.482-.21.52-.581,1.281-.357,1.834.214.526.947.592,1.549.543a11.965,11.965,0,0,0,3.11-.854c1.319-.494,2.593-1.065,3.846-1.653.495-.231.985-.47,1.471-.711a6.162,6.162,0,0,0,3.858,3.724.631.631,0,0,0,.762-.306,13.056,13.056,0,0,1,1.812-3.13c.889.823,1.5,1.886,2.376,2.721a7.594,7.594,0,0,0,3.828,2.079l.028,0c.036.1.075.2.117.3.247.589.143,1.207.455,1.776.149.277.629.188.834.024a37.743,37.743,0,0,0,4.074-3.839c.479-.514.975-1.036,1.447-1.573.026.037.045.074.07.111a5.648,5.648,0,0,0,2.645,2.573.549.549,0,0,0,.6-.174,17.27,17.27,0,0,0,1.405-2.553c.057.106.117.213.178.318a8.113,8.113,0,0,0,2.471,2.375,10.68,10.68,0,0,0,2.687,1.852.751.751,0,0,0,.81-.24,7.652,7.652,0,0,0,1.336-4.214,19.55,19.55,0,0,0,3.546,2.418,30.051,30.051,0,0,0,3.76,1.7,15.265,15.265,0,0,0,4.578,1.286.593.593,0,0,0,.664-.437,9.4,9.4,0,0,0-.734-4.151c.782.292,1.588.541,2.4.773.918.258,1.857.513,2.8.715a12.427,12.427,0,0,1,3.3.828c.27.147.71-.134.693-.361a4.334,4.334,0,0,0-.85-2.059c2.939,1.331,5.943,2.6,9.434,2.583.247,0,.512-.221.508-.416a6.478,6.478,0,0,0-.171-1.288,28.471,28.471,0,0,0,4.229.748.625.625,0,0,0,.647-.338,4.19,4.19,0,0,0,0-1.8c.214.117.429.234.648.349a33.185,33.185,0,0,0,6.759,2.317.637.637,0,0,0,.77-.308,5.6,5.6,0,0,0,.074-2.557,15.314,15.314,0,0,0,5.861,1.866.656.656,0,0,0,.742-.488c.094-.773.137-1.551.18-2.328.488.18.981.341,1.462.5a38.383,38.383,0,0,0,5.968,1.932.611.611,0,0,0,.694-.458,4.576,4.576,0,0,0-1.533-3.178c2.725.4,5.232,1.6,7.888,2.212.3.068.693-.21.675-.446a5.858,5.858,0,0,0-.648-2.218c.369.2.745.394,1.122.6.945.507,1.958.917,2.878,1.457a6.6,6.6,0,0,0,1.084.559c.016.149.029.3.045.447.036.318.531.324.794.2,1.972-.89,2.437-2.7,2.767-4.406,1.068,1.518,2.8,3.075,4.9,2.286a2.587,2.587,0,0,0,1.655-2.284,10.83,10.83,0,0,0,4.652,1.857.6.6,0,0,0,.676-.445,4.46,4.46,0,0,0-.4-2.467c2.263,1.39,5.256,2.8,5.721.746.208-.911-1.117-1.949-1.811-2.54l-.073-.06a14.675,14.675,0,0,0,6,.229c1.3-.226,3.762-1.172,3.1-2.269a.244.244,0,0,0-.06-.239c-.109-.142-.225-.278-.343-.414a6.9,6.9,0,0,0,2.161-.556c1.319-.627,1.135-1.5.362-2.367a13.369,13.369,0,0,0,2.223-.317c.921-.214.981-.841.833-1.513-.207-.925-1.335-1.653-2.426-2.238,1.622.048,3.267-.043,4.913-.1.3-.01.643-.27.626-.513-.161-2.079-3.575-2.872-5.654-3.386-.317-.079-.633-.152-.949-.221a6.527,6.527,0,0,1,2.421-.722c.318-.027.688-.362.476-.619-.831-1-2.557-1.225-3.963-1.3-1.518-.079-2.991-.183-4.486-.219,1.04-.461,2.079-.923,3.159-1.325a13.927,13.927,0,0,1,4.911-1.226.4.4,0,0,0,.408-.314h.022a.072.072,0,0,0,.023,0c.251-.014.428-.314.171-.425-.912-.4-1.666-.98-2.609-1.356a9.62,9.62,0,0,0-3.192-.654c-.2-.007-.391-.008-.586-.011.513-.393.988-.783,1.411-1.129.233-.189.288-.558-.062-.69a8.8,8.8,0,0,0-3.769-.33c1.065-.755,2.057-1.587,3.033-2.365,1.936-1.544,3.879-3.4,6.388-4.376.325-.125.7-.617.191-.788a10.634,10.634,0,0,0-4.86.008,19.915,19.915,0,0,0-3.045.7c-.134.041-.581.173-1.146.355.151-.405.271-.817.392-1.209.339-1.1,1.07-2.606.225-3.655a.625.625,0,0,0-.673-.174,6,6,0,0,0-1.35.664c.044-.408.075-.819.091-1.23.029-.684-.057-2.314-1.3-2.381a1.541,1.541,0,0,0-.289.012,14.564,14.564,0,0,0,.062-2.794c-.1-1.286-.28-2.886-1.6-3.787a.674.674,0,0,0-.681-.017,4.513,4.513,0,0,0-1.519,1.592,7.15,7.15,0,0,0-1.459-3.614.694.694,0,0,0-1.021.084,22.355,22.355,0,0,0-2.088,2.957c-.141.207-.284.4-.435.59a4.049,4.049,0,0,0-.768-1.067c-.025-.025-.053-.054-.08-.084a11.993,11.993,0,0,0,.17-4.3c-.039-.231-.365-.3-.608-.24a21.033,21.033,0,0,0-3.6,1.119,3.651,3.651,0,0,0,.085-2.5.324.324,0,0,0-.345-.19,7.747,7.747,0,0,0-.952.088,10.656,10.656,0,0,0,1.089-4.037.371.371,0,0,0-.526-.294,18.484,18.484,0,0,0-2.5,1.116,2.4,2.4,0,0,0,.155-1.883c-.641-1.143-1.844-.023-2.739,1.089-.01-.22-.024-.437-.039-.641-.048-.619-.135-1.8-.973-2.137a1.3,1.3,0,0,0-1.146.109,14.93,14.93,0,0,0-2.017,1.36,2.012,2.012,0,0,0-.559-1.622,1.479,1.479,0,0,0-1.042-.343c.177-1.013.326-2.622-.5-3.4-.613-.578-1.543-.222-2.379.3.033-.063.068-.127.1-.191.7-1.373,1.713-3.6.758-5.037-1.036-1.556-4.074-.348-5.953.538a9.011,9.011,0,0,0,.623-1.726,2.225,2.225,0,0,0-.135-1.925c-.482-.594-1.448-.221-2.017.041a11.892,11.892,0,0,0-2.716,1.974c-.415.36-.835.716-1.256,1.073,0-.076-.006-.152-.016-.225-.118-.964-1.225-.912-2-.4a10.892,10.892,0,0,0-2.265,2.255c-.336.4-.707.776-1.061,1.163a11.465,11.465,0,0,0-1.879-6.165c-.638-.96-1.478-2.388-2.905-2.715a1.514,1.514,0,0,0-1.56.853,7.577,7.577,0,0,0-.229,3.218c0,1.017.018,2.041.066,3.058q-.186-.212-.4-.419c-.686-.68-2.243-1.995-3.541-1.617a1.987,1.987,0,0,0-.641.311c-.121-.351-.256-.7-.415-1.052a13.54,13.54,0,0,0-4.141-4.858,2.641,2.641,0,0,0-1.717-.746c-.871.067-1.384,1.335-1.7,1.821a22.281,22.281,0,0,0-1.634,2.807,11.549,11.549,0,0,0-.082-1.231c-.059-.465-.042-2.008-1.122-1.793a2.45,2.45,0,0,0-1.438,1.016q.1-.864.147-1.729A5.84,5.84,0,0,0,261.606.62a.821.821,0,0,0-.851-.62Z",
    transform: "translate(-150.845)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-179",
    cx: 0.271,
    cy: -0.957,
    r: 2.293,
    gradientTransform: "matrix(0.471, 0.02, 0.007, -0.788, -0.498, 4.495)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e7c85a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.065,
    stopColor: "#d9c85a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.186,
    stopColor: "#b7c85a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.302,
    stopColor: "#90c95a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.509,
    stopColor: "#8fc554"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.711,
    stopColor: "#8dbf49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882,
    stopColor: "#3f8c1e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#086800"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-269"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11148",
    "data-name": "Rectangle 11148",
    width: 175.278,
    height: 61.655,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-270"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32145",
    "data-name": "Path 32145",
    d: "M295.3,75.961c-.269-.109-.026-.425.243-.317a37.123,37.123,0,0,0,6.341,2.038.187.187,0,0,0,.008-.067,5.858,5.858,0,0,0-.648-2.218c.369.2.745.394,1.121.6.945.507,1.959.917,2.879,1.456a6.522,6.522,0,0,0,1.084.56c0,.024,0,.048.008.073a11.145,11.145,0,0,0,2.082-.282,6.572,6.572,0,0,0,1.514-3.546,7.376,7.376,0,0,0,1.778,1.828c.539-.535.746-1.141-.154-1.652-.111-.062-.17-.213-.041-.292,1.086-.664,2.058-1.679,1.187-2.756-.134-.166.131-.333.325-.25,1.834.783,3.958-.741,3.071-1.987a2.914,2.914,0,0,1-.709-.609c-.124-.152.137-.361.325-.25a2.49,2.49,0,0,1,.721.6c1.993,1.189,5.978.218,7.873-.49a5.393,5.393,0,0,0,2.488-1.9,2.258,2.258,0,0,0,.63-1.4c-.072-.668-1.022-.643-1.668-.606a.182.182,0,0,1-.11-.345,14.184,14.184,0,0,0,3.934-2.041c.694-.658.936-1.824-.208-2.324a3.932,3.932,0,0,0-2.819-.027c-.145.05-.37-.012-.35-.165.344-2.557-5.307-.445-5.989.9-.066.128-.345.2-.429.038-.758-1.471-3.037-.758-4.352-.217-.185.076-.4-.053-.342-.213a3.188,3.188,0,0,0-2.9-4.41c-.188-.022-.276-.142-.2-.281,1.036-1.834,1.976-5.471-1.885-5.389-.247,0-.3-.252-.111-.347,2.232-1.143,1.934-3.437.359-4.9a3.238,3.238,0,0,0-2.32-1.052c-1.237.114-1.562,1.362-1.7,2.146-.042.229-.48.241-.471,0,.079-1.857-2.171-2.6-4.155-2.867a.177.177,0,0,1-.136-.275c1.039-1.209,2.271-2.916,1.809-4.443-.54-1.791-3.026-1.981-4.992-1.883a.185.185,0,1,1-.055-.365c1.011-.243,2.3-.792,2.053-1.794a2.83,2.83,0,0,0-1.291-1.578c-.3.238-.606.465-.918.684-.227.159-.555-.106-.329-.265.28-.2.577-.408.869-.633-2.013-1.047-4.366-.811-5.621.915-.149.207-.553.014-.4-.192a4.909,4.909,0,0,1,6.366-1,3.661,3.661,0,0,0,1.643-2.617,2.313,2.313,0,0,0-2.411-2.285c-2.249-.082-5.072,1.243-5.4,3.114-.035.194-.4.264-.463.044a4.3,4.3,0,0,0-6.033-2.843c-.188.08-.388-.056-.341-.214a2.2,2.2,0,0,0-.9-2.782,2.883,2.883,0,0,0-3.206.84c-.109.1-.365.044-.391-.087-.235-1.2-1.245-3.624-3.271-3.462-2.659.213-1.971,2.512-2.279,3.971-.032.152-.354.18-.43.038-.973-1.864-4.534-2.266-4.685.195-.01.184-.315.247-.439.088-1.928-2.535-6.367-1.762-7.552.884-1.094,2.433.433,5,1.806,7.153.139.219-.234.373-.41.183-.759-.831-2.013-.918-2.5.154a.266.266,0,0,1-.393.078c-.588-.43-1.714-.839-2.261-.054-.3.423-.079.877.176,1.269a10.665,10.665,0,0,0,1.337,1.624c.183.188-.153.447-.336.258-.023-.022-.044-.043-.066-.066a.2.2,0,0,1-.079-.051c-.411-.41-1.354-.326-1.906-.177a2,2,0,0,0-1.666,1.5c-.024.147-.186.218-.357.155-.784-.283-2.846-1.005-3.259.06a3.652,3.652,0,0,0,.479,2.694c.067.145-.188.3-.348.2-.733-.459-1.425-.954-2.189-1.38a6.126,6.126,0,0,0-1.561-.705c-.8-.183-.547.515-.412.9.067.2-.317.33-.435.137a7.547,7.547,0,0,0-1.286-1.9c-.863-.759-1.691.062-2.267.63a.258.258,0,0,1-.388-.085c-.441-1.8-1.046-4.176-4.023-4.209-2.612-.029-2.971,2.291-2.243,3.8.06.128-.135.275-.294.225-.952-.3-2.133-.391-2.667.458a.24.24,0,0,1-.2.09c-1.568-.1.641,2.278.988,2.665.753.838,1.673,1.624,2.329,2.512.136.183-.189.372-.374.219a1.039,1.039,0,0,0-1.67.191A2.167,2.167,0,0,0,236.1,46.9a1.463,1.463,0,0,1-.488,1c-.445.436-2.125.244-2.742.36a.245.245,0,0,1-.287-.133c-.308-1.2-1.049-2.85-2.7-3.288-1.791-.478-3.132.656-4.01,1.752a.263.263,0,0,1-.428-.049c-.846-2.243-4.332-4.21-7.006-2.267-1.907,1.386-2.774,3.474-3.567,5.365-.084.2-.452.154-.459-.055-.048-1.637-.59-3.913-2.5-4.883-2.206-1.121-3.964.717-4.9,2.12a.273.273,0,0,1-.323.063c-1.554-.857-2.572-2.492-4.449-2.979-2.546-.658-1.684,2.908-1.512,3.965a.236.236,0,0,1-.4.174,8.647,8.647,0,0,0-3.9-2.007,7.7,7.7,0,0,0-4.711.894.282.282,0,0,1-.283-.032,7.857,7.857,0,0,0-3.687-1.582c-1.941-.253-2.655.773-2.5,2.182.018.163-.275.24-.4.127a18.07,18.07,0,0,0-4.705-3.384c-1.037-.447-2.652-.974-3.653-.165-1.654,1.339-1.027,3.876-.227,5.408.092.179-.1.329-.327.25-.686-.24-1.868-.692-2.425-.037a7.382,7.382,0,0,0-.915,1.615.251.251,0,0,1-.461-.055,6.555,6.555,0,0,0-1.77-3.083c-.739-.839-2.317-2.333-2.959-.612a.265.265,0,0,1-.393.076c-.839-.641-4.465-2.082-3.846-.111.05.163-.17.282-.349.206a9.5,9.5,0,0,0-5.013-.776,4.114,4.114,0,0,0-.492.514c-.294.375-.393.7-.092,1.095a1.349,1.349,0,0,0,.87.4,10.212,10.212,0,0,0-2.65,1.024c-1.97,1.127,1.973,2.467,2.926,2.745,1.46.429,2.988.807,4.535,1.113-1.095.537-2.687,1.6-2.43,2.626.292,1.165,2.6,1.126,3.735,1.313.991.164,2.008.348,3.032.477-.446.2-.884.4-1.312.629A10.575,10.575,0,0,0,161.3,63.34a.282.282,0,0,0,.094.349c1.551.949,4.227-.092,5.814-.514q.993-.264,1.989-.522A19.75,19.75,0,0,0,167.636,68c-.09.666-.312,2.014.529,2.469.7.378,1.631-.05,2.242-.344a17.922,17.922,0,0,0,2.4-1.5c.925-.642,1.944-1.2,2.914-1.8a26.354,26.354,0,0,0,2.33-1.573,5.355,5.355,0,0,0,1.585,3.816,2.718,2.718,0,0,0,3.583.061c-.319.932-.541,2.06.149,2.623.9.733,2.748-.321,3.5-.706,1-.509-.5,1.609.578,1.134-.864,1.691,1.085.7.792,2.526-.031.194.2.367.445.336a24.125,24.125,0,0,0,5.046-1.439c1.184-.416,2.59-.638,3.812-1.061-.392.655-.743,1.322-1.059,1.987-.388.814-.672,1.655-1.006,2.482-.212.52-.581,1.281-.357,1.833.214.527.947.593,1.549.544a11.92,11.92,0,0,0,3.11-.856c1.319-.492,2.592-1.062,3.846-1.65.495-.232.984-.471,1.471-.712a6.162,6.162,0,0,0,3.858,3.724.63.63,0,0,0,.762-.307,13.1,13.1,0,0,1,1.812-3.13c.889.825,1.5,1.887,2.376,2.722a7.594,7.594,0,0,0,3.828,2.079l.028,0c.036.1.075.2.117.3.246.589.143,1.207.455,1.777.149.275.627.186.833.023a37.526,37.526,0,0,0,4.074-3.839c.48-.514.976-1.037,1.448-1.573.026.037.045.074.07.111a5.648,5.648,0,0,0,2.645,2.573.552.552,0,0,0,.6-.174,17.27,17.27,0,0,0,1.405-2.553c.057.108.116.213.178.318a8.1,8.1,0,0,0,2.471,2.375,10.694,10.694,0,0,0,2.685,1.852.753.753,0,0,0,.811-.24,7.633,7.633,0,0,0,1.336-4.214,19.615,19.615,0,0,0,3.546,2.419,30.655,30.655,0,0,0,3.76,1.695,15.265,15.265,0,0,0,4.578,1.286.593.593,0,0,0,.664-.439,9.369,9.369,0,0,0-.735-4.148c.782.29,1.589.54,2.4.771.917.259,1.857.514,2.8.716a12.407,12.407,0,0,1,3.3.828c.271.147.711-.134.694-.361a4.329,4.329,0,0,0-.85-2.059c2.939,1.331,5.943,2.6,9.434,2.583.247,0,.513-.222.508-.417a6.5,6.5,0,0,0-.171-1.288,28.513,28.513,0,0,0,4.228.749A.623.623,0,0,0,271.7,80a4.2,4.2,0,0,0,0-1.8c.214.117.43.234.648.349a33.3,33.3,0,0,0,6.758,2.318.641.641,0,0,0,.771-.31,5.583,5.583,0,0,0,.074-2.557,15.328,15.328,0,0,0,5.861,1.866.656.656,0,0,0,.742-.489c.094-.772.136-1.55.18-2.327.488.18.982.339,1.462.5a38.253,38.253,0,0,0,5.968,1.931.611.611,0,0,0,.694-.457,4.582,4.582,0,0,0-1.533-3.178c2.725.4,5.232,1.6,7.888,2.212A.575.575,0,0,0,301.6,78a38.187,38.187,0,0,1-6.295-2.035",
    transform: "translate(-154.893 -21.869)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-180",
    cx: 0.512,
    cy: -0.233,
    r: 1.784,
    gradientTransform: "matrix(0.369, 0.02, 0.006, -0.788, -0.659, 5.574)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e7c85a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.065,
    stopColor: "#d9c85a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.186,
    stopColor: "#b7c85a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.302,
    stopColor: "#90c95a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.509,
    stopColor: "#8fc554"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.711,
    stopColor: "#8dbf49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.844,
    stopColor: "#518428"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "#083d00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#083d00"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-271"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32147",
    "data-name": "Path 32147",
    d: "M281.647,69.235v.007c.036.318.531.324.794.2a4.227,4.227,0,0,0,.623-.345,13.708,13.708,0,0,1-1.416.134",
    transform: "translate(-281.647 -69.101)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-181",
    cx: -73.336,
    cy: -346.862,
    r: 424.542,
    gradientTransform: "matrix(0.348, 0.02, 0.005, -0.788, -154.555, 530.774)",
    xlinkHref: "#radial-gradient-179"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-273"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11150",
    "data-name": "Rectangle 11150",
    width: 122.732,
    height: 50.44,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-274"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11151",
    "data-name": "Rectangle 11151",
    width: 182.206,
    height: 84.755,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-275"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32150",
    "data-name": "Path 32150",
    d: "M336.087,61.44c-.318-.079-.633-.152-.95-.221a6.54,6.54,0,0,1,2.422-.722c.318-.027.69-.362.476-.619-.831-1-2.557-1.225-3.963-1.3-1.518-.078-2.991-.183-4.486-.218,1.04-.461,2.079-.924,3.159-1.325a13.927,13.927,0,0,1,4.911-1.226.394.394,0,0,0,.406-.314c.016,0,.03,0,.045,0,.251-.014.428-.316.171-.427-.912-.394-1.666-.979-2.609-1.355a9.62,9.62,0,0,0-3.192-.654c-.2-.007-.391-.01-.587-.011.514-.393.988-.784,1.413-1.129.232-.189.288-.558-.062-.69a8.8,8.8,0,0,0-3.769-.33c1.065-.755,2.058-1.587,3.033-2.365,1.936-1.544,3.879-3.4,6.388-4.376.325-.125.7-.618.191-.788a10.634,10.634,0,0,0-4.86.008,19.915,19.915,0,0,0-3.045.7c-.134.041-.582.173-1.145.355.151-.405.27-.817.391-1.209.339-1.1,1.07-2.606.225-3.655a.625.625,0,0,0-.673-.174,5.948,5.948,0,0,0-1.35.666c.044-.409.075-.82.091-1.231.029-.684-.057-2.314-1.3-2.381a1.541,1.541,0,0,0-.289.012,14.664,14.664,0,0,0,.063-2.794c-.105-1.286-.281-2.886-1.6-3.787a.674.674,0,0,0-.681-.017,4.506,4.506,0,0,0-1.519,1.593,7.15,7.15,0,0,0-1.459-3.615.694.694,0,0,0-1.021.084,22.242,22.242,0,0,0-2.088,2.957c-.14.207-.286.4-.436.59a4,4,0,0,0-.767-1.067l-.081-.084a11.966,11.966,0,0,0,.171-4.3c-.039-.231-.366-.3-.608-.24a20.848,20.848,0,0,0-3.6,1.119,3.657,3.657,0,0,0,.084-2.5.323.323,0,0,0-.344-.19,7.723,7.723,0,0,0-.954.088,10.656,10.656,0,0,0,1.089-4.037.372.372,0,0,0-.526-.294,18.341,18.341,0,0,0-2.5,1.117,2.4,2.4,0,0,0,.155-1.885c-.639-1.144-1.844-.024-2.739,1.09-.01-.222-.025-.439-.039-.643-.048-.618-.136-1.8-.973-2.134a1.3,1.3,0,0,0-1.146.108,14.82,14.82,0,0,0-2.017,1.36,2.012,2.012,0,0,0-.559-1.623,1.486,1.486,0,0,0-1.041-.342c.176-1.013.325-2.622-.5-3.4-.613-.578-1.543-.222-2.379.3l.1-.191c.7-1.373,1.713-3.6.758-5.037-1.036-1.556-4.074-.348-5.953.538a8.929,8.929,0,0,0,.621-1.726,2.215,2.215,0,0,0-.134-1.924c-.482-.6-1.448-.223-2.017.038a11.932,11.932,0,0,0-2.716,1.975c-.415.36-.835.717-1.256,1.073,0-.075-.006-.151-.016-.225-.118-.964-1.226-.912-2-.4a10.863,10.863,0,0,0-2.265,2.255c-.336.4-.707.774-1.061,1.162A11.454,11.454,0,0,0,281.3,5.283c-.639-.96-1.478-2.388-2.9-2.715a1.515,1.515,0,0,0-1.561.853,4.4,4.4,0,0,0-.276,2.046,2.308,2.308,0,0,1,.911-.012A2.959,2.959,0,0,1,279.631,7.1a9.593,9.593,0,0,1,.521,6.633,1.975,1.975,0,0,1,2.171-.47c.972.436.761,1.493.415,2.248a1.3,1.3,0,0,1,1.676,1.122c1.157-1.441,2.07-3.073,3.742-4.19,1.166-.782,3.35-1.38,4.436-.123.969,1.126.013,2.748-.678,3.8a24.039,24.039,0,0,1-2.158,2.761c.92-.516,2-.892,2.691-.25.724.673.367,1.931-.017,2.851a3.1,3.1,0,0,1,.8.084c2.932.734-.133,3.741-1.48,5.111,1.27-.288,2.5-.717,3.779-.969.936-.183,2.732-.6,3.542.056.834.673-.169,1.727-.731,2.284-.457.451-.948.872-1.456,1.282,2.321-.984,5.684-1.9,6.6-.014.642,1.323-.86,2.633-1.956,3.506a26.549,26.549,0,0,1-2.725,1.892c1.823-.7,3.751-1.511,5.679-1.214.955.147,2.241.762,2.167,1.656a2.545,2.545,0,0,1-.785,1.5,29.412,29.412,0,0,1,3.365-1.529c1.231-.451,3.414-1.252,4.657-.4,2.47,1.7-1.948,4.037-4.647,5.341,3.116-.777,7.076-1.756,9.588-.048,2.307,1.568-.414,2.8-2.341,3.669a8.092,8.092,0,0,1,3.817.361c1.194.557.644,1.435-.062,2.108,1.752-.195,4.216.134,4.269,1.791.049,1.583-2.084,2.536-3.637,3.314,2.471.771,5.209,1.932,5.76,4.159.433,1.748-2.28,2.425-3.99,2.811,1.439,1.751,5.55,6.877.945,7.11a3.7,3.7,0,0,1-2.137,4.368,4.407,4.407,0,0,1-4.985-1.105A5.555,5.555,0,0,1,313.4,72.1c-1.735.571-2.995-.428-3.855-1.524a23.669,23.669,0,0,1-3.963,2.32,3.559,3.559,0,0,1-3.505-.565c-1.164-1.188-1.105-2.782-.911-4.324a3.613,3.613,0,0,1-1.007.936.282.282,0,0,1-.369-.042c-1.012-1.138-.378-2.8.151-3.993.642-1.445,1.532-2.806,2.238-4.229-1.837-.386-1.123-1.8-1.183-3-.056-1.1-1.065-1.993-1.885-2.816-.1-.1-.19-.192-.287-.289a4.687,4.687,0,0,1-1.157,2.868,2.234,2.234,0,0,1-2.994-.037c-.92-1.077-.819-2.663-.73-3.9.077-1.059.27-2.1.418-3.154-.7.564-1.379,1.144-2.133,1.666a5.394,5.394,0,0,1-2.492,1.2c-1.973.117-1.2-1.735-.534-2.855-1.324.725-3.032,1.6-4.541,1.374-1.664-.25-1.953-1.8-2.02-3a18.734,18.734,0,0,1-3.488,2.893.288.288,0,0,1-.284.025,5.939,5.939,0,0,1-1.972-1.733c-.029.435-.08.87-.145,1.3a1.551,1.551,0,0,1,.626.293,1.913,1.913,0,0,1,.471,1.964,12.348,12.348,0,0,1-1.95,4.219,45.922,45.922,0,0,1,5.54-2.1c1.857-.508,3.994-.869,5.777-.013a.165.165,0,0,1,.079.253c-1.263,1.676-3.912,2.395-6.381,2.806a39.3,39.3,0,0,1,6.007.794c1.983.429,5.107,1.2,5.246,3.165,0,.081-.082.157-.177.176a27.8,27.8,0,0,1-7.26.082c2.469.739,4.975,1.714,6.305,3.552a.167.167,0,0,1-.09.252,26.022,26.022,0,0,1-12.814.543c.057.066.114.131.172.2.777.913,1.879,1.962,2.148,3.07a.2.2,0,0,1-.232.231,26.665,26.665,0,0,1-6.013-.864,18.775,18.775,0,0,1,1.341,1.539c.5.656,1.8,2.273.616,2.928-1.71.949-4.673-.558-6-1.35a20.041,20.041,0,0,1-3.946-3.038c-.327.517-.678,1.018-1.016,1.481-.572.784-2.212,3.187-3.828,2.647-1.708-.571-1.214-2.537-.806-3.767a24.423,24.423,0,0,1-2.223,1.465c-1.073.642-2.732,1.637-4.191,1.438a1.271,1.271,0,0,1-.9-2.174,9.6,9.6,0,0,1,1.285-1.367,21.069,21.069,0,0,1-9.987,1.377c.691.7,1.054,1.61-.314,2.047a9.665,9.665,0,0,1-4.29.22c1.07,1.764,2.75,4.777.073,6.026-2.646,1.235-5.386-.888-7.312-2.238-.241.638-.733,1.42-1.709,1.258a3.016,3.016,0,0,1-1.947-1.373c-1.986,2.277-10.475,6.246-10.78,2.019a3.978,3.978,0,0,1-1.429.758c-.614.2-1.028-.1-1.539-.391A3.342,3.342,0,0,1,213.5,76.5c-2.443,1.1-6.479,2.273-8.724.424-1.887-1.554-.672-3.7.5-5.34a11.315,11.315,0,0,1-4.992.3c-1.557-.367-.706-1.258.151-1.864a17.926,17.926,0,0,1-6.2-.412c-1.732-.568-.657-1.628.384-2.335-1.691.29-3.928.816-5-.36-1.18-1.3.435-2.676,1.313-3.885a8.149,8.149,0,0,1-4.118.821,9.045,9.045,0,0,1-3.76-1.371c.59,1.3,1.391,2.605,1.293,4-.012.149-.2.217-.357.157a13.893,13.893,0,0,1-3.434-1.861c-.551.791-1.954,2.648-3.184,1.953-1.125-.636-.93-2.1-.7-3.144-1.409.817-3.583,2.115-5.121,1.177-1.367-.837.235-2.47,1.138-3.42-1.006.142-2.182.075-2.632-.739-.282-.517.042-.992.522-1.374a19.069,19.069,0,0,1-4.118.49,8.547,8.547,0,0,1-4.024-.626c-.392-.228-.624-.678-.274-1.005a1.314,1.314,0,0,1,.252-.182c-.269-.017-.538-.033-.808-.048h-.051c-1.033.575-2.215,1.494-1.99,2.394.292,1.165,2.6,1.126,3.735,1.313.991.164,2.008.348,3.032.477-.446.2-.884.4-1.312.629a10.575,10.575,0,0,0-4.624,4.443.282.282,0,0,0,.094.349c1.551.949,4.227-.092,5.814-.514q.993-.264,1.989-.522a19.75,19.75,0,0,0-1.56,5.352c-.09.666-.312,2.014.529,2.469.7.378,1.631-.05,2.242-.344a17.922,17.922,0,0,0,2.4-1.5c.925-.642,1.944-1.2,2.914-1.8a26.354,26.354,0,0,0,2.33-1.573,5.355,5.355,0,0,0,1.585,3.816,2.718,2.718,0,0,0,3.583.061c-.319.932-.541,2.06.149,2.623.9.733,2.748-.321,3.5-.706,1-.509-.5,1.609.578,1.134-.864,1.691,1.085.7.792,2.526-.031.194.2.367.445.336a24.125,24.125,0,0,0,5.046-1.439c1.184-.416,2.59-.638,3.812-1.061-.392.655-.743,1.322-1.059,1.987-.388.814-.672,1.655-1.006,2.482-.212.52-.581,1.281-.357,1.833.214.527.947.593,1.549.544a11.92,11.92,0,0,0,3.11-.856c1.319-.492,2.592-1.062,3.846-1.65.495-.232.984-.471,1.471-.712a6.162,6.162,0,0,0,3.858,3.724.63.63,0,0,0,.762-.307,13.1,13.1,0,0,1,1.812-3.13c.889.825,1.5,1.887,2.376,2.722a7.594,7.594,0,0,0,3.828,2.079l.028,0c.036.1.075.2.117.3.246.589.143,1.207.455,1.777.149.275.627.186.833.023a37.526,37.526,0,0,0,4.074-3.839c.48-.514.976-1.037,1.448-1.573.026.037.045.074.07.111a5.648,5.648,0,0,0,2.645,2.573.552.552,0,0,0,.6-.174,17.27,17.27,0,0,0,1.405-2.553c.057.108.116.213.178.318a8.1,8.1,0,0,0,2.471,2.375,10.694,10.694,0,0,0,2.685,1.852.753.753,0,0,0,.811-.24,7.633,7.633,0,0,0,1.336-4.214,19.615,19.615,0,0,0,3.546,2.419,30.655,30.655,0,0,0,3.76,1.695,15.265,15.265,0,0,0,4.578,1.286.593.593,0,0,0,.664-.439,9.369,9.369,0,0,0-.735-4.148c.782.29,1.589.54,2.4.771.917.259,1.857.514,2.8.716a12.407,12.407,0,0,1,3.3.828c.271.147.711-.134.694-.361a4.329,4.329,0,0,0-.85-2.059c2.939,1.331,5.943,2.6,9.434,2.583.247,0,.513-.222.508-.417a6.5,6.5,0,0,0-.171-1.288,28.513,28.513,0,0,0,4.228.749.623.623,0,0,0,.648-.339,4.2,4.2,0,0,0,0-1.8c.214.117.43.234.648.349a33.3,33.3,0,0,0,6.758,2.318.641.641,0,0,0,.771-.31,5.582,5.582,0,0,0,.074-2.557,15.328,15.328,0,0,0,5.861,1.866.656.656,0,0,0,.742-.489c.094-.772.136-1.55.18-2.327.488.18.982.339,1.462.5a38.254,38.254,0,0,0,5.968,1.931.611.611,0,0,0,.694-.457,4.581,4.581,0,0,0-1.533-3.178c2.725.4,5.232,1.6,7.888,2.212.3.068.693-.209.675-.446a5.858,5.858,0,0,0-.648-2.218c.369.2.745.394,1.121.6.945.507,1.959.917,2.879,1.456a6.521,6.521,0,0,0,1.084.56c.016.149.029.3.045.447.035.317.531.324.794.2,1.971-.89,2.437-2.7,2.765-4.406,1.07,1.518,2.8,3.075,4.9,2.287a2.592,2.592,0,0,0,1.655-2.286,10.833,10.833,0,0,0,4.652,1.858.6.6,0,0,0,.676-.443,4.467,4.467,0,0,0-.4-2.467c2.262,1.389,5.255,2.8,5.721.745.208-.911-1.117-1.95-1.812-2.538-.023-.022-.047-.041-.071-.061a14.649,14.649,0,0,0,5.995.228c1.3-.223,3.762-1.171,3.1-2.268a.238.238,0,0,0-.06-.239c-.109-.142-.225-.278-.343-.414a6.946,6.946,0,0,0,2.161-.556c1.319-.627,1.135-1.5.362-2.367a13.546,13.546,0,0,0,2.224-.317c.92-.214.98-.843.832-1.513-.207-.925-1.335-1.654-2.426-2.238,1.622.047,3.267-.043,4.913-.1.3-.01.643-.269.626-.513-.161-2.079-3.575-2.872-5.654-3.386",
    transform: "translate(-159.535 -2.54)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-182",
    cx: 0.428,
    cy: 0.198,
    r: 1.912,
    gradientTransform: "matrix(0.481, 0.02, 0.007, -0.788, -0.546, 4.595)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e7c85a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.065,
    stopColor: "#d9c85a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.186,
    stopColor: "#b7c85a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.302,
    stopColor: "#90c95a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#8ac456"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.528,
    stopColor: "#79b94b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.672,
    stopColor: "#5fa639"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.829,
    stopColor: "#398b20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.993,
    stopColor: "#0a6901"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#086800"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-276"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11152",
    "data-name": "Rectangle 11152",
    width: 85.088,
    height: 59.303,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-277"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11153",
    "data-name": "Rectangle 11153",
    width: 85.088,
    height: 43.21,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-278"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11154",
    "data-name": "Rectangle 11154",
    width: 6.761,
    height: 4.558,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-279"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11155",
    "data-name": "Rectangle 11155",
    width: 3.56,
    height: 2.727,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-280"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11156",
    "data-name": "Rectangle 11156",
    width: 2.867,
    height: 3.999,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-281"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11157",
    "data-name": "Rectangle 11157",
    width: 4.191,
    height: 3.559,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-282"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11158",
    "data-name": "Rectangle 11158",
    width: 3.701,
    height: 4.795,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-283"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11159",
    "data-name": "Rectangle 11159",
    width: 5.548,
    height: 3.447,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-284"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11160",
    "data-name": "Rectangle 11160",
    width: 5.046,
    height: 3.962,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-285"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11161",
    "data-name": "Rectangle 11161",
    width: 3.492,
    height: 3.063,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-286"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11162",
    "data-name": "Rectangle 11162",
    width: 1.834,
    height: 1.825,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-287"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11163",
    "data-name": "Rectangle 11163",
    width: 3.582,
    height: 4.776,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-288"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11164",
    "data-name": "Rectangle 11164",
    width: 1.588,
    height: 1.809,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-289"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11165",
    "data-name": "Rectangle 11165",
    width: 2.206,
    height: 1.416,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-290"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11166",
    "data-name": "Rectangle 11166",
    width: 3.32,
    height: 3.961,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-291"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11167",
    "data-name": "Rectangle 11167",
    width: 0.908,
    height: 0.89,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-292"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11168",
    "data-name": "Rectangle 11168",
    width: 4.667,
    height: 3.803,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-293"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11169",
    "data-name": "Rectangle 11169",
    width: 2.818,
    height: 3.604,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-294"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11170",
    "data-name": "Rectangle 11170",
    width: 9.832,
    height: 2.987,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-295"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11200",
    "data-name": "Rectangle 11200",
    width: 149.364,
    height: 59.016,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-296"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11171",
    "data-name": "Rectangle 11171",
    width: 5.189,
    height: 2.846,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-297"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32203",
    "data-name": "Path 32203",
    d: "M305.92,58c-.171-1.141-1.752-1.14-2.818-.917a14.887,14.887,0,0,0-1.6.539c-.632.209-1.158,1.052-.331,1.367.369.14.757.243,1.126.384a3.257,3.257,0,0,0,2.3.336A1.619,1.619,0,0,0,305.92,58",
    transform: "translate(-300.745 -56.972)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-183",
    cx: 0.526,
    cy: 0.488,
    r: 0.685,
    gradientTransform: "matrix(0.561, 0.02, 0.009, -0.788, -27.55, 89.853)",
    xlinkHref: "#radial-gradient-179"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-298"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11172",
    "data-name": "Rectangle 11172",
    width: 3.705,
    height: 2.039,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-299"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32205",
    "data-name": "Path 32205",
    d: "M302.193,60.989a7.735,7.735,0,0,0-1.738-.186c-.712-.062-1.307.719-.606,1.06.379.184.779.338,1.153.529a2.344,2.344,0,0,0,1.356.439.984.984,0,0,0,.826-.545c.234-.636-.29-1.066-.992-1.3",
    transform: "translate(-299.535 -60.799)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-184",
    cx: 0.524,
    cy: 0.502,
    r: 0.708,
    gradientTransform: "matrix(0.517, 0.02, 0.008, -0.788, -40.196, 126.198)",
    xlinkHref: "#radial-gradient-179"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-300"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11173",
    "data-name": "Rectangle 11173",
    width: 4.592,
    height: 2.122,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-301"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32207",
    "data-name": "Path 32207",
    d: "M304.3,45.947a3.173,3.173,0,0,0-2.413,1.432c-.376.716.939.868,1.356.335.439-.56,1.609-.188,2.217-.1a.831.831,0,0,0,.947-.624c.088-.947-1.15-1.183-2.107-1.042",
    transform: "translate(-301.816 -45.91)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-185",
    cx: 0.523,
    cy: 0.481,
    r: 0.735,
    gradientTransform: "matrix(0.504, 0.02, 0.008, -0.788, -35.702, 123.409)",
    xlinkHref: "#radial-gradient-179"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-302"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11174",
    "data-name": "Rectangle 11174",
    width: 5.551,
    height: 3.242,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-303"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32209",
    "data-name": "Path 32209",
    d: "M305.516,38.144a31.2,31.2,0,0,0-4.349,2.028c-.457.251-.719,1.089.1,1.14a3.69,3.69,0,0,0,2.5-.635c.754-.5,1.409-1.088,2.194-1.558.559-.338.411-1.285-.441-.975",
    transform: "translate(-300.737 -38.083)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-186",
    cx: 0.505,
    cy: 0.526,
    r: 0.662,
    gradientTransform: "matrix(0.594, 0.02, 0.009, -0.788, -23.924, 90.453)",
    xlinkHref: "#radial-gradient-179"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-304"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11175",
    "data-name": "Rectangle 11175",
    width: 3.252,
    height: 3.732,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-305"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32211",
    "data-name": "Path 32211",
    d: "M301.329,35.557a3.849,3.849,0,0,0-1.35,1.132c-.394.451-1.166,1.166-1.142,1.729a.957.957,0,0,0,1.349.749,2.088,2.088,0,0,0,1.361-1.778,2.43,2.43,0,0,1,.435-1.337c.348-.372-.234-.672-.652-.495",
    transform: "translate(-298.836 -35.504)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-187",
    cx: 0.469,
    cy: 0.493,
    r: 0.492,
    gradientTransform: "matrix(1.121, 0.02, 0.017, -0.788, 10.993, 83.124)",
    xlinkHref: "#radial-gradient-179"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-306"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11176",
    "data-name": "Rectangle 11176",
    width: 2.188,
    height: 2.309,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-307"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32213",
    "data-name": "Path 32213",
    d: "M300,33.26a1,1,0,0,0-1.058-.272.947.947,0,0,0-.771.924.721.721,0,0,0-.075.264c-.008.137-.037.274-.057.411-.048.312.249.6.636.654a1.2,1.2,0,0,0,1.068-.433,2.043,2.043,0,0,0,.465-.8A.914.914,0,0,0,300,33.26",
    transform: "translate(-298.035 -32.94)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-188",
    cx: 0.503,
    cy: 0.506,
    r: 0.52,
    gradientTransform: "matrix(1.05, 0.02, 0.016, -0.788, 6.288, 139.995)",
    xlinkHref: "#radial-gradient-179"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-308"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11177",
    "data-name": "Rectangle 11177",
    width: 4.972,
    height: 6.171,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-309"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32215",
    "data-name": "Path 32215",
    d: "M298.123,27.6c-.936.228-1.429,1.135-1.867,1.753a4.187,4.187,0,0,0-.991,3.153,1.764,1.764,0,0,0,1.564,1.184,2.931,2.931,0,0,0,2.8-1.255,5.531,5.531,0,0,0,.528-2.379c.1-.949-.275-2.889-2.033-2.456",
    transform: "translate(-295.199 -27.538)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-189",
    cx: 0.513,
    cy: 0.519,
    r: 0.483,
    gradientTransform: "matrix(1.226, 0.02, 0.019, -0.788, 13.867, 53.189)",
    xlinkHref: "#radial-gradient-179"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-310"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11178",
    "data-name": "Rectangle 11178",
    width: 1.628,
    height: 1.543,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-311"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32217",
    "data-name": "Path 32217",
    d: "M293.957,29.161a1,1,0,0,0-.549.219.613.613,0,0,0-.257.442c0,.038.006.076.006.115l-.069.118a.326.326,0,0,0-.033.133.365.365,0,0,0,.24.443,1.023,1.023,0,0,0,1.157-.327,1.068,1.068,0,0,0,.215-.6c.036-.323-.311-.57-.71-.538",
    transform: "translate(-293.042 -29.159)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-190",
    cx: 0.5,
    cy: 0.474,
    r: 0.519,
    gradientTransform: "matrix(0.984, 0.02, 0.015, -0.788, -4.874, 204.754)",
    xlinkHref: "#radial-gradient-179"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-312"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11179",
    "data-name": "Rectangle 11179",
    width: 3.582,
    height: 3.753,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-313"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32219",
    "data-name": "Path 32219",
    d: "M291.574,23.378c-.195-.666-1.3-.724-1.808-.243a3.052,3.052,0,0,0-.557.569,7.97,7.97,0,0,1-.477.684c-.073.094-.154.185-.237.275a4.093,4.093,0,0,0-.212.363c-.008.017-.017.037-.026.056a.371.371,0,0,0-.027.043.389.389,0,0,1,.025-.041c-.02.036-.039.066-.044.073a1.163,1.163,0,0,0-.129.3.585.585,0,0,0-.025.124V25.6a.654.654,0,0,0,.008.153c.007.1.016.133.023.1a1.989,1.989,0,0,0,.1.258,1.21,1.21,0,0,0,1.146.449,2.487,2.487,0,0,0,2.03-1.61,2.4,2.4,0,0,0,.208-1.57",
    transform: "translate(-288.056 -22.819)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-191",
    cx: 0.488,
    cy: 0.513,
    r: 0.518,
    gradientTransform: "matrix(1.06, 0.02, 0.016, -0.788, 4.572, 90.858)",
    xlinkHref: "#radial-gradient-179"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-314"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11180",
    "data-name": "Rectangle 11180",
    width: 0.02,
    height: 0.033,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-315"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32221",
    "data-name": "Path 32221",
    d: "M288.186,24.781c.007-.012.013-.02.019-.032-.018.029-.023.036-.019.032",
    transform: "translate(-288.185 -24.749)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-192",
    cx: 0.54,
    cy: 0.467,
    r: 0.444,
    gradientTransform: "matrix(1.51, 0.02, 0.023, -0.788, 7161.642, 10098.033)",
    xlinkHref: "#radial-gradient-179"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-316"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11181",
    "data-name": "Rectangle 11181",
    width: 2.424,
    height: 2.132,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-317"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32223",
    "data-name": "Path 32223",
    d: "M290.19,26.71a1.17,1.17,0,0,0-1.1.858.916.916,0,0,0-.127.169l.03-.051a.6.6,0,0,1-.078.1c.017-.016.031-.031.048-.048a.667.667,0,0,0-.2.626c.086.336.452.482.853.474a1.56,1.56,0,0,0,1.551-1.39c.022-.441-.405-.784-.975-.737",
    transform: "translate(-288.743 -26.705)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-193",
    cx: 0.505,
    cy: 0.508,
    r: 0.572,
    gradientTransform: "matrix(0.871, 0.02, 0.013, -0.788, -18.516, 160.31)",
    xlinkHref: "#radial-gradient-179"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-318"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11182",
    "data-name": "Rectangle 11182",
    width: 4.554,
    height: 3.998,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-319"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32225",
    "data-name": "Path 32225",
    d: "M282.627,57.7a10.5,10.5,0,0,1-1.9,1.12,2.516,2.516,0,0,0-1.232.8c-.846.92.345,2.3,1.736,1.794a2.823,2.823,0,0,0,.887-.445,1.729,1.729,0,0,0,.429-.517l.016-.019a7.492,7.492,0,0,0,.514-.774,5.494,5.494,0,0,0,.679-1.674c.117-.549-.78-.556-1.133-.286",
    transform: "translate(-279.216 -57.53)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-194",
    cx: 0.541,
    cy: 0.466,
    r: 0.522,
    gradientTransform: "matrix(0.854, 0.02, 0.013, -0.788, -9.442, 63.565)",
    xlinkHref: "#radial-gradient-179"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-320"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11183",
    "data-name": "Rectangle 11183",
    width: 11.019,
    height: 7.416,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-321"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32227",
    "data-name": "Path 32227",
    d: "M287.526,65.109c-.815-.767-1.26-1.894-2.713-2.017a1.472,1.472,0,0,0-1.257.491,3.766,3.766,0,0,0-2.089-1.881c-3.374-1.231-6.7,2.853-3.432,4.546l.148.079c.18.122.345.262.527.382.3.2.582.416.869.626.344.252.662.507,1.037.73.256.152.477.3.745.445l.025.013a.384.384,0,0,0,.088.08,1.961,1.961,0,0,0,2.532-.473,3.057,3.057,0,0,0,.311-2.806c.16.1.335.2.51.3a4.714,4.714,0,0,0,1.828.625c.772.1,1.378-.663.87-1.143",
    transform: "translate(-276.695 -61.475)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-195",
    cx: 0.559,
    cy: 0.54,
    r: 0.566,
    gradientTransform: "matrix(0.664, 0.02, 0.01, -0.788, -8.278, 31.55)",
    xlinkHref: "#radial-gradient-179"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-322"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11184",
    "data-name": "Rectangle 11184",
    width: 8.723,
    height: 4.822,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-323"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32229",
    "data-name": "Path 32229",
    d: "M294.488,64.764a2.621,2.621,0,0,0-1.317-.984,1.6,1.6,0,0,0-1.453.272,1.2,1.2,0,0,0-.3.372,4.232,4.232,0,0,0-.3-.558,5.7,5.7,0,0,0-1.364-1.582c-1.9-1.347-4.923,1.144-3.171,2.6a6.451,6.451,0,0,0,1.832.859c.514.183,1.011.406,1.512.611a1.24,1.24,0,0,0,1.613-.843c.01-.045.014-.09.022-.135a3.09,3.09,0,0,0,.992.6.076.076,0,0,1,.017.01l.022.011a1.985,1.985,0,0,1,.174.125l.016.014a.669.669,0,0,0,.633.569,1.224,1.224,0,0,0,1.07-.433,1.128,1.128,0,0,0,0-1.513",
    transform: "translate(-286.054 -61.897)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-196",
    cx: 0.554,
    cy: 0.574,
    r: 0.619,
    gradientTransform: "matrix(0.59, 0.02, 0.009, -0.788, -13.799, 46.751)",
    xlinkHref: "#radial-gradient-179"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-324"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11185",
    "data-name": "Rectangle 11185",
    width: 3.956,
    height: 2.993,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-325"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32231",
    "data-name": "Path 32231",
    d: "M296.23,63.487a3.514,3.514,0,0,0-.727-1.055c-.047-.044-.094-.09-.141-.136.026.023-.105-.117-.124-.142a1.635,1.635,0,0,0-1.462-.572,1.547,1.547,0,0,0-1.348.889c-.112.393-.2.933.277,1.221a8.588,8.588,0,0,0,.857.454,10.2,10.2,0,0,0,1.4.378c.809.241,1.561-.425,1.263-1.036",
    transform: "translate(-292.341 -61.581)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-197",
    cx: 0.488,
    cy: 0.47,
    r: 0.589,
    gradientTransform: "matrix(0.744, 0.02, 0.012, -0.788, -20.777, 86.334)",
    xlinkHref: "#radial-gradient-179"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-326"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11186",
    "data-name": "Rectangle 11186",
    width: 7.512,
    height: 3.338,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-327"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32233",
    "data-name": "Path 32233",
    d: "M310.066,53.42c-1.661-1.8-4.288-.451-6.433-.116-.547.085-1.2.7-.636,1.092a5.072,5.072,0,0,0,2.111.815,20.8,20.8,0,0,0,2.6.627,2.674,2.674,0,0,0,1.9-.551c.519-.425.975-1.315.462-1.868",
    transform: "translate(-302.778 -52.506)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-198",
    cx: 0.503,
    cy: 0.592,
    r: 0.685,
    gradientTransform: "matrix(0.535, 0.02, 0.008, -0.788, -20.524, 68.266)",
    xlinkHref: "#radial-gradient-179"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-328"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11187",
    "data-name": "Rectangle 11187",
    width: 6.776,
    height: 6.394,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-329"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32235",
    "data-name": "Path 32235",
    d: "M276.979,66.13a2.24,2.24,0,0,0-.593-.594,2.712,2.712,0,0,0-1.633-.513,1.054,1.054,0,0,0-.406.085,5.442,5.442,0,0,1-1.817-2.52c-.4-.938-1.91-.458-2.027.369a5.327,5.327,0,0,0,1.573,5.082,2.054,2.054,0,0,0,2.6-.085,1.424,1.424,0,0,0,.3.158,1.752,1.752,0,0,0,2.139-.865,1.26,1.26,0,0,0-.136-1.116",
    transform: "translate(-270.407 -62.074)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-199",
    cx: 0.51,
    cy: 0.514,
    r: 0.517,
    gradientTransform: "matrix(0.995, 0.02, 0.015, -0.788, -0.552, 39.352)",
    xlinkHref: "#radial-gradient-179"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-330"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11188",
    "data-name": "Rectangle 11188",
    width: 6.958,
    height: 7.009,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-331"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32237",
    "data-name": "Path 32237",
    d: "M270.883,66.207c-.011-.006-.024-.01-.036-.017a1.047,1.047,0,0,0-.037-1.864,5.874,5.874,0,0,1-1.013-.954c-.866-.952-2.695.091-2.117,1.084a8.643,8.643,0,0,0,.718,1.092c-.129-.035-.256-.067-.387-.094-.62-.134-1.189-.293-1.824-.386-.519-.075-1.088.312-1.1.723a3.68,3.68,0,0,0,1.374,2.9A4.731,4.731,0,0,0,269.591,70a2.735,2.735,0,0,0,2.365-1.558,1.738,1.738,0,0,0-1.073-2.234",
    transform: "translate(-265.09 -62.997)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-200",
    cx: 0.491,
    cy: 0.531,
    r: 0.51,
    gradientTransform: "matrix(1.053, 0.02, 0.016, -0.788, 1.937, 36.156)",
    xlinkHref: "#radial-gradient-179"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-332"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11189",
    "data-name": "Rectangle 11189",
    width: 7.052,
    height: 4.664,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-333"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32239",
    "data-name": "Path 32239",
    d: "M190.776,60.744c-1.135-.345-2.18.458-3.2.737-.165.035-.216.047-.161.037-.2.036-.411.073-.618.111a4.429,4.429,0,0,0-.783.22c-1.254.48-2.069,1.3-1.882,2.444a1.491,1.491,0,0,0,1.358,1.028c1.557.05,2.42-.742,3.481-1.5a6.662,6.662,0,0,0,1.139-1.17,10.909,10.909,0,0,0,.917-.994.566.566,0,0,0-.251-.912",
    transform: "translate(-184.106 -60.659)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-201",
    cx: 0.503,
    cy: 0.52,
    r: 0.632,
    gradientTransform: "matrix(0.686, 0.02, 0.011, -0.788, -9.512, 55.207)",
    xlinkHref: "#radial-gradient-179"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-334"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11190",
    "data-name": "Rectangle 11190",
    width: 2.958,
    height: 2.755,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-335"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32241",
    "data-name": "Path 32241",
    d: "M186.687,59.008a1.026,1.026,0,0,0-1.105.325c-.229.283-.461.563-.71.834a4.984,4.984,0,0,1-.381.362,1.642,1.642,0,0,0-.365.572c-.192.378.3.713.756.574a2.5,2.5,0,0,0,1.2-.805,12.643,12.643,0,0,0,.834-1.028.519.519,0,0,0-.229-.834",
    transform: "translate(-184.083 -58.953)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-202",
    cx: 0.51,
    cy: 0.5,
    r: 0.532,
    gradientTransform: "matrix(0.92, 0.02, 0.014, -0.788, -6.077, 94.862)",
    xlinkHref: "#radial-gradient-179"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-336"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11191",
    "data-name": "Rectangle 11191",
    width: 5.249,
    height: 3.962,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-337"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32243",
    "data-name": "Path 32243",
    d: "M195.686,64.776a.69.69,0,0,0-.869-.343c-.362.09-.57.222-.845.308-.5.158-.98.265-1.469.459-1.25.491-2.493,1.474-1.815,2.657a1.388,1.388,0,0,0,1.274.5A4.561,4.561,0,0,0,194.8,66.62c.437-.488,1.162-1.215.89-1.844",
    transform: "translate(-190.497 -64.4)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-203",
    cx: 0.522,
    cy: 0.504,
    r: 0.612,
    gradientTransform: "matrix(0.688, 0.02, 0.011, -0.788, -12.004, 65.74)",
    xlinkHref: "#radial-gradient-179"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-338"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11192",
    "data-name": "Rectangle 11192",
    width: 2.69,
    height: 3.959,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-339"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32245",
    "data-name": "Path 32245",
    d: "M209.589,68.739c-.062-.4-.606-.639-1.079-.6a1.323,1.323,0,0,0-1.249,1.024c-.173.921-.428,2.4.921,2.873a1.167,1.167,0,0,0,1.261-.372c.627-.883.294-1.972.146-2.926",
    transform: "translate(-207.121 -68.134)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-204",
    cx: 0.506,
    cy: 0.492,
    r: 0.483,
    gradientTransform: "matrix(1.228, 0.02, 0.019, -0.788, 15.934, 64.877)",
    xlinkHref: "#radial-gradient-179"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-340"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11193",
    "data-name": "Rectangle 11193",
    width: 6.628,
    height: 6.372,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-341"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32247",
    "data-name": "Path 32247",
    d: "M234.649,70.291A3.061,3.061,0,0,0,233,69.146c.494.215-.129-.11-.243-.2a5.684,5.684,0,0,1-.525-.472,7.08,7.08,0,0,0-2.26-1.531c-.725-.294-1.8.287-1.762.92a8.288,8.288,0,0,0,.555,3.282,3.468,3.468,0,0,0,4.811,1.7,1.865,1.865,0,0,0,1.068-2.562",
    transform: "translate(-228.213 -66.868)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-205",
    cx: 0.482,
    cy: 0.475,
    r: 0.503,
    gradientTransform: "matrix(1.019, 0.02, 0.016, -0.788, 0.4, 37.161)",
    xlinkHref: "#radial-gradient-179"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-342"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11194",
    "data-name": "Rectangle 11194",
    width: 8.87,
    height: 6.022,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-343"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32249",
    "data-name": "Path 32249",
    d: "M240.9,67.685c-.127-1.5-2.064-2.193-3.543-2.81a11.465,11.465,0,0,0-3.647-.562,1.466,1.466,0,0,0-1.465.767c-.71,1.333.566,2.133,1.52,3.047a18.505,18.505,0,0,0,1.644,1.539,4.3,4.3,0,0,0,3.571.5,2.336,2.336,0,0,0,1.921-2.481",
    transform: "translate(-232.036 -64.307)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-206",
    cx: 0.521,
    cy: 0.497,
    r: 0.644,
    gradientTransform: "matrix(0.662, 0.02, 0.01, -0.788, -9.878, 43.098)",
    xlinkHref: "#radial-gradient-179"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-344"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11195",
    "data-name": "Rectangle 11195",
    width: 4.688,
    height: 3.236,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-345"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32251",
    "data-name": "Path 32251",
    d: "M244.155,68.214c-.171-1.079-1.917-1.947-3.173-2.157-1.127-.189-2.164,1.264-.984,1.72a6.123,6.123,0,0,1,1.243.921,2.351,2.351,0,0,0,2.166.485.908.908,0,0,0,.748-.969",
    transform: "translate(-239.476 -66.04)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-207",
    cx: 0.554,
    cy: 0.503,
    r: 0.596,
    gradientTransform: "matrix(0.666, 0.02, 0.01, -0.788, -17.612, 74.017)",
    xlinkHref: "#radial-gradient-179"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-346"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11196",
    "data-name": "Rectangle 11196",
    width: 8.403,
    height: 6.639,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-347"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32253",
    "data-name": "Path 32253",
    d: "M250.456,67.441c-.127-.882-1.288-1.456-2.12-1.9a35.4,35.4,0,0,0-4.02-1.69,1.6,1.6,0,0,0-2.207,1.451c.216,1.289,1.284,2.259,2.345,3.194.54.477.739.789,1.409,1.313a3.426,3.426,0,0,0,3.358.249,2.292,2.292,0,0,0,1.236-2.621",
    transform: "translate(-242.095 -63.748)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-208",
    cx: 0.5,
    cy: 0.511,
    r: 0.572,
    gradientTransform: "matrix(0.824, 0.02, 0.013, -0.788, -5.951, 37.977)",
    xlinkHref: "#radial-gradient-179"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-348"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11197",
    "data-name": "Rectangle 11197",
    width: 2.819,
    height: 2.054,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-349"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32255",
    "data-name": "Path 32255",
    d: "M253.111,66.794a1.835,1.835,0,0,0-.269-.344l-.173-.1c.076.043.078.041,0,0-.055-.036-.106-.075-.157-.115a5.776,5.776,0,0,0-.645-.492,1.058,1.058,0,0,0-1.2.1c-.269.22-.47.729-.078.952a6.3,6.3,0,0,1,.7.533,1.436,1.436,0,0,0,.648.318,2.026,2.026,0,0,0,.721-.075c.349-.086.694-.5.458-.776",
    transform: "translate(-250.37 -65.6)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-209",
    cx: 0.503,
    cy: 0.514,
    r: 0.608,
    gradientTransform: "matrix(0.69, 0.02, 0.011, -0.788, -29.408, 123.002)",
    xlinkHref: "#radial-gradient-179"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-350"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11198",
    "data-name": "Rectangle 11198",
    width: 5.777,
    height: 5.607,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-351"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32257",
    "data-name": "Path 32257",
    d: "M258.963,69.056a2.173,2.173,0,0,1-.2-.78,4.046,4.046,0,0,0-.373-1.146,3.994,3.994,0,0,0-2.756-2.5,2.066,2.066,0,0,0-2.351,1.551c-.183,1.39,1.364,2.235,2.443,3.137a2.645,2.645,0,0,0,2.852.666c.382-.2.592-.583.388-.923",
    transform: "translate(-253.266 -64.58)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-210",
    cx: 0.505,
    cy: 0.492,
    r: 0.514,
    gradientTransform: "matrix(0.999, 0.02, 0.015, -0.788, -0.403, 44.206)",
    xlinkHref: "#radial-gradient-179"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-352"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11199",
    "data-name": "Rectangle 11199",
    width: 3.377,
    height: 2.807,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-353"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32259",
    "data-name": "Path 32259",
    d: "M262.315,66.366a4.613,4.613,0,0,1-.5-.566,3.25,3.25,0,0,1-.246-.387,1.332,1.332,0,0,0-1.784-.405,1.04,1.04,0,0,0-.642,1.089c.067.41.437.674.834.9a8.087,8.087,0,0,0,1.177.563c.88.339,1.752-.627,1.157-1.2",
    transform: "translate(-259.134 -64.824)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-211",
    cx: 0.458,
    cy: 0.471,
    r: 0.533,
    gradientTransform: "matrix(0.822, 0.02, 0.013, -0.788, -14.473, 85.058)",
    xlinkHref: "#radial-gradient-179"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-354"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11201",
    "data-name": "Rectangle 11201",
    width: 3.331,
    height: 3.384,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-355"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11202",
    "data-name": "Rectangle 11202",
    width: 1.619,
    height: 1.187,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-356"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11203",
    "data-name": "Rectangle 11203",
    width: 2.287,
    height: 1.711,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-357"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11204",
    "data-name": "Rectangle 11204",
    width: 43.813,
    height: 25.323,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-358"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32268",
    "data-name": "Path 32268",
    d: "M256.3,54.285a.527.527,0,0,0,.556-.539c-.263-1.606-2.406-2.087-4.2-2.644a13.353,13.353,0,0,0,2.531-.341c.4-.122.608-.539.185-.736a9.2,9.2,0,0,0-4.509-.644,7.316,7.316,0,0,0,3.264-2.289.289.289,0,0,0-.235-.473c-.087-.006-.173-.011-.262-.012-.031,0-.063,0-.1,0h-.161l-.121,0-.128,0c-.049,0-.1,0-.142.007l-.1.007-.164.014-.018,0c-.226.022-.454.055-.675.1h0a10.06,10.06,0,0,0-2.419.813c.839-1.384,1.815-3.4.486-3.561a2.554,2.554,0,0,0-1.579.526c.4-.692.729-1.638-.308-1.85a3.485,3.485,0,0,0-2.409.913,3.093,3.093,0,0,0-.044-.416c-.024-.14-.184-.207-.351-.209.047-.161.088-.324.124-.489a5.781,5.781,0,0,0,.115-1.824.912.912,0,0,0-.386-.8c-.67-.351-1.4.275-1.922.984a1.189,1.189,0,0,0-.163-.428.557.557,0,0,0-.026-.177c-.1-.287-.479-.319-.79-.195-.036.016-.072.033-.106.053a2.319,2.319,0,0,0-1.189.55c.272-.863.283-1.723-.57-1.824a2.425,2.425,0,0,0-1.47.515,16.162,16.162,0,0,0-2.06,1.709,8.815,8.815,0,0,0-.659.707c0-.014,0-.03,0-.044.062-.608.359-1.87-.4-2.312a1,1,0,0,0-.356-.133,1.257,1.257,0,0,1,.326-.372c.287-.225.081-.666-.379-.525a3.561,3.561,0,0,0-1.61,1.126,4.3,4.3,0,0,0-.844,1.229c-.031-.308-.1-.62-.134-.919a4.1,4.1,0,0,0-.594-1.868c-.307-.484-1.267-.082-1.272.344a3.391,3.391,0,0,1-.331,1.318,6.11,6.11,0,0,0-.821-.73,3.125,3.125,0,0,1-.27-.374.537.537,0,0,0-.652-.161c-.123-.054-.247-.1-.378-.148a1.338,1.338,0,0,0-1.4.249c-.014.019-.033.041-.048.061a2.029,2.029,0,0,0-1.2-.182.6.6,0,0,0-.467.455,2.607,2.607,0,0,0,.348,1.019,7.14,7.14,0,0,1,.316,1.174c-.067-.022-.141-.045-.222-.068a3.484,3.484,0,0,1-1.095-.457.781.781,0,0,0-1.105.36,3.109,3.109,0,0,0-.669-.3.72.72,0,0,0-.76.212,2.127,2.127,0,0,0-.265.56v0a6.491,6.491,0,0,0-1.873-2.279.756.756,0,0,0-.929.164,4.2,4.2,0,0,0-.877,4.1,4.236,4.236,0,0,1-.582-.3c-.539-.337-.933-.785-1.469-1.115-.424-.263-1.045.09-.956.468a7.359,7.359,0,0,1,.059.795,3.358,3.358,0,0,0,.405,1.067,3.566,3.566,0,0,0,.661.876c.216.218.739.637.823.758a.313.313,0,0,1,.025.035.586.586,0,0,0-.256.375,8.971,8.971,0,0,0-2.623-.316c-.289.014-.515.243-.466.454.159.68,1.011,1.122,1.729,1.477l.267.133a3.654,3.654,0,0,0,.337.329,4.48,4.48,0,0,0-3.085.843c-.2.188-.261.459.057.6a5.185,5.185,0,0,0,1.468.333,5.217,5.217,0,0,0,.537.223,12.177,12.177,0,0,0,1.764.372c-.288-.047.483.106.483.109.167.03.335.05.506.065l.074,0c-.212.163-.425.324-.639.483a10.6,10.6,0,0,0-1.585,1.22.437.437,0,0,0,.208.721,4.638,4.638,0,0,0,2.262-.063c.409-.08.813-.178,1.218-.269.085-.02.14-.033.173-.043-.013.035-.029.069-.042.1-.021.049-.038.1-.056.146-.01.025-.017.049-.024.073-.02.066-.042.131-.059.2a.306.306,0,0,0,.206.415,3.776,3.776,0,0,0,2.158-.24c.819-.271,1.588-.621,2.362-.957.549-.238,1.113-.455,1.68-.67a4.017,4.017,0,0,0-.9,1.88c-.03.213.207.345.468.339a5.534,5.534,0,0,0,2.519-.85c.422-.235.838-.473,1.255-.712a4.4,4.4,0,0,0-.48,2.058.336.336,0,0,0,.336.327,3.162,3.162,0,0,0,1.691-.507c.253-.136.513-.271.783-.4-.7.711-1.3,1.478-1.946,2.218a.21.21,0,0,0,.1.347,4.67,4.67,0,0,0,2.8-.465c.189-.074.38-.153.568-.233a3.723,3.723,0,0,0-1.215,1.9.281.281,0,0,0,.21.287,3.791,3.791,0,0,0,2.561-.556c.462-.221.911-.455,1.36-.691-.3.287-.62.565-.951.831a5.99,5.99,0,0,0-1.468.707c-.259.178-.512.36-.762.544a2.233,2.233,0,0,0-.325.3,5.4,5.4,0,0,0-.95.68c-.177.166-.247.424.054.543,1.126.448,2.6-.025,3.68-.339.966-.282,2-.5,2.966-.82a4.566,4.566,0,0,0-.644,1.421c-.164.668-.2,2.032.931,2.262.534.108.99-.49,1.249-.725a10.47,10.47,0,0,0,1.288-1.486,11.924,11.924,0,0,0,1.017-1.628,2.574,2.574,0,0,0,.146.452c.214.508.594,1.414,1.539,1.166.8-.208.884-1.138.976-1.656.061-.339.091-.664.118-.99a10.777,10.777,0,0,0,1.462,1.393c.538.423,1.843,1.319,2.615.649.71-.619.179-1.519-.191-2.167a7.338,7.338,0,0,0-.948-1.267,5.746,5.746,0,0,0,1.8.421,1.758,1.758,0,0,0,1.667-.715,12.068,12.068,0,0,0,1.9.333c.892.078,2.416.233,2.993-.443.6-.7-.4-1.384-1.132-1.808a.409.409,0,0,0-.249-.152l-.016-.013a.45.45,0,0,0-.158-.092c-.026-.008-.051-.018-.074-.027l-.036-.013-.134-.073a13.255,13.255,0,0,0,1.873.12M232.961,41.521a.547.547,0,0,0,.114.186c-.168.3-.324.6-.459.9l-.006-.014c-.053-.142-.111-.284-.177-.425a1.765,1.765,0,0,0,.264-.231,1.257,1.257,0,0,0,.264-.416",
    transform: "translate(-213.045 -37.696)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-212",
    cx: 0.908,
    cy: 2.312,
    r: 5.028,
    gradientTransform: "matrix(0.595, 0.02, 0.009, -0.788, -2.353, 12.494)",
    xlinkHref: "#radial-gradient-180"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-359"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11205",
    "data-name": "Rectangle 11205",
    width: 76.829,
    height: 45.972,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-360"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11206",
    "data-name": "Rectangle 11206",
    width: 65.446,
    height: 30.28,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-361"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11207",
    "data-name": "Rectangle 11207",
    width: 6.761,
    height: 7.211,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-362"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11208",
    "data-name": "Rectangle 11208",
    width: 5.971,
    height: 6.579,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-363"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11209",
    "data-name": "Rectangle 11209",
    width: 4.065,
    height: 3.779,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-364"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11210",
    "data-name": "Rectangle 11210",
    width: 1.638,
    height: 1.619,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-_500_503"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 451,
    height: 240
  })))), /*#__PURE__*/React.createElement("g", {
    id: "_500_503",
    "data-name": "500 & 503",
    clipPath: "url(#clip-_500_503)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15516",
    "data-name": "Group 15516",
    transform: "translate(9 7)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15515",
    "data-name": "Group 15515",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14760",
    "data-name": "Group 14760"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14759",
    "data-name": "Group 14759",
    clipPath: "url(#clip-path)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_31674",
    "data-name": "Path 31674",
    d: "M158.156,70.892S-39.266,80.539,17.007,114.5c41.421,25-100.873,53.705,67.806,88.5,194.043,40.025,415.808-19.658,329.558-68.266-68.707-29.163-43.057-18.914-16.724-26.17,30.017-8.272-40.915-50.018-239.491-37.673",
    transform: "translate(0 13.388)",
    fill: "#9bb21f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14650",
    "data-name": "Group 14650",
    transform: "translate(0 93.258)",
    opacity: 0.5,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_14649",
    "data-name": "Group 14649"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14648",
    "data-name": "Group 14648",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31675",
    "data-name": "Path 31675",
    d: "M100.5,196.1q-14.9-4.03-29.795-8.164c-10.158-2.828-20.5-5.989-29.765-11.122-7.126-3.946-15.267-9.879-16.44-18.61-.528-3.939-.072-8.092,3.448-10.523,3.639-2.512,8.146-3.386,11.22-6.671-2.756-1.354-10-1.877-9.347-5.912.684-4.186,4.894-5.52,8.5-6.589,4.826-1.431,10.333-2.093,14.3-5.49,3.191-2.737-1.192-4.515-3.58-5.372-4.047-1.452-8.256-2.387-12.351-3.677-5.452-1.717-11.289-4.292-11.9-10.777-.448-4.822,3.156-8.709,6.814-11.318,5.91-4.215,12.883-6.89,19.719-9.191,5.188-1.747,10.452-3.254,15.745-4.647-42.58,6.647-78.323,17.573-50.055,34.631,41.421,25-100.873,53.7,67.806,88.5a660.776,660.776,0,0,0,114.478,12.871c-33.259-4.136-66.377-9.172-98.795-17.94",
    transform: "translate(0 -78.034)",
    fill: "#9bb21f"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14653",
    "data-name": "Group 14653",
    transform: "translate(166.911 82.021)",
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14652",
    "data-name": "Group 14652"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14651",
    "data-name": "Group 14651",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31676",
    "data-name": "Path 31676",
    d: "M387.124,134.734c-68.706-29.163-43.056-18.914-16.723-26.17,29.2-8.049-37.152-47.765-223.6-38.555.3.069.6.128.9.2,4.814,1.181,11.181,2.688,14.807,6.317,5.188,5.19-6.322,9.378-9.532,10.947a29.616,29.616,0,0,0-5.434,3.087c-1.368,1.08-.815.981.561,2.145a26.244,26.244,0,0,0,2.665,2.016c5.223,3.387,11.155,5.581,17.052,7.474,5.718,1.834,11.511,3.7,17.322,5.214,6.293,1.638,12.766,2.43,19.1,3.889,5.653,1.3,11.957,2.955,16.4,6.914a14.389,14.389,0,0,1,4.315,7.552c.888,3.252,2.437,6.144,6.146,6.463,6.271.54,12.508-1.861,18.615-2.911,4.624-.8,8.142.092,12.427,1.9,5.191,2.193,10.292,5.062,15.75,6.541,2.792.755,7.024,1.146,6.654-3.356-.239-2.915-1.451-5.618-1.892-8.5a.8.8,0,0,1,.412-.811,26.721,26.721,0,0,1,11.754-1.544c3.363.272,8.247,1.045,10.076,4.353,1.741,3.149.584,5.636-1.893,7.824-7.174,6.339,5.2,6.592,9.122,6.333,9.093-.6,18.372-1.114,27.457-.182,8.116.831,18.966,2.867,23.084,10.952,8.447,16.582-16.3,28.858-27.828,34.119a280.76,280.76,0,0,1-26.6,10.256c-12.317,4.177-24.523,8.766-37.256,11.551-17.758,3.883-36.148,3.651-54.242,4.074-18.921.44-37.846.632-56.769.969q-10.155.181-20.313.441c167.937,12.308,321.65-37.7,247.46-79.509",
    transform: "translate(-139.664 -68.632)",
    fill: "#9bb21f"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14656",
    "data-name": "Group 14656",
    transform: "translate(151.626 183.626)",
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14655",
    "data-name": "Group 14655"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14654",
    "data-name": "Group 14654",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31677",
    "data-name": "Path 31677",
    d: "M145.386,156.829c-.025-.066-.043-.131-.076-.2s-.075-.128-.115-.192c-.032-.048-.057-.094-.092-.141-.059-.074-.124-.146-.19-.222-.032-.03-.056-.063-.087-.1-.085-.08-.178-.16-.272-.24a.882.882,0,0,1-.073-.06c-.112-.086-.231-.17-.357-.252a.365.365,0,0,0-.045-.029c-.137-.088-.286-.174-.441-.257l-.016-.01a16.778,16.778,0,0,0-7.442-1.481c-4.817,0-8.782,1.454-9.256,3.318a1.55,1.55,0,0,0-.049.376c0,2.039,4.166,3.693,9.3,3.693s9.307-1.654,9.307-3.693a1.626,1.626,0,0,0-.044-.365c-.014-.05-.038-.1-.056-.151",
    transform: "translate(-126.874 -153.65)",
    fill: "#9bb21f"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14659",
    "data-name": "Group 14659",
    transform: "translate(253.127 195.83)",
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14658",
    "data-name": "Group 14658"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14657",
    "data-name": "Group 14657",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31678",
    "data-name": "Path 31678",
    d: "M216.719,163.941c-2.547-.3-4.742.276-4.9,1.286s1.768,2.073,4.312,2.372,4.743-.276,4.906-1.286-1.77-2.072-4.314-2.372",
    transform: "translate(-211.806 -163.862)",
    fill: "#9bb21f"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14662",
    "data-name": "Group 14662",
    transform: "translate(301.271 187.516)",
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14661",
    "data-name": "Group 14661"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14660",
    "data-name": "Group 14660",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31679",
    "data-name": "Path 31679",
    d: "M270.424,159.672a1.589,1.589,0,0,0-.105-.226c-.021-.044-.055-.085-.079-.128-.048-.066-.094-.13-.145-.195l-.12-.129q-.086-.088-.183-.176c-.048-.043-.1-.086-.146-.128-.074-.054-.146-.108-.223-.159-.057-.042-.116-.082-.177-.122-.085-.053-.176-.1-.264-.154-.068-.035-.127-.072-.2-.108-.131-.067-.275-.131-.418-.194a17.189,17.189,0,0,0-7.3-1.019c-5.093.258-9.107,2.1-8.969,4.125l0,.008a.149.149,0,0,0,0,.026,1.556,1.556,0,0,0,.07.345l0,.008a1.885,1.885,0,0,0,.161.345l0,0c.982,1.622,4.777,2.683,9.227,2.46,5.092-.259,9.11-2.106,8.97-4.124a1.582,1.582,0,0,0-.069-.35,1.136,1.136,0,0,0-.045-.111",
    transform: "translate(-252.09 -156.906)",
    fill: "#9bb21f"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14665",
    "data-name": "Group 14665",
    transform: "translate(350.575 143.558)",
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14664",
    "data-name": "Group 14664"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14663",
    "data-name": "Group 14663",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31680",
    "data-name": "Path 31680",
    d: "M310.388,123.986a1.694,1.694,0,0,0-.088-.281,1.308,1.308,0,0,0-.063-.13,2.581,2.581,0,0,0-.171-.28c-.025-.037-.049-.074-.076-.109a3.723,3.723,0,0,0-.325-.359c-.007-.006-.011-.012-.018-.019a5.01,5.01,0,0,0-.471-.39l-.025-.016a6.194,6.194,0,0,0-.523-.343c-.033-.018-.062-.035-.094-.054q-.264-.151-.555-.294a.839.839,0,0,0-.1-.048q-.333-.161-.7-.307l-.007,0a18.439,18.439,0,0,0-4.805-1.117c-4.712-.484-8.741.641-9.006,2.51a1.959,1.959,0,0,0,.711,1.622l.028.03c.081.078.166.153.257.226a1.057,1.057,0,0,0,.09.075c.085.068.177.137.272.2.042.031.087.06.13.09.094.065.191.124.3.185.051.033.108.065.164.094.1.06.206.117.318.173.06.032.128.065.192.1.111.053.219.108.338.16.068.031.139.059.209.087.2.086.41.165.625.245.114.042.226.081.343.122.1.033.2.066.3.1.124.039.251.076.379.114.1.03.207.056.311.086.137.033.272.069.409.1.106.026.213.048.319.074l.449.092c.1.023.2.039.307.061.173.031.348.059.523.085.088.016.176.031.268.042q.4.057.813.1c4.713.484,8.746-.638,9.01-2.506a1.38,1.38,0,0,0-.007-.4.738.738,0,0,0-.027-.121",
    transform: "translate(-293.346 -120.123)",
    fill: "#9bb21f"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14668",
    "data-name": "Group 14668",
    transform: "translate(376.566 156.124)",
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14667",
    "data-name": "Group 14667"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14666",
    "data-name": "Group 14666",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31681",
    "data-name": "Path 31681",
    d: "M319.926,130.871c-2.263-.553-4.4-.092-4.774,1.028s1.152,2.479,3.417,3.034,4.4.1,4.778-1.024-1.156-2.481-3.42-3.038",
    transform: "translate(-315.094 -130.638)",
    fill: "#9bb21f"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14671",
    "data-name": "Group 14671",
    transform: "translate(113.055 183.394)",
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14670",
    "data-name": "Group 14670"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14669",
    "data-name": "Group 14669",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31682",
    "data-name": "Path 31682",
    d: "M105.851,154.817a.756.756,0,0,0-.106-.148c-.018-.017-.027-.032-.045-.049a1.636,1.636,0,0,0-.226-.183.049.049,0,0,0-.018-.008,2.386,2.386,0,0,0-.293-.165c-.024-.014-.054-.024-.08-.037-.1-.048-.216-.1-.338-.141-.017,0-.031-.013-.049-.018a8.09,8.09,0,0,0-1-.28l-.069-.014a16.71,16.71,0,0,0-3.359-.318c-3.128,0-5.662.724-5.662,1.617a.468.468,0,0,0,.045.194l0,.008a1.609,1.609,0,0,0,.84.664.245.245,0,0,1,.031.014c.074.032.151.062.231.091l.076.031c.076.026.153.054.234.077.037.013.076.025.116.036.072.025.152.045.232.066.053.014.1.027.151.038.076.02.154.041.237.056.059.013.118.027.18.039l.238.047c.069.011.139.024.21.035s.159.026.24.037.155.025.235.035.161.02.24.03.178.019.267.026.155.017.234.025l.3.019c.074.007.147.011.225.018.114.006.229.008.348.014l.191.008c.185,0,.37.007.558.007,3.131,0,5.667-.724,5.667-1.616a.464.464,0,0,0-.049-.2.493.493,0,0,0-.03-.056",
    transform: "translate(-94.6 -153.456)",
    fill: "#9bb21f"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14674",
    "data-name": "Group 14674",
    transform: "translate(79.879 133.998)",
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14673",
    "data-name": "Group 14673"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14672",
    "data-name": "Group 14672",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31683",
    "data-name": "Path 31683",
    d: "M77.822,113.874a1.128,1.128,0,0,0-.1-.186.423.423,0,0,0-.044-.062,2.051,2.051,0,0,0-.52-.46l-.055-.036c-.1-.062-.216-.125-.335-.185-.017-.006-.027-.014-.045-.021a6.292,6.292,0,0,0-.975-.363.031.031,0,0,0-.018-.006c-.185-.053-.376-.1-.578-.147a13.153,13.153,0,0,0-2.782-.283c-3.056,0-5.53.93-5.53,2.076a1.064,1.064,0,0,0,.356.731.243.243,0,0,1,.031.03,2.5,2.5,0,0,0,.376.289c.017.012.038.025.056.036a4.126,4.126,0,0,0,.5.258l.048.021a7.667,7.667,0,0,0,1.338.418l.1.023c.24.051.491.094.749.133l.139.018c.262.037.533.065.813.086.039,0,.081,0,.122,0,.294.019.6.03.9.03,3.053,0,5.527-.93,5.527-2.077a.809.809,0,0,0-.044-.255.5.5,0,0,0-.03-.071",
    transform: "translate(-66.839 -112.123)",
    fill: "#9bb21f"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14677",
    "data-name": "Group 14677",
    transform: "translate(169.158 109.066)",
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14676",
    "data-name": "Group 14676"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14675",
    "data-name": "Group 14675",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31684",
    "data-name": "Path 31684",
    d: "M158.955,93.785a1.416,1.416,0,0,0-.167-.277c-.023-.03-.042-.06-.066-.091a3.146,3.146,0,0,0-.356-.339l-.056-.038a4.378,4.378,0,0,0-.425-.283c-.044-.027-.093-.054-.139-.08-.16-.084-.33-.169-.508-.249l-.1-.044c-.221-.094-.461-.185-.716-.269-.035-.013-.073-.024-.108-.036-.223-.07-.46-.139-.7-.2-.06-.013-.121-.029-.182-.045-.277-.067-.563-.131-.864-.19l-.018,0a22.912,22.912,0,0,0-4.237-.375c-4.841,0-8.768,1.344-8.768,3a1.107,1.107,0,0,0,.074.372l0,0a3.071,3.071,0,0,0,1.739,1.45c.031.011.057.026.087.038.122.054.247.1.38.152.051.019.1.041.16.06.118.042.245.084.373.123.073.025.146.047.22.069l.373.105.271.067c.122.031.247.06.373.087.105.025.213.047.32.067l.373.072c.122.02.244.038.368.06s.243.039.369.054.274.037.414.054c.122.014.237.03.361.042.154.016.311.027.468.042.115.011.223.018.339.025.179.014.361.023.545.03.1,0,.195.011.293.014.282.01.575.016.865.016,4.841,0,8.764-1.344,8.764-3a1.162,1.162,0,0,0-.073-.374c-.014-.035-.031-.07-.049-.1",
    transform: "translate(-141.544 -91.262)",
    fill: "#9bb21f"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14680",
    "data-name": "Group 14680",
    transform: "translate(100.761 112.879)",
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14679",
    "data-name": "Group 14679"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14678",
    "data-name": "Group 14678",
    clipPath: "url(#clip-path-13)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31685",
    "data-name": "Path 31685",
    d: "M101.722,96.975a1.38,1.38,0,0,0-.169-.276c-.023-.03-.041-.06-.067-.09a2.544,2.544,0,0,0-.354-.341c-.017-.013-.038-.024-.056-.038a4.081,4.081,0,0,0-.428-.281c-.042-.027-.088-.054-.137-.08-.159-.088-.326-.171-.509-.252-.031-.014-.061-.03-.1-.043-.221-.094-.461-.183-.715-.268-.035-.014-.073-.023-.108-.036-.225-.072-.459-.137-.7-.2-.062-.014-.12-.032-.183-.048-.278-.068-.565-.133-.864-.191l-.018,0a22.96,22.96,0,0,0-4.238-.374c-4.841,0-8.767,1.343-8.767,3a1.076,1.076,0,0,0,.076.372v0a3.076,3.076,0,0,0,1.739,1.45c.031.011.057.026.088.038.121.053.25.1.379.152l.159.059c.12.043.245.085.374.123.073.026.147.048.22.071.12.036.247.071.373.1.09.025.179.048.271.069l.376.09c.1.021.21.044.317.065.124.024.247.048.373.071s.244.043.366.061.244.039.369.056.276.037.416.051c.12.014.237.03.36.042l.471.042c.111.007.221.017.338.026q.269.018.545.029l.293.016q.428.014.864.014c4.841,0,8.765-1.343,8.765-3a1.078,1.078,0,0,0-.073-.374c-.016-.035-.031-.072-.049-.105",
    transform: "translate(-84.312 -94.452)",
    fill: "#9bb21f"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14683",
    "data-name": "Group 14683",
    transform: "translate(290.001 118.068)",
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14682",
    "data-name": "Group 14682"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14681",
    "data-name": "Group 14681",
    clipPath: "url(#clip-path-14)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31686",
    "data-name": "Path 31686",
    d: "M252.306,100.65a1.92,1.92,0,0,0-.084-.189c-.016-.024-.027-.047-.041-.071a1.7,1.7,0,0,0-.169-.222L252,100.15a2.2,2.2,0,0,0-.259-.239.232.232,0,0,1-.025-.02c-.091-.068-.189-.136-.293-.2-.014-.008-.029-.016-.045-.026a5.481,5.481,0,0,0-1.3-.538h-.007a9.519,9.519,0,0,0-2.552-.332c-2.683,0-4.853.982-4.853,2.194a1.191,1.191,0,0,0,.311.768h0a2.588,2.588,0,0,0,.7.571h.006a3.8,3.8,0,0,0,.478.24l.01,0a5.038,5.038,0,0,0,.531.2.271.271,0,0,0,.031.012c.184.059.376.111.575.157l.1.022c.188.042.379.078.582.109a.512.512,0,0,0,.051.006c.208.03.422.054.643.072.051,0,.1.007.151.011.222.013.451.022.684.022,2.681,0,4.856-.981,4.856-2.192a1.184,1.184,0,0,0-.038-.264c-.007-.025-.018-.05-.025-.074",
    transform: "translate(-242.66 -98.794)",
    fill: "#9bb21f"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14686",
    "data-name": "Group 14686",
    transform: "translate(62.007 111.305)",
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14685",
    "data-name": "Group 14685"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14684",
    "data-name": "Group 14684",
    clipPath: "url(#clip-path-15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31687",
    "data-name": "Path 31687",
    d: "M153.293,162.285s8.134-7.194,33.623-4.643,49.348,5.107,74.022,13.691c-7.049-6.032-6.779-10.21,11.933-14.385s30.907-3.712,28.468,4.176c9.76-11.138,14.371-19.259,39.859-20.882-13.287-2.785-17.354-1.858-30.1-12.068s2.983-17.635,20.064-18.563c-13.016-3.713-21.147-1.625-27.114.7s-12.744-.466-30.1-1.16-25.488-1.162-2.17-8.586c-14.369-.463-13.827,3.48-23.046,2.783s-56.4-6.035-84.053-4.177c-9.221.465-16.271-5.569-27.928-6.033,8.405,3.481,17.623,7.658,2.168,8.586s-30.911,5.107-36.334,3.713-18.435-3.019-24.674-.7c16.813,2.089,30.368,5.569,33.621,9.977S80.9,121.908,68.424,123.3s-14.37,3.944-14.37,3.944,11.387-1.624,19.794,2.553.271,10.676-21.963,9.978c3.526,3.946,9.489,4.177,17.354,3.714s20.336.232,30.91,16.706c-.271-6.728,7.594-10.211,23.045-8.586s32.81,3.48,30.1,6.266,0,4.409,0,4.409",
    transform: "translate(-51.885 -93.135)",
    fill: "#9bb21f"
  }))))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31688",
    "data-name": "Path 31688",
    d: "M231.647,108.608c-.755-.864.161-2.023,2.88-3.082-14.286-3.493-64.788-6.985-96.671-5.458,2.3,1.965,2.04,3.277,2.04,3.277l-.253,1.983c7.84-.66,44.671-3.159,92,3.281",
    transform: "translate(26.894 19.45)",
    fill: "#aa684b"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31689",
    "data-name": "Path 31689",
    d: "M231.712,109c-.02,0-.041,0-.059,0a472.1,472.1,0,0,0-63.484-4.308c-14.618,0-24.747.719-28.424,1.028a.464.464,0,0,1-.317-.1.322.322,0,0,1-.114-.274l.256-1.984c0-.025.161-1.213-1.93-3a.307.307,0,0,1-.087-.359.39.39,0,0,1,.344-.215c5.115-.246,10.9-.37,17.183-.37,29.172,0,67.122,2.785,79.618,5.84a.354.354,0,0,1,.286.3.33.33,0,0,1-.229.33c-1.643.642-2.691,1.36-2.874,1.974a.581.581,0,0,0,.1.546.322.322,0,0,1,.141.257.373.373,0,0,1-.4.337Zm-63.543-4.985a473.762,473.762,0,0,1,62.916,4.22,1.124,1.124,0,0,1,.033-.543c.207-.688,1.019-1.379,2.375-2.019-13.358-2.951-50.037-5.582-78.412-5.582-5.931,0-11.41.11-16.3.329,1.787,1.775,1.579,2.978,1.57,3.033l-.2,1.552c4.039-.326,13.961-.991,28.018-.991",
    transform: "translate(26.83 19.396)",
    fill: "#894730"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14689",
    "data-name": "Group 14689",
    transform: "translate(164.75 119.151)",
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14688",
    "data-name": "Group 14688"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14687",
    "data-name": "Group 14687",
    clipPath: "url(#clip-path-16)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31690",
    "data-name": "Path 31690",
    d: "M139.644,105.327c2.308-.194,7.141-.547,14-.784a24,24,0,0,1,1.333-4.843c-6.051,0-11.839.115-17.118.367,2.3,1.965,2.04,3.277,2.04,3.277Z",
    transform: "translate(-137.856 -99.7)",
    fill: "#aa684b"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14692",
    "data-name": "Group 14692",
    transform: "translate(239.14 121.937)",
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14691",
    "data-name": "Group 14691"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14690",
    "data-name": "Group 14690",
    clipPath: "url(#clip-path-17)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31691",
    "data-name": "Path 31691",
    d: "M222.384,105.071a177.38,177.38,0,0,0-21.5-3.039,24.9,24.9,0,0,1-.786,3.9c6.223.582,12.706,1.311,19.4,2.223-.755-.864.161-2.023,2.88-3.082",
    transform: "translate(-200.102 -102.032)",
    fill: "#aa684b"
  }))))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31692",
    "data-name": "Path 31692",
    d: "M116.792,114.171c-.88,1.759-4.688,3.383-13.707,4.467-19.13,1.091-36.729,3.057-36.729,3.057s9.056,1.293,13.464,4.176a207.206,207.206,0,0,0,32.19-4.036c5.188-1.145,4.963-6.187,4.782-7.664",
    transform: "translate(12.946 22.274)",
    fill: "#aa684b"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31693",
    "data-name": "Path 31693",
    d: "M79.884,126.263a.425.425,0,0,1-.237-.068c-4.283-2.8-13.2-4.1-13.293-4.112a.359.359,0,0,1-.33-.338.367.367,0,0,1,.345-.33c.176-.019,17.828-1.978,36.751-3.057,9.88-1.188,12.727-2.975,13.373-4.263a.406.406,0,0,1,.422-.2.366.366,0,0,1,.33.3c.2,1.578.405,6.817-5.07,8.026a210.018,210.018,0,0,1-32.269,4.044h-.024m-11.028-4.435c2.983.58,8.068,1.791,11.15,3.756a209.12,209.12,0,0,0,31.972-4.018c4.042-.893,4.588-4.348,4.555-6.317-1.788,1.676-6.176,2.917-13.329,3.779-14.843.845-28.9,2.232-34.348,2.8",
    transform: "translate(12.881 22.219)",
    fill: "#894730"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14695",
    "data-name": "Group 14695",
    transform: "translate(79.303 141.161)",
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14694",
    "data-name": "Group 14694"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14693",
    "data-name": "Group 14693",
    clipPath: "url(#clip-path-18)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31694",
    "data-name": "Path 31694",
    d: "M88.7,123.443c.167-1.067.777-3.118,2.182-3.542,2.075-.623,4.353-.59,6.471-1.237.55-.171,1.086-.363,1.63-.546-17.47,1.116-32.624,2.808-32.624,2.808s9.055,1.293,13.464,4.176c3.069-.153,6.011-.368,8.81-.62a6.281,6.281,0,0,1,.066-1.039",
    transform: "translate(-66.357 -118.117)",
    fill: "#aa684b"
  }))))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31695",
    "data-name": "Path 31695",
    d: "M147.155,107.259l.57-4.479a196.6,196.6,0,0,0-50,4.363,59.365,59.365,0,0,1,7.772,3.307,213.18,213.18,0,0,1,41.655-3.191",
    transform: "translate(19.066 20.014)",
    fill: "#aa684b"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31696",
    "data-name": "Path 31696",
    d: "M105.564,110.844a.431.431,0,0,1-.209-.053,58.879,58.879,0,0,0-7.7-3.278.341.341,0,0,1-.25-.335.356.356,0,0,1,.294-.3,205.536,205.536,0,0,1,42.6-4.568c4.7,0,7.5.191,7.525.192a.394.394,0,0,1,.271.122.3.3,0,0,1,.09.25l-.571,4.482a.368.368,0,0,1-.409.3c-.017,0-1.63-.061-4.372-.061a212.22,212.22,0,0,0-37.182,3.243.513.513,0,0,1-.084.01m-6.524-3.565a58.151,58.151,0,0,1,6.6,2.871,213.416,213.416,0,0,1,37.192-3.232c2,0,3.411.032,4.041.049l.485-3.822c-.931-.049-3.419-.166-7.061-.166a205.177,205.177,0,0,0-41.255,4.3",
    transform: "translate(19.002 19.959)",
    fill: "#894730"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14698",
    "data-name": "Group 14698",
    transform: "translate(116.794 123.72)",
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14697",
    "data-name": "Group 14697"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14696",
    "data-name": "Group 14696",
    clipPath: "url(#clip-path-19)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31697",
    "data-name": "Path 31697",
    d: "M114.888,105.888a2.72,2.72,0,0,1,1.476-1.566,5.428,5.428,0,0,1,1.364-.247,8.044,8.044,0,0,0,1.508-.552,196.673,196.673,0,0,0-21.507,3.438,59.365,59.365,0,0,1,7.772,3.307c3.185-.592,6.351-1.078,9.429-1.477a4.757,4.757,0,0,1-.042-2.9",
    transform: "translate(-97.728 -103.524)",
    fill: "#aa684b"
  }))))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31698",
    "data-name": "Path 31698",
    d: "M82.547,126.494c.51,5.021-18.112,7.641-18.112,7.641a50.177,50.177,0,0,1,17.818,2.941,20.3,20.3,0,0,0,.294-10.583",
    transform: "translate(12.571 24.678)",
    fill: "#aa684b"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31699",
    "data-name": "Path 31699",
    d: "M82.317,137.468a.485.485,0,0,1-.165-.03A49.093,49.093,0,0,0,65.4,134.514c-.56,0-.875.012-.88.012a.36.36,0,0,1-.411-.3.348.348,0,0,1,.327-.366c5.08-.716,18.175-3.418,17.782-7.28a.348.348,0,0,1,.325-.36.4.4,0,0,1,.447.244,20.348,20.348,0,0,1-.294,10.749.34.34,0,0,1-.208.221.4.4,0,0,1-.171.036m-14.236-3.553a48.809,48.809,0,0,1,13.96,2.744,21.068,21.068,0,0,0,.506-8.476c-1.07,1.6-3.972,3.074-8.678,4.388-2.047.571-4.122,1.021-5.788,1.343",
    transform: "translate(12.507 24.623)",
    fill: "#894730"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14701",
    "data-name": "Group 14701",
    transform: "translate(77.006 156.19)",
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14700",
    "data-name": "Group 14700"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14699",
    "data-name": "Group 14699",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31700",
    "data-name": "Path 31700",
    d: "M75.92,130.693a75.719,75.719,0,0,1-11.485,2.622,52,52,0,0,1,12.516,1.327,20.2,20.2,0,0,0-1.031-3.949",
    transform: "translate(-64.435 -130.693)",
    fill: "#aa684b"
  }))))), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31701",
    "data-name": "Path 31701",
    d: "M141.805,155.291c0,2.04-4.166,3.7-9.3,3.7s-9.306-1.656-9.306-3.7,4.166-3.692,9.306-3.692,9.3,1.652,9.3,3.692",
    transform: "translate(24.034 29.576)",
    fill: "#b5662a"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31702",
    "data-name": "Path 31702",
    d: "M132.565,159.376c-5.439,0-9.7-1.77-9.7-4.031s4.262-4.027,9.7-4.027,9.7,1.77,9.7,4.027-4.263,4.031-9.7,4.031m0-7.387c-4.832,0-8.913,1.538-8.913,3.356s4.081,3.358,8.913,3.358,8.913-1.537,8.913-3.358-4.081-3.356-8.913-3.356",
    transform: "translate(23.97 29.521)",
    fill: "#914919"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14704",
    "data-name": "Group 14704",
    transform: "translate(147.228 182.405)",
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14703",
    "data-name": "Group 14703"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14702",
    "data-name": "Group 14702",
    clipPath: "url(#clip-path-21)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31703",
    "data-name": "Path 31703",
    d: "M139.42,152.628a8.646,8.646,0,0,1-5.061,3.755,13.138,13.138,0,0,1-7.092.526,9.35,9.35,0,0,1-4.024-2.193,1.479,1.479,0,0,0-.049.373c0,2.041,4.166,3.7,9.306,3.7s9.3-1.655,9.3-3.7c0-.945-.906-1.807-2.385-2.461",
    transform: "translate(-123.194 -152.628)",
    fill: "#b5662a"
  }))))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31704",
    "data-name": "Path 31704",
    d: "M217.353,164.262c-.165,1.01-2.36,1.585-4.9,1.285s-4.48-1.36-4.314-2.371,2.355-1.586,4.9-1.287,4.48,1.362,4.318,2.373",
    transform: "translate(40.603 31.568)",
    fill: "#b5662a"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31705",
    "data-name": "Path 31705",
    d: "M213.837,166.018a11.767,11.767,0,0,1-1.379-.081,9.415,9.415,0,0,1-3.332-.97c-.951-.522-1.417-1.154-1.317-1.782.16-1.006,1.719-1.655,3.968-1.655a11.746,11.746,0,0,1,1.378.081c2.8.331,4.846,1.539,4.649,2.751-.163,1.006-1.719,1.656-3.966,1.656m-2.06-3.816c-1.721,0-3.093.461-3.191,1.076-.055.345.3.755.966,1.123a8.561,8.561,0,0,0,3.014.869c2.21.258,4.339-.239,4.461-1,.112-.705-1.5-1.7-3.981-1.992a11.23,11.23,0,0,0-1.269-.074",
    transform: "translate(40.539 31.513)",
    fill: "#914919"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31706",
    "data-name": "Path 31706",
    d: "M266.859,158.08c.137,2.02-3.878,3.866-8.97,4.125s-9.334-1.174-9.476-3.2,3.877-3.866,8.97-4.124,9.337,1.176,9.476,3.2",
    transform: "translate(48.462 30.211)",
    fill: "#b5662a"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31707",
    "data-name": "Path 31707",
    d: "M256.776,162.625c-4.894,0-8.55-1.488-8.691-3.54-.152-2.241,3.946-4.21,9.34-4.482,5.454-.276,9.738,1.294,9.891,3.514.152,2.238-3.951,4.206-9.342,4.478-.4.021-.806.03-1.2.03m1.849-7.378c-.379,0-.765.007-1.153.03-4.785.24-8.727,1.967-8.6,3.768.121,1.774,4.227,3.125,9.056,2.88,4.785-.244,8.723-1.969,8.6-3.768-.111-1.632-3.586-2.91-7.9-2.91",
    transform: "translate(48.398 30.156)",
    fill: "#914919"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14707",
    "data-name": "Group 14707",
    transform: "translate(296.879 186.077)",
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14706",
    "data-name": "Group 14706"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14705",
    "data-name": "Group 14705",
    clipPath: "url(#clip-path-22)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31708",
    "data-name": "Path 31708",
    d: "M264.61,155.7c-.522,1.509-2.544,2.542-4.151,3.094-3.29,1.133-7.649,1.789-11.015.529a7.168,7.168,0,0,1-1.029-.472c.151,2.016,4.386,3.443,9.472,3.187s9.108-2.106,8.97-4.125c-.061-.881-.9-1.647-2.248-2.213",
    transform: "translate(-248.415 -155.701)",
    fill: "#b5662a"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14710",
    "data-name": "Group 14710",
    transform: "translate(300.368 185.926)",
    opacity: 0.5,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14709",
    "data-name": "Group 14709"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14708",
    "data-name": "Group 14708",
    clipPath: "url(#clip-path-23)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31709",
    "data-name": "Path 31709",
    d: "M258.681,156.177c.086.521-1.488,1.139-3.516,1.38s-3.742.018-3.828-.5,1.493-1.139,3.517-1.38,3.743-.018,3.827.5",
    transform: "translate(-251.335 -155.575)",
    fill: "#b5662a"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14713",
    "data-name": "Group 14713",
    transform: "translate(150.442 182.211)",
    opacity: 0.5,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14712",
    "data-name": "Group 14712"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14711",
    "data-name": "Group 14711",
    clipPath: "url(#clip-path-24)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31710",
    "data-name": "Path 31710",
    d: "M133.231,153.068c.084.52-1.49,1.138-3.522,1.38s-3.739.018-3.823-.5,1.489-1.139,3.516-1.38,3.742-.018,3.829.5",
    transform: "translate(-125.883 -152.467)",
    fill: "#b5662a"
  }))))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31711",
    "data-name": "Path 31711",
    d: "M306.741,122.451c-.263,1.867-4.3,2.99-9.007,2.506s-8.315-2.394-8.054-4.264,4.293-2.993,9.006-2.508,8.317,2.395,8.055,4.266",
    transform: "translate(56.511 23.035)",
    fill: "#b5662a"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31712",
    "data-name": "Path 31712",
    d: "M299.961,125.46a22.064,22.064,0,0,1-2.211-.115c-5-.515-8.69-2.552-8.4-4.639.246-1.742,3.155-2.916,7.237-2.916a21.315,21.315,0,0,1,2.207.116c5,.514,8.692,2.553,8.4,4.639-.247,1.745-3.155,2.915-7.235,2.915m-3.371-7c-3.552,0-6.266.975-6.456,2.322-.232,1.654,3.3,3.437,7.711,3.891a20.843,20.843,0,0,0,2.116.11c3.549,0,6.265-.976,6.455-2.321.231-1.658-3.3-3.437-7.711-3.894a20.494,20.494,0,0,0-2.115-.109",
    transform: "translate(56.447 22.98)",
    fill: "#914919"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14716",
    "data-name": "Group 14716",
    transform: "translate(346.3 142.336)",
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14715",
    "data-name": "Group 14715"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14714",
    "data-name": "Group 14714",
    clipPath: "url(#clip-path-25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31713",
    "data-name": "Path 31713",
    d: "M303.468,119.1a4.071,4.071,0,0,1-3.123,2.85,20.756,20.756,0,0,1-10.577-.694c.641,1.6,3.878,3.08,7.945,3.5,4.711.484,8.744-.639,9.007-2.506.161-1.15-1.138-2.31-3.253-3.149",
    transform: "translate(-289.769 -119.101)",
    fill: "#b5662a"
  }))))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31714",
    "data-name": "Path 31714",
    d: "M319.665,131.857c-.375,1.12-2.513,1.578-4.778,1.024s-3.791-1.912-3.417-3.034,2.513-1.581,4.777-1.024,3.792,1.912,3.418,3.034",
    transform: "translate(60.754 25.086)",
    fill: "#b5662a"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31715",
    "data-name": "Path 31715",
    d: "M316.837,133.507a8.388,8.388,0,0,1-1.993-.247c-2.51-.617-4.13-2.132-3.687-3.453.308-.925,1.56-1.5,3.27-1.5a8.452,8.452,0,0,1,1.993.247c2.507.617,4.129,2.132,3.689,3.451-.313.929-1.566,1.5-3.272,1.5m-2.41-4.528c-1.322,0-2.309.4-2.516,1.016-.308.924,1.133,2.122,3.148,2.618a7.532,7.532,0,0,0,1.778.222c1.321,0,2.308-.4,2.516-1.016.31-.926-1.134-2.125-3.151-2.62a7.5,7.5,0,0,0-1.775-.221",
    transform: "translate(60.69 25.031)",
    fill: "#914919"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31716",
    "data-name": "Path 31716",
    d: "M102.249,153.022c0,.892-2.537,1.616-5.667,1.616s-5.662-.724-5.662-1.616,2.535-1.618,5.662-1.618,5.667.724,5.667,1.618",
    transform: "translate(17.738 29.538)",
    fill: "#b5662a"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31717",
    "data-name": "Path 31717",
    d: "M96.647,155.022c-3.008,0-6.057-.67-6.057-1.95,0-2.565,12.117-2.565,12.117,0,0,1.28-3.049,1.95-6.06,1.95m0-3.232c-3.216,0-5.269.76-5.269,1.281s2.053,1.279,5.269,1.279,5.273-.756,5.273-1.279-2.057-1.281-5.273-1.281",
    transform: "translate(17.673 29.488)",
    fill: "#914919"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14719",
    "data-name": "Group 14719",
    transform: "translate(108.701 181.15)",
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14718",
    "data-name": "Group 14718"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14717",
    "data-name": "Group 14717",
    clipPath: "url(#clip-path-26)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31718",
    "data-name": "Path 31718",
    d: "M99.353,151.579a9.945,9.945,0,0,1-8.4,1.6c.338.8,2.724,1.422,5.619,1.422,3.129,0,5.666-.723,5.666-1.615,0-.606-1.168-1.133-2.889-1.41",
    transform: "translate(-90.956 -151.578)",
    fill: "#b5662a"
  }))))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31719",
    "data-name": "Path 31719",
    d: "M56.569,141.046c0,.892-2.418,1.616-5.395,1.616s-5.395-.724-5.395-1.616,2.415-1.617,5.395-1.617,5.395.725,5.395,1.617",
    transform: "translate(8.931 27.201)",
    fill: "#b5662a"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31720",
    "data-name": "Path 31720",
    d: "M51.239,143.049c-2.874,0-5.788-.672-5.788-1.954,0-2.562,11.577-2.562,11.577,0,0,1.282-2.914,1.954-5.789,1.954m0-3.233c-3.055,0-5,.758-5,1.279s1.946,1.279,5,1.279,5-.755,5-1.279-1.948-1.279-5-1.279",
    transform: "translate(8.867 27.151)",
    fill: "#914919"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31721",
    "data-name": "Path 31721",
    d: "M68.747,126.46c0,.827-2.295,1.5-5.125,1.5s-5.126-.674-5.126-1.5,2.3-1.5,5.126-1.5,5.125.672,5.125,1.5",
    transform: "translate(11.412 24.379)",
    fill: "#b5662a"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31722",
    "data-name": "Path 31722",
    d: "M63.687,128.347c-2.743,0-5.517-.631-5.517-1.836,0-2.412,11.033-2.412,11.033,0,0,1.2-2.774,1.836-5.517,1.836m0-3c-2.889,0-4.73.692-4.73,1.166s1.842,1.163,4.73,1.163,4.733-.688,4.733-1.163-1.844-1.166-4.733-1.166",
    transform: "translate(11.348 24.328)",
    fill: "#914919"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31723",
    "data-name": "Path 31723",
    d: "M74.217,112.148c0,1.148-2.474,2.077-5.531,2.077s-5.526-.929-5.526-2.077,2.474-2.077,5.526-2.077,5.531.93,5.531,2.077",
    transform: "translate(12.322 21.474)",
    fill: "#b5662a"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31724",
    "data-name": "Path 31724",
    d: "M68.75,114.618c-3.375,0-5.92-1.04-5.92-2.415s2.546-2.414,5.92-2.414,5.924,1.039,5.924,2.414-2.547,2.415-5.924,2.415m0-4.155c-3.025,0-5.137.918-5.137,1.74s2.112,1.74,5.137,1.74,5.139-.915,5.139-1.74-2.111-1.74-5.139-1.74",
    transform: "translate(12.258 21.419)",
    fill: "#914919"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14722",
    "data-name": "Group 14722",
    transform: "translate(75.586 131.828)",
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14721",
    "data-name": "Group 14721"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14720",
    "data-name": "Group 14720",
    clipPath: "url(#clip-path-27)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31725",
    "data-name": "Path 31725",
    d: "M71.45,110.308c-.849,2.019-4.707,2.4-8.2,2.2.5.956,2.737,1.674,5.422,1.674,3.057,0,5.531-.929,5.531-2.077,0-.766-1.1-1.434-2.75-1.794",
    transform: "translate(-63.247 -110.308)",
    fill: "#b5662a"
  }))))), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31726",
    "data-name": "Path 31726",
    d: "M155.4,92.211c0,1.659-3.923,3-8.766,3s-8.767-1.342-8.767-3,3.925-3,8.767-3,8.766,1.344,8.766,3",
    transform: "translate(26.896 17.404)",
    fill: "#b5662a"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31727",
    "data-name": "Path 31727",
    d: "M146.7,95.6c-5.135,0-9.16-1.468-9.16-3.337s4.025-3.337,9.16-3.337,9.16,1.466,9.16,3.337S151.831,95.6,146.7,95.6m0-6c-4.932,0-8.373,1.4-8.373,2.664s3.441,2.663,8.373,2.663,8.373-1.4,8.373-2.663S151.631,89.6,146.7,89.6",
    transform: "translate(26.832 17.349)",
    fill: "#914919"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14725",
    "data-name": "Group 14725",
    transform: "translate(164.835 106.989)",
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14724",
    "data-name": "Group 14724"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14723",
    "data-name": "Group 14723",
    clipPath: "url(#clip-path-28)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31728",
    "data-name": "Path 31728",
    d: "M150.858,89.524c-1.241,2.963-7.7,3.521-12.931,3,.537,1.48,4.219,2.627,8.692,2.627,4.841,0,8.766-1.342,8.766-3,0-1.129-1.83-2.114-4.527-2.626",
    transform: "translate(-137.927 -89.524)",
    fill: "#b5662a"
  }))))), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31729",
    "data-name": "Path 31729",
    d: "M213.341,93.221c0,.829-2.295,1.5-5.125,1.5s-5.126-.672-5.126-1.5,2.295-1.5,5.126-1.5,5.125.672,5.125,1.5",
    transform: "translate(39.621 17.894)",
    fill: "#b5662a"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31730",
    "data-name": "Path 31730",
    d: "M208.281,95.109c-2.74,0-5.518-.631-5.518-1.838,0-2.409,11.035-2.409,11.035,0,0,1.207-2.776,1.838-5.518,1.838m0-3c-2.889,0-4.731.688-4.731,1.163s1.843,1.163,4.731,1.163,4.73-.688,4.73-1.163-1.843-1.163-4.73-1.163",
    transform: "translate(39.557 17.844)",
    fill: "#914919"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31731",
    "data-name": "Path 31731",
    d: "M248.686,98.937c0,1.212-2.171,2.194-4.852,2.194s-4.857-.982-4.857-2.194,2.174-2.194,4.857-2.194,4.852.982,4.852,2.194",
    transform: "translate(46.622 18.874)",
    fill: "#b5662a"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31732",
    "data-name": "Path 31732",
    d: "M243.9,101.521c-2.944,0-5.249-1.11-5.249-2.529s2.305-2.53,5.249-2.53,5.248,1.109,5.248,2.53-2.307,2.529-5.248,2.529m0-4.387c-2.42,0-4.464.851-4.464,1.858s2.044,1.856,4.464,1.856,4.459-.85,4.459-1.856-2.042-1.858-4.459-1.858",
    transform: "translate(46.558 18.819)",
    fill: "#914919"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14728",
    "data-name": "Group 14728",
    transform: "translate(285.912 115.945)",
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14727",
    "data-name": "Group 14727"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14726",
    "data-name": "Group 14726",
    clipPath: "url(#clip-path-29)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31733",
    "data-name": "Path 31733",
    d: "M246.332,97.018a4.952,4.952,0,0,1-1.9,2.267,6.537,6.537,0,0,1-5.194.366c.692.832,2.461,1.426,4.545,1.426,2.679,0,4.852-.982,4.852-2.193,0-.789-.921-1.478-2.3-1.866",
    transform: "translate(-239.239 -97.018)",
    fill: "#b5662a"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14731",
    "data-name": "Group 14731",
    transform: "translate(349.329 141.894)",
    opacity: 0.5,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14730",
    "data-name": "Group 14730"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14729",
    "data-name": "Group 14729",
    clipPath: "url(#clip-path-30)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31734",
    "data-name": "Path 31734",
    d: "M299.716,119.723c-.007.525-1.673.933-3.719.912s-3.7-.466-3.694-.992,1.674-.933,3.721-.911,3.7.465,3.692.991",
    transform: "translate(-292.303 -118.731)",
    fill: "#b5662a"
  }))))), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31735",
    "data-name": "Path 31735",
    d: "M79.174,102.916s.369-.022,1.015-.016,1.573,0,2.676.075c1.108.048,2.394.166,3.771.3.688.069,1.4.177,2.112.28s1.45.2,2.175.338,1.439.3,2.146.443,1.4.284,2.063.488c.662.18,1.3.373,1.894.555s1.182.317,1.678.535c1.017.39,1.84.749,2.424.985l.9.391-.966-.269c-.609-.186-1.488-.424-2.512-.752-.509-.183-1.1-.272-1.7-.427s-1.249-.282-1.909-.449-1.352-.284-2.054-.427l-2.127-.416c-.712-.147-1.438-.237-2.145-.355s-1.4-.25-2.079-.335-1.335-.185-1.955-.276-1.213-.167-1.76-.229-1.046-.129-1.488-.192c-.446-.047-.833-.091-1.15-.125l-1.007-.117",
    transform: "translate(15.446 20.075)",
    fill: "#663019"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31736",
    "data-name": "Path 31736",
    d: "M126.526,94.651s.241.03.656.122,1.015.212,1.711.412c.707.173,1.5.453,2.359.741.422.148.852.324,1.289.5s.886.348,1.315.556c.843.433,1.723.813,2.467,1.284l1.073.672a8.675,8.675,0,0,1,.93.635c.543.431.967.813,1.273,1.068s.467.411.467.411-.213-.11-.565-.313-.864-.492-1.447-.858c-.284-.191-.647-.338-.993-.532s-.725-.382-1.11-.583c-.373-.219-.8-.392-1.206-.593l-1.26-.6c-.415-.209-.858-.376-1.278-.566s-.829-.382-1.242-.544c-.825-.326-1.573-.67-2.236-.924s-1.2-.5-1.594-.645l-.609-.245",
    transform: "translate(24.684 18.466)",
    fill: "#663019"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31737",
    "data-name": "Path 31737",
    d: "M218.838,105.246s.154-.117.436-.3.69-.437,1.2-.718c.251-.141.533-.281.833-.429s.613-.312.955-.451c.673-.3,1.4-.6,2.143-.857.378-.128.749-.257,1.117-.384s.748-.213,1.1-.318c.721-.195,1.391-.378,1.986-.477s1.091-.182,1.435-.241.547-.075.547-.075-.18.08-.506.2-.778.3-1.337.484-1.194.429-1.887.666-1.428.494-2.156.764c-.742.241-1.46.533-2.151.772s-1.327.485-1.875.686-1.018.359-1.334.49l-.513.184",
    transform: "translate(42.693 19.704)",
    fill: "#663019"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31738",
    "data-name": "Path 31738",
    d: "M263.141,113.357a20.466,20.466,0,0,1,2.555-2.011,30.95,30.95,0,0,1,2.923-1.754c.551-.3,1.154-.57,1.753-.857.62-.255,1.251-.522,1.894-.757.661-.2,1.3-.459,1.967-.614a18.836,18.836,0,0,1,1.956-.446,14.869,14.869,0,0,1,1.869-.262,16.94,16.94,0,0,1,1.692-.1c.527,0,1.006.01,1.432.023.421.037.788.091,1.091.122.6.08.941.128.941.128s-.347,0-.954,0c-.3,0-.668-.012-1.085,0-.417.037-.886.078-1.4.106a15.2,15.2,0,0,0-1.631.21c-.583.067-1.177.219-1.795.349-.626.112-1.244.319-1.882.488s-1.263.415-1.9.617c-.632.221-1.248.474-1.858.716-.587.278-1.2.5-1.747.786s-1.1.525-1.606.791c-.512.251-.973.521-1.408.759-.851.5-1.572.9-2.052,1.221s-.76.485-.76.485",
    transform: "translate(51.336 20.787)",
    fill: "#663019"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31739",
    "data-name": "Path 31739",
    d: "M69.761,120.488l-.578.03c-.366.012-.889.031-1.515.055l-4.565.116c-.417-.006-.831.031-1.235.047s-.808.027-1.2.042c-.771.059-1.49.116-2.114.145-.307.027-.587.073-.838.1l-.651.079c-.362.042-.578.056-.578.056s.194-.072.537-.183c.174-.054.382-.121.627-.2s.515-.172.822-.237.645-.122,1-.179.734-.13,1.128-.173.8-.075,1.209-.1.834-.068,1.256-.07c.839,0,1.683-.032,2.469.02.788.029,1.523.079,2.146.152.626.057,1.144.151,1.507.2s.566.1.566.1",
    transform: "translate(11.021 23.412)",
    fill: "#663019"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31740",
    "data-name": "Path 31740",
    d: "M67.021,132.987s-.76.195-1.923.375c-.581.1-1.266.166-2,.238s-1.521.1-2.309.131c-.786-.007-1.579.013-2.314-.035s-1.429-.1-2.013-.18-1.067-.192-1.407-.251-.526-.112-.526-.112.2-.012.545-.017.839-.019,1.419,0c.292.006.608-.019.944-.017s.686-.014,1.052-.011.739-.026,1.122-.026.77-.014,1.158-.017c.777-.018,1.555-.036,2.285-.05s1.415-.022,2-.033h1.423l.544.01",
    transform: "translate(10.639 25.943)",
    fill: "#663019"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31741",
    "data-name": "Path 31741",
    d: "M88.768,142.384a4.358,4.358,0,0,1,.7.552,8.215,8.215,0,0,1,.624.63c.215.241.4.517.6.789a8.219,8.219,0,0,1,.509.838,8.329,8.329,0,0,1,.316.79,4.126,4.126,0,0,1,.2.795,5.872,5.872,0,0,1-.611-.631,7.86,7.86,0,0,1-.515-.673c-.081-.129-.2-.246-.292-.381s-.19-.263-.288-.4c-.18-.272-.354-.55-.508-.814a8.207,8.207,0,0,1-.408-.73,7.13,7.13,0,0,1-.331-.767",
    transform: "translate(17.318 27.778)",
    fill: "#663019"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31742",
    "data-name": "Path 31742",
    d: "M141.474,146.06s-.324.324-.827.766c-.257.215-.55.473-.874.733s-.664.543-1.013.816l-.513.414c-.163.142-.353.261-.5.4-.311.269-.621.5-.888.71a9.564,9.564,0,0,1-.883.707,7.153,7.153,0,0,1,.533-.95,10.845,10.845,0,0,1,.735-.875c.289-.3.642-.593.985-.9.372-.268.73-.55,1.1-.776a11.346,11.346,0,0,1,1.046-.586,7.059,7.059,0,0,1,1.1-.46",
    transform: "translate(26.527 28.495)",
    fill: "#663019"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31743",
    "data-name": "Path 31743",
    d: "M214.907,153.162a6.512,6.512,0,0,1,1.141.059,10.881,10.881,0,0,1,1.142.2c.414.087.837.233,1.266.363.414.171.833.326,1.2.52a10.488,10.488,0,0,1,.957.584,7.389,7.389,0,0,1,.789.721,9.54,9.54,0,0,1-1.03-.394c-.306-.111-.667-.232-1.033-.382-.179-.08-.391-.127-.584-.206s-.4-.147-.6-.222c-.411-.135-.808-.287-1.189-.423s-.737-.275-1.042-.391c-.611-.239-1.018-.429-1.018-.429",
    transform: "translate(41.926 29.88)",
    fill: "#663019"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31744",
    "data-name": "Path 31744",
    d: "M261.455,150.042a10.676,10.676,0,0,1,.566-1.312c.207-.405.465-.9.8-1.452.169-.275.351-.568.543-.875s.439-.608.67-.935c.451-.666,1.059-1.315,1.647-2.035.326-.339.66-.687,1-1.042l.525-.54c.2-.166.392-.336.589-.506.394-.343.8-.688,1.2-1.041q.66-.484,1.327-.979a32.272,32.272,0,0,1,2.842-1.852c.991-.576,2.066-1.037,3.077-1.551,1.061-.44,2.126-.832,3.143-1.231,1.052-.337,2.091-.606,3.063-.881a12.792,12.792,0,0,1,1.441-.323l1.361-.256a19.267,19.267,0,0,1,2.4-.373l1.866-.173,1.619-.137-1.6.267-1.833.289c-.716.086-1.489.308-2.345.5q-.64.145-1.329.307a11.714,11.714,0,0,0-1.405.373c-.944.3-1.944.62-2.973.95-.992.406-2.03.8-3.062,1.245-.979.519-2.025.984-2.983,1.557a32.16,32.16,0,0,0-2.81,1.775q-.663.473-1.315.943l-1.194,1c-.195.166-.39.329-.586.49-.179.172-.355.343-.533.512-.356.337-.7.666-1.041.986-.612.687-1.245,1.3-1.722,1.938-.513.614-.951,1.2-1.327,1.721s-.674,1-.917,1.387-.424.7-.531.924-.173.332-.173.332",
    transform: "translate(51.008 25.859)",
    fill: "#663019"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31745",
    "data-name": "Path 31745",
    d: "M222.859,113.322c4.35,1.863,18.409-2.563,45.854,2.544,1.764-1.6,3.331-2.753,3.331-2.753s-13.52-4.147-47.955-4.8a19.556,19.556,0,0,1-6.583-.516,9.339,9.339,0,0,0,5.353,5.526",
    transform: "translate(42.433 21.03)",
    fill: "#aa684b"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31746",
    "data-name": "Path 31746",
    d: "M268.777,116.259a.4.4,0,0,1-.084-.01,145,145,0,0,0-26.757-2.556c-4.081,0-7.533.179-10.305.324-1.934.1-3.607.186-4.987.186a10.257,10.257,0,0,1-3.9-.523,9.719,9.719,0,0,1-5.552-5.736.308.308,0,0,1,.11-.339.451.451,0,0,1,.406-.068,19.549,19.549,0,0,0,6.42.495c34.138.649,47.977,4.782,48.112,4.821a.361.361,0,0,1,.255.256.308.308,0,0,1-.133.317c-.016.012-1.57,1.162-3.3,2.727a.425.425,0,0,1-.286.108m-26.841-3.24a145.567,145.567,0,0,1,26.708,2.534c1.092-.982,2.1-1.789,2.688-2.244-3.071-.795-17.3-4.036-47.188-4.6-.6.031-1.212.048-1.791.048a19.646,19.646,0,0,1-4.17-.381,9.161,9.161,0,0,0,4.915,4.706,9.49,9.49,0,0,0,3.546.455c1.356,0,3.018-.088,4.938-.188,2.785-.146,6.247-.326,10.354-.326",
    transform: "translate(42.369 20.975)",
    fill: "#894730"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14734",
    "data-name": "Group 14734",
    transform: "translate(285.024 130.115)",
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14733",
    "data-name": "Group 14733"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14732",
    "data-name": "Group 14732",
    clipPath: "url(#clip-path-31)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31747",
    "data-name": "Path 31747",
    d: "M238.5,108.874c.035.012.067.025.1.035,2.248.778,4.883,1.353,6.788,2.707a7.45,7.45,0,0,1,1.772,1.8,151.476,151.476,0,0,1,17.46,2.243c1.764-1.6,3.332-2.753,3.332-2.753s-8.587-2.627-29.454-4.029",
    transform: "translate(-238.496 -108.874)",
    fill: "#aa684b"
  }))))), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31748",
    "data-name": "Path 31748",
    d: "M256.545,121.56c.405,2.407.2,3.955,1.809,4.642,1.465.627,12.759,2.969,18.562,12.346.632-.232,1.033-.342,1.033-.342s1.783-9.166-20.15-15.933a2.774,2.774,0,0,1-1.257-1,1.084,1.084,0,0,0,0,.284",
    transform: "translate(50.047 23.66)",
    fill: "#aa684b"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31749",
    "data-name": "Path 31749",
    d: "M276.979,138.938a.414.414,0,0,1-.35-.177c-4.966-8.029-13.919-10.8-17.291-11.84-.512-.157-.883-.27-1.1-.362-1.47-.629-1.624-1.849-1.832-3.533-.054-.418-.11-.874-.189-1.364a1.487,1.487,0,0,1-.011-.361.362.362,0,0,1,.311-.3.419.419,0,0,1,.425.169,2.448,2.448,0,0,0,1.1.858c21.942,6.765,20.432,15.9,20.356,16.288a.349.349,0,0,1-.264.267c-.01,0-.394.108-1,.329a.488.488,0,0,1-.152.026m-19.87-16.623c.031.223.056.434.08.638.216,1.714.365,2.56,1.4,3,.172.072.54.188,1.011.332,3.413,1.054,12.412,3.835,17.55,11.885.2-.069.366-.12.49-.16.073-1.336-.347-9.335-19.916-15.371a4.33,4.33,0,0,1-.619-.329",
    transform: "translate(49.983 23.605)",
    fill: "#894730"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14737",
    "data-name": "Group 14737",
    transform: "translate(318.046 150.023)",
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14736",
    "data-name": "Group 14736"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14735",
    "data-name": "Group 14735",
    clipPath: "url(#clip-path-32)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31750",
    "data-name": "Path 31750",
    d: "M266.127,125.533a13.763,13.763,0,0,1,.755,2.4,13.56,13.56,0,0,1,.241,1.993,24.621,24.621,0,0,1,7.92,7.787c.633-.231,1.033-.342,1.033-.342s1.156-5.978-9.949-11.843",
    transform: "translate(-266.127 -125.533)",
    fill: "#aa684b"
  }))))), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31751",
    "data-name": "Path 31751",
    d: "M293.257,129.661c-1.607-.687-1.4-2.235-1.809-4.642a1.2,1.2,0,0,1,0-.284c-1.316-2.063,1.855-5.582,4.559-8.039-27.445-5.107-41.506-.681-45.854-2.544a9.335,9.335,0,0,1-5.353-5.526,3.184,3.184,0,0,1-1.4-.767c-47.333-6.439-84.164-3.94-92-3.281l-.317,2.5a213.075,213.075,0,0,0-41.655,3.191c3.3,1.751,6.186,3.955,5.172,5.979.18,1.478.405,6.52-4.782,7.664a207.056,207.056,0,0,1-32.19,4.036,4.516,4.516,0,0,1,2.351,3.027,20.306,20.306,0,0,1-.3,10.583,23.272,23.272,0,0,1,11.264,8.407c7.394-5.239,50.248-3.492,61.215,4.367,20.916-3.711,73.716,1.964,89.533,8.513,5.354-11.35,42.85-14.408,60.2-13.1,2.752-4.716,7.776-6.955,9.934-7.735-5.8-9.378-17.1-11.719-18.562-12.346",
    transform: "translate(15.144 20.201)",
    fill: "#83492a"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31752",
    "data-name": "Path 31752",
    d: "M241.754,163.232a.461.461,0,0,1-.173-.033c-11.988-4.966-46.833-9.659-71.7-9.659a105.517,105.517,0,0,0-17.576,1.171.442.442,0,0,1-.331-.072c-6.673-4.78-25.449-7.282-40.553-7.282-10.047,0-17.581,1.092-20.161,2.917a.454.454,0,0,1-.324.073.4.4,0,0,1-.268-.164c-2.377-3.564-6.109-6.345-11.086-8.269a.325.325,0,0,1-.217-.387,20.173,20.173,0,0,0,.294-10.418,4.166,4.166,0,0,0-2.2-2.843.314.314,0,0,1-.14-.368.39.39,0,0,1,.355-.235,209.03,209.03,0,0,0,32.113-4.025c4.869-1.073,4.667-5.862,4.489-7.3a.318.318,0,0,1,.027-.17c.951-1.9-2.2-4.069-5.018-5.562a.319.319,0,0,1-.177-.343.36.36,0,0,1,.3-.271,213.055,213.055,0,0,1,37.348-3.259c2,0,3.411.031,4.038.049l.276-2.186a.379.379,0,0,1,.354-.3c3.689-.307,13.85-1.03,28.5-1.03a473.489,473.489,0,0,1,63.606,4.315.411.411,0,0,1,.253.13,2.813,2.813,0,0,0,1.22.655.36.36,0,0,1,.238.222,9.011,9.011,0,0,0,5.152,5.318,9.457,9.457,0,0,0,3.546.455c1.356,0,3.018-.087,4.938-.186,2.781-.146,6.247-.326,10.354-.326a145.563,145.563,0,0,1,26.924,2.574.374.374,0,0,1,.292.226.306.306,0,0,1-.09.332c-3.83,3.478-5.428,6.193-4.5,7.649a.281.281,0,0,1,.049.188.866.866,0,0,0,0,.21c.082.5.14.961.192,1.385.215,1.714.363,2.559,1.4,3,.171.073.54.188,1.01.332,3.45,1.066,12.612,3.9,17.721,12.154a.293.293,0,0,1,.022.27.362.362,0,0,1-.216.2c-2.024.731-7.026,2.938-9.733,7.578a.418.418,0,0,1-.388.184c-2.471-.186-5.285-.281-8.361-.281-18.18,0-46.876,3.508-51.436,13.17a.374.374,0,0,1-.225.188.416.416,0,0,1-.139.023m-71.876-10.364c24.711,0,59.272,4.63,71.674,9.574,2.889-5.424,12.774-8.55,20.648-10.219a158.31,158.31,0,0,1,31.353-3.045c2.989,0,5.734.088,8.166.265,2.683-4.425,7.347-6.67,9.615-7.545-5-7.781-13.764-10.488-17.091-11.517-.51-.158-.883-.271-1.1-.363-1.47-.629-1.624-1.849-1.832-3.533-.054-.418-.11-.874-.189-1.364a1.326,1.326,0,0,1-.017-.262c-.991-1.713.421-4.373,4.2-7.906a144.269,144.269,0,0,0-26.08-2.432c-4.085,0-7.535.178-10.305.324-1.937.1-3.609.186-4.987.186a10.227,10.227,0,0,1-3.9-.525,9.74,9.74,0,0,1-5.5-5.575,3.618,3.618,0,0,1-1.284-.709,472.638,472.638,0,0,0-63.337-4.286c-14.214,0-24.184.679-28.1,1l-.282,2.226a.358.358,0,0,1-.408.3c-.018,0-1.631-.061-4.373-.061a213.521,213.521,0,0,0-36.247,3.073c3.817,2.163,5.346,4.136,4.553,5.874.189,1.673.3,6.752-5.079,7.94a209.021,209.021,0,0,1-31.29,4A4.141,4.141,0,0,1,80.43,131a20.233,20.233,0,0,1-.231,10.419,23.507,23.507,0,0,1,10.922,8.1c3.018-1.8,10.349-2.834,20.3-2.834,15.135,0,33.97,2.519,40.908,7.335a107.39,107.39,0,0,1,17.552-1.152",
    transform: "translate(15.079 20.146)",
    fill: "#663019"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31753",
    "data-name": "Path 31753",
    d: "M91.444,98.918s-3-9.255-19.525-6.427c13.218-6.427,22.53.257,22.53.257s-3-5.915-9.312-6.684c12.015-1.029,13.818,6.169,13.818,6.169s.9-6.426,6.91-7.711a17.794,17.794,0,0,0-3.906,8.74s4.206-4.626,9.313-4.626c-7.811,7.2-9.015,10.8-9.015,10.8Z",
    transform: "translate(14.031 16.489)",
    fill: "#237812"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31754",
    "data-name": "Path 31754",
    d: "M102.323,99.823h-.02l-10.814-.515a.393.393,0,0,1-.36-.244c-.088-.275-2.334-6.72-13.263-6.72a34.682,34.682,0,0,0-5.806.532.412.412,0,0,1-.446-.215.315.315,0,0,1,.174-.408,26.548,26.548,0,0,1,11.647-2.837,21.8,21.8,0,0,1,9.955,2.318,12.292,12.292,0,0,0-8.245-5.284.359.359,0,0,1-.338-.338.366.366,0,0,1,.354-.331c.792-.066,1.57-.1,2.309-.1,7.5,0,10.42,3.518,11.443,5.39.6-1.973,2.336-5.839,6.918-6.822a.43.43,0,0,1,.418.131.3.3,0,0,1,.007.381,19.151,19.151,0,0,0-3.656,7.479c1.526-1.376,4.847-3.889,8.735-3.889a.4.4,0,0,1,.361.2.3.3,0,0,1-.073.365C104,95.945,102.713,99.544,102.7,99.579a.4.4,0,0,1-.379.244M91.8,98.648l10.249.49c.4-.92,2.158-4.25,8.331-10.056-4.423.514-8.008,4.4-8.048,4.441a.436.436,0,0,1-.448.108.337.337,0,0,1-.252-.336,17.472,17.472,0,0,1,3.374-8.108c-4.766,1.679-5.588,7.083-5.6,7.139a.377.377,0,0,1-.373.3.4.4,0,0,1-.4-.268c-.063-.241-1.617-5.917-10.952-6a13.975,13.975,0,0,1,7.187,6.314.3.3,0,0,1-.123.4.45.45,0,0,1-.488-.011,20.03,20.03,0,0,0-10.825-2.97,24.786,24.786,0,0,0-9.044,1.777,32.164,32.164,0,0,1,3.474-.2c6.015,0,9.5,1.95,11.371,3.583a9.629,9.629,0,0,1,2.563,3.4",
    transform: "translate(13.967 16.434)",
    fill: "#175607"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14740",
    "data-name": "Group 14740",
    transform: "translate(92.767 123.748)",
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14739",
    "data-name": "Group 14739"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14738",
    "data-name": "Group 14738",
    clipPath: "url(#clip-path-33)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31755",
    "data-name": "Path 31755",
    d: "M293.257,129.661c-1.606-.687-1.4-2.235-1.808-4.642a1.084,1.084,0,0,1,0-.284c-1.317-2.062,1.854-5.582,4.558-8.039-27.445-5.107-41.5-.681-45.854-2.543a9.335,9.335,0,0,1-5.352-5.526,3.2,3.2,0,0,1-1.4-.768c-47.334-6.439-84.166-3.94-92-3.281l-.317,2.5a213.127,213.127,0,0,0-41.655,3.192c3.3,1.751,6.185,3.955,5.171,5.98.182,1.477.406,6.519-4.782,7.664a207.357,207.357,0,0,1-32.19,4.036,4.508,4.508,0,0,1,2.351,3.025,20.3,20.3,0,0,1-.294,10.584,23.277,23.277,0,0,1,11.263,8.409c7.4-5.239,50.249-3.492,61.215,4.366,20.916-3.711,73.717,1.965,89.533,8.513,5.354-11.35,42.85-14.408,60.2-13.1,2.753-4.716,7.776-6.954,9.935-7.735-5.8-9.377-17.1-11.718-18.563-12.346m-32.6,17.395c-26.484,2.831-22.843,10.482-41.713,5.383s-28.472-4.533-47.011-3.4-24.5-3.116-11.919-5.949-12.251-5.95-41.051-3.4-41.715-4.531-12.912-9.349,39.065-9.631,26.155-11.9-13.243-3.4-1-5.383c0,0,8.94-2.266,33.106,0s21.19-1.7,9.27-3.682,15.23-3.4,45.687.281,6.953,11.052,32.113,9.919,45.688,1.7,32.113,6.8,0,3.683,9.6,8.784-5.959,9.065-32.444,11.9",
    transform: "translate(-77.623 -103.547)",
    fill: "#83492a"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14743",
    "data-name": "Group 14743",
    transform: "translate(120.572 173.794)",
    opacity: 0.6,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14742",
    "data-name": "Group 14742"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14741",
    "data-name": "Group 14741",
    clipPath: "url(#clip-path-34)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31756",
    "data-name": "Path 31756",
    d: "M238.081,161.941c-7.619-2.442-15.49-4.356-23.168-6.685a138.607,138.607,0,0,0-22.525-4.417,127.111,127.111,0,0,0-25.422-1.177c-7.822.546-15.827,1.2-23.176,3.647-.323.109-.805.993-.25.862,7.678-1.811,15.959-2.084,23.892-2.507,7.9-.418,15.958.489,23.746,1.594a147.406,147.406,0,0,1,23.352,4.831,173.976,173.976,0,0,0,22.328,5.867c.829.14,2.1-1.732,1.223-2.014",
    transform: "translate(-92.618 -144.639)",
    fill: "#9bb21f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31757",
    "data-name": "Path 31757",
    d: "M228.659,161.15c-.985-.331-1.983-.568-3-.807-.578-.134-1.454,1.2-.854,1.407.98.33,1.936.648,2.952.888.611.145,1.54-1.273.9-1.488",
    transform: "translate(-76.754 -142.514)",
    fill: "#9bb21f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31758",
    "data-name": "Path 31758",
    d: "M134.869,149.373a49.851,49.851,0,0,0-15.712-3.778c-6.231-.614-11.528.535-17.527,1.567-.526.092-1.169,1.3-.354,1.223,5.754-.546,10.949-1.224,16.785-.6,5.392.578,10.523,2.167,15.767,3.295.7.149,1.76-1.384,1.041-1.708",
    transform: "translate(-100.889 -145.423)",
    fill: "#9bb21f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31759",
    "data-name": "Path 31759",
    d: "M262.65,146.854c-6.683-.786-14.115.288-20.558,1.823a55.8,55.8,0,0,0-8.87,3.08,19.587,19.587,0,0,0-3.31,1.954c-1.01.7-1.421,1.912-2.379,2.556-.349.235-.728,1.356.078,1.005,1.7-.736,2.672-2.167,4.4-2.979a51.745,51.745,0,0,1,9.3-2.92c6.69-1.668,13.554-1.313,20.375-2.082.886-.1,2.292-2.28.966-2.437",
    transform: "translate(-76.26 -145.195)",
    fill: "#9bb21f"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14746",
    "data-name": "Group 14746",
    transform: "translate(93.049 102.382)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14745",
    "data-name": "Group 14745"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14744",
    "data-name": "Group 14744",
    clipPath: "url(#clip-path-35)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31760",
    "data-name": "Path 31760",
    d: "M89.2,93.458c-2.659-3.373-6.731-4.012-11.154-3.582-.112.012-.287.3-.12.31a22.9,22.9,0,0,1,5.855.678,13.794,13.794,0,0,1,4.851,3.167c.268.245.746-.349.568-.572",
    transform: "translate(-77.859 -84.871)",
    fill: "#237812"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31761",
    "data-name": "Path 31761",
    d: "M91.98,88.879c-1.207-1.646-3.665-2.419-5.788-2.773-.142-.023-.361.294-.21.347a13.141,13.141,0,0,1,4.984,2.77c1.254,1.258,1.524,3.061,1.883,4.62.09.387.657-.188.654-.394a7.978,7.978,0,0,0-1.523-4.57",
    transform: "translate(-76.285 -85.584)",
    fill: "#237812"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31762",
    "data-name": "Path 31762",
    d: "M99.1,85.688c-3.343,1.451-3.884,4.958-4.1,7.864-.038.529.7-.06.739-.355.3-2.663.655-5.552,3.381-7.229.108-.065.2-.376-.019-.28",
    transform: "translate(-74.515 -85.669)",
    fill: "#237812"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31763",
    "data-name": "Path 31763",
    d: "M103.939,88.573a12.585,12.585,0,0,0-7.255,5.077c-.252.373.105.561.385.206a15.8,15.8,0,0,1,6.806-4.923c.117-.049.294-.416.065-.36",
    transform: "translate(-74.204 -85.104)",
    fill: "#237812"
  }))))), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31764",
    "data-name": "Path 31764",
    d: "M273.762,109.684s-4.507-6.685-12.315-7.455c9.01-1.286,13.818,2.826,13.818,2.826s-.9-5.655-3.9-6.94c7.51.257,7.51,5.4,7.51,5.4s1.8-5.4,5.105-5.656a23.612,23.612,0,0,0,.3,4.629,9.271,9.271,0,0,1,7.51-3.343c-7.51,6.683-8.852,9.224-8.852,9.224s-6.471-.74-9.172,1.317",
    transform: "translate(51.006 19.091)",
    fill: "#237812"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31765",
    "data-name": "Path 31765",
    d: "M273.828,110.075a.282.282,0,0,1-.063,0,.392.392,0,0,1-.276-.164c-.044-.065-4.5-6.548-12.021-7.29a.36.36,0,0,1-.349-.324.355.355,0,0,1,.327-.342,24.72,24.72,0,0,1,3.485-.252,18.333,18.333,0,0,1,9.822,2.566c-.385-1.606-1.414-4.9-3.505-5.794a.322.322,0,0,1-.2-.385.433.433,0,0,1,.4-.253c5.331.183,7.059,2.771,7.617,4.407.773-1.673,2.432-4.466,4.947-4.661a.424.424,0,0,1,.3.086.311.311,0,0,1,.13.247,33.728,33.728,0,0,0,.176,3.776,9.555,9.555,0,0,1,7.264-2.826.4.4,0,0,1,.345.213.306.306,0,0,1-.084.356c-7.338,6.53-8.765,9.1-8.777,9.129a.415.415,0,0,1-.411.194c-.029,0-6.315-.7-8.858,1.236a.431.431,0,0,1-.262.085M264,102.389a19.218,19.218,0,0,1,9.926,6.849c2.629-1.624,7.62-1.29,8.846-1.178.467-.724,2.317-3.27,8.158-8.527a8.966,8.966,0,0,0-6.262,3.189.417.417,0,0,1-.4.148.373.373,0,0,1-.312-.263,22.346,22.346,0,0,1-.308-4.292c-2.738.651-4.321,5.3-4.335,5.344a.407.407,0,0,1-.433.243.358.358,0,0,1-.338-.332c0-.185-.093-4.216-5.8-4.957,2.24,2.005,2.94,6.244,2.973,6.452a.329.329,0,0,1-.215.345.452.452,0,0,1-.453-.061c-.035-.031-3.575-2.979-10.12-2.979-.3,0-.614.006-.926.019",
    transform: "translate(50.942 19.037)",
    fill: "#175607"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14749",
    "data-name": "Group 14749",
    transform: "translate(315.627 121.201)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14748",
    "data-name": "Group 14748"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14747",
    "data-name": "Group 14747",
    clipPath: "url(#clip-path-36)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31766",
    "data-name": "Path 31766",
    d: "M271.933,105.024a8.2,8.2,0,0,0-3.358-2.623,10.281,10.281,0,0,0-1.763-.66c-.851-.221-1.7-.147-2.535-.324-.1-.02-.237.2-.141.231a5.261,5.261,0,0,0,1.12.161,8.691,8.691,0,0,1,2.609.825,11.86,11.86,0,0,1,3.741,2.718c.148.149.416-.2.327-.327",
    transform: "translate(-264.103 -101.416)",
    fill: "#237812"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14752",
    "data-name": "Group 14752",
    transform: "translate(323.896 117.678)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14751",
    "data-name": "Group 14751"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14750",
    "data-name": "Group 14750",
    clipPath: "url(#clip-path-37)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31767",
    "data-name": "Path 31767",
    d: "M271.305,98.48c-.149-.075-.379.241-.24.331a9.977,9.977,0,0,1,3.2,3.235,11.493,11.493,0,0,1,1.2,4.617c.038.247.4-.13.41-.247a7.943,7.943,0,0,0-4.572-7.935",
    transform: "translate(-271.022 -98.468)",
    fill: "#237812"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14755",
    "data-name": "Group 14755",
    transform: "translate(330.761 117.543)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14754",
    "data-name": "Group 14754"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14753",
    "data-name": "Group 14753",
    clipPath: "url(#clip-path-38)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31768",
    "data-name": "Path 31768",
    d: "M280.363,98.383c-2.575,1.366-3.358,4.094-3.595,6.519-.042.429.569-.057.6-.293.33-2.151.857-4.5,3.016-5.875.134-.082.234-.489-.025-.351",
    transform: "translate(-276.766 -98.355)",
    fill: "#237812"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14758",
    "data-name": "Group 14758",
    transform: "translate(335.926 118.576)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14757",
    "data-name": "Group 14757"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14756",
    "data-name": "Group 14756",
    clipPath: "url(#clip-path-39)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31769",
    "data-name": "Path 31769",
    d: "M286.613,99.237c-2.3-.249-4.321,2.281-5.439,3.656-.226.275.027.6.327.283,1.376-1.456,2.7-3.11,4.955-3.545.135-.026.38-.369.157-.394",
    transform: "translate(-281.088 -99.219)",
    fill: "#237812"
  }))))))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14762",
    "data-name": "Group 14762",
    transform: "translate(183.476 73.392)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14761",
    "data-name": "Group 14761",
    clipPath: "url(#clip-path-40)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31770",
    "data-name": "Path 31770",
    d: "M153.618,59.452,346.507,61.8l-.834,42.38-192.89-2.351Z",
    transform: "translate(-153.669 -61.793)",
    fill: "url(#radial-gradient)"
  })))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14764",
    "data-name": "Group 14764",
    transform: "translate(334.471 75.759)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14763",
    "data-name": "Group 14763",
    clipPath: "url(#clip-path-41)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31772",
    "data-name": "Path 31772",
    d: "M279.923,62.984l40.269.491-.272,13.813L279.652,76.8Z",
    transform: "translate(-279.914 -63.472)",
    fill: "url(#radial-gradient-2)"
  })))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14766",
    "data-name": "Group 14766",
    transform: "translate(312.827 76.926)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14765",
    "data-name": "Group 14765",
    clipPath: "url(#clip-path-42)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31774",
    "data-name": "Path 31774",
    d: "M261.815,63.969l39.428.48-.291,14.774-39.428-.48Z",
    transform: "translate(-261.806 -64.446)",
    fill: "url(#radial-gradient-3)"
  })))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14768",
    "data-name": "Group 14768",
    transform: "translate(253.474 77.777)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14767",
    "data-name": "Group 14767",
    clipPath: "url(#clip-path-43)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31776",
    "data-name": "Path 31776",
    d: "M212.155,64.477,271.6,65.2l-.287,14.608-59.449-.724Z",
    transform: "translate(-212.141 -65.198)",
    fill: "url(#radial-gradient-4)"
  })))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14770",
    "data-name": "Group 14770",
    transform: "translate(216.094 76.036)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14769",
    "data-name": "Group 14769",
    clipPath: "url(#clip-path-44)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31778",
    "data-name": "Path 31778",
    d: "M180.876,63.157l46.067.561-.3,15.33-46.067-.561Z",
    transform: "translate(-180.865 -63.715)",
    fill: "url(#radial-gradient-5)"
  })))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14772",
    "data-name": "Group 14772",
    transform: "translate(187.495 73.794)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14771",
    "data-name": "Group 14771",
    clipPath: "url(#clip-path-45)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31780",
    "data-name": "Path 31780",
    d: "M156.944,61.272l46.958.572-.287,14.584-46.958-.572Z",
    transform: "translate(-156.933 -61.841)",
    fill: "url(#radial-gradient-6)"
  })))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14774",
    "data-name": "Group 14774",
    transform: "translate(184.561 80.831)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14773",
    "data-name": "Group 14773",
    clipPath: "url(#clip-path-46)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31782",
    "data-name": "Path 31782",
    d: "M154.4,67.347l28.846.352-.559,28.411-28.846-.352Z",
    transform: "translate(-154.547 -67.692)",
    fill: "url(#radial-gradient-7)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14786",
    "data-name": "Group 14786"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14785",
    "data-name": "Group 14785",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14779",
    "data-name": "Group 14779",
    transform: "translate(184.63 89.008)",
    opacity: 0.4,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14778",
    "data-name": "Group 14778"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14777",
    "data-name": "Group 14777",
    clipPath: "url(#clip-path-48)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14776",
    "data-name": "Group 14776",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14775",
    "data-name": "Group 14775",
    clipPath: "url(#clip-path-49)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31784",
    "data-name": "Path 31784",
    d: "M154.379,74.19l28.683.35-.4,20.236-28.683-.35Z",
    transform: "translate(-154.59 -74.534)",
    fill: "url(#radial-gradient-8)"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14784",
    "data-name": "Group 14784",
    transform: "translate(212.468 77.743)",
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14783",
    "data-name": "Group 14783"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14782",
    "data-name": "Group 14782",
    clipPath: "url(#clip-path-50)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14781",
    "data-name": "Group 14781",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14780",
    "data-name": "Group 14780",
    clipPath: "url(#clip-path-51)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31786",
    "data-name": "Path 31786",
    d: "M177.877,64.858,197.5,65.1l-.62,31.508-19.623-.239Z",
    transform: "translate(-177.887 -65.09)",
    fill: "url(#radial-gradient-9)"
  }))))))))), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14788",
    "data-name": "Group 14788",
    transform: "translate(215.66 88.689)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14787",
    "data-name": "Group 14787",
    clipPath: "url(#clip-path-52)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31788",
    "data-name": "Path 31788",
    d: "M180.486,73.828l38.077.464-.478,24.274L180.008,98.1Z",
    transform: "translate(-180.542 -74.286)",
    fill: "url(#radial-gradient-10)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14800",
    "data-name": "Group 14800"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14799",
    "data-name": "Group 14799",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14793",
    "data-name": "Group 14793",
    transform: "translate(215.66 90.917)",
    opacity: 0.4,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14792",
    "data-name": "Group 14792"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14791",
    "data-name": "Group 14791",
    clipPath: "url(#clip-path-54)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14790",
    "data-name": "Group 14790",
    transform: "translate(-0.001 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14789",
    "data-name": "Group 14789",
    clipPath: "url(#clip-path-55)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31790",
    "data-name": "Path 31790",
    d: "M180.478,75.692l38.034.464L218.078,98.2l-38.034-.463Z",
    transform: "translate(-180.535 -76.15)",
    fill: "url(#radial-gradient-11)"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14798",
    "data-name": "Group 14798",
    transform: "translate(250.399 78.202)",
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14797",
    "data-name": "Group 14797"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14796",
    "data-name": "Group 14796",
    clipPath: "url(#clip-path-56)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14795",
    "data-name": "Group 14795",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14794",
    "data-name": "Group 14794",
    clipPath: "url(#clip-path-57)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31792",
    "data-name": "Path 31792",
    d: "M209.249,65.3l14.255.174-.668,33.977-14.255-.174Z",
    transform: "translate(-209.707 -65.463)",
    fill: "url(#radial-gradient-12)"
  }))))))))), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14802",
    "data-name": "Group 14802",
    transform: "translate(252.911 90.379)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14801",
    "data-name": "Group 14801",
    clipPath: "url(#clip-path-58)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31794",
    "data-name": "Path 31794",
    d: "M211.455,75.03l58.77.716-.447,22.743-58.77-.716Z",
    transform: "translate(-211.745 -75.741)",
    fill: "url(#radial-gradient-13)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14809",
    "data-name": "Group 14809"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14808",
    "data-name": "Group 14808",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14807",
    "data-name": "Group 14807",
    transform: "translate(310.332 79.309)",
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14806",
    "data-name": "Group 14806"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14805",
    "data-name": "Group 14805",
    clipPath: "url(#clip-path-60)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14804",
    "data-name": "Group 14804",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14803",
    "data-name": "Group 14803",
    clipPath: "url(#clip-path-61)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31796",
    "data-name": "Path 31796",
    d: "M259.74,66.328l4.007.049-.627,31.888-4.007-.049Z",
    transform: "translate(-259.781 -66.369)",
    fill: "url(#radial-gradient-14)"
  }))))))))), _g50 || (_g50 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14811",
    "data-name": "Group 14811",
    transform: "translate(312.791 90.613)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14810",
    "data-name": "Group 14810",
    clipPath: "url(#clip-path-62)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31798",
    "data-name": "Path 31798",
    d: "M261.8,75.418l39.968.487-.445,22.614-39.968-.487Z",
    transform: "translate(-261.804 -75.9)",
    fill: "url(#radial-gradient-15)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14818",
    "data-name": "Group 14818"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14817",
    "data-name": "Group 14817",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14816",
    "data-name": "Group 14816",
    transform: "translate(333.702 76.874)",
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g51 || (_g51 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14815",
    "data-name": "Group 14815"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14814",
    "data-name": "Group 14814",
    clipPath: "url(#clip-path-64)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14813",
    "data-name": "Group 14813",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14812",
    "data-name": "Group 14812",
    clipPath: "url(#clip-path-65)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31800",
    "data-name": "Path 31800",
    d: "M279.339,64.115l21.235.259-.66,33.543-21.235-.259Z",
    transform: "translate(-279.334 -64.366)",
    fill: "url(#radial-gradient-16)"
  }))))))))), _g52 || (_g52 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14820",
    "data-name": "Group 14820",
    transform: "translate(353.335 81.78)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14819",
    "data-name": "Group 14819",
    clipPath: "url(#clip-path-66)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31802",
    "data-name": "Path 31802",
    d: "M295.688,68.213l21.8.266-.555,28.211-21.8-.266Z",
    transform: "translate(-295.757 -68.472)",
    fill: "url(#radial-gradient-17)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14832",
    "data-name": "Group 14832"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14831",
    "data-name": "Group 14831",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14825",
    "data-name": "Group 14825",
    transform: "translate(254.411 98.404)",
    opacity: 0.4,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g53 || (_g53 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14824",
    "data-name": "Group 14824"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14823",
    "data-name": "Group 14823",
    clipPath: "url(#clip-path-68)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14822",
    "data-name": "Group 14822",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14821",
    "data-name": "Group 14821",
    clipPath: "url(#clip-path-69)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31804",
    "data-name": "Path 31804",
    d: "M212.939,81.764l56.808.692-.289,14.7-56.808-.692Z",
    transform: "translate(-212.925 -82.452)",
    fill: "url(#radial-gradient-18)"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14830",
    "data-name": "Group 14830",
    transform: "translate(313.072 92.501)",
    opacity: 0.4,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g54 || (_g54 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14829",
    "data-name": "Group 14829"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14828",
    "data-name": "Group 14828",
    clipPath: "url(#clip-path-70)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14827",
    "data-name": "Group 14827",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14826",
    "data-name": "Group 14826",
    clipPath: "url(#clip-path-71)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31806",
    "data-name": "Path 31806",
    d: "M262.012,77.008l38.971.475L300.576,98.2,261.6,97.723Z",
    transform: "translate(-262.035 -77.478)",
    fill: "url(#radial-gradient-19)"
  }))))))))), _g55 || (_g55 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14834",
    "data-name": "Group 14834",
    transform: "translate(312.791 91.49)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14833",
    "data-name": "Group 14833",
    clipPath: "url(#clip-path-72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31808",
    "data-name": "Path 31808",
    d: "M261.728,76.55l.522.006-.054,2.723-.522-.006Z",
    transform: "translate(-261.741 -76.556)",
    fill: "url(#radial-gradient-20)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15227",
    "data-name": "Group 15227"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15226",
    "data-name": "Group 15226",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14839",
    "data-name": "Group 14839",
    transform: "translate(353.335 83.513)",
    opacity: 0.4,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g56 || (_g56 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14838",
    "data-name": "Group 14838"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14837",
    "data-name": "Group 14837",
    clipPath: "url(#clip-path-74)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14836",
    "data-name": "Group 14836",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14835",
    "data-name": "Group 14835",
    clipPath: "url(#clip-path-75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31810",
    "data-name": "Path 31810",
    d: "M295.682,69.664l21.688.264-.521,26.478-21.688-.264Z",
    transform: "translate(-295.752 -69.922)",
    fill: "url(#radial-gradient-21)"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14844",
    "data-name": "Group 14844",
    transform: "translate(190.018 98.618)",
    opacity: 0.4,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g57 || (_g57 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14843",
    "data-name": "Group 14843"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14842",
    "data-name": "Group 14842",
    clipPath: "url(#clip-path-76)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14841",
    "data-name": "Group 14841",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14840",
    "data-name": "Group 14840",
    clipPath: "url(#clip-path-77)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31812",
    "data-name": "Path 31812",
    d: "M159.038,82.09l22.894.279-.212,10.8-22.894-.279Z",
    transform: "translate(-159.033 -82.602)",
    fill: "url(#radial-gradient-22)"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14849",
    "data-name": "Group 14849",
    transform: "translate(184.787 97.811)",
    opacity: 0.4,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g58 || (_g58 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14848",
    "data-name": "Group 14848"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14847",
    "data-name": "Group 14847",
    clipPath: "url(#clip-path-78)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14846",
    "data-name": "Group 14846"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14845",
    "data-name": "Group 14845",
    clipPath: "url(#clip-path-79)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31814",
    "data-name": "Path 31814",
    d: "M154.626,81.825l1.837.022-.02,1.04-1.837-.022Z",
    transform: "translate(-154.625 -81.848)",
    fill: "url(#radial-gradient-23)"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14854",
    "data-name": "Group 14854",
    transform: "translate(216.231 104.486)",
    opacity: 0.4,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g59 || (_g59 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14853",
    "data-name": "Group 14853"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14852",
    "data-name": "Group 14852",
    clipPath: "url(#clip-path-80)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14851",
    "data-name": "Group 14851",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14850",
    "data-name": "Group 14850",
    clipPath: "url(#clip-path-81)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31816",
    "data-name": "Path 31816",
    d: "M180.968,87.006l37.131.452-.168,8.529L180.8,95.535Z",
    transform: "translate(-180.959 -87.512)",
    fill: "url(#radial-gradient-24)"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14859",
    "data-name": "Group 14859",
    transform: "translate(256.143 106.477)",
    opacity: 0.4,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g60 || (_g60 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14858",
    "data-name": "Group 14858"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14857",
    "data-name": "Group 14857",
    clipPath: "url(#clip-path-82)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14856",
    "data-name": "Group 14856",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14855",
    "data-name": "Group 14855",
    clipPath: "url(#clip-path-83)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31818",
    "data-name": "Path 31818",
    d: "M214.363,87.971l54.931.669-.143,7.282-54.931-.669Z",
    transform: "translate(-214.35 -89.314)",
    fill: "url(#radial-gradient-25)"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14864",
    "data-name": "Group 14864",
    transform: "translate(313.072 104.386)",
    opacity: 0.4,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g61 || (_g61 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14863",
    "data-name": "Group 14863"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14862",
    "data-name": "Group 14862",
    clipPath: "url(#clip-path-84)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14861",
    "data-name": "Group 14861",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14860",
    "data-name": "Group 14860",
    clipPath: "url(#clip-path-85)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31820",
    "data-name": "Path 31820",
    d: "M261.974,86.963l37.7.459-.174,8.82-37.7-.459Z",
    transform: "translate(-261.997 -87.421)",
    fill: "url(#radial-gradient-26)"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14869",
    "data-name": "Group 14869",
    transform: "translate(353.335 95.298)",
    opacity: 0.4,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g62 || (_g62 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14868",
    "data-name": "Group 14868"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14867",
    "data-name": "Group 14867",
    clipPath: "url(#clip-path-86)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14866",
    "data-name": "Group 14866",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14865",
    "data-name": "Group 14865",
    clipPath: "url(#clip-path-87)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31822",
    "data-name": "Path 31822",
    d: "M295.644,79.527l21.315.26-.289,14.694-21.315-.26Z",
    transform: "translate(-295.714 -79.783)",
    fill: "url(#radial-gradient-27)"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14874",
    "data-name": "Group 14874",
    transform: "translate(334.473 75.759)",
    opacity: 0.4,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g63 || (_g63 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14873",
    "data-name": "Group 14873"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14872",
    "data-name": "Group 14872",
    clipPath: "url(#clip-path-88)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14871",
    "data-name": "Group 14871"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14870",
    "data-name": "Group 14870",
    clipPath: "url(#clip-path-89)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31824",
    "data-name": "Path 31824",
    d: "M279.924,62.984l40.268.491-.272,13.813L279.653,76.8Z",
    transform: "translate(-279.915 -63.472)",
    fill: "url(#radial-gradient-28)"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14879",
    "data-name": "Group 14879",
    transform: "translate(312.826 76.926)",
    opacity: 0.4,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g64 || (_g64 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14878",
    "data-name": "Group 14878"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14877",
    "data-name": "Group 14877",
    clipPath: "url(#clip-path-90)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14876",
    "data-name": "Group 14876",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14875",
    "data-name": "Group 14875",
    clipPath: "url(#clip-path-91)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31826",
    "data-name": "Path 31826",
    d: "M261.814,63.969l39.429.481-.291,14.773-39.429-.48Z",
    transform: "translate(-261.805 -64.446)",
    fill: "url(#radial-gradient-29)"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14884",
    "data-name": "Group 14884",
    transform: "translate(253.474 77.777)",
    opacity: 0.4,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g65 || (_g65 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14883",
    "data-name": "Group 14883"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14882",
    "data-name": "Group 14882",
    clipPath: "url(#clip-path-92)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14881",
    "data-name": "Group 14881"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14880",
    "data-name": "Group 14880",
    clipPath: "url(#clip-path-93)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31828",
    "data-name": "Path 31828",
    d: "M212.155,64.477,271.6,65.2l-.287,14.608-59.448-.724Z",
    transform: "translate(-212.141 -65.198)",
    fill: "url(#radial-gradient-30)"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14889",
    "data-name": "Group 14889",
    transform: "translate(216.094 76.036)",
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g66 || (_g66 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14888",
    "data-name": "Group 14888"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14887",
    "data-name": "Group 14887",
    clipPath: "url(#clip-path-94)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14886",
    "data-name": "Group 14886",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14885",
    "data-name": "Group 14885",
    clipPath: "url(#clip-path-95)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31830",
    "data-name": "Path 31830",
    d: "M180.876,63.157l46.067.561-.3,15.33-46.067-.561Z",
    transform: "translate(-180.865 -63.715)",
    fill: "url(#radial-gradient-5)"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14894",
    "data-name": "Group 14894",
    transform: "translate(187.495 73.794)",
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g67 || (_g67 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14893",
    "data-name": "Group 14893"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14892",
    "data-name": "Group 14892",
    clipPath: "url(#clip-path-96)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14891",
    "data-name": "Group 14891",
    transform: "translate(0 -0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14890",
    "data-name": "Group 14890",
    clipPath: "url(#clip-path-97)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31832",
    "data-name": "Path 31832",
    d: "M156.944,61.232,203.9,61.8l-.288,14.632-46.958-.572Z",
    transform: "translate(-156.933 -61.848)",
    fill: "url(#radial-gradient-32)"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14897",
    "data-name": "Group 14897",
    transform: "translate(334.269 75.757)",
    opacity: 0.4,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g68 || (_g68 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14896",
    "data-name": "Group 14896"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14895",
    "data-name": "Group 14895",
    clipPath: "url(#clip-path-98)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31834",
    "data-name": "Path 31834",
    d: "M294.937,69.425c-.072-.173.179-.265.349-.2a31.576,31.576,0,0,0,4.729,1.6,3.882,3.882,0,0,0-.251-1.454.184.184,0,0,1,.167-.226,25.508,25.508,0,0,1,3.975-.024,19.981,19.981,0,0,0,4.358.01c1.5-.264,2.977-.663,4.5-.851.643-.079,1.122-.027,1.44-.544.068-.114.136-.225.207-.336-1.233-.235-2.462-.48-3.692-.724-2.506-.5-5-1.031-7.432-1.735-.392-.114-2.1-.564-3.837-1.122a.055.055,0,0,1-.019.008,4.82,4.82,0,0,1-2.568-.408,2.839,2.839,0,0,1-.747-.027.877.877,0,0,1-.258.051h-.01a6,6,0,0,1-1.623.1c-.92-.022-1.821.065-2.738.127-1.919.129-3.824.35-5.745.468-2.01.123-4.025.213-6.036.335,1.493.71,2.89,1.618,4.247,2.427,1.989,1.183,4.131,2.143,6.173,3.259a52.953,52.953,0,0,1,5.122,3.189,7.909,7.909,0,0,0-.307-3.923",
    transform: "translate(-279.702 -63.39)",
    fill: "#276a15"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14900",
    "data-name": "Group 14900",
    transform: "translate(313.355 76.924)",
    opacity: 0.4,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g69 || (_g69 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14899",
    "data-name": "Group 14899"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14898",
    "data-name": "Group 14898",
    clipPath: "url(#clip-path-99)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31835",
    "data-name": "Path 31835",
    d: "M266,75.831a17.46,17.46,0,0,0,1.589-3.5.25.25,0,0,1,.292-.124,63.22,63.22,0,0,0,9.166,2.369,4.526,4.526,0,0,0-.663-2.224c-.087-.17.1-.339.327-.25a31.3,31.3,0,0,0,7.092,2.2c-.437-.913-1.36-1.617-1.3-2.665.007-.127.149-.2.3-.174,2.526.416,4.621,1.564,6.984,2.314a15.835,15.835,0,0,0,3.774.71,7.424,7.424,0,0,1,2.152.367c-.118-.085-.243-.167-.365-.252-1.745-1.207-3.487-2.393-5.146-3.676-1.617-1.252-3.036-2.677-4.706-3.88-.745-.537-1.511-1.056-2.228-1.619-.461-.362-.913-.737-1.411-1.064-1.321.091-2.639.2-3.951.356-3.851.453-7.661,1.085-11.525,1.457-1.261.122-2.512.355-3.767.528-.045,2.273-.151,4.546-.405,6.812,0,.033-.01.069-.012.1a9.227,9.227,0,0,0,3.8,2.207",
    transform: "translate(-262.202 -64.367)",
    fill: "#276a15"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14903",
    "data-name": "Group 14903",
    transform: "translate(256.823 77.774)",
    opacity: 0.4,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g70 || (_g70 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14902",
    "data-name": "Group 14902"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14901",
    "data-name": "Group 14901",
    clipPath: "url(#clip-path-100)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31836",
    "data-name": "Path 31836",
    d: "M217.079,75.83c.685-.317,1.187-.823,1.9-1.11,3-1.207,5.085,1.14,7.9,1.542a3.593,3.593,0,0,0-.669-1.891c-.084-.136.059-.329.269-.27,3.187.884,6.342,1.874,9.613,2.549.882.183,1.772.351,2.671.483.5.074,1.009.148,1.517.2.431.047.4-.372.423-.613a3.251,3.251,0,0,1,.6-2.1c1.079-1.14,3.8-.476,5.147-.13.888.228,1.861.54,2.853.765,0-.2-.014-.4-.026-.584-.006-.075.079-.163.176-.176,3.53-.463,7.312.212,10.783.778a2.953,2.953,0,0,0-.817-1.768c-.121-.154.134-.355.326-.249a9.044,9.044,0,0,0,2.915,1c-.065-.252-.115-.508-.192-.759-.038-.115.074-.238.229-.233,2.072.082,3.814,1.135,5.777,1.477.355-1.184.765-2.354,1.11-3.541.433-1.484.659-2.987.956-4.486-.114.012-.229.023-.344.031a10.445,10.445,0,0,1-1.856.059l-.023.008-.016,0a.55.55,0,0,1-.275.053,8.464,8.464,0,0,1-1.524-.084c-1.015-.047-2.029-.047-3.045-.029-1.715.029-3.424.039-5.14,0-3.873-.1-7.736-.331-11.6-.532s-7.731-.155-11.588-.361c-1.715-.092-3.42-.267-5.131-.385a21.707,21.707,0,0,1-3.272-.4.715.715,0,0,1-1.005.41c.293.172.061.065-.185.059-.307-.011-.614-.014-.923-.018-.68-.006-1.36-.007-2.04-.007-.288,0-.576,0-.865,0-.667,1.031-1.684,1.916-2.463,2.895-1.091,1.371-2.118,2.773-3.16,4.168-.386.52-.778,1.04-1.184,1.551a1.759,1.759,0,0,1,.281.43c.275.587.711,1.814,1.9,1.268",
    transform: "translate(-214.898 -65.078)",
    fill: "#276a15"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14906",
    "data-name": "Group 14906",
    transform: "translate(221.46 76.034)",
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g71 || (_g71 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14905",
    "data-name": "Group 14905"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14904",
    "data-name": "Group 14904",
    clipPath: "url(#clip-path-101)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31837",
    "data-name": "Path 31837",
    d: "M185.335,72.163c-.094.454.032.918.8.968a2.571,2.571,0,0,1,.684.094c.584.212.745.694.993,1.128.748,1.309,4.123.3,5.324-.072,1.659-.519,3.22-1.192,4.816-1.811a.221.221,0,0,1,.219-.122h.147c.216,0,.316.245.129.337a2.215,2.215,0,0,0,2.063,1.768c1.041.043,1.451-.51,2.21-.929,1.364-.751,1.751.247,2.746.784a3.881,3.881,0,0,0,.495-1.105.247.247,0,0,1,.356-.155,12.872,12.872,0,0,1,3.111,2.192c1.088.886,2.44,2.142,4.07,2.353a2.96,2.96,0,0,0,.7.011c.142-.131.294-.264.448-.4.637-.566.89-1.452,1.448-2.089.52-.6,1.077-1.168,1.662-1.725,2.626-2.487,5.409-4.948,7.77-7.6l-2.344-.024c-2.546-.032-5.091-.122-7.621-.359-2.633-.245-5.2-.724-7.809-1.061-1.352-.174-2.71-.324-4.076-.4-1.219-.069-2.465-.02-3.668-.192-.249-.036-.513-.082-.779-.124a9.117,9.117,0,0,1-2.019,1.249c-1.312.778-2.5,1.6-3.75,2.428-1,.655-2.13,1.132-3.187,1.715a37.617,37.617,0,0,0-3.388,2.162c-.5.348-1.025.667-1.551.987",
    transform: "translate(-185.308 -63.622)",
    fill: "#276a15"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14909",
    "data-name": "Group 14909",
    transform: "translate(208.204 73.792)",
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g72 || (_g72 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14908",
    "data-name": "Group 14908"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14907",
    "data-name": "Group 14907",
    clipPath: "url(#clip-path-102)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31838",
    "data-name": "Path 31838",
    d: "M175.566,63.3c1.542.92-.319,2.317-1.065,3.267a31.828,31.828,0,0,0,3.73.006c.123,0,.24.088.232.186a6.355,6.355,0,0,1-.253,1.257c-.237.828-.378,1.178.871,1.164,1.174-.013,2.318-.235,3.49-.252.124,0,.239.091.232.19a2.537,2.537,0,0,1-.571,1.425c2.494-.5,4.638-1.758,7.159-2.216.121-.022.264.032.288.133a1.589,1.589,0,0,1,.016.713c3.266-1.974,6.786-3.583,10.3-5.26h-.013c-.621.075-1.243.148-1.868.194-1.169.086-2.33.057-3.5.041a43.185,43.185,0,0,1-7.546-.618,30.772,30.772,0,0,1-3.259-.768,12.291,12.291,0,0,1-1.821-.609l-.237-.122c-.7-.081-1.393-.232-2.1-.274a7.215,7.215,0,0,0-2.688.431c-.924.29-1.838.6-2.751.907a2.923,2.923,0,0,1,1.35.2",
    transform: "translate(-174.216 -61.746)",
    fill: "#276a15"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15176",
    "data-name": "Group 15176",
    transform: "translate(187.283 85.576)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g73 || (_g73 = /*#__PURE__*/React.createElement("g", {
    id: "Group_15175",
    "data-name": "Group 15175"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15174",
    "data-name": "Group 15174",
    clipPath: "url(#clip-path-103)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14911",
    "data-name": "Group 14911",
    transform: "translate(16.093 14.64)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14910",
    "data-name": "Group 14910",
    clipPath: "url(#clip-path-104)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31839",
    "data-name": "Path 31839",
    d: "M170.1,83.826l.774.009-.012.607-.774-.009Z",
    transform: "translate(-170.193 -83.862)",
    fill: "url(#radial-gradient-33)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14913",
    "data-name": "Group 14913",
    transform: "translate(19.435 11.587)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14912",
    "data-name": "Group 14912",
    clipPath: "url(#clip-path-105)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31841",
    "data-name": "Path 31841",
    d: "M172.957,81.265l.839.01-.016.808-.839-.01Z",
    transform: "translate(-172.978 -81.309)",
    fill: "url(#radial-gradient-34)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14915",
    "data-name": "Group 14915",
    transform: "translate(20.53 16.713)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14914",
    "data-name": "Group 14914",
    clipPath: "url(#clip-path-106)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31843",
    "data-name": "Path 31843",
    d: "M173.838,85.553l2.145.026-.035,1.8-2.145-.026Z",
    transform: "translate(-173.906 -85.598)",
    fill: "url(#radial-gradient-35)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14917",
    "data-name": "Group 14917",
    transform: "translate(19.935 14.004)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14916",
    "data-name": "Group 14916",
    clipPath: "url(#clip-path-107)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31845",
    "data-name": "Path 31845",
    d: "M173.375,83.314l.451.005-.008.408-.451-.006Z",
    transform: "translate(-173.395 -83.325)",
    fill: "url(#radial-gradient-36)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14919",
    "data-name": "Group 14919",
    transform: "translate(11.339 8.624)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14918",
    "data-name": "Group 14918",
    clipPath: "url(#clip-path-108)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31847",
    "data-name": "Path 31847",
    d: "M166.177,78.767l3.627.044-.041,2.082-3.627-.044Z",
    transform: "translate(-166.21 -78.833)",
    fill: "url(#radial-gradient-37)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14921",
    "data-name": "Group 14921",
    transform: "translate(16.773 9.236)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14920",
    "data-name": "Group 14920",
    clipPath: "url(#clip-path-109)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31849",
    "data-name": "Path 31849",
    d: "M170.635,79.322l.826.01-.009.468-.826-.01Z",
    transform: "translate(-170.768 -79.336)",
    fill: "url(#radial-gradient-38)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14923",
    "data-name": "Group 14923",
    transform: "translate(14.105 12.065)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14922",
    "data-name": "Group 14922",
    clipPath: "url(#clip-path-110)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31851",
    "data-name": "Path 31851",
    d: "M168.478,81.664l.731.009-.012.589-.731-.009Z",
    transform: "translate(-168.521 -81.709)",
    fill: "url(#radial-gradient-39)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14925",
    "data-name": "Group 14925",
    transform: "translate(5.235 11.37)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14924",
    "data-name": "Group 14924",
    clipPath: "url(#clip-path-111)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31853",
    "data-name": "Path 31853",
    d: "M161.087,81.094l2.46.03-.04,2.019-2.46-.03Z",
    transform: "translate(-161.099 -81.125)",
    fill: "url(#radial-gradient-40)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14927",
    "data-name": "Group 14927",
    transform: "translate(19.068 5.923)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14926",
    "data-name": "Group 14926",
    clipPath: "url(#clip-path-112)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31855",
    "data-name": "Path 31855",
    d: "M172.569,76.552l.718.009-.008.405-.718-.009Z",
    transform: "translate(-172.685 -76.564)",
    fill: "url(#radial-gradient-41)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14929",
    "data-name": "Group 14929",
    transform: "translate(20.617 7.006)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14928",
    "data-name": "Group 14928",
    clipPath: "url(#clip-path-113)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31857",
    "data-name": "Path 31857",
    d: "M173.837,77.455l.936.011-.01.53-.936-.011Z",
    transform: "translate(-173.988 -77.471)",
    fill: "url(#radial-gradient-42)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14931",
    "data-name": "Group 14931",
    transform: "translate(0.001 6.486)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14930",
    "data-name": "Group 14930",
    clipPath: "url(#clip-path-114)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31859",
    "data-name": "Path 31859",
    d: "M156.582,77.02l.972.012-.011.551-.972-.012Z",
    transform: "translate(-156.738 -77.035)",
    fill: "url(#radial-gradient-43)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14933",
    "data-name": "Group 14933",
    transform: "translate(0.535 8.149)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14932",
    "data-name": "Group 14932",
    clipPath: "url(#clip-path-115)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31861",
    "data-name": "Path 31861",
    d: "M157.036,78.412l.917.011-.01.519-.917-.011Z",
    transform: "translate(-157.183 -78.428)",
    fill: "url(#radial-gradient-44)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14935",
    "data-name": "Group 14935",
    transform: "translate(19.592 16.633)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14934",
    "data-name": "Group 14934",
    clipPath: "url(#clip-path-116)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31863",
    "data-name": "Path 31863",
    d: "M173.057,85.5l1.066.013-.015.763-1.066-.013Z",
    transform: "translate(-173.116 -85.529)",
    fill: "url(#radial-gradient-45)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14937",
    "data-name": "Group 14937",
    transform: "translate(21.344 18.488)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14936",
    "data-name": "Group 14936",
    clipPath: "url(#clip-path-117)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31865",
    "data-name": "Path 31865",
    d: "M174.537,87.028l.845.01-.014.689-.845-.01Z",
    transform: "translate(-174.578 -87.085)",
    fill: "url(#radial-gradient-46)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14939",
    "data-name": "Group 14939",
    transform: "translate(7.27 12.9)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14938",
    "data-name": "Group 14938",
    clipPath: "url(#clip-path-118)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31867",
    "data-name": "Path 31867",
    d: "M162.756,82.314l1.109.014-.027,1.35-1.109-.014Z",
    transform: "translate(-162.806 -82.417)",
    fill: "url(#radial-gradient-47)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14941",
    "data-name": "Group 14941",
    transform: "translate(2.653 0.657)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14940",
    "data-name": "Group 14940",
    clipPath: "url(#clip-path-119)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31869",
    "data-name": "Path 31869",
    d: "M158.882,72.136l.751.009-.013.649-.751-.009Z",
    transform: "translate(-158.942 -72.16)",
    fill: "url(#radial-gradient-48)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14943",
    "data-name": "Group 14943",
    transform: "translate(0.177 1.389)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14942",
    "data-name": "Group 14942",
    clipPath: "url(#clip-path-120)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31871",
    "data-name": "Path 31871",
    d: "M156.853,72.728l3.654.045-.037,1.89-3.654-.045Z",
    transform: "translate(-156.867 -72.776)",
    fill: "url(#radial-gradient-49)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14945",
    "data-name": "Group 14945",
    transform: "translate(59.615 13.265)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14944",
    "data-name": "Group 14944",
    clipPath: "url(#clip-path-121)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31873",
    "data-name": "Path 31873",
    d: "M206.556,82.608l.6.007-.014.711-.6-.007Z",
    transform: "translate(-206.603 -82.724)",
    fill: "url(#radial-gradient-50)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14947",
    "data-name": "Group 14947",
    transform: "translate(31.04 15.761)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14946",
    "data-name": "Group 14946",
    clipPath: "url(#clip-path-122)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31875",
    "data-name": "Path 31875",
    d: "M182.678,84.775l1.615.02-.025,1.263-1.615-.02Z",
    transform: "translate(-182.689 -84.798)",
    fill: "url(#radial-gradient-51)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14949",
    "data-name": "Group 14949",
    transform: "translate(32.498 12.803)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14948",
    "data-name": "Group 14948",
    clipPath: "url(#clip-path-123)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31877",
    "data-name": "Path 31877",
    d: "M183.8,82.307l.808.01-.009.458-.808-.01Z",
    transform: "translate(-183.926 -82.321)",
    fill: "url(#radial-gradient-52)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14951",
    "data-name": "Group 14951",
    transform: "translate(33.867 15.497)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14950",
    "data-name": "Group 14950",
    clipPath: "url(#clip-path-124)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31879",
    "data-name": "Path 31879",
    d: "M184.983,84.565l.5.006-.006.28-.5-.006Z",
    transform: "translate(-185.063 -84.575)",
    fill: "url(#radial-gradient-53)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14953",
    "data-name": "Group 14953",
    transform: "translate(33.724 20.179)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14952",
    "data-name": "Group 14952",
    clipPath: "url(#clip-path-125)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31881",
    "data-name": "Path 31881",
    d: "M184.911,88.453l3.1.038-.036,1.832-3.1-.038Z",
    transform: "translate(-184.94 -88.498)",
    fill: "url(#radial-gradient-54)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14955",
    "data-name": "Group 14955",
    transform: "translate(39.745 19.043)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14954",
    "data-name": "Group 14954",
    clipPath: "url(#clip-path-126)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31883",
    "data-name": "Path 31883",
    d: "M189.825,87.525l1.065.013-.012.6-1.065-.013Z",
    transform: "translate(-189.997 -87.543)",
    fill: "url(#radial-gradient-55)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14957",
    "data-name": "Group 14957",
    transform: "translate(40.296 21.421)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14956",
    "data-name": "Group 14956",
    clipPath: "url(#clip-path-127)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31885",
    "data-name": "Path 31885",
    d: "M190.306,89.518l.918.011-.01.519-.918-.011Z",
    transform: "translate(-190.453 -89.532)",
    fill: "url(#radial-gradient-56)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14959",
    "data-name": "Group 14959",
    transform: "translate(42.833 14.355)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14958",
    "data-name": "Group 14958",
    clipPath: "url(#clip-path-128)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31887",
    "data-name": "Path 31887",
    d: "M192.38,83.6l1.285.016-.014.728-1.285-.016Z",
    transform: "translate(-192.587 -83.621)",
    fill: "url(#radial-gradient-57)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14961",
    "data-name": "Group 14961",
    transform: "translate(47.355 20.798)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14960",
    "data-name": "Group 14960",
    clipPath: "url(#clip-path-129)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31889",
    "data-name": "Path 31889",
    d: "M196.33,88.924l2.921.036-.037,1.887-2.921-.036Z",
    transform: "translate(-196.343 -89.026)",
    fill: "url(#radial-gradient-58)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14963",
    "data-name": "Group 14963",
    transform: "translate(50.856 23.247)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14962",
    "data-name": "Group 14962",
    clipPath: "url(#clip-path-130)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31891",
    "data-name": "Path 31891",
    d: "M199.168,91.048l.716.009-.008.4-.716-.009Z",
    transform: "translate(-199.284 -91.06)",
    fill: "url(#radial-gradient-59)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14965",
    "data-name": "Group 14965",
    transform: "translate(47.636 24.316)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14964",
    "data-name": "Group 14964",
    clipPath: "url(#clip-path-131)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31893",
    "data-name": "Path 31893",
    d: "M196.468,91.942l.771.009-.009.436-.771-.009Z",
    transform: "translate(-196.591 -91.955)",
    fill: "url(#radial-gradient-60)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14967",
    "data-name": "Group 14967",
    transform: "translate(40.616 24.138)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14966",
    "data-name": "Group 14966",
    clipPath: "url(#clip-path-132)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31895",
    "data-name": "Path 31895",
    d: "M190.377,91.769l2.405.029-.027,1.361-2.405-.029Z",
    transform: "translate(-190.763 -91.811)",
    fill: "url(#radial-gradient-61)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14969",
    "data-name": "Group 14969",
    transform: "translate(39.655 24.062)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14968",
    "data-name": "Group 14968",
    clipPath: "url(#clip-path-133)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31897",
    "data-name": "Path 31897",
    d: "M189.8,91.73l.715.009-.008.4-.715-.009Z",
    transform: "translate(-189.911 -91.742)",
    fill: "url(#radial-gradient-62)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14971",
    "data-name": "Group 14971",
    transform: "translate(42.958 22.707)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14970",
    "data-name": "Group 14970",
    clipPath: "url(#clip-path-134)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31899",
    "data-name": "Path 31899",
    d: "M192.556,90.6l.754.009-.008.426-.754-.009Z",
    transform: "translate(-192.677 -90.608)",
    fill: "url(#radial-gradient-63)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14973",
    "data-name": "Group 14973",
    transform: "translate(35.06 23.134)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14972",
    "data-name": "Group 14972",
    clipPath: "url(#clip-path-135)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31901",
    "data-name": "Path 31901",
    d: "M185.82,90.939l1.708.021-.019.964L185.8,91.9Z",
    transform: "translate(-186.095 -90.969)",
    fill: "url(#radial-gradient-64)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14975",
    "data-name": "Group 14975",
    transform: "translate(50.412 19.997)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14974",
    "data-name": "Group 14974",
    clipPath: "url(#clip-path-136)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31903",
    "data-name": "Path 31903",
    d: "M198.763,88.323l1.025.012-.016.812-1.025-.012Z",
    transform: "translate(-198.921 -88.342)",
    fill: "url(#radial-gradient-65)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14977",
    "data-name": "Group 14977",
    transform: "translate(56.788 14.236)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14976",
    "data-name": "Group 14976",
    clipPath: "url(#clip-path-137)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31905",
    "data-name": "Path 31905",
    d: "M204.156,83.461l1,.012-.018.919-1-.012Z",
    transform: "translate(-204.246 -83.529)",
    fill: "url(#radial-gradient-66)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14979",
    "data-name": "Group 14979",
    transform: "translate(57.085 14.344)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14978",
    "data-name": "Group 14978",
    clipPath: "url(#clip-path-138)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31907",
    "data-name": "Path 31907",
    d: "M204.476,83.606h.021v.021h-.021Z",
    transform: "translate(-204.476 -83.609)",
    fill: "url(#radial-gradient-67)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14981",
    "data-name": "Group 14981",
    transform: "translate(58.543 12.968)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14980",
    "data-name": "Group 14980",
    clipPath: "url(#clip-path-139)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31909",
    "data-name": "Path 31909",
    d: "M205.658,82.4l.822.01-.014.734-.822-.01Z",
    transform: "translate(-205.706 -82.469)",
    fill: "url(#radial-gradient-68)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14983",
    "data-name": "Group 14983",
    transform: "translate(59.543 13.776)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14982",
    "data-name": "Group 14982",
    clipPath: "url(#clip-path-140)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31911",
    "data-name": "Path 31911",
    d: "M206.525,83.131h.037v.01h-.037Z",
    transform: "translate(-206.534 -83.133)",
    fill: "url(#radial-gradient-69)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14985",
    "data-name": "Group 14985",
    transform: "translate(58.489 13.335)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14984",
    "data-name": "Group 14984",
    clipPath: "url(#clip-path-141)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31913",
    "data-name": "Path 31913",
    d: "M205.571,82.729l3.442.042-.064,3.265-3.442-.042Z",
    transform: "translate(-205.679 -82.771)",
    fill: "url(#radial-gradient-70)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14987",
    "data-name": "Group 14987",
    transform: "translate(58.498 20.603)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14986",
    "data-name": "Group 14986",
    clipPath: "url(#clip-path-142)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31915",
    "data-name": "Path 31915",
    d: "M205.657,88.831l.862.01-.014.694-.862-.01Z",
    transform: "translate(-205.662 -88.849)",
    fill: "url(#radial-gradient-71)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14989",
    "data-name": "Group 14989",
    transform: "translate(58.119 21.251)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14988",
    "data-name": "Group 14988",
    clipPath: "url(#clip-path-143)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31917",
    "data-name": "Path 31917",
    d: "M205.242,89.378l.753.009-.008.425-.753-.009Z",
    transform: "translate(-205.362 -89.39)",
    fill: "url(#radial-gradient-72)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14991",
    "data-name": "Group 14991",
    transform: "translate(56.332 20.987)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14990",
    "data-name": "Group 14990",
    clipPath: "url(#clip-path-144)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31919",
    "data-name": "Path 31919",
    d: "M203.826,89.1l.864.011-.014.694-.864-.011Z",
    transform: "translate(-203.852 -89.18)",
    fill: "url(#radial-gradient-73)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14993",
    "data-name": "Group 14993",
    transform: "translate(90.897 16.431)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14992",
    "data-name": "Group 14992",
    clipPath: "url(#clip-path-145)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31921",
    "data-name": "Path 31921",
    d: "M232.762,85.336l1.615.02-.025,1.262-1.615-.02Z",
    transform: "translate(-232.774 -85.359)",
    fill: "url(#radial-gradient-74)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14995",
    "data-name": "Group 14995",
    transform: "translate(92.354 13.47)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14994",
    "data-name": "Group 14994",
    clipPath: "url(#clip-path-146)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31923",
    "data-name": "Path 31923",
    d: "M233.88,82.866l.808.01-.009.459-.808-.01Z",
    transform: "translate(-234.01 -82.879)",
    fill: "url(#radial-gradient-75)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14997",
    "data-name": "Group 14997",
    transform: "translate(93.722 16.164)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14996",
    "data-name": "Group 14996",
    clipPath: "url(#clip-path-147)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31925",
    "data-name": "Path 31925",
    d: "M235.067,85.124l.494.006-.006.282-.494-.006Z",
    transform: "translate(-235.146 -85.132)",
    fill: "url(#radial-gradient-76)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14999",
    "data-name": "Group 14999",
    transform: "translate(93.58 20.848)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14998",
    "data-name": "Group 14998",
    clipPath: "url(#clip-path-148)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31927",
    "data-name": "Path 31927",
    d: "M235,89.013l3.1.038-.036,1.833-3.1-.038Z",
    transform: "translate(-235.024 -89.058)",
    fill: "url(#radial-gradient-77)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15001",
    "data-name": "Group 15001",
    transform: "translate(99.601 19.712)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15000",
    "data-name": "Group 15000",
    clipPath: "url(#clip-path-149)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31929",
    "data-name": "Path 31929",
    d: "M239.911,88.085l1.063.013-.012.6-1.063-.013Z",
    transform: "translate(-240.082 -88.103)",
    fill: "url(#radial-gradient-78)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15003",
    "data-name": "Group 15003",
    transform: "translate(100.152 22.091)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15002",
    "data-name": "Group 15002",
    clipPath: "url(#clip-path-150)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31931",
    "data-name": "Path 31931",
    d: "M240.391,90.078l.919.011-.01.519-.919-.011Z",
    transform: "translate(-240.539 -90.094)",
    fill: "url(#radial-gradient-79)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15005",
    "data-name": "Group 15005",
    transform: "translate(102.688 15.026)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15004",
    "data-name": "Group 15004",
    clipPath: "url(#clip-path-151)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31933",
    "data-name": "Path 31933",
    d: "M242.465,84.161l1.285.016-.014.725-1.285-.016Z",
    transform: "translate(-242.671 -84.182)",
    fill: "url(#radial-gradient-80)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15007",
    "data-name": "Group 15007",
    transform: "translate(107.211 21.467)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15006",
    "data-name": "Group 15006",
    clipPath: "url(#clip-path-152)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31935",
    "data-name": "Path 31935",
    d: "M246.414,89.484l2.924.036-.037,1.887-2.924-.036Z",
    transform: "translate(-246.428 -89.585)",
    fill: "url(#radial-gradient-81)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15009",
    "data-name": "Group 15009",
    transform: "translate(110.711 23.915)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15008",
    "data-name": "Group 15008",
    clipPath: "url(#clip-path-153)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31937",
    "data-name": "Path 31937",
    d: "M249.252,91.608l.716.009-.008.405-.716-.009Z",
    transform: "translate(-249.368 -91.619)",
    fill: "url(#radial-gradient-82)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15011",
    "data-name": "Group 15011",
    transform: "translate(107.491 24.985)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15010",
    "data-name": "Group 15010",
    clipPath: "url(#clip-path-154)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31939",
    "data-name": "Path 31939",
    d: "M246.551,92.5l.774.009-.009.435-.774-.009Z",
    transform: "translate(-246.676 -92.514)",
    fill: "url(#radial-gradient-83)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15013",
    "data-name": "Group 15013",
    transform: "translate(100.472 24.809)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15012",
    "data-name": "Group 15012",
    clipPath: "url(#clip-path-155)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31941",
    "data-name": "Path 31941",
    d: "M240.461,92.33l2.406.029-.027,1.359-2.406-.029Z",
    transform: "translate(-240.848 -92.372)",
    fill: "url(#radial-gradient-84)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15015",
    "data-name": "Group 15015",
    transform: "translate(99.511 24.729)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15014",
    "data-name": "Group 15014",
    clipPath: "url(#clip-path-156)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31943",
    "data-name": "Path 31943",
    d: "M239.88,92.288l.716.009-.008.405-.716-.009Z",
    transform: "translate(-239.997 -92.3)",
    fill: "url(#radial-gradient-85)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15017",
    "data-name": "Group 15017",
    transform: "translate(102.814 23.377)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15016",
    "data-name": "Group 15016",
    clipPath: "url(#clip-path-157)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31945",
    "data-name": "Path 31945",
    d: "M242.641,91.156l.754.009-.008.427-.754-.009Z",
    transform: "translate(-242.762 -91.169)",
    fill: "url(#radial-gradient-86)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15019",
    "data-name": "Group 15019",
    transform: "translate(94.917 23.804)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15018",
    "data-name": "Group 15018",
    clipPath: "url(#clip-path-158)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31947",
    "data-name": "Path 31947",
    d: "M235.905,91.5l1.706.021-.019.967-1.706-.021Z",
    transform: "translate(-236.18 -91.529)",
    fill: "url(#radial-gradient-87)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15021",
    "data-name": "Group 15021",
    transform: "translate(110.268 20.667)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15020",
    "data-name": "Group 15020",
    clipPath: "url(#clip-path-159)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31949",
    "data-name": "Path 31949",
    d: "M248.848,88.883l1.027.013-.016.813-1.027-.013Z",
    transform: "translate(-249.006 -88.903)",
    fill: "url(#radial-gradient-88)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15023",
    "data-name": "Group 15023",
    transform: "translate(116.645 14.906)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15022",
    "data-name": "Group 15022",
    clipPath: "url(#clip-path-160)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31951",
    "data-name": "Path 31951",
    d: "M254.243,84.023l1,.012-.018.916-1-.012Z",
    transform: "translate(-254.331 -84.089)",
    fill: "url(#radial-gradient-89)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15025",
    "data-name": "Group 15025",
    transform: "translate(116.941 15.014)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15024",
    "data-name": "Group 15024",
    clipPath: "url(#clip-path-161)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31953",
    "data-name": "Path 31953",
    d: "M254.561,84.167h.021v.021h-.021Z",
    transform: "translate(-254.561 -84.17)",
    fill: "url(#radial-gradient-90)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15027",
    "data-name": "Group 15027",
    transform: "translate(118.399 13.637)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15026",
    "data-name": "Group 15026",
    clipPath: "url(#clip-path-162)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31955",
    "data-name": "Path 31955",
    d: "M255.744,82.958l.818.01-.014.737-.818-.01Z",
    transform: "translate(-255.791 -83.029)",
    fill: "url(#radial-gradient-91)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15029",
    "data-name": "Group 15029",
    transform: "translate(119.399 14.445)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15028",
    "data-name": "Group 15028",
    clipPath: "url(#clip-path-163)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31957",
    "data-name": "Path 31957",
    d: "M256.61,83.691h.038V83.7h-.038Z",
    transform: "translate(-256.62 -83.694)",
    fill: "url(#radial-gradient-92)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15031",
    "data-name": "Group 15031",
    transform: "translate(118.344 14.004)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15030",
    "data-name": "Group 15030",
    clipPath: "url(#clip-path-164)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31959",
    "data-name": "Path 31959",
    d: "M255.654,83.288l3.447.042-.064,3.267-3.447-.042Z",
    transform: "translate(-255.763 -83.331)",
    fill: "url(#radial-gradient-93)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15033",
    "data-name": "Group 15033",
    transform: "translate(118.354 21.275)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15032",
    "data-name": "Group 15032",
    clipPath: "url(#clip-path-165)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31961",
    "data-name": "Path 31961",
    d: "M255.741,89.392l.862.01-.014.694-.862-.01Z",
    transform: "translate(-255.747 -89.411)",
    fill: "url(#radial-gradient-94)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15035",
    "data-name": "Group 15035",
    transform: "translate(117.975 21.923)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15034",
    "data-name": "Group 15034",
    clipPath: "url(#clip-path-166)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31963",
    "data-name": "Path 31963",
    d: "M255.327,89.939l.753.009-.008.424-.753-.009Z",
    transform: "translate(-255.447 -89.952)",
    fill: "url(#radial-gradient-95)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15037",
    "data-name": "Group 15037",
    transform: "translate(116.187 21.657)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15036",
    "data-name": "Group 15036",
    clipPath: "url(#clip-path-167)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31965",
    "data-name": "Path 31965",
    d: "M253.91,89.662l.863.011-.014.693-.863-.011Z",
    transform: "translate(-253.936 -89.74)",
    fill: "url(#radial-gradient-96)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15039",
    "data-name": "Group 15039",
    transform: "translate(98.653 17.812)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15038",
    "data-name": "Group 15038",
    clipPath: "url(#clip-path-168)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31967",
    "data-name": "Path 31967",
    d: "M239.243,86.475l1.677.02-.025,1.287-1.677-.02Z",
    transform: "translate(-239.267 -86.517)",
    fill: "url(#radial-gradient-97)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15041",
    "data-name": "Group 15041",
    transform: "translate(97.634 21.422)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15040",
    "data-name": "Group 15040",
    clipPath: "url(#clip-path-169)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31969",
    "data-name": "Path 31969",
    d: "M238.274,89.49l.879.011-.01.524-.879-.011Z",
    transform: "translate(-238.434 -89.539)",
    fill: "url(#radial-gradient-98)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15043",
    "data-name": "Group 15043",
    transform: "translate(96.965 18.783)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15042",
    "data-name": "Group 15042",
    clipPath: "url(#clip-path-170)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31971",
    "data-name": "Path 31971",
    d: "M237.765,87.3l.539.007-.006.323-.539-.007Z",
    transform: "translate(-237.863 -87.329)",
    fill: "url(#radial-gradient-99)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15045",
    "data-name": "Group 15045",
    transform: "translate(95.443 12.539)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15044",
    "data-name": "Group 15044",
    clipPath: "url(#clip-path-171)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31973",
    "data-name": "Path 31973",
    d: "M236.56,82.061l3.136.038-.036,1.823-3.136-.038Z",
    transform: "translate(-236.581 -82.105)",
    fill: "url(#radial-gradient-100)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15047",
    "data-name": "Group 15047",
    transform: "translate(91.446 14.275)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15046",
    "data-name": "Group 15046",
    clipPath: "url(#clip-path-172)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31975",
    "data-name": "Path 31975",
    d: "M233.052,83.494l1.16.014-.014.694-1.16-.014Z",
    transform: "translate(-233.264 -83.562)",
    fill: "url(#radial-gradient-101)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15049",
    "data-name": "Group 15049",
    transform: "translate(91.427 11.943)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15048",
    "data-name": "Group 15048",
    clipPath: "url(#clip-path-173)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31977",
    "data-name": "Path 31977",
    d: "M233.061,81.552l1,.012-.012.6-1-.012Z",
    transform: "translate(-233.244 -81.608)",
    fill: "url(#radial-gradient-102)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15051",
    "data-name": "Group 15051",
    transform: "translate(87.396 18.434)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15050",
    "data-name": "Group 15050",
    clipPath: "url(#clip-path-174)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31979",
    "data-name": "Path 31979",
    d: "M229.628,86.965l1.4.017-.016.835-1.4-.017Z",
    transform: "translate(-229.883 -87.044)",
    fill: "url(#radial-gradient-103)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15053",
    "data-name": "Group 15053",
    transform: "translate(82.198 10.409)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15052",
    "data-name": "Group 15052",
    clipPath: "url(#clip-path-175)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31981",
    "data-name": "Path 31981",
    d: "M225.462,80.261l3.018.037-.035,1.776-3.018-.037Z",
    transform: "translate(-225.502 -80.326)",
    fill: "url(#radial-gradient-104)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15055",
    "data-name": "Group 15055",
    transform: "translate(81.438 9.053)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15054",
    "data-name": "Group 15054",
    clipPath: "url(#clip-path-176)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31983",
    "data-name": "Path 31983",
    d: "M224.736,79.145l.781.01-.009.463-.781-.01Z",
    transform: "translate(-224.879 -79.188)",
    fill: "url(#radial-gradient-105)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15057",
    "data-name": "Group 15057",
    transform: "translate(84.785 8.329)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15056",
    "data-name": "Group 15056",
    clipPath: "url(#clip-path-177)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31985",
    "data-name": "Path 31985",
    d: "M227.528,78.535l.84.01-.01.5-.84-.01Z",
    transform: "translate(-227.681 -78.583)",
    fill: "url(#radial-gradient-106)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15059",
    "data-name": "Group 15059",
    transform: "translate(90.686 8.361)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15058",
    "data-name": "Group 15058",
    clipPath: "url(#clip-path-178)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31987",
    "data-name": "Path 31987",
    d: "M232.2,78.479l2.618.032-.031,1.561-2.618-.032Z",
    transform: "translate(-232.675 -78.626)",
    fill: "url(#radial-gradient-107)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15061",
    "data-name": "Group 15061",
    transform: "translate(92.67 9.522)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15060",
    "data-name": "Group 15060",
    clipPath: "url(#clip-path-179)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31989",
    "data-name": "Path 31989",
    d: "M234.135,79.535l.78.01-.009.466-.78-.009Z",
    transform: "translate(-234.277 -79.581)",
    fill: "url(#radial-gradient-108)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15063",
    "data-name": "Group 15063",
    transform: "translate(89.131 10.463)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15062",
    "data-name": "Group 15062",
    clipPath: "url(#clip-path-180)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31991",
    "data-name": "Path 31991",
    d: "M231.168,80.322l.817.01-.01.489-.817-.01Z",
    transform: "translate(-231.316 -80.368)",
    fill: "url(#radial-gradient-109)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15065",
    "data-name": "Group 15065",
    transform: "translate(96.432 10.389)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15064",
    "data-name": "Group 15064",
    clipPath: "url(#clip-path-181)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31993",
    "data-name": "Path 31993",
    d: "M237.12,80.211l1.859.023-.022,1.107-1.859-.023Z",
    transform: "translate(-237.459 -80.316)",
    fill: "url(#radial-gradient-110)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15067",
    "data-name": "Group 15067",
    transform: "translate(80.931 12.036)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15066",
    "data-name": "Group 15066",
    clipPath: "url(#clip-path-182)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31995",
    "data-name": "Path 31995",
    d: "M224.4,81.556l1.069.013-.016.8-1.069-.013Z",
    transform: "translate(-224.438 -81.701)",
    fill: "url(#radial-gradient-111)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15069",
    "data-name": "Group 15069",
    transform: "translate(73.588 16.894)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15068",
    "data-name": "Group 15068",
    clipPath: "url(#clip-path-183)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31997",
    "data-name": "Path 31997",
    d: "M218.224,85.681l1.059.013-.017.874-1.059-.013Z",
    transform: "translate(-218.3 -85.754)",
    fill: "url(#radial-gradient-112)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15071",
    "data-name": "Group 15071",
    transform: "translate(74.07 17.55)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15070",
    "data-name": "Group 15070",
    clipPath: "url(#clip-path-184)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31999",
    "data-name": "Path 31999",
    d: "M218.686,86.291h.024v.017h-.024Z",
    transform: "translate(-218.689 -86.291)",
    fill: "url(#radial-gradient-113)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15073",
    "data-name": "Group 15073",
    transform: "translate(71.737 18.115)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15072",
    "data-name": "Group 15072",
    clipPath: "url(#clip-path-185)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32001",
    "data-name": "Path 32001",
    d: "M216.7,86.726l.853.01-.014.689-.853-.01Z",
    transform: "translate(-216.747 -86.772)",
    fill: "url(#radial-gradient-114)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15075",
    "data-name": "Group 15075",
    transform: "translate(71.525 17.839)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15074",
    "data-name": "Group 15074",
    clipPath: "url(#clip-path-186)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32003",
    "data-name": "Path 32003",
    d: "M216.559,86.533h.035v.015h-.035Z",
    transform: "translate(-216.559 -86.533)",
    fill: "url(#radial-gradient-115)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15077",
    "data-name": "Group 15077",
    transform: "translate(69.641 15.084)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15076",
    "data-name": "Group 15076",
    clipPath: "url(#clip-path-187)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32005",
    "data-name": "Path 32005",
    d: "M214.961,84.143l3.206.039-.066,3.373-3.206-.039Z",
    transform: "translate(-215 -84.244)",
    fill: "url(#radial-gradient-116)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15079",
    "data-name": "Group 15079",
    transform: "translate(73.101 10.544)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15078",
    "data-name": "Group 15078",
    clipPath: "url(#clip-path-188)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32007",
    "data-name": "Path 32007",
    d: "M217.828,80.387l.875.011-.014.7-.875-.011Z",
    transform: "translate(-217.89 -80.437)",
    fill: "url(#radial-gradient-117)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15081",
    "data-name": "Group 15081",
    transform: "translate(73.863 10.18)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15080",
    "data-name": "Group 15080",
    clipPath: "url(#clip-path-189)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32009",
    "data-name": "Path 32009",
    d: "M218.392,80.086l.818.01-.01.488-.818-.01Z",
    transform: "translate(-218.541 -80.131)",
    fill: "url(#radial-gradient-118)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15083",
    "data-name": "Group 15083",
    transform: "translate(75.351 10.466)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15082",
    "data-name": "Group 15082",
    clipPath: "url(#clip-path-190)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32011",
    "data-name": "Path 32011",
    d: "M219.7,80.34l.9.011-.013.655-.9-.011Z",
    transform: "translate(-219.775 -80.368)",
    fill: "url(#radial-gradient-119)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15085",
    "data-name": "Group 15085",
    transform: "translate(129.611 13.055)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15084",
    "data-name": "Group 15084",
    clipPath: "url(#clip-path-191)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32013",
    "data-name": "Path 32013",
    d: "M265.16,82.512l1.615.02-.025,1.263-1.615-.02Z",
    transform: "translate(-265.169 -82.534)",
    fill: "url(#radial-gradient-120)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15087",
    "data-name": "Group 15087",
    transform: "translate(131.07 10.097)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15086",
    "data-name": "Group 15086",
    clipPath: "url(#clip-path-192)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32015",
    "data-name": "Path 32015",
    d: "M266.277,80.044l.807.01-.009.455-.807-.01Z",
    transform: "translate(-266.407 -80.057)",
    fill: "url(#radial-gradient-121)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15089",
    "data-name": "Group 15089",
    transform: "translate(132.439 12.789)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15088",
    "data-name": "Group 15088",
    clipPath: "url(#clip-path-193)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32017",
    "data-name": "Path 32017",
    d: "M267.464,82.3l.494.006-.006.281-.494-.006Z",
    transform: "translate(-267.543 -82.308)",
    fill: "url(#radial-gradient-122)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15091",
    "data-name": "Group 15091",
    transform: "translate(132.295 17.473)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15090",
    "data-name": "Group 15090",
    clipPath: "url(#clip-path-194)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32019",
    "data-name": "Path 32019",
    d: "M267.391,86.189l3.1.038-.036,1.832-3.1-.038Z",
    transform: "translate(-267.419 -86.234)",
    fill: "url(#radial-gradient-123)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15093",
    "data-name": "Group 15093",
    transform: "translate(138.316 16.337)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15092",
    "data-name": "Group 15092",
    clipPath: "url(#clip-path-195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32021",
    "data-name": "Path 32021",
    d: "M272.305,85.26l1.065.013-.012.6-1.065-.013Z",
    transform: "translate(-272.477 -85.279)",
    fill: "url(#radial-gradient-124)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15095",
    "data-name": "Group 15095",
    transform: "translate(138.868 18.716)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15094",
    "data-name": "Group 15094",
    clipPath: "url(#clip-path-196)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32023",
    "data-name": "Path 32023",
    d: "M272.788,87.253l.916.011-.01.522-.916-.011Z",
    transform: "translate(-272.935 -87.27)",
    fill: "url(#radial-gradient-125)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15097",
    "data-name": "Group 15097",
    transform: "translate(141.405 11.651)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15096",
    "data-name": "Group 15096",
    clipPath: "url(#clip-path-197)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32025",
    "data-name": "Path 32025",
    d: "M274.861,81.336l1.284.016-.014.726-1.284-.016Z",
    transform: "translate(-275.067 -81.359)",
    fill: "url(#radial-gradient-126)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15099",
    "data-name": "Group 15099",
    transform: "translate(145.927 18.093)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15098",
    "data-name": "Group 15098",
    clipPath: "url(#clip-path-198)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32027",
    "data-name": "Path 32027",
    d: "M278.81,86.661l2.921.036-.037,1.886-2.921-.036Z",
    transform: "translate(-278.824 -86.762)",
    fill: "url(#radial-gradient-127)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15101",
    "data-name": "Group 15101",
    transform: "translate(149.428 20.542)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15100",
    "data-name": "Group 15100",
    clipPath: "url(#clip-path-199)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32029",
    "data-name": "Path 32029",
    d: "M281.649,88.784l.715.009-.008.4-.715-.009Z",
    transform: "translate(-281.764 -88.797)",
    fill: "url(#radial-gradient-128)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15103",
    "data-name": "Group 15103",
    transform: "translate(146.208 21.61)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15102",
    "data-name": "Group 15102",
    clipPath: "url(#clip-path-200)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32031",
    "data-name": "Path 32031",
    d: "M278.949,89.677l.768.009-.009.437-.768-.009Z",
    transform: "translate(-279.072 -89.69)",
    fill: "url(#radial-gradient-129)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15105",
    "data-name": "Group 15105",
    transform: "translate(139.188 21.432)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15104",
    "data-name": "Group 15104",
    clipPath: "url(#clip-path-201)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32033",
    "data-name": "Path 32033",
    d: "M272.858,89.506l2.4.029-.027,1.361-2.4-.029Z",
    transform: "translate(-273.244 -89.545)",
    fill: "url(#radial-gradient-130)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15107",
    "data-name": "Group 15107",
    transform: "translate(138.226 21.356)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15106",
    "data-name": "Group 15106",
    clipPath: "url(#clip-path-202)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32035",
    "data-name": "Path 32035",
    d: "M272.276,89.465l.717.009-.008.4-.717-.009Z",
    transform: "translate(-272.391 -89.478)",
    fill: "url(#radial-gradient-131)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15109",
    "data-name": "Group 15109",
    transform: "translate(141.53 20.002)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15108",
    "data-name": "Group 15108",
    clipPath: "url(#clip-path-203)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32037",
    "data-name": "Path 32037",
    d: "M275.037,88.331l.753.009-.008.427-.753-.009Z",
    transform: "translate(-275.158 -88.345)",
    fill: "url(#radial-gradient-132)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15111",
    "data-name": "Group 15111",
    transform: "translate(133.633 20.428)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15110",
    "data-name": "Group 15110",
    clipPath: "url(#clip-path-204)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32039",
    "data-name": "Path 32039",
    d: "M268.3,88.675l1.707.021-.019.967-1.707-.021Z",
    transform: "translate(-268.576 -88.704)",
    fill: "url(#radial-gradient-133)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15113",
    "data-name": "Group 15113",
    transform: "translate(148.984 17.291)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15112",
    "data-name": "Group 15112",
    clipPath: "url(#clip-path-205)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32041",
    "data-name": "Path 32041",
    d: "M281.245,86.058l1.024.012-.016.814-1.024-.012Z",
    transform: "translate(-281.402 -86.078)",
    fill: "url(#radial-gradient-134)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15115",
    "data-name": "Group 15115",
    transform: "translate(155.359 11.53)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15114",
    "data-name": "Group 15114",
    clipPath: "url(#clip-path-206)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32043",
    "data-name": "Path 32043",
    d: "M286.636,81.2l1,.012-.018.916-1-.012Z",
    transform: "translate(-286.725 -81.265)",
    fill: "url(#radial-gradient-135)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15117",
    "data-name": "Group 15117",
    transform: "translate(155.657 11.64)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15116",
    "data-name": "Group 15116",
    clipPath: "url(#clip-path-207)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32045",
    "data-name": "Path 32045",
    d: "M286.957,81.343h.018v.021h-.018Z",
    transform: "translate(-286.957 -81.346)",
    fill: "url(#radial-gradient-136)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15119",
    "data-name": "Group 15119",
    transform: "translate(157.114 10.262)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15118",
    "data-name": "Group 15118",
    clipPath: "url(#clip-path-208)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32047",
    "data-name": "Path 32047",
    d: "M288.138,80.133l.823.01-.014.736-.823-.01Z",
    transform: "translate(-288.187 -80.204)",
    fill: "url(#radial-gradient-137)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15121",
    "data-name": "Group 15121",
    transform: "translate(158.114 11.07)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15120",
    "data-name": "Group 15120",
    clipPath: "url(#clip-path-209)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11126",
    "data-name": "Rectangle 11126",
    width: 0.009,
    height: 0.038,
    transform: "translate(-0.01 0.006) rotate(-89.306)",
    fill: "url(#radial-gradient-138)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15123",
    "data-name": "Group 15123",
    transform: "translate(157.07 17.897)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15122",
    "data-name": "Group 15122",
    clipPath: "url(#clip-path-210)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32050",
    "data-name": "Path 32050",
    d: "M288.137,86.568l.861.01-.014.694-.861-.01Z",
    transform: "translate(-288.142 -86.584)",
    fill: "url(#radial-gradient-139)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15125",
    "data-name": "Group 15125",
    transform: "translate(156.691 18.547)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15124",
    "data-name": "Group 15124",
    clipPath: "url(#clip-path-211)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32052",
    "data-name": "Path 32052",
    d: "M287.722,87.113l.753.009-.008.425-.753-.009Z",
    transform: "translate(-287.843 -87.127)",
    fill: "url(#radial-gradient-140)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15127",
    "data-name": "Group 15127",
    transform: "translate(154.903 18.281)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15126",
    "data-name": "Group 15126",
    clipPath: "url(#clip-path-212)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32054",
    "data-name": "Path 32054",
    d: "M286.306,86.837l.863.011-.014.695-.863-.01Z",
    transform: "translate(-286.333 -86.915)",
    fill: "url(#radial-gradient-141)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15129",
    "data-name": "Group 15129",
    transform: "translate(168.367 9.933)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15128",
    "data-name": "Group 15128",
    clipPath: "url(#clip-path-213)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32056",
    "data-name": "Path 32056",
    d: "M297.59,79.88l1.181.014-.027,1.392-1.181-.014Z",
    transform: "translate(-297.598 -79.925)",
    fill: "url(#radial-gradient-142)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15131",
    "data-name": "Group 15131",
    transform: "translate(166.769 6.913)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15130",
    "data-name": "Group 15130",
    clipPath: "url(#clip-path-214)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32058",
    "data-name": "Path 32058",
    d: "M296.154,77.313l.68.008-.012.631-.68-.008Z",
    transform: "translate(-296.277 -77.405)",
    fill: "url(#radial-gradient-143)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15133",
    "data-name": "Group 15133",
    transform: "translate(169.449 9.143)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15132",
    "data-name": "Group 15132",
    clipPath: "url(#clip-path-215)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32060",
    "data-name": "Path 32060",
    d: "M298.436,79.208l.416.005-.008.389-.416-.005Z",
    transform: "translate(-298.511 -79.266)",
    fill: "url(#radial-gradient-144)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15135",
    "data-name": "Group 15135",
    transform: "translate(168.331 16.348)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15134",
    "data-name": "Group 15134",
    clipPath: "url(#clip-path-216)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32062",
    "data-name": "Path 32062",
    d: "M297.546,85.246l2.18.027-.038,1.953-2.18-.027Z",
    transform: "translate(-297.573 -85.293)",
    fill: "url(#radial-gradient-145)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15137",
    "data-name": "Group 15137",
    transform: "translate(175.299 10.872)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15136",
    "data-name": "Group 15136",
    clipPath: "url(#clip-path-217)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32064",
    "data-name": "Path 32064",
    d: "M303.261,80.6l.9.011-.016.833-.9-.011Z",
    transform: "translate(-303.422 -80.723)",
    fill: "url(#radial-gradient-146)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15139",
    "data-name": "Group 15139",
    transform: "translate(177.327 13.003)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15138",
    "data-name": "Group 15138",
    clipPath: "url(#clip-path-218)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32066",
    "data-name": "Path 32066",
    d: "M304.974,82.4l.775.009-.014.719-.775-.009Z",
    transform: "translate(-305.114 -82.504)",
    fill: "url(#radial-gradient-147)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15141",
    "data-name": "Group 15141",
    transform: "translate(173.553 5.552)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15140",
    "data-name": "Group 15140",
    clipPath: "url(#clip-path-219)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32068",
    "data-name": "Path 32068",
    d: "M301.771,76.127l1.081.013-.02,1.008-1.081-.013Z",
    transform: "translate(-301.967 -76.276)",
    fill: "url(#radial-gradient-148)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15143",
    "data-name": "Group 15143",
    transform: "translate(183.032 5.159)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15142",
    "data-name": "Group 15142",
    clipPath: "url(#clip-path-220)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32070",
    "data-name": "Path 32070",
    d: "M309.865,75.8l1.559.019-.045,2.308-1.559-.019Z",
    transform: "translate(-309.872 -75.946)",
    fill: "url(#radial-gradient-149)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15145",
    "data-name": "Group 15145",
    transform: "translate(184.352 11.918)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15144",
    "data-name": "Group 15144",
    clipPath: "url(#clip-path-221)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32072",
    "data-name": "Path 32072",
    d: "M310.878,81.51l.6.007-.011.562-.6-.007Z",
    transform: "translate(-310.987 -81.592)",
    fill: "url(#radial-gradient-150)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15147",
    "data-name": "Group 15147",
    transform: "translate(174.999 12.556)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15146",
    "data-name": "Group 15146",
    clipPath: "url(#clip-path-222)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32074",
    "data-name": "Path 32074",
    d: "M303.045,82.039l.649.008-.012.6-.649-.008Z",
    transform: "translate(-303.162 -82.127)",
    fill: "url(#radial-gradient-151)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15149",
    "data-name": "Group 15149",
    transform: "translate(171.266 14.096)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15148",
    "data-name": "Group 15148",
    clipPath: "url(#clip-path-223)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32076",
    "data-name": "Path 32076",
    d: "M299.718,83.171l2.025.025-.037,1.882-2.025-.025Z",
    transform: "translate(-300.084 -83.445)",
    fill: "url(#radial-gradient-152)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15151",
    "data-name": "Group 15151",
    transform: "translate(170.491 14.472)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15150",
    "data-name": "Group 15150",
    clipPath: "url(#clip-path-224)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32078",
    "data-name": "Path 32078",
    d: "M299.281,83.649l.6.007-.011.559-.6-.007Z",
    transform: "translate(-299.389 -83.729)",
    fill: "url(#radial-gradient-153)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15153",
    "data-name": "Group 15153",
    transform: "translate(171.287 12.29)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15152",
    "data-name": "Group 15152",
    clipPath: "url(#clip-path-225)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32080",
    "data-name": "Path 32080",
    d: "M299.942,81.818l.634.008-.012.589-.634-.008Z",
    transform: "translate(-300.056 -81.904)",
    fill: "url(#radial-gradient-154)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15155",
    "data-name": "Group 15155",
    transform: "translate(175.848 15.956)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15154",
    "data-name": "Group 15154",
    clipPath: "url(#clip-path-226)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32082",
    "data-name": "Path 32082",
    d: "M303.64,84.795l1.436.017-.026,1.337-1.436-.017Z",
    transform: "translate(-303.899 -84.989)",
    fill: "url(#radial-gradient-155)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15157",
    "data-name": "Group 15157",
    transform: "translate(181.809 8.858)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15156",
    "data-name": "Group 15156",
    clipPath: "url(#clip-path-227)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32084",
    "data-name": "Path 32084",
    d: "M308.768,78.984l.765.009-.017.859-.765-.009Z",
    transform: "translate(-308.858 -79.024)",
    fill: "url(#radial-gradient-156)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15159",
    "data-name": "Group 15159",
    transform: "translate(181.106 1.658)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15158",
    "data-name": "Group 15158",
    clipPath: "url(#clip-path-228)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32086",
    "data-name": "Path 32086",
    d: "M308.237,72.946l.693.008-.019.953-.692-.008Z",
    transform: "translate(-308.258 -73.003)",
    fill: "url(#radial-gradient-157)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15161",
    "data-name": "Group 15161",
    transform: "translate(181.106 1.84)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15160",
    "data-name": "Group 15160",
    clipPath: "url(#clip-path-229)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11127",
    "data-name": "Rectangle 11127",
    width: 0.023,
    height: 0.005,
    transform: "matrix(0.012, -1, 1, 0.012, -0.001, 0.019)",
    fill: "url(#radial-gradient-158)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15163",
    "data-name": "Group 15163",
    transform: "translate(181.075 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15162",
    "data-name": "Group 15162",
    clipPath: "url(#clip-path-230)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32089",
    "data-name": "Path 32089",
    d: "M308.216,71.543l.507.006-.016.793-.507-.006Z",
    transform: "translate(-308.231 -71.618)",
    fill: "url(#radial-gradient-159)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15165",
    "data-name": "Group 15165",
    transform: "translate(177.63 4.041)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15164",
    "data-name": "Group 15164",
    clipPath: "url(#clip-path-231)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11128",
    "data-name": "Rectangle 11128",
    width: 0.003,
    height: 0.029,
    transform: "matrix(0.012, -1, 1, 0.012, -0.007, 0.002)",
    fill: "url(#radial-gradient-160)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15167",
    "data-name": "Group 15167",
    transform: "translate(176.991 3.718)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15166",
    "data-name": "Group 15166",
    clipPath: "url(#clip-path-232)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32092",
    "data-name": "Path 32092",
    d: "M304.758,74.624l3.527.043-.058,2.967-3.527-.043Z",
    transform: "translate(-304.829 -74.735)",
    fill: "url(#radial-gradient-161)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15169",
    "data-name": "Group 15169",
    transform: "translate(183.404 12.006)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15168",
    "data-name": "Group 15168",
    clipPath: "url(#clip-path-233)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32094",
    "data-name": "Path 32094",
    d: "M310.152,81.643l.605.007-.015.772-.605-.007Z",
    transform: "translate(-310.182 -81.654)",
    fill: "url(#radial-gradient-162)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15171",
    "data-name": "Group 15171",
    transform: "translate(181.643 13.676)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15170",
    "data-name": "Group 15170",
    clipPath: "url(#clip-path-234)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32096",
    "data-name": "Path 32096",
    d: "M308.648,83.026l.459.006-.01.506-.459-.006Z",
    transform: "translate(-308.713 -83.054)",
    fill: "url(#radial-gradient-163)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15173",
    "data-name": "Group 15173",
    transform: "translate(182.133 12.594)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15172",
    "data-name": "Group 15172",
    clipPath: "url(#clip-path-235)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32098",
    "data-name": "Path 32098",
    d: "M309.1,82.075l.517.006-.015.786-.517-.006Z",
    transform: "translate(-309.115 -82.158)",
    fill: "url(#radial-gradient-164)"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15181",
    "data-name": "Group 15181",
    transform: "translate(184.56 80.831)",
    opacity: 0.3,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g74 || (_g74 = /*#__PURE__*/React.createElement("g", {
    id: "Group_15180",
    "data-name": "Group 15180"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15179",
    "data-name": "Group 15179",
    clipPath: "url(#clip-path-236)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15178",
    "data-name": "Group 15178",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15177",
    "data-name": "Group 15177",
    clipPath: "url(#clip-path-237)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32100",
    "data-name": "Path 32100",
    d: "M154.424,67.377l25.515.311-.157,7.971-25.515-.311Z",
    transform: "translate(-154.464 -67.686)",
    fill: "url(#radial-gradient-165)"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15186",
    "data-name": "Group 15186",
    transform: "translate(215.876 88.689)",
    opacity: 0.3,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g75 || (_g75 = /*#__PURE__*/React.createElement("g", {
    id: "Group_15185",
    "data-name": "Group 15185"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15184",
    "data-name": "Group 15184",
    clipPath: "url(#clip-path-238)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15183",
    "data-name": "Group 15183",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15182",
    "data-name": "Group 15182",
    clipPath: "url(#clip-path-239)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32102",
    "data-name": "Path 32102",
    d: "M180.656,73.9l30.673.374-.1,4.831-30.673-.374Z",
    transform: "translate(-180.65 -74.272)",
    fill: "url(#radial-gradient-166)"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15191",
    "data-name": "Group 15191",
    transform: "translate(252.91 90.379)",
    opacity: 0.3,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g76 || (_g76 = /*#__PURE__*/React.createElement("g", {
    id: "Group_15190",
    "data-name": "Group 15190"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15189",
    "data-name": "Group 15189",
    clipPath: "url(#clip-path-240)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15188",
    "data-name": "Group 15188",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15187",
    "data-name": "Group 15187",
    clipPath: "url(#clip-path-241)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32104",
    "data-name": "Path 32104",
    d: "M211.408,74.725l53.368.65-.089,4.529-53.368-.65Z",
    transform: "translate(-211.684 -75.801)",
    fill: "url(#radial-gradient-167)"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15196",
    "data-name": "Group 15196",
    transform: "translate(344.731 91.109)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g77 || (_g77 = /*#__PURE__*/React.createElement("g", {
    id: "Group_15195",
    "data-name": "Group 15195"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15194",
    "data-name": "Group 15194",
    clipPath: "url(#clip-path-242)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15193",
    "data-name": "Group 15193",
    transform: "translate(0 -0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15192",
    "data-name": "Group 15192",
    clipPath: "url(#clip-path-243)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32106",
    "data-name": "Path 32106",
    d: "M288.462,76.1l5.889.072-.029,1.48-5.889-.072Z",
    transform: "translate(-288.461 -76.261)",
    fill: "url(#radial-gradient-168)"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15201",
    "data-name": "Group 15201",
    transform: "translate(338.471 91.079)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g78 || (_g78 = /*#__PURE__*/React.createElement("g", {
    id: "Group_15200",
    "data-name": "Group 15200"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15199",
    "data-name": "Group 15199",
    clipPath: "url(#clip-path-244)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15198",
    "data-name": "Group 15198",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15197",
    "data-name": "Group 15197",
    clipPath: "url(#clip-path-245)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32108",
    "data-name": "Path 32108",
    d: "M283.22,76.173l3.7.045-.009.469-3.7-.045Z",
    transform: "translate(-283.219 -76.218)",
    fill: "url(#radial-gradient-169)"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15206",
    "data-name": "Group 15206",
    transform: "translate(312.791 90.954)",
    opacity: 0.3,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g79 || (_g79 = /*#__PURE__*/React.createElement("g", {
    id: "Group_15205",
    "data-name": "Group 15205"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15204",
    "data-name": "Group 15204",
    clipPath: "url(#clip-path-246)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15203",
    "data-name": "Group 15203",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15202",
    "data-name": "Group 15202",
    clipPath: "url(#clip-path-247)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32110",
    "data-name": "Path 32110",
    d: "M261.745,75.881l22.17.27-.082,4.183-22.17-.27Z",
    transform: "translate(-261.743 -76.15)",
    fill: "url(#radial-gradient-170)"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15211",
    "data-name": "Group 15211",
    transform: "translate(354.799 83.705)",
    opacity: 0.3,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g80 || (_g80 = /*#__PURE__*/React.createElement("g", {
    id: "Group_15210",
    "data-name": "Group 15210"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15209",
    "data-name": "Group 15209",
    clipPath: "url(#clip-path-248)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15208",
    "data-name": "Group 15208",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15207",
    "data-name": "Group 15207",
    clipPath: "url(#clip-path-249)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32112",
    "data-name": "Path 32112",
    d: "M296.913,69.892l14.767.18-.185,9.415-14.767-.18Z",
    transform: "translate(-296.91 -70.07)",
    fill: "url(#radial-gradient-171)"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15214",
    "data-name": "Group 15214",
    transform: "translate(214.416 90.372)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g81 || (_g81 = /*#__PURE__*/React.createElement("g", {
    id: "Group_15213",
    "data-name": "Group 15213"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15212",
    "data-name": "Group 15212",
    clipPath: "url(#clip-path-250)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32114",
    "data-name": "Path 32114",
    d: "M179.561,86.443c.049.59.084,1.18.081,1.772,0,.46,0,.924.018,1.386.256.664.521,1.33.752,2-.255-2.425-.07-4.837-.272-7.265-.241-2.9-.213-5.785-.362-8.681,0-.055-.1-.042-.1.007-.023,1.42-.16,2.841-.263,4.263.186,2.163.165,4.343.147,6.518",
    transform: "translate(-179.414 -75.619)",
    fill: "#fff"
  }))))), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    id: "Path_32115",
    "data-name": "Path 32115",
    d: "M213.716,91.4a21.17,21.17,0,0,1-.97-5.06c-.206-1.736-.633-3.445-.913-5.174a28.137,28.137,0,0,1-.674-4.428c0-.051-.045-.068-.093-.063s-.1.033-.1.08a7.4,7.4,0,0,0-.062,1.441c.134.81.434,1.594.516,2.413.179,1.739.384,3.5.67,5.233a33.369,33.369,0,0,0,.967,5.1,32.045,32.045,0,0,1,1.409,4.675c.026.17.344.075.35-.062a11.3,11.3,0,0,0-1.1-4.158",
    transform: "translate(41.141 14.958)",
    fill: "#fff"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    id: "Path_32116",
    "data-name": "Path 32116",
    d: "M261.771,83.976c.043-.675-.477-1.207-.633-1.861-.4-1.659.226-3.371-.128-5.047-.01-.051-.108-.016-.1.029.3,1.6-.223,3.191-.047,4.795.085.754.685,1.6.416,2.344A3.088,3.088,0,0,0,261.3,86.2c.038.143.272.054.289-.053a3.581,3.581,0,0,0,0-.876,8.18,8.18,0,0,1,.183-1.3",
    transform: "translate(50.885 15.03)",
    fill: "#fff"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    id: "Path_32117",
    "data-name": "Path 32117",
    d: "M261.852,92.862c-.825-2.2-.067-4.584-.537-6.829-.019-.084-.176-.026-.163.045.231,1.287-.077,2.561.033,3.848.09,1.031-.194,2.066.488,3.006.053.074.2,0,.178-.071",
    transform: "translate(50.948 16.776)",
    fill: "#fff"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    id: "Path_32118",
    "data-name": "Path 32118",
    d: "M261.874,92.467c-.044-.12-.275-.038-.235.068a2.235,2.235,0,0,1,.092.843c0,.129.234.091.238-.02a2.419,2.419,0,0,0-.094-.89",
    transform: "translate(51.042 18.028)",
    fill: "#fff"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    id: "Path_32119",
    "data-name": "Path 32119",
    d: "M296.238,78.622c.062-1.1.145-2.179.127-3.282,0-.088-.159-.063-.164.014-.111,1.935-.027,4.105-.794,5.936-.353.844.178,1.661.14,2.532a31.378,31.378,0,0,0-.293,3.363c.008.152.262.105.276-.024.125-1.022.229-2.044.348-3.065a7.888,7.888,0,0,0,.152-1.5,2.807,2.807,0,0,1,.141-1.454c.348-.81.019-1.676.067-2.518",
    transform: "translate(57.6 14.687)",
    fill: "#fff"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    id: "Path_32120",
    "data-name": "Path 32120",
    d: "M294.99,86.717c-.017.835-.039,1.667.013,2.5.011.153.265.106.28-.024.085-.837.1-1.67.111-2.508.006-.221-.4-.158-.4.031",
    transform: "translate(57.546 16.884)",
    fill: "#fff"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    id: "Path_32121",
    "data-name": "Path 32121",
    d: "M294.975,90.082a.933.933,0,0,1-.112.5c-.03.051.056.078.087.031a1.01,1.01,0,0,0,.127-.535c0-.056-.1-.041-.1.006",
    transform: "translate(57.524 17.566)",
    fill: "#fff"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    id: "Path_32122",
    "data-name": "Path 32122",
    d: "M155.233,72.361a13.3,13.3,0,0,0-1.05-1.887,1.766,1.766,0,0,1,.755-2.284c.063-.026.079-.129-.012-.135-1.16-.079-1.523,2.071-1.236,2.672.258.54.613,1.047.851,1.593a17.247,17.247,0,0,1,.546,1.746,25.369,25.369,0,0,1,.4,4.036c.014.093.177.032.189-.036a12.452,12.452,0,0,0-.441-5.705",
    transform: "translate(29.965 13.277)",
    fill: "#fff"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    id: "Path_32123",
    "data-name": "Path 32123",
    d: "M155.059,77.062c-.219,1.034-.022,2.083-.231,3.106-.092.453-.141.917-.19,1.373-.054.485-.288.756-.124,1.229.041.115.252.041.225-.063a2.439,2.439,0,0,1,.212-1.422,8.239,8.239,0,0,0,.14-1.138c.14-1.033.2-2.1.423-3.119.054-.243-.41-.172-.454.035",
    transform: "translate(30.133 14.997)",
    fill: "#fff"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    id: "Path_32124",
    "data-name": "Path 32124",
    d: "M168.319,64.472c-1.638.246-3.249.624-4.851.985-1.768.4-3.384,1.036-5.088,1.569-.065.02-.054.105.022.084,1.579-.447,3.09-1.024,4.719-1.353,1.736-.351,3.527-.564,5.218-1.042.148-.043.178-.272-.02-.243",
    transform: "translate(30.89 12.577)",
    fill: "#fff"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    id: "Path_32125",
    "data-name": "Path 32125",
    d: "M175.13,73.424a53.4,53.4,0,0,0-5.923-2.3c-2.274-.575-4.252-1.61-6.431-2.357-.047-.017-.1.045-.047.065a63.163,63.163,0,0,0,5.941,2.456,19.276,19.276,0,0,1,2.99,1.052,17.415,17.415,0,0,0,3.31,1.3c.154.037.332-.145.159-.212",
    transform: "translate(31.743 13.415)",
    fill: "#fff"
  })), _g82 || (_g82 = /*#__PURE__*/React.createElement("g", {
    id: "Group_15217",
    "data-name": "Group 15217",
    transform: "translate(228.175 88.879)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15216",
    "data-name": "Group 15216"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15215",
    "data-name": "Group 15215",
    clipPath: "url(#clip-path-251)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32126",
    "data-name": "Path 32126",
    d: "M200.006,75.221c-2.929-.627-6.1-.157-8.987-.85-.067-.018-.135.086-.059.1,2.873.723,6.051.28,8.975.927.127.027.216-.148.07-.18",
    transform: "translate(-190.927 -74.37)",
    fill: "#fff"
  }))))), _g83 || (_g83 = /*#__PURE__*/React.createElement("g", {
    id: "Group_15220",
    "data-name": "Group 15220",
    transform: "translate(269.052 90.418)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15219",
    "data-name": "Group 15219"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15218",
    "data-name": "Group 15218",
    clipPath: "url(#clip-path-252)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32127",
    "data-name": "Path 32127",
    d: "M239.371,76.367c-2.383-.163-4.755-.375-7.138-.555-2.34-.178-4.686-.135-7.035-.154-.077,0-.1.1-.008.1,2.473.033,4.954-.013,7.412.235a53.417,53.417,0,0,0,6.713.611c.151,0,.239-.225.057-.238",
    transform: "translate(-225.131 -75.658)",
    fill: "#fff"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15225",
    "data-name": "Group 15225",
    transform: "translate(325.378 90.372)",
    opacity: 0.3,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g84 || (_g84 = /*#__PURE__*/React.createElement("g", {
    id: "Group_15224",
    "data-name": "Group 15224"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15223",
    "data-name": "Group 15223",
    clipPath: "url(#clip-path-253)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15222",
    "data-name": "Group 15222",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15221",
    "data-name": "Group 15221",
    clipPath: "url(#clip-path-254)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32128",
    "data-name": "Path 32128",
    d: "M272.23,75.4l14.655.179-.02,1.026-14.655-.179Z",
    transform: "translate(-272.272 -75.662)",
    fill: "url(#radial-gradient-172)"
  }))))))))), _g85 || (_g85 = /*#__PURE__*/React.createElement("g", {
    id: "Group_15229",
    "data-name": "Group 15229",
    transform: "translate(358.13 83.107)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15228",
    "data-name": "Group 15228",
    clipPath: "url(#clip-path-255)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32130",
    "data-name": "Path 32130",
    d: "M299.658,69.42l11.871.145-.1,5.2-11.871-.145Z",
    transform: "translate(-299.689 -69.563)",
    fill: "url(#radial-gradient-173)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15256",
    "data-name": "Group 15256"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15255",
    "data-name": "Group 15255",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15234",
    "data-name": "Group 15234",
    transform: "translate(334.473 75.759)",
    opacity: 0.4,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g86 || (_g86 = /*#__PURE__*/React.createElement("g", {
    id: "Group_15233",
    "data-name": "Group 15233"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15232",
    "data-name": "Group 15232",
    clipPath: "url(#clip-path-257)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15231",
    "data-name": "Group 15231"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15230",
    "data-name": "Group 15230",
    clipPath: "url(#clip-path-258)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32132",
    "data-name": "Path 32132",
    d: "M279.908,63.139l25,.3-.191,9.7-25-.3Z",
    transform: "translate(-279.902 -63.441)",
    fill: "url(#radial-gradient-174)"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15239",
    "data-name": "Group 15239",
    transform: "translate(313.452 76.926)",
    opacity: 0.4,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g87 || (_g87 = /*#__PURE__*/React.createElement("g", {
    id: "Group_15238",
    "data-name": "Group 15238"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15237",
    "data-name": "Group 15237",
    clipPath: "url(#clip-path-259)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15236",
    "data-name": "Group 15236",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15235",
    "data-name": "Group 15235",
    clipPath: "url(#clip-path-260)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32134",
    "data-name": "Path 32134",
    d: "M262.331,64.063l30.211.368-.259,13.183-30.211-.368Z",
    transform: "translate(-262.324 -64.428)",
    fill: "url(#radial-gradient-175)"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15244",
    "data-name": "Group 15244",
    transform: "translate(256.012 77.777)",
    opacity: 0.4,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g88 || (_g88 = /*#__PURE__*/React.createElement("g", {
    id: "Group_15243",
    "data-name": "Group 15243"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15242",
    "data-name": "Group 15242",
    clipPath: "url(#clip-path-261)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15241",
    "data-name": "Group 15241"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15240",
    "data-name": "Group 15240",
    clipPath: "url(#clip-path-262)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32136",
    "data-name": "Path 32136",
    d: "M214.269,64.5l56.855.693-.231,11.746-56.855-.693Z",
    transform: "translate(-214.256 -65.193)",
    fill: "url(#radial-gradient-176)"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15249",
    "data-name": "Group 15249",
    transform: "translate(219.443 76.036)",
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g89 || (_g89 = /*#__PURE__*/React.createElement("g", {
    id: "Group_15248",
    "data-name": "Group 15248"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15247",
    "data-name": "Group 15247",
    clipPath: "url(#clip-path-263)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15246",
    "data-name": "Group 15246",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15245",
    "data-name": "Group 15245",
    clipPath: "url(#clip-path-264)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32138",
    "data-name": "Path 32138",
    d: "M183.668,63.191l42.661.52-.242,12.321-42.661-.52Z",
    transform: "translate(-183.658 -63.708)",
    fill: "url(#radial-gradient-177)"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15254",
    "data-name": "Group 15254",
    transform: "translate(198.643 73.794)",
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g90 || (_g90 = /*#__PURE__*/React.createElement("g", {
    id: "Group_15253",
    "data-name": "Group 15253"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15252",
    "data-name": "Group 15252",
    clipPath: "url(#clip-path-265)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15251",
    "data-name": "Group 15251",
    transform: "translate(0 -0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15250",
    "data-name": "Group 15250",
    clipPath: "url(#clip-path-266)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32140",
    "data-name": "Path 32140",
    d: "M166.265,61.346l35.784.436-.257,13.059L166.008,74.4Z",
    transform: "translate(-166.257 -61.826)",
    fill: "url(#radial-gradient-178)"
  }))))))))), _g91 || (_g91 = /*#__PURE__*/React.createElement("g", {
    id: "Group_15258",
    "data-name": "Group 15258",
    transform: "translate(180.273)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15257",
    "data-name": "Group 15257",
    clipPath: "url(#clip-path-267)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32142",
    "data-name": "Path 32142",
    d: "M150.787-1.968,345.539.405l-1.775,90.221L149.013,88.252Z",
    transform: "translate(-151.202 -0.384)",
    fill: "url(#radial-gradient-179)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15265",
    "data-name": "Group 15265"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15264",
    "data-name": "Group 15264",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15263",
    "data-name": "Group 15263",
    transform: "translate(185.111 26.135)",
    opacity: 0.4,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g92 || (_g92 = /*#__PURE__*/React.createElement("g", {
    id: "Group_15262",
    "data-name": "Group 15262"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15261",
    "data-name": "Group 15261",
    clipPath: "url(#clip-path-269)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15260",
    "data-name": "Group 15260",
    transform: "translate(0 -0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15259",
    "data-name": "Group 15259",
    clipPath: "url(#clip-path-270)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32144",
    "data-name": "Path 32144",
    d: "M153.941,19.935,332.17,22.107l-1.26,64.049L152.681,83.984Z",
    transform: "translate(-155.325 -22.246)",
    fill: "url(#radial-gradient-180)"
  }))))))))), _g93 || (_g93 = /*#__PURE__*/React.createElement("g", {
    id: "Group_15267",
    "data-name": "Group 15267",
    transform: "translate(336.594 82.582)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15266",
    "data-name": "Group 15266",
    clipPath: "url(#clip-path-271)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32146",
    "data-name": "Path 32146",
    d: "M281.649,69.087l1.425.017-.009.482-1.425-.017Z",
    transform: "translate(-281.649 -69.104)",
    fill: "url(#radial-gradient-181)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15514",
    "data-name": "Group 15514"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15513",
    "data-name": "Group 15513",
    clipPath: "url(#clip-path)"
  }, _g94 || (_g94 = /*#__PURE__*/React.createElement("g", {
    id: "Group_15270",
    "data-name": "Group 15270",
    transform: "translate(180.274)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15269",
    "data-name": "Group 15269"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15268",
    "data-name": "Group 15268",
    clipPath: "url(#clip-path-273)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32148",
    "data-name": "Path 32148",
    d: "M159.764,50.329c-.053.036-.106.073-.159.111.863-.1,1.723-.216,2.578-.36-.761-1.23-2.295-1.947-3.5-2.893a.159.159,0,0,1,.006-.262c1.61-.984,3.935-.837,5.833-.626a29.841,29.841,0,0,1,4.9,1.1c1.551.437,4.623,1.35,5.636-.24,1.156-1.817-2.044-3.633-3.561-4.657a.174.174,0,0,1,.109-.308c1.643-.169,3.443.109,5.028-.355,1.407-.411-.484-1.171-.927-1.532-.076-.062-.066-.139-.065-.219a3.62,3.62,0,0,0-.429-1.2q-.55-1.327-1.218-2.617c-.1-.184.172-.382.373-.22a7.917,7.917,0,0,0,3.221,1.823,5.185,5.185,0,0,0-.116-1.26c-.05-.124.129-.28.294-.223,1.172.4,3.554,1.058,4.443-.088s-.115-2.593-.908-3.571c-.145-.177.2-.379.373-.22a3.933,3.933,0,0,0,2.62,1.331,2.549,2.549,0,0,0,1.924-1.1,6.747,6.747,0,0,0,1.266-3.83c.007-.195.312-.233.44-.087,2.033,2.314,5.123,5.987,9.294,5.089A31.5,31.5,0,0,0,195.4,28.2c-.076-.172.249-.318.394-.174a4.861,4.861,0,0,0,2.3,1.453c1.324.27,1.864-.623,2.134-1.49.054-.17.324-.161.431-.039a27.648,27.648,0,0,0,4.08,4.348c1.618,1.2,4.232,1.979,5.778.232a6.684,6.684,0,0,0,1.352-4.758,11.7,11.7,0,0,0-.808-4.217c-.082-.2.313-.324.433-.139.558.859,1.563,1.931,2.762.954a6.7,6.7,0,0,0,1.454-1.766.243.243,0,0,1,.2-.088c.266.03.519.091.778.137-.3-1.8-.325-3.632-.681-5.432-.042-.213.275-.311.431-.137.522.575,1.22,1.028,1.773,1.58a2.637,2.637,0,0,0,.651-.514.273.273,0,0,1,.4,0c1.06,1.409,1.881,3.177,3.376,4.342,2.009,1.566,4.013-.552,5.16-1.819.112-.123.38-.116.429.051.6,2.038.958,4.2,2.143,6.094.272.436,1.611,2.53,2.372,2.174a3.074,3.074,0,0,0,1.488-1.63A11.488,11.488,0,0,0,235,22.4a14.378,14.378,0,0,0-.592-4.1c-.065-.2.327-.335.434-.136a5.992,5.992,0,0,0,1.882,2.077c.467-.549,1.292-.864,1.4-1.6a.253.253,0,0,1,.439-.088c.324.517,1.223,1.99,2.145,1.2a5.372,5.372,0,0,0,1.347-2.275,51.057,51.057,0,0,1,1.68-5.041.269.269,0,0,1,.4-.076,13.861,13.861,0,0,0,2.7,1.594c-.289-.452-.553-.914-.884-1.348-.147-.192.179-.347.373-.22a3.682,3.682,0,0,0,4.157.331,7.333,7.333,0,0,0,2.093-2.291c.1-.161.465-.084.435.1-.088.522-.364,1.989.8,1.887a6.241,6.241,0,0,0,2.632-1.151,21.15,21.15,0,0,0,4.3-3.5.251.251,0,0,1,.435.1c.16,1.3.724,3.5,2.96,2.538a12.893,12.893,0,0,0,3.435-2.418.285.285,0,0,1,.333,0c1.728,1.273,3.211,2.912,5.493,3.579a10.859,10.859,0,0,0-.043-4.207,13.6,13.6,0,0,0-4.117-4.807,2.633,2.633,0,0,0-1.716-.747c-.871.067-1.385,1.335-1.7,1.821a22.3,22.3,0,0,0-1.634,2.808,10.979,10.979,0,0,0-.082-1.232c-.059-.465-.042-2.008-1.122-1.793a2.445,2.445,0,0,0-1.436,1.017q.095-.864.146-1.73a5.832,5.832,0,0,0-.078-2.082c-.505-1.582-3.137.3-3.765.813a29.884,29.884,0,0,0-4.586,4.957c-.308.4-.625.828-.929,1.275-.012-.055-.02-.109-.033-.164-.13-.549-.588-2.567-1.754-2.35A1.541,1.541,0,0,0,249.454,6.2c-.36.785-.614,1.6-.993,2.382a22.765,22.765,0,0,0-1.01,2.432,9.587,9.587,0,0,0-2.109-4.092c-.635-.712-2.066-1.915-3.349-1.912-.008-.019-.019-.039-.029-.057-.446-.778-1.756-2.739-3.2-2.329-1.633.464-1.012,2.945-.932,3.918.025.325.066.647.111.967a8.136,8.136,0,0,0-2.43-2.177c-1.1-.539-1.689.216-1.864,1.019a16.918,16.918,0,0,0-.072,2.881c-.026.666-.074,1.329-.118,1.993A15.113,15.113,0,0,0,230.5,7.664a3.6,3.6,0,0,0-2.183-.955,1.524,1.524,0,0,0-1.163-.549c-.477,0-.712.367-.834.743-.831-.753-1.719-.993-2.552-.082a7.9,7.9,0,0,0-1.621,3.21,29.915,29.915,0,0,0-2.457-2.8c-.636-.662-1.454-1.87-2.709-1.823a2.771,2.771,0,0,0-2.126,1.33,15.225,15.225,0,0,0-2.371,5.918c-.025.114-.047.229-.069.344a1.708,1.708,0,0,0-2.3-.174,1.849,1.849,0,0,0-.146.145c-.4-.551-.844-1.086-1.243-1.616a3.324,3.324,0,0,0-2.761-1.518,2.585,2.585,0,0,0-2.1.966,5.171,5.171,0,0,0-.927,2.242c-.133.529-.258,1.058-.368,1.588-.851-.821-1.729-1.242-2.363-.341a2.936,2.936,0,0,0-.454,1.276,21.065,21.065,0,0,0-1.79-1.477c-.815-.621-2.356-1.874-3.616-1.764a.481.481,0,0,0-.489.5,6.266,6.266,0,0,0,.186.973c-.292-.194-.6-.38-.915-.558a.594.594,0,0,0-.825.241,6.384,6.384,0,0,0-.079,2.243c-.014.491-.048.981-.085,1.471a6.177,6.177,0,0,0-1.218-.813.6.6,0,0,0-.734.3,8.367,8.367,0,0,0-.123,2.636c0,.143-.01.287-.016.43a12.145,12.145,0,0,0-1.2-1.548c-.918-.988-1.972-2.36-3.465-2.842a.771.771,0,0,0-.927.374,8.867,8.867,0,0,0-.264,3.347,17.713,17.713,0,0,0,.1,1.919,14.341,14.341,0,0,0-1.668-1.42,7.59,7.59,0,0,0-3.739-1.906c-.339-.029-.688.184-.7.462a6.5,6.5,0,0,0,.343,1.646c.158.765.327,1.53.523,2.29a17.064,17.064,0,0,0,.537,1.734,11.023,11.023,0,0,0-2.058-.5.608.608,0,0,0-.691.455,5.446,5.446,0,0,0,1.025,2.64,12.754,12.754,0,0,0-2.951-.9c-.66-.117-5.422-1-4.95.558.465,1.539,1.934,2.984,3.248,4.176a1.889,1.889,0,0,0-1.477.564c-.43.582.441,1.242.892,1.622.278.237.568.494.875.745a7.11,7.11,0,0,0-2.028.037,23.2,23.2,0,0,0-5.023-1,13.4,13.4,0,0,0-4.619-.082,1.662,1.662,0,0,0-1.137,2.449,11.08,11.08,0,0,0,2.659,3.154,13.692,13.692,0,0,0-1.807-.108.652.652,0,0,0-.549.362c-.582,1.151.829,2.4,1.711,3.2.274.247.547.495.827.74a31.148,31.148,0,0,0-5.652,1.034,19.277,19.277,0,0,0-5.209,2.114c-.841.5-2.291,1.537-1.685,2.5.7,1.11,2.765,1.654,4.147,2a38.3,38.3,0,0,0,4.627.758",
    transform: "translate(-150.845 0)",
    fill: "#b5fe79"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15275",
    "data-name": "Group 15275",
    transform: "translate(190.659 3.036)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g95 || (_g95 = /*#__PURE__*/React.createElement("g", {
    id: "Group_15274",
    "data-name": "Group 15274"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15273",
    "data-name": "Group 15273",
    clipPath: "url(#clip-path-274)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15272",
    "data-name": "Group 15272",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15271",
    "data-name": "Group 15271",
    clipPath: "url(#clip-path-275)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32149",
    "data-name": "Path 32149",
    d: "M159.687.571,343.734,2.814,342.019,90,157.971,87.756Z",
    transform: "translate(-159.84 -2.924)",
    fill: "url(#radial-gradient-182)"
  }))))))), _g96 || (_g96 = /*#__PURE__*/React.createElement("g", {
    id: "Group_15278",
    "data-name": "Group 15278",
    transform: "translate(270.33 9.856)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15277",
    "data-name": "Group 15277"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15276",
    "data-name": "Group 15276",
    clipPath: "url(#clip-path-276)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32151",
    "data-name": "Path 32151",
    d: "M311.25,52.875c-.348-1.37-3.744-1.48-5.036-1.575-.539-.041-1.072-.086-1.605-.13a11.1,11.1,0,0,0,1.7-.555c.648-.106,1.294-.215,1.937-.337.453-.086.865-.837.212-.937l-.1-.01a1.116,1.116,0,0,0,.092-1.733c-1.282-1.275-4.194-1.578-6.238-1.662.541-.255,1.076-.515,1.585-.8.669-.373,1.071-1.013.718-1.635-.644-1.141-3.151-.854-4.367-.745-1.022.091-2.038.226-3.046.381a21.872,21.872,0,0,0,3.384-2.385c1.2-1.152-.274-1.983-1.7-2.164a10.453,10.453,0,0,0-3.84.247c.458-.341.925-.674,1.4-1,.991-.67,2.12-1.429,2.23-2.524.041-.37-.331-.626-.785-.457-1.574.59-3.076,1.284-4.582,1.97a10,10,0,0,0,1.365-2.8c.333-1.127.868-2.7-.237-3.668a.663.663,0,0,0-.712-.105,14.6,14.6,0,0,0-4.773,3.944,2.122,2.122,0,0,0-1.413.359,3.129,3.129,0,0,0,.653-1.885c-.013-.277-.326-.411-.642-.372a7.773,7.773,0,0,0-3.595,1.489c1.464-2.72,3.227-6.721.351-6.779a5.367,5.367,0,0,0-2.751,1.085,9.228,9.228,0,0,0-2.528,2.562c-.061.087-.117.179-.176.269a12.658,12.658,0,0,0-.21-2.489c-.075-.386-.473-.508-.908-.375-1.734.532-2.252,1.833-2.615,3.159-.2-.59-.4-1.181-.656-1.757-.359-.8-1.1-2.467-2.542-2.249-2.13.321-2.273,2.918-2.151,4.2q.032.332.087.663c-1.182-.386-2.479.461-3.694,1.337,1.262-1.367,2.17-2.884.082-3.769l-.016-.006a3.7,3.7,0,0,0,1.094-1.176.346.346,0,0,0-.127-.486c-1.573-.878-3.473-.633-5.3-.259,1.009-.535,2.046-1.045,3.006-1.61,1.107-.653,3.824-1.992,3.442-3.34-.241-.851-1.664-.742-3.08-.4a1.391,1.391,0,0,0,.237-.437.365.365,0,0,0-.185-.405c-1.9-1.056-4.348-.4-6.563.276,1.3-.8,2.681-1.53,4-2.283,1.227-.7,3.5-1.934,3.43-3.324-.07-1.439-2.051-1.538-3.492-1.391a13.544,13.544,0,0,0-3.384.876c-.987.367-1.888.884-2.83,1.335a13.058,13.058,0,0,0,1.348-1.968.443.443,0,0,0-.44-.649c-2.035.032-3.373,1.175-4.986,1.953a40.983,40.983,0,0,0,.234-6.779,1.321,1.321,0,0,0-1.248-1.315c-1.04-.118-2.052.952-2.541,1.514a11.238,11.238,0,0,0-2.436,5.22c-.434-.48-.876-.957-1.305-1.44-.968-1.09-2.2-2.462-3.972-2.736a1.025,1.025,0,0,0-.933.282,2.071,2.071,0,0,0-.422,1.746c.081,1.028.152,2.06.27,3.087.03.27.067.54.1.81-.716-.482-1.48-.923-2.2-1.355-1.653-.98-3.882-2.281-6.107-1.834-2.02.405-1.139,2.518-.52,3.486.777,1.209,1.662,2.365,2.528,3.53a9.52,9.52,0,0,0-4.538-.508c-.552.1-1.019.721-.621,1.116a14.569,14.569,0,0,0,3.352,2.179c-.514-.01-1.052-.068-1.4-.068a5.923,5.923,0,0,0-1.735.316c-.8.245-2.787.869-2.6,1.8.208,1.033,2.926,1.477,3.943,1.769a41.683,41.683,0,0,0,4.881,1.143c-2.671.6-5.237,1.65-7.747,2.487-.521.173-.765.985-.082,1.129,2.125.454,4.357-.026,6.463-.321q.692-.1,1.374-.209a31.933,31.933,0,0,0-3.055,2.216c-.366.3-.434.881.239.936A12.2,12.2,0,0,0,237,33.672c1.2-.394,2.35-.853,3.521-1.284-1.66,1.453-3.04,3.177-3.192,5.079a.447.447,0,0,0,.48.513c1.8-.045,3.7-1.417,5.053-2.269a15.3,15.3,0,0,0,1.47-1.046c-.18.5-.374,1-.606,1.483a.4.4,0,0,0,.4.586,6.1,6.1,0,0,0,3.315-1.186c-.36,1.137-.792,2.2.308,3.277a3.276,3.276,0,0,0,1.581.822,5.963,5.963,0,0,0-1.481,1.68.506.506,0,0,0,.5.741,11.883,11.883,0,0,0,4.325-1.358,41.365,41.365,0,0,1-3.124,3.015c-1.145,1.046-2.556,2.535-1.874,3.994.645,1.38,2.318.356,3.607-.785a4.806,4.806,0,0,0-.274,1.49,8.1,8.1,0,0,0,1.632,3.951.556.556,0,0,0,.621.257c1.708-.486,2.305-1.867,3.15-3.043.553.037,1.131,0,1.7-.013a7.127,7.127,0,0,1-1.359,2.7c-.153.237.032.522.366.543,1.471.092,2.774-.9,3.744-1.644.647-.495,1.269-1.018,1.886-1.546a16.388,16.388,0,0,0,.927-4.883,3.852,3.852,0,0,1,0-.484c.014-.24.466-.234.471,0,0,.188,0,.375,0,.563a1.164,1.164,0,0,0,.673,1.1,2.252,2.252,0,0,0,1.971-.379,6.118,6.118,0,0,0,1.909-1.812c.938-1.354,1.53-2.831,2.412-4.2.11-.169.441-.076.437.1a9.629,9.629,0,0,0,0,2.148c.234,1.127,1.182,1.138,2.364.718.2-.074.446.087.314.257a3.782,3.782,0,0,0-1.066,2.21c.081,1.211,1.827,1.076,2.792.636a25.153,25.153,0,0,0,4.786-3.222c.179-.137.429.013.387.186-.217.907-.7,1.764-.945,2.669a2.052,2.052,0,0,0-.085,1.342c.281.612,1.227.4,1.827.263.173-.038.332.1.284.232-1.041,2.817,4.779,2.912,6.971,2.507.27-.05.392.226.176.341-1.065.56-2.547,1.048-2.945,2.079a11.025,11.025,0,0,0,2.868,0c.238-.023.38.163.224.312-.5.482-1,.966-1.44,1.482a6.13,6.13,0,0,0,3.473-.48c.217-.079.425.088.318.258-.89,1.379-2.06,3.708-1.084,5.218,1.658,2.561,3.907-.884,4.709-2.021a.251.251,0,0,1,.435.1c.1,2.056-1.632,3.99-1.451,6.075.051.563.5,1.226,1.251.667a5.268,5.268,0,0,0,1.172-1.264,27.507,27.507,0,0,0,1.453-2.43c.108-.192.521-.048.428.147a15.982,15.982,0,0,0-1.628,5c-.068.626-.257,2.33.927,2.493a.492.492,0,0,0,.146,0c.053-.117.1-.219.131-.3.2-.439.387-.9.563-1.356.02-.261.022-.478.026-.581.006-.239.478-.233.471.006,0,.117-.006.253-.008.4a4.457,4.457,0,0,0,1.775.611.607.607,0,0,0,.614-.423,6.7,6.7,0,0,0-.164-2.788c.207.134.412.265.624.391,1.164.7,3.007,1.821,4.563,1.274,1.78-.627,1.1-2.94.613-4.384,1.48.038,2.8-.251,3.161-1.262.529-1.459-1.644-2.55-3.007-3.107-.362-.148-.745-.3-1.144-.454.584-.161,1.165-.327,1.742-.486,1.3-.361,3.43-.82,3.076-2.212",
    transform: "translate(-226.2 -8.247)",
    fill: "#89e255"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15281",
    "data-name": "Group 15281",
    transform: "translate(270.33 25.949)",
    opacity: 0.8,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g97 || (_g97 = /*#__PURE__*/React.createElement("g", {
    id: "Group_15280",
    "data-name": "Group 15280"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15279",
    "data-name": "Group 15279",
    clipPath: "url(#clip-path-277)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32152",
    "data-name": "Path 32152",
    d: "M311.25,50.248c-.348-1.37-3.744-1.48-5.036-1.575-.539-.041-1.072-.086-1.605-.13a11.1,11.1,0,0,0,1.7-.555c.648-.106,1.294-.215,1.937-.337.453-.086.865-.837.212-.937l-.1-.01a1.116,1.116,0,0,0,.092-1.733,2.885,2.885,0,0,0-.349-.292c-.269,2-3.747,2.861-6.353,2.8,1.578,1.558,4.039,4.706,1.227,6.054-1.613.773-1.868-1.485-1.9-2.9a8.657,8.657,0,0,1-1.8,1.877c-.817.65-2.106,1.548-3.389,1.305-3.18-.6-1.22-3.681-.086-5.341-1.267.471-2.915.712-3.487-.569a2.714,2.714,0,0,1-.186-1.537,13.22,13.22,0,0,1-4-.27c-1.135-.3-2.019-1.2-1.1-2.079a6.629,6.629,0,0,1,3-1.426c-1.133-.063-2.279-.063-3.4-.221-1.166-.165-2.67-.433-2.939-1.494a1.228,1.228,0,0,1,.343-1.086,2.291,2.291,0,0,1-.984-3.286c-1.713,1.2-4.265,2.889-6.257,1.97-1.138-.523-.454-1.75.354-2.683a4.17,4.17,0,0,1-3.645.233,2.653,2.653,0,0,1-1.417-2.259,11.652,11.652,0,0,1-1.305,1.779c-.581.669-1.542,1.88-2.714,1.936a2.324,2.324,0,0,1-.727-.075,4.167,4.167,0,0,1-1.285,1.054c-.99.507-1.527.066-1.79-.563-.642,1.972-1.632,4.284-3.563,5.545-.545.356-2.3.849-2.714.109-.386-.691.143-1.568.448-2.312-.547.2-1.231.337-1.631-.048a1.906,1.906,0,0,1-.353-1.739,42.594,42.594,0,0,1,1.282-4.148c-.862.3-2.342.746-2.758.022-.452-.784.03-1.911.376-2.794-1.042.551-2.754,1.335-3.669.629-.892-.687-.43-1.954.036-2.9-1.04.7-2.48,1.562-3.61,1.134-1.576-.6-1.172-1.876-.341-2.788-1.137.195-2.734.424-3.469-.186-.521-.431.059-1.078.7-1.594-2.99,1.036-6.677,2.345-9.6,1.028a.167.167,0,0,1-.079-.255,8.157,8.157,0,0,1,4.119-2.449,9.588,9.588,0,0,1-2.463-.369c-.195-.061-.222-.245-.048-.339.209-.114.411-.226.623-.329-2.671-.449-5.376-.721-7.981-1.4a10.99,10.99,0,0,1-2.608-.992c-.49.287-.843.643-.757,1.06.208,1.033,2.926,1.477,3.943,1.769a41.683,41.683,0,0,0,4.881,1.143c-2.671.6-5.237,1.65-7.747,2.487-.521.173-.765.985-.082,1.129,2.125.454,4.357-.026,6.463-.321q.692-.1,1.374-.209a31.933,31.933,0,0,0-3.055,2.216c-.366.3-.434.881.239.936A12.2,12.2,0,0,0,237,31.045c1.2-.394,2.35-.853,3.521-1.284-1.66,1.453-3.04,3.177-3.192,5.079a.447.447,0,0,0,.48.513c1.8-.045,3.7-1.417,5.053-2.269a15.3,15.3,0,0,0,1.47-1.046c-.18.5-.374,1-.606,1.483a.4.4,0,0,0,.4.586,6.1,6.1,0,0,0,3.315-1.186c-.36,1.137-.792,2.2.308,3.277a3.276,3.276,0,0,0,1.581.822,5.963,5.963,0,0,0-1.481,1.68.506.506,0,0,0,.5.741,11.883,11.883,0,0,0,4.325-1.358,41.366,41.366,0,0,1-3.124,3.015c-1.145,1.046-2.556,2.535-1.874,3.994.645,1.38,2.318.356,3.607-.785a4.806,4.806,0,0,0-.274,1.49,8.1,8.1,0,0,0,1.632,3.951.556.556,0,0,0,.621.257c1.708-.486,2.305-1.867,3.15-3.043.553.037,1.131,0,1.7-.013a7.127,7.127,0,0,1-1.359,2.7c-.153.237.032.522.366.543,1.471.092,2.774-.9,3.744-1.644.647-.495,1.269-1.018,1.886-1.546a16.388,16.388,0,0,0,.927-4.883,3.852,3.852,0,0,1,0-.484c.014-.24.466-.234.471,0,0,.188,0,.375,0,.563a1.164,1.164,0,0,0,.673,1.1,2.252,2.252,0,0,0,1.971-.379,6.118,6.118,0,0,0,1.909-1.812c.938-1.354,1.53-2.831,2.412-4.2.11-.169.441-.076.437.1a9.629,9.629,0,0,0,0,2.148c.234,1.127,1.182,1.138,2.364.718.2-.074.446.087.314.257a3.782,3.782,0,0,0-1.066,2.21c.081,1.211,1.827,1.076,2.792.636a25.152,25.152,0,0,0,4.786-3.222c.179-.137.429.013.387.186-.217.907-.7,1.764-.945,2.669a2.052,2.052,0,0,0-.085,1.342c.281.612,1.227.4,1.827.263.173-.038.332.1.284.232-1.041,2.817,4.779,2.912,6.971,2.507.27-.05.392.226.176.341-1.065.56-2.547,1.048-2.945,2.079a11.026,11.026,0,0,0,2.868,0c.238-.023.38.163.224.312-.5.482-1,.966-1.44,1.482a6.13,6.13,0,0,0,3.473-.48c.217-.079.425.088.318.258-.89,1.379-2.06,3.708-1.084,5.218,1.658,2.561,3.907-.884,4.709-2.021a.251.251,0,0,1,.435.1c.1,2.056-1.632,3.99-1.451,6.075.051.563.5,1.226,1.251.667a5.268,5.268,0,0,0,1.172-1.264,27.507,27.507,0,0,0,1.453-2.43c.108-.192.521-.048.428.147a15.982,15.982,0,0,0-1.628,5c-.068.626-.257,2.33.927,2.493a.492.492,0,0,0,.146,0c.053-.117.1-.219.131-.3.2-.439.387-.9.563-1.356.02-.261.022-.478.026-.581.006-.239.478-.233.471.006,0,.117-.006.253-.008.4a4.457,4.457,0,0,0,1.775.611.607.607,0,0,0,.614-.423,6.7,6.7,0,0,0-.164-2.788c.207.134.412.265.624.391,1.164.7,3.007,1.821,4.563,1.274,1.78-.627,1.1-2.94.613-4.384,1.48.038,2.8-.251,3.161-1.262.529-1.459-1.644-2.55-3.007-3.107-.362-.148-.745-.3-1.144-.454.584-.161,1.165-.327,1.742-.486,1.3-.361,3.43-.82,3.076-2.212",
    transform: "translate(-226.2 -21.713)",
    fill: "#b4e255"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15284",
    "data-name": "Group 15284",
    transform: "translate(193.093 35.382)",
    opacity: 0.4,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }, _g98 || (_g98 = /*#__PURE__*/React.createElement("g", {
    id: "Group_15283",
    "data-name": "Group 15283"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15282",
    "data-name": "Group 15282",
    clipPath: "url(#clip-path-278)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32153",
    "data-name": "Path 32153",
    d: "M167.764,30.9a7.106,7.106,0,0,0-5.147-1.215,1.216,1.216,0,0,0-1,.658.621.621,0,0,0,.4.837c.474.145.7.636.988.956.467.523.8,1.091,1.306,1.6.806.808,2.528.326,3.249-.265a1.591,1.591,0,0,0,.207-2.568",
    transform: "translate(-161.572 -29.606)",
    fill: "#f3fe8b"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15287",
    "data-name": "Group 15287",
    transform: "translate(194.447 32.755)",
    opacity: 0.4,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }, _g99 || (_g99 = /*#__PURE__*/React.createElement("g", {
    id: "Group_15286",
    "data-name": "Group 15286"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15285",
    "data-name": "Group 15285",
    clipPath: "url(#clip-path-279)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32154",
    "data-name": "Path 32154",
    d: "M165.245,28.261c-.393-.221-.767-.465-1.14-.705-.783-.506-1.814.4-1.225,1,.3.3.6.6.912.893a1.673,1.673,0,0,0,1.717.614.994.994,0,0,0,.751-.766c.076-.578-.517-.76-1.015-1.04",
    transform: "translate(-162.705 -27.408)",
    fill: "#f3fe8b"
  }))))), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    id: "Path_32155",
    "data-name": "Path 32155",
    d: "M160.114,36.823a1.556,1.556,0,0,0-.516-.065,1.611,1.611,0,0,0-.292.047l-.059.013-.047.007c-.237.037-.478.051-.718.071a.885.885,0,0,0-.749.494.5.5,0,0,0,.47.669c.657.066,1.518.179,2-.276.268-.255.449-.8-.088-.96",
    transform: "translate(30.766 7.171)",
    fill: "#cefe79"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_15290",
    "data-name": "Group 15290",
    transform: "translate(223.956 14.983)",
    opacity: 0.4,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }, _g100 || (_g100 = /*#__PURE__*/React.createElement("g", {
    id: "Group_15289",
    "data-name": "Group 15289"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15288",
    "data-name": "Group 15288",
    clipPath: "url(#clip-path-280)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32156",
    "data-name": "Path 32156",
    d: "M189.835,14.069a3.577,3.577,0,0,0-.853-1.368,1.051,1.051,0,0,0-1.08-.029.812.812,0,0,0-.5.844c.118.894-.007,2.038.729,2.768.691.682,2.139-.166,2.131-.85a3.979,3.979,0,0,0-.429-1.365",
    transform: "translate(-187.397 -12.537)",
    fill: "#f3fe8b"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15293",
    "data-name": "Group 15293",
    transform: "translate(224.166 26.027)",
    opacity: 0.4,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }, _g101 || (_g101 = /*#__PURE__*/React.createElement("g", {
    id: "Group_15292",
    "data-name": "Group 15292"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15291",
    "data-name": "Group 15291",
    clipPath: "url(#clip-path-281)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32157",
    "data-name": "Path 32157",
    d: "M191.333,22.911a2.779,2.779,0,0,0-.706-.319c-.215-.056-.428-.115-.638-.178a3.561,3.561,0,0,1-1-.482.915.915,0,0,0-1.414.729,3.972,3.972,0,0,0,.394,1.121,4.125,4.125,0,0,0,.778,1.245,1.994,1.994,0,0,0,2.046.054,1.974,1.974,0,0,0,.685-.563,1.088,1.088,0,0,0-.147-1.607",
    transform: "translate(-187.572 -21.778)",
    fill: "#f3fe8b"
  }))))), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    id: "Path_32158",
    "data-name": "Path 32158",
    d: "M211.676,11.684a5.731,5.731,0,0,0-.467-.919c-.023-.044-.045-.091-.067-.137.272.57-.159-.274-.092-.2a3.2,3.2,0,0,0-.441-.419,1.243,1.243,0,0,0-.161-.1,1.61,1.61,0,0,0,0-.688,3.441,3.441,0,0,0-1.722-2.1c-1.024-.589-2.367-1.084-3.29-.068a1.408,1.408,0,0,0-.277,1.2,1.6,1.6,0,0,0,.192.58c0,.007.02.043.039.087a17.577,17.577,0,0,0-.361,2.475c-.075,1.212,1.184,1.444,2.262,1.123a1.374,1.374,0,0,0,.029.264c-.077.594-.232,1.346.523,1.653a1.167,1.167,0,0,0,1.078-.2,1.231,1.231,0,0,0,.206-.176,2.171,2.171,0,0,0,.245-.018,3.414,3.414,0,0,0,1.594-.635,1.666,1.666,0,0,0,.706-1.716",
    transform: "translate(39.999 1.262)",
    fill: "#cefe79"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_15296",
    "data-name": "Group 15296",
    transform: "translate(232.813 11.757)",
    opacity: 0.4,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }, _g102 || (_g102 = /*#__PURE__*/React.createElement("g", {
    id: "Group_15295",
    "data-name": "Group 15295"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15294",
    "data-name": "Group 15294",
    clipPath: "url(#clip-path-282)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32159",
    "data-name": "Path 32159",
    d: "M198.139,11.277A13.588,13.588,0,0,0,197.4,10.1c-.341-.558-1.19-.117-1.4.257-.068.123-.137.245-.209.366-.385.048-.74.342-.632.674s-.22.746-.21,1.133v0a3.655,3.655,0,0,0-.131.825c-.068,2.01,3.69,1.435,3.7-.3a4.138,4.138,0,0,0-.37-1.779",
    transform: "translate(-194.808 -9.838)",
    fill: "#f3fe8b"
  }))))), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    id: "Path_32160",
    "data-name": "Path 32160",
    d: "M244.506,12.882a3.58,3.58,0,0,0-3.778-2.753,3.257,3.257,0,0,0-2.72,1.794.47.47,0,0,0-.025.056l-.024-.018c-.143-.087-.288-.17-.436-.251a.936.936,0,0,0-.1-.081c-2.235-1.713-5.958,1.013-4.641,3.026a4.333,4.333,0,0,0,2.356,1.532,1.452,1.452,0,0,0,.121.182l-.022-.008c-.116-.042-.235-.078-.356-.116-.288-.09-.582-.176-.87-.269-.35-.112-1.028-.262-1.2-.551-.288-.489-1.2-.16-1.331.245a2,2,0,0,0,.341,1.583c.146.27.318.532.488.794.081.129.164.258.245.388s.067.112-.023-.018a.955.955,0,0,1,.09.311,1.571,1.571,0,0,0,1.413,1.068c.063.007.131.017.2.023a2.678,2.678,0,0,0,1.964-.569c.443-.366.877-1.047.647-1.568l-.061-.137a2.239,2.239,0,0,0-.142-.271l.045.029c.125.081.1.08.148.155a.761.761,0,0,0,1.024.145,4.978,4.978,0,0,0,1.609.458c1.27.123,2.289-1.076,1.438-1.886a.989.989,0,0,1-.234-.367,2.914,2.914,0,0,0,1.255.921,2.1,2.1,0,0,0,2.216-.653c.8-.846.6-2.222.374-3.193",
    transform: "translate(45.146 1.973)",
    fill: "#cefe79"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    id: "Path_32161",
    "data-name": "Path 32161",
    d: "M235.733,19.089c-.033-.28-.41-.489-.7-.6l-.252-.061c.078.017.056.008-.062-.022-.1-.031-.2-.068-.3-.1-.229-.079-.468-.136-.7-.221-.611-.228-1.266.355-1.025.815-.1-.035-.213-.072-.337-.116a19.837,19.837,0,0,0-2.187-.649c-.767-.185-1.659.617-1.45,1.19a4.7,4.7,0,0,0,3.744,3.187,2.735,2.735,0,0,0,2.4-.973,1.456,1.456,0,0,0,.214-1.472,1.45,1.45,0,0,0,.4-.228.737.737,0,0,0,.255-.752",
    transform: "translate(44.615 3.519)",
    fill: "#cefe79"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    id: "Path_32162",
    "data-name": "Path 32162",
    d: "M232.39,23.507a3.757,3.757,0,0,0-2.193-.731,20.446,20.446,0,0,0-2.5-.19c-.774-.013-1.527,1-.834,1.439.565.357,1.164.66,1.766.973a4.49,4.49,0,0,0,2.04.764c1.5.031,2.752-1.207,1.716-2.254",
    transform: "translate(44.206 4.406)",
    fill: "#cefe79"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    id: "Path_32163",
    "data-name": "Path 32163",
    d: "M235.192,23.25a6.346,6.346,0,0,1-1.18-.18c-.583-.17-1.252.411-.788.814a5.9,5.9,0,0,0,1.181.742,1.155,1.155,0,0,0,1.262-.372.613.613,0,0,0-.476-1",
    transform: "translate(45.47 4.495)",
    fill: "#cefe79"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    id: "Path_32164",
    "data-name": "Path 32164",
    d: "M205.449,11.757a2.746,2.746,0,0,0-1.077-.2c-.453,0-.814.468-.6.782.012.017.02.035.032.053-.018-.022.026.071.026.086s.013.076.018.1a1.685,1.685,0,0,0,.016.229,1.13,1.13,0,0,0,.958.893,1.236,1.236,0,0,0,1.258-.662,1.012,1.012,0,0,0-.63-1.274",
    transform: "translate(39.742 2.254)",
    fill: "#cefe79"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    id: "Path_32165",
    "data-name": "Path 32165",
    d: "M212.936,8.882a.974.974,0,0,0-.163-.3c-.017-.036-.026-.047-.025-.038a.973.973,0,0,1-.026-.11c-.061-.354-.663-.341-.9-.124-.081.076-.155.157-.229.237.079-.078.049-.047-.09.1-.048.049-.09.1-.134.148-.238.276-.391.823-.133,1.1a.871.871,0,0,0,.766.3,1.184,1.184,0,0,0,.823-.428.863.863,0,0,0,.115-.878",
    transform: "translate(41.183 1.591)",
    fill: "#cefe79"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    id: "Path_32166",
    "data-name": "Path 32166",
    d: "M276.363,28.44a3.234,3.234,0,0,0-.348-.109,15.656,15.656,0,0,0,.978-1.429.577.577,0,0,0-.257-.931,1.158,1.158,0,0,0-1.236.362,8.291,8.291,0,0,0-.718.843,1.562,1.562,0,0,0-.375,1.126,4.4,4.4,0,0,0-1.665.76,1.141,1.141,0,0,0-.082-.105c.018.056.032.1.042.133h0a.067.067,0,0,0-.008-.025c-.023-.06-.045-.12-.073-.178-.079-.188-.167-.374-.256-.56l-.014-.031c-.027-.06-.048-.12-.07-.179a1.358,1.358,0,0,1-.08-.348c-.071-.645-1.12-.51-1.529-.206a3.677,3.677,0,0,0-.513.477c-.184-.679-.709-1.274-.723-2.016-.017-.851-1.377-.7-1.664-.033a3.47,3.47,0,0,0-.264,2.035,1.036,1.036,0,0,0-.212,0c-.017,0-.033,0-.049-.006a2.248,2.248,0,0,0-.324-.4,7.14,7.14,0,0,1-.5-.987,5.2,5.2,0,0,1-.63-1.419c-.147-.66-1.183-.436-1.518-.033a7.484,7.484,0,0,0-.939,1.506c-.249.5-.241,1.276-.508,1.7a2.231,2.231,0,0,0-.385,1.267,1.307,1.307,0,0,0-1.828.749l-.032-.007c-.6-.3-1.269-.675-1.354-1.139-.171-.92-1.754-.353-1.842.335-.056.448-.191.884-.226,1.335-.029.343.152.906.017,1.2l-.062-.022c-.6-.208-1.169-.483-1.772-.7s-1.18.344-.962.789c.682,1.392.875,2.9,2.589,3.778a2.715,2.715,0,0,0,2.817-.529c.049.079.1.158.141.241a2.986,2.986,0,0,0,2.045,1.419,1.813,1.813,0,0,0,2.065-1.364c-.066.48.167-.674.1-.376.032-.134.047-.267.066-.4a1.952,1.952,0,0,0,0-.541,5.845,5.845,0,0,0,.446.49c.919.89,2.531.068,3.143-.588a7.522,7.522,0,0,0,1.725-2.872c.023.01.047.022.069.03a2.553,2.553,0,0,0,1.735-.022c-.024.226-.036.451-.042.669a2.876,2.876,0,0,0,.49,1.883,2.062,2.062,0,0,0,2.8.073,4.049,4.049,0,0,0,.436-.435c.024-.027.043-.049.059-.068.143-.133.3-.256.447-.384s.289-.228.442-.336a4.588,4.588,0,0,0,1.316-1.134,2.034,2.034,0,0,0-.907-3.286",
    transform: "translate(49.619 4.837)",
    fill: "#95e25e"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    id: "Path_32167",
    "data-name": "Path 32167",
    d: "M250.9,34.236a2.843,2.843,0,0,0-2.537-1.1,3.9,3.9,0,0,0-1.4.4,3.03,3.03,0,0,0-1.372,1.429,1.79,1.79,0,0,0,.761,2.228c-.71.18-1.341.6-1.4,1.2-.069.724.932.967,1.682.941a7.072,7.072,0,0,0,.957-.1.753.753,0,0,0-.275.776c.227.721,1.206.77,1.983.678a1.426,1.426,0,0,0,1.35-1.108.772.772,0,0,0-.315-.68,1.347,1.347,0,0,0-1.055-.188c.283-.238.415-.6.184-.853a2.81,2.81,0,0,0,1.125-.338,2.124,2.124,0,0,0,1.154-1.5c.152-.656-.446-1.254-.847-1.779",
    transform: "translate(47.789 6.463)",
    fill: "#cefe79"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    id: "Path_32168",
    "data-name": "Path 32168",
    d: "M268.784,10.154c-1.825.079-2.77,1.474-3.6,2.574-.412.555-.918,1.57-.049,1.992a2.874,2.874,0,0,0,1.98-.268c1.408-.533,3.236-.917,3.586-2.322.269-1.08-.38-2.044-1.922-1.977",
    transform: "translate(51.633 1.98)",
    fill: "#95e25e"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    id: "Path_32169",
    "data-name": "Path 32169",
    d: "M260.236,6.556a3.189,3.189,0,0,0-.9-2.846c-.594-.556-1.579.158-1.66.662-.17,1.076-.86,2.547.684,3.216a1.508,1.508,0,0,0,1.579-.393,4.895,4.895,0,0,0-.065,2.687c.176.611,1.279.4,1.431-.116.263-.909.06-1.844.382-2.746.284-.8-.947-.97-1.456-.464",
    transform: "translate(50.213 0.685)",
    fill: "#95e25e"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    id: "Path_32170",
    "data-name": "Path 32170",
    d: "M271.682,8.185a1.437,1.437,0,0,0-.785.28c-.061.05-.124.1-.188.142-.035.019-.066.039-.1.056a2.923,2.923,0,0,1,.7-1.472c.537-.526-.016-1.331-.854-.893a5.846,5.846,0,0,0-1.689,1.395c-.564.635-1.5,1.514-.667,2.26a1.364,1.364,0,0,0,1.23.165,1.711,1.711,0,0,0,.849-.537.831.831,0,0,0,.951.276,3.069,3.069,0,0,0,.592-.271,1.5,1.5,0,0,0,.508-.391.868.868,0,0,0,.128-.238c.017-.074.036-.147.053-.222.076-.321-.348-.59-.728-.55",
    transform: "translate(52.24 1.204)",
    fill: "#95e25e"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    id: "Path_32171",
    "data-name": "Path 32171",
    d: "M273.6,9.839a.706.706,0,0,0-.636-.251,2.2,2.2,0,0,0-.743.256.943.943,0,0,0-.417.3.56.56,0,0,0-.116.476.53.53,0,0,0,.344.357,1.031,1.031,0,0,0,.786-.065,2.7,2.7,0,0,0,.257-.127l.116-.062a1.2,1.2,0,0,0,.361-.29.492.492,0,0,0,.048-.594",
    transform: "translate(53.002 1.87)",
    fill: "#cefe79"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    id: "Path_32172",
    "data-name": "Path 32172",
    d: "M274.3,13.533a1.062,1.062,0,0,0-.662-.684,2.042,2.042,0,0,0-2.511,1.213,3.986,3.986,0,0,0-.259.614.7.7,0,0,0,.223.827,1.211,1.211,0,0,0,1.058.142,9.084,9.084,0,0,0,.973-.4c.717-.373,1.416-.969,1.178-1.71",
    transform: "translate(52.836 2.488)",
    fill: "#95e25e"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    id: "Path_32173",
    "data-name": "Path 32173",
    d: "M277.273,18.044a.841.841,0,0,0-.862.452l0,.008-.042.071-.047.056h0c-.051.047-.106.091-.159.135a1.1,1.1,0,0,0-.272.331c-.207.363.308.694.735.558a1.983,1.983,0,0,0,1.085-.994c.134-.263-.075-.574-.434-.618",
    transform: "translate(53.814 3.519)",
    fill: "#cefe79"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    id: "Path_32174",
    "data-name": "Path 32174",
    d: "M282.294,19.166c-1.783-1.017-3.414,2.046-3.4,3.028.019,1.29,1.75,1.972,2.954,1.058a3.131,3.131,0,0,0,.961-3.48,1.323,1.323,0,0,0-.515-.606",
    transform: "translate(54.41 3.699)",
    fill: "#cefe79"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    id: "Path_32175",
    "data-name": "Path 32175",
    d: "M285.108,20.988a1.227,1.227,0,0,0-1.114.449,5.182,5.182,0,0,0-.3.549c-.027.059-.055.116-.085.173a.7.7,0,0,0,.045.7,1.113,1.113,0,0,0,1.389.194,1.294,1.294,0,0,0,.587-.589,1.5,1.5,0,0,0,.079-.4,3.108,3.108,0,0,1,.057-.4c.076-.321-.278-.631-.662-.679",
    transform: "translate(55.316 4.093)",
    fill: "#cefe79"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    id: "Path_32176",
    "data-name": "Path 32176",
    d: "M286.892,18.481c-.453.037-.9.372-.907.743,0,.024-.01.082-.011.112-.03.049-.147.268-.133.234a.712.712,0,0,0-.055.2,1.414,1.414,0,0,1,.014.194.418.418,0,0,0,.167.312.774.774,0,0,0,.661.09,1.347,1.347,0,0,0,.814-.577,1.536,1.536,0,0,0,.247-.7c.026-.361-.339-.641-.8-.6",
    transform: "translate(55.754 3.605)",
    fill: "#cefe79"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    id: "Path_32177",
    "data-name": "Path 32177",
    d: "M285.786,19.569l0-.012,0,.012",
    transform: "translate(55.754 3.815)",
    fill: "#cefe79"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    id: "Path_32178",
    "data-name": "Path 32178",
    d: "M285.8,19.73c0-.022,0-.042-.006-.063.006.084.008.09.006.063",
    transform: "translate(55.756 3.837)",
    fill: "#cefe79"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    id: "Path_32179",
    "data-name": "Path 32179",
    d: "M286.542,32.747a2.305,2.305,0,0,0,.27-.12c1.353-.687,1.561-2.434-.238-2.777a3.707,3.707,0,0,0-2.993,1.089,10.073,10.073,0,0,1-1.483,1.4c-.629.36-.767,1.523.354,1.361a11.837,11.837,0,0,0,1.377-.288.7.7,0,0,0,.534,1.162c.076.01.468.1.159.018.191.049.384.1.577.143a1.983,1.983,0,0,0,.9-.067,1.648,1.648,0,0,0,1.06-.87.734.734,0,0,0-.245-.909,1.25,1.25,0,0,0-.27-.143",
    transform: "translate(54.941 5.815)",
    fill: "#95e25e"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    id: "Path_32180",
    "data-name": "Path 32180",
    d: "M290.708,33.893a6.411,6.411,0,0,0-1.327.108c-1.321.229-5.062,1.55-3.153,3.013,1.08.828,3.16.539,4.4.195a2.629,2.629,0,0,0,1.692-.98,1.645,1.645,0,0,0-.357-2,2.5,2.5,0,0,0-1.255-.333",
    transform: "translate(55.737 6.611)",
    fill: "#95e25e"
  })), _g103 || (_g103 = /*#__PURE__*/React.createElement("g", {
    id: "Group_15299",
    "data-name": "Group 15299",
    transform: "translate(311.328 62.743)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15298",
    "data-name": "Group 15298"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15297",
    "data-name": "Group 15297",
    clipPath: "url(#clip-path-283)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32181",
    "data-name": "Path 32181",
    d: "M265.9,53.267a2.7,2.7,0,0,0-2.344-.765c-.749.013-1.451.3-2.207.264-.655-.035-1.2.642-.555.974a6.119,6.119,0,0,0,1.575.477,6.9,6.9,0,0,1,.8.185,1.171,1.171,0,0,1,.18.081c-.666-.081-1.182.751-.532,1.039a2.987,2.987,0,0,0,2.026.347c.3-.11.608-.369.51-.658a.739.739,0,0,0-.313-.392c.742-.251,1.291-.944.854-1.551",
    transform: "translate(-260.506 -52.501)",
    fill: "#8be255"
  }))))), _g104 || (_g104 = /*#__PURE__*/React.createElement("g", {
    id: "Group_15302",
    "data-name": "Group 15302",
    transform: "translate(301.829 66.636)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15301",
    "data-name": "Group 15301"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15300",
    "data-name": "Group 15300",
    clipPath: "url(#clip-path-284)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32182",
    "data-name": "Path 32182",
    d: "M256.985,56.982a3.907,3.907,0,0,0-1.212-.489,7.754,7.754,0,0,0-1.172-.277,1.287,1.287,0,0,1-.715-.283c-.625-.539-1.543.3-1.285.835.247.515.252,1.129.657,1.6.247.284.506.563.771.837a2.285,2.285,0,0,0,1.844.507c.831-.062,1.762-.717,1.728-1.416a1.549,1.549,0,0,0-.617-1.31",
    transform: "translate(-252.557 -55.758)",
    fill: "#8be255"
  }))))), _g105 || (_g105 = /*#__PURE__*/React.createElement("g", {
    id: "Group_15305",
    "data-name": "Group 15305",
    transform: "translate(300.172 70.888)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15304",
    "data-name": "Group 15304"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15303",
    "data-name": "Group 15303",
    clipPath: "url(#clip-path-285)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32183",
    "data-name": "Path 32183",
    d: "M254.662,61.8c-.087-1.094-1.673-1.808-2.689-2.415-.382-.228-.981.142-.752.49a12.364,12.364,0,0,0,.972,1.453,2.279,2.279,0,0,0,1.6,1.046c.392.03.9-.223.872-.574",
    transform: "translate(-251.171 -59.316)",
    fill: "#8be255"
  }))))), _g106 || (_g106 = /*#__PURE__*/React.createElement("g", {
    id: "Group_15308",
    "data-name": "Group 15308",
    transform: "translate(294.375 71.106)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15307",
    "data-name": "Group 15307"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15306",
    "data-name": "Group 15306",
    clipPath: "url(#clip-path-286)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32184",
    "data-name": "Path 32184",
    d: "M247.821,59.549a.952.952,0,0,0-1.025.3,3.123,3.123,0,0,0-.376.58.631.631,0,0,0,.013.7c.146.237.54.232.786.109a1.183,1.183,0,0,0,.58-.58c.011-.019.019-.037.03-.056a.179.179,0,0,0,.023-.039,2.34,2.34,0,0,1,.184-.241.478.478,0,0,0-.214-.773",
    transform: "translate(-246.32 -59.498)",
    fill: "#8be255"
  }))))), _g107 || (_g107 = /*#__PURE__*/React.createElement("g", {
    id: "Group_15311",
    "data-name": "Group 15311",
    transform: "translate(348.927 63.288)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15310",
    "data-name": "Group 15310"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15309",
    "data-name": "Group 15309",
    clipPath: "url(#clip-path-287)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32185",
    "data-name": "Path 32185",
    d: "M295.423,55.85c-.512-1.046-1.537-1.732-2.23-2.678-.337-.463-1.209-.1-1.224.349a7.442,7.442,0,0,0,.155,1.6c.1.522.339,1.036.381,1.563.16,1.962,3.751.874,2.917-.833",
    transform: "translate(-291.967 -52.957)",
    fill: "#89e255"
  }))))), _g108 || (_g108 = /*#__PURE__*/React.createElement("g", {
    id: "Group_15314",
    "data-name": "Group 15314",
    transform: "translate(352.94 61.278)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15313",
    "data-name": "Group 15313"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15312",
    "data-name": "Group 15312",
    clipPath: "url(#clip-path-288)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32186",
    "data-name": "Path 32186",
    d: "M296.9,52.169a3.336,3.336,0,0,0-.125-.515.681.681,0,0,0-.87-.343c-.466.131-.706.532-.522.889a2.784,2.784,0,0,1,.139.3,1.389,1.389,0,0,0,.11.283,1.462,1.462,0,0,0,.207.195c.252.234.712.033.875-.164a.786.786,0,0,0,.188-.647",
    transform: "translate(-295.325 -51.275)",
    fill: "#89e255"
  }))))), _g109 || (_g109 = /*#__PURE__*/React.createElement("g", {
    id: "Group_15317",
    "data-name": "Group 15317",
    transform: "translate(351.693 53.609)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15316",
    "data-name": "Group 15316"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15315",
    "data-name": "Group 15315",
    clipPath: "url(#clip-path-289)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32187",
    "data-name": "Path 32187",
    d: "M296.459,45.5a.715.715,0,0,0-.482-.391c-.25-.093-.521-.151-.78-.222a.776.776,0,0,0-.711.133c-.183.149-.326.506-.051.656.117.067.238.133.357.2l.1.055c.048.026.092.054.136.081a2.035,2.035,0,0,0,.333.214,1.183,1.183,0,0,0,.568.029.578.578,0,0,0,.543-.446.54.54,0,0,0-.012-.3",
    transform: "translate(-294.281 -44.858)",
    fill: "#89e255"
  }))))), _g110 || (_g110 = /*#__PURE__*/React.createElement("g", {
    id: "Group_15320",
    "data-name": "Group 15320",
    transform: "translate(332.781 64.962)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15319",
    "data-name": "Group 15319"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15318",
    "data-name": "Group 15318",
    clipPath: "url(#clip-path-290)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32188",
    "data-name": "Path 32188",
    d: "M281.543,54.522a1.144,1.144,0,0,0-1.312.108,4.993,4.993,0,0,0-1.52,1.686c-.326.6-.479,1.617.431,1.948a1.015,1.015,0,0,0,.806-.066,2.045,2.045,0,0,0,.966-1.448,3.1,3.1,0,0,1,.709-1.358.59.59,0,0,0-.079-.87",
    transform: "translate(-278.457 -54.357)",
    fill: "#89e255"
  }))))), _g111 || (_g111 = /*#__PURE__*/React.createElement("g", {
    id: "Group_15323",
    "data-name": "Group 15323",
    transform: "translate(333.849 69.489)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15322",
    "data-name": "Group 15322"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15321",
    "data-name": "Group 15321",
    clipPath: "url(#clip-path-291)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32189",
    "data-name": "Path 32189",
    d: "M280.215,58.291a.4.4,0,0,0-.365-.145c-.274.023-.512.247-.455.467l.006.032a.226.226,0,0,0,.038.325.417.417,0,0,0,.427.012.732.732,0,0,0,.372-.439.273.273,0,0,0-.023-.253",
    transform: "translate(-279.35 -58.145)",
    fill: "#89e255"
  }))))), _g112 || (_g112 = /*#__PURE__*/React.createElement("g", {
    id: "Group_15326",
    "data-name": "Group 15326",
    transform: "translate(311.314 56.132)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15325",
    "data-name": "Group 15325"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15324",
    "data-name": "Group 15324",
    clipPath: "url(#clip-path-292)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32190",
    "data-name": "Path 32190",
    d: "M262.982,46.969c-2.871-.035-3.614,3.762-.308,3.8,2.869.035,3.615-3.762.308-3.8",
    transform: "translate(-260.494 -46.969)",
    fill: "#8be255"
  }))))), _g113 || (_g113 = /*#__PURE__*/React.createElement("g", {
    id: "Group_15329",
    "data-name": "Group 15329",
    transform: "translate(326.659 53.418)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15328",
    "data-name": "Group 15328"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15327",
    "data-name": "Group 15327",
    clipPath: "url(#clip-path-293)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32191",
    "data-name": "Path 32191",
    d: "M274.763,44.931c-.79.77-1.791,2.136-1.3,3.145.149.31.656.247.938.13,1.178-.491,1.588-1.973,1.742-2.927.1-.618-.962-.761-1.383-.349",
    transform: "translate(-273.334 -44.698)",
    fill: "#89e255"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15332",
    "data-name": "Group 15332",
    transform: "translate(183.529 46.289)",
    opacity: 0.4,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }, _g114 || (_g114 = /*#__PURE__*/React.createElement("g", {
    id: "Group_15331",
    "data-name": "Group 15331"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15330",
    "data-name": "Group 15330",
    clipPath: "url(#clip-path-294)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32192",
    "data-name": "Path 32192",
    d: "M163.158,39.958c-.929-.866-2.733-.958-4.074-.938a13.385,13.385,0,0,1-4.513-.253c-.48-.169-1.28.347-.906.743a6.847,6.847,0,0,0,3.741,1.823c1.774.379,3.754.672,5.431-.082a.769.769,0,0,0,.321-1.292",
    transform: "translate(-153.569 -38.733)",
    fill: "#f3fe8b"
  }))))), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    id: "Path_32193",
    "data-name": "Path 32193",
    d: "M163.644,46.345a3.488,3.488,0,0,0-2.3-.312,16.645,16.645,0,0,1-2.776.314c-.515-.053-1.226.571-.686.9a5.222,5.222,0,0,0,2.419.858,5.282,5.282,0,0,0,3-.368c.5-.289.949-.994.347-1.4",
    transform: "translate(30.764 8.971)",
    fill: "#cefe79"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    id: "Path_32194",
    "data-name": "Path 32194",
    d: "M162.093,45.09l-.035-.006a.79.79,0,0,0-.388-.044,1.318,1.318,0,0,1-.154.011H161.5l-.085,0a.856.856,0,0,0-.865.453.42.42,0,0,0,.035.4.637.637,0,0,0,.571.223,3.234,3.234,0,0,0,.557-.055,1.043,1.043,0,0,0,.632-.433c.169-.214.062-.484-.257-.544",
    transform: "translate(31.316 8.785)",
    fill: "#cefe79"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    id: "Path_32195",
    "data-name": "Path 32195",
    d: "M167.164,49.26c-1.624-.284-3.141.761-4.746.551-.966-.125-1.693.96-.8,1.405,1.734.868,4.956.638,6.133-.722.409-.472.121-1.113-.584-1.235",
    transform: "translate(31.451 9.601)",
    fill: "#cefe79"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    id: "Path_32196",
    "data-name": "Path 32196",
    d: "M177.071,16.948c-.024,0-.027.03,0,.031s.027-.03,0-.031",
    transform: "translate(34.541 3.306)",
    fill: "#cefe79"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    id: "Path_32197",
    "data-name": "Path 32197",
    d: "M200.446,12c-.017-.067-.033-.134-.053-.2-.012-.043-.039-.294-.033-.118a.616.616,0,0,0-.743-.563c-.424.035-.84.345-.846.693a2.588,2.588,0,0,0,.06.54,1.53,1.53,0,0,0,.045.2.661.661,0,0,0,.092.186c.016.025.082.157.02.016a.61.61,0,0,0,.661.367.859.859,0,0,0,.731-.48,1.045,1.045,0,0,0,.066-.642",
    transform: "translate(38.778 2.168)",
    fill: "#cefe79"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    id: "Path_32198",
    "data-name": "Path 32198",
    d: "M218.515,10.206c-.661-.951-1.817-1.607-2.479-2.553-.418-.6-1.4,0-1.322.519a9.212,9.212,0,0,0,.758,2.146,7.858,7.858,0,0,0,.9,2.21,1.611,1.611,0,0,0,1.689.437A1.577,1.577,0,0,0,219.229,12c.274-.684-.32-1.235-.713-1.8",
    transform: "translate(41.888 1.445)",
    fill: "#cefe79"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    id: "Path_32199",
    "data-name": "Path 32199",
    d: "M220.827,10.6c-.073-.09-.145-.179-.22-.269a.778.778,0,0,0-.532-.3,1.211,1.211,0,0,0-.889.259.786.786,0,0,0-.307.529.54.54,0,0,0,.09.345.683.683,0,0,0,.322.243l.329.179a.936.936,0,0,0,.4.051,1.115,1.115,0,0,0,.606-.24c.234-.194.4-.553.2-.8",
    transform: "translate(42.701 1.957)",
    fill: "#cefe79"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    id: "Path_32200",
    "data-name": "Path 32200",
    d: "M221.516,6.256c-.114-.174-.412.019-.343.174a1.684,1.684,0,0,1,.036.858c-.029.286.546.208.531-.044a1.908,1.908,0,0,0-.224-.988",
    transform: "translate(43.147 1.207)",
    fill: "#cefe79"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    id: "Path_32201",
    "data-name": "Path 32201",
    d: "M242.24,3.306h0c.311-.508-.365-1.122-1.089-.734a2.878,2.878,0,0,0-1.031,1.086,2.619,2.619,0,0,0-.509,1.355c0,.81,1.4.938,1.809.234a4.417,4.417,0,0,0,.423-1.043,4.634,4.634,0,0,1,.326-.74.412.412,0,0,0,.039-.061.647.647,0,0,0,.031-.1",
    transform: "translate(46.746 0.478)",
    fill: "#cefe79"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_15480",
    "data-name": "Group 15480",
    transform: "translate(219.996 27.271)",
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15479",
    "data-name": "Group 15479"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15478",
    "data-name": "Group 15478",
    clipPath: "url(#clip-path-295)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15337",
    "data-name": "Group 15337",
    transform: "translate(139.422 40.815)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g115 || (_g115 = /*#__PURE__*/React.createElement("g", {
    id: "Group_15336",
    "data-name": "Group 15336"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15335",
    "data-name": "Group 15335",
    clipPath: "url(#clip-path-296)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15334",
    "data-name": "Group 15334",
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15333",
    "data-name": "Group 15333",
    clipPath: "url(#clip-path-297)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32202",
    "data-name": "Path 32202",
    d: "M300.42,56.823l5.745.07-.063,3.19-5.745-.07Z",
    transform: "translate(-300.821 -57.001)",
    fill: "url(#radial-gradient-183)"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15342",
    "data-name": "Group 15342",
    transform: "translate(137.977 45.39)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g116 || (_g116 = /*#__PURE__*/React.createElement("g", {
    id: "Group_15341",
    "data-name": "Group 15341"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15340",
    "data-name": "Group 15340",
    clipPath: "url(#clip-path-298)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15339",
    "data-name": "Group 15339",
    transform: "translate(-0.001 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15338",
    "data-name": "Group 15338",
    clipPath: "url(#clip-path-299)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32204",
    "data-name": "Path 32204",
    d: "M299.219,60.706l4.313.053-.043,2.2-4.312-.053Z",
    transform: "translate(-299.606 -60.817)",
    fill: "url(#radial-gradient-184)"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15347",
    "data-name": "Group 15347",
    transform: "translate(140.702 27.596)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g117 || (_g117 = /*#__PURE__*/React.createElement("g", {
    id: "Group_15346",
    "data-name": "Group 15346"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15345",
    "data-name": "Group 15345",
    clipPath: "url(#clip-path-300)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15344",
    "data-name": "Group 15344",
    transform: "translate(0 -0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15343",
    "data-name": "Group 15343",
    clipPath: "url(#clip-path-301)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32206",
    "data-name": "Path 32206",
    d: "M301.566,45.772l5.031.061-.049,2.5-5.031-.061Z",
    transform: "translate(-301.874 -45.936)",
    fill: "url(#radial-gradient-185)"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15352",
    "data-name": "Group 15352",
    transform: "translate(139.412 18.242)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g118 || (_g118 = /*#__PURE__*/React.createElement("g", {
    id: "Group_15351",
    "data-name": "Group 15351"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15350",
    "data-name": "Group 15350",
    clipPath: "url(#clip-path-302)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15349",
    "data-name": "Group 15349",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15348",
    "data-name": "Group 15348",
    clipPath: "url(#clip-path-303)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32208",
    "data-name": "Path 32208",
    d: "M300.508,37.813l6.137.075-.071,3.615-6.137-.075Z",
    transform: "translate(-300.795 -38.135)",
    fill: "url(#radial-gradient-186)"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15357",
    "data-name": "Group 15357",
    transform: "translate(137.14 15.161)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g119 || (_g119 = /*#__PURE__*/React.createElement("g", {
    id: "Group_15356",
    "data-name": "Group 15356"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15355",
    "data-name": "Group 15355",
    clipPath: "url(#clip-path-304)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15354",
    "data-name": "Group 15354",
    transform: "translate(-0.001 -0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15353",
    "data-name": "Group 15353",
    clipPath: "url(#clip-path-305)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32210",
    "data-name": "Path 32210",
    d: "M298.83,35.364l3.6.044-.08,4.079-3.6-.044Z",
    transform: "translate(-298.852 -35.532)",
    fill: "url(#radial-gradient-187)"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15362",
    "data-name": "Group 15362",
    transform: "translate(136.183 12.096)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g120 || (_g120 = /*#__PURE__*/React.createElement("g", {
    id: "Group_15361",
    "data-name": "Group 15361"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15360",
    "data-name": "Group 15360",
    clipPath: "url(#clip-path-306)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15359",
    "data-name": "Group 15359",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15358",
    "data-name": "Group 15358",
    clipPath: "url(#clip-path-307)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32212",
    "data-name": "Path 32212",
    d: "M298.007,32.856l2.315.028-.048,2.454-2.315-.028Z",
    transform: "translate(-298.05 -32.956)",
    fill: "url(#radial-gradient-188)"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15367",
    "data-name": "Group 15367",
    transform: "translate(132.794 5.64)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g121 || (_g121 = /*#__PURE__*/React.createElement("g", {
    id: "Group_15366",
    "data-name": "Group 15366"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15365",
    "data-name": "Group 15365",
    clipPath: "url(#clip-path-308)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15364",
    "data-name": "Group 15364",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15363",
    "data-name": "Group 15363",
    clipPath: "url(#clip-path-309)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32214",
    "data-name": "Path 32214",
    d: "M295.044,27.174l5.4.066-.132,6.718-5.4-.066Z",
    transform: "translate(-295.255 -27.609)",
    fill: "url(#radial-gradient-189)"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15372",
    "data-name": "Group 15372",
    transform: "translate(130.216 7.577)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g122 || (_g122 = /*#__PURE__*/React.createElement("g", {
    id: "Group_15371",
    "data-name": "Group 15371"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15370",
    "data-name": "Group 15370",
    clipPath: "url(#clip-path-310)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15369",
    "data-name": "Group 15369",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15368",
    "data-name": "Group 15368",
    clipPath: "url(#clip-path-311)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32216",
    "data-name": "Path 32216",
    d: "M293.02,29.117l1.728.021-.034,1.712-1.728-.021Z",
    transform: "translate(-293.053 -29.167)",
    fill: "url(#radial-gradient-190)"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15377",
    "data-name": "Group 15377",
    transform: "translate(124.257)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g123 || (_g123 = /*#__PURE__*/React.createElement("g", {
    id: "Group_15376",
    "data-name": "Group 15376"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15375",
    "data-name": "Group 15375",
    clipPath: "url(#clip-path-312)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15374",
    "data-name": "Group 15374",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15373",
    "data-name": "Group 15373",
    clipPath: "url(#clip-path-313)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32218",
    "data-name": "Path 32218",
    d: "M288.068,22.644l3.753.046-.079,4.018-3.753-.046Z",
    transform: "translate(-288.069 -22.854)",
    fill: "url(#radial-gradient-191)"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15382",
    "data-name": "Group 15382",
    transform: "translate(124.411 2.307)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g124 || (_g124 = /*#__PURE__*/React.createElement("g", {
    id: "Group_15381",
    "data-name": "Group 15381"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15380",
    "data-name": "Group 15380",
    clipPath: "url(#clip-path-314)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15379",
    "data-name": "Group 15379",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15378",
    "data-name": "Group 15378",
    clipPath: "url(#clip-path-315)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32220",
    "data-name": "Path 32220",
    d: "M288.183,24.749h.023v.036h-.023Z",
    transform: "translate(-288.186 -24.749)",
    fill: "url(#radial-gradient-192)"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15387",
    "data-name": "Group 15387",
    transform: "translate(125.078 4.644)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g125 || (_g125 = /*#__PURE__*/React.createElement("g", {
    id: "Group_15386",
    "data-name": "Group 15386"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15385",
    "data-name": "Group 15385",
    clipPath: "url(#clip-path-316)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15384",
    "data-name": "Group 15384",
    transform: "translate(-0.001 0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15383",
    "data-name": "Group 15383",
    clipPath: "url(#clip-path-317)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32222",
    "data-name": "Path 32222",
    d: "M288.714,26.645l2.53.031-.043,2.211-2.53-.031Z",
    transform: "translate(-288.757 -26.717)",
    fill: "url(#radial-gradient-193)"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15392",
    "data-name": "Group 15392",
    transform: "translate(113.693 41.483)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g126 || (_g126 = /*#__PURE__*/React.createElement("g", {
    id: "Group_15391",
    "data-name": "Group 15391"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15390",
    "data-name": "Group 15390",
    clipPath: "url(#clip-path-318)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15389",
    "data-name": "Group 15389",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15388",
    "data-name": "Group 15388",
    clipPath: "url(#clip-path-319)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32224",
    "data-name": "Path 32224",
    d: "M278.761,57.4l5.311.065-.09,4.55-5.311-.065Z",
    transform: "translate(-279.323 -57.556)",
    fill: "url(#radial-gradient-194)"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15397",
    "data-name": "Group 15397",
    transform: "translate(110.68 46.197)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g127 || (_g127 = /*#__PURE__*/React.createElement("g", {
    id: "Group_15396",
    "data-name": "Group 15396"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15395",
    "data-name": "Group 15395",
    clipPath: "url(#clip-path-320)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15394",
    "data-name": "Group 15394",
    transform: "translate(0 -0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15393",
    "data-name": "Group 15393",
    clipPath: "url(#clip-path-321)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32226",
    "data-name": "Path 32226",
    d: "M275.112,60.5l13.436.164-.175,8.883-13.436-.164Z",
    transform: "translate(-277.038 -61.665)",
    fill: "url(#radial-gradient-195)"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15402",
    "data-name": "Group 15402",
    transform: "translate(121.865 46.702)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g128 || (_g128 = /*#__PURE__*/React.createElement("g", {
    id: "Group_15401",
    "data-name": "Group 15401"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15400",
    "data-name": "Group 15400",
    clipPath: "url(#clip-path-322)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15399",
    "data-name": "Group 15399",
    transform: "translate(0.001 0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15398",
    "data-name": "Group 15398",
    clipPath: "url(#clip-path-323)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32228",
    "data-name": "Path 32228",
    d: "M285.05,60.991l10.18.124-.117,5.951-10.18-.124Z",
    transform: "translate(-286.273 -62.074)",
    fill: "url(#radial-gradient-196)"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15407",
    "data-name": "Group 15407",
    transform: "translate(129.378 46.324)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g129 || (_g129 = /*#__PURE__*/React.createElement("g", {
    id: "Group_15406",
    "data-name": "Group 15406"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15405",
    "data-name": "Group 15405",
    clipPath: "url(#clip-path-324)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15404",
    "data-name": "Group 15404",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15403",
    "data-name": "Group 15403",
    clipPath: "url(#clip-path-325)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32230",
    "data-name": "Path 32230",
    d: "M292.26,61.536l4.358.053-.064,3.236-4.358-.053Z",
    transform: "translate(-292.369 -61.59)",
    fill: "url(#radial-gradient-197)"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15412",
    "data-name": "Group 15412",
    transform: "translate(141.851 35.479)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g130 || (_g130 = /*#__PURE__*/React.createElement("g", {
    id: "Group_15411",
    "data-name": "Group 15411",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15410",
    "data-name": "Group 15410",
    clipPath: "url(#clip-path-326)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15409",
    "data-name": "Group 15409",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15408",
    "data-name": "Group 15408",
    clipPath: "url(#clip-path-327)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32232",
    "data-name": "Path 32232",
    d: "M302.5,51.685l8.231.1-.086,4.349-8.231-.1Z",
    transform: "translate(-302.849 -52.666)",
    fill: "url(#radial-gradient-198)"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15417",
    "data-name": "Group 15417",
    transform: "translate(103.165 46.913)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g131 || (_g131 = /*#__PURE__*/React.createElement("g", {
    id: "Group_15416",
    "data-name": "Group 15416"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15415",
    "data-name": "Group 15415",
    clipPath: "url(#clip-path-328)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15414",
    "data-name": "Group 15414",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15413",
    "data-name": "Group 15413",
    clipPath: "url(#clip-path-329)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32234",
    "data-name": "Path 32234",
    d: "M270.279,61.648l7.136.087-.141,7.155-7.136-.087Z",
    transform: "translate(-270.46 -62.157)",
    fill: "url(#radial-gradient-199)"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15422",
    "data-name": "Group 15422",
    transform: "translate(96.811 48.016)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g132 || (_g132 = /*#__PURE__*/React.createElement("g", {
    id: "Group_15421",
    "data-name": "Group 15421"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15420",
    "data-name": "Group 15420",
    clipPath: "url(#clip-path-330)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15419",
    "data-name": "Group 15419",
    transform: "translate(-0.001 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15418",
    "data-name": "Group 15418",
    clipPath: "url(#clip-path-331)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32236",
    "data-name": "Path 32236",
    d: "M265.1,62.441l7.292.089-.153,7.753-7.292-.089Z",
    transform: "translate(-265.117 -63.105)",
    fill: "url(#radial-gradient-200)"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15427",
    "data-name": "Group 15427",
    transform: "translate(0.027 45.222)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g133 || (_g133 = /*#__PURE__*/React.createElement("g", {
    id: "Group_15426",
    "data-name": "Group 15426"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15425",
    "data-name": "Group 15425",
    clipPath: "url(#clip-path-332)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15424",
    "data-name": "Group 15424",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15423",
    "data-name": "Group 15423",
    clipPath: "url(#clip-path-333)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32238",
    "data-name": "Path 32238",
    d: "M183.99,60.367l7.4.09-.1,5.061-7.4-.09Z",
    transform: "translate(-184.148 -60.716)",
    fill: "url(#radial-gradient-201)"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15432",
    "data-name": "Group 15432",
    transform: "translate(0 43.183)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g134 || (_g134 = /*#__PURE__*/React.createElement("g", {
    id: "Group_15431",
    "data-name": "Group 15431"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15430",
    "data-name": "Group 15430",
    clipPath: "url(#clip-path-334)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15429",
    "data-name": "Group 15429",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15428",
    "data-name": "Group 15428",
    clipPath: "url(#clip-path-335)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32240",
    "data-name": "Path 32240",
    d: "M183.968,58.834l3.248.04-.059,3-3.248-.04Z",
    transform: "translate(-184.117 -58.976)",
    fill: "url(#radial-gradient-202)"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15437",
    "data-name": "Group 15437",
    transform: "translate(7.665 49.693)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g135 || (_g135 = /*#__PURE__*/React.createElement("g", {
    id: "Group_15436",
    "data-name": "Group 15436"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15435",
    "data-name": "Group 15435",
    clipPath: "url(#clip-path-336)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15434",
    "data-name": "Group 15434",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15433",
    "data-name": "Group 15433",
    clipPath: "url(#clip-path-337)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32242",
    "data-name": "Path 32242",
    d: "M190.1,64.283l6.025.073-.081,4.126-6.025-.073Z",
    transform: "translate(-190.589 -64.423)",
    fill: "url(#radial-gradient-203)"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15442",
    "data-name": "Group 15442",
    transform: "translate(27.533 54.156)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g136 || (_g136 = /*#__PURE__*/React.createElement("g", {
    id: "Group_15441",
    "data-name": "Group 15441"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15440",
    "data-name": "Group 15440",
    clipPath: "url(#clip-path-338)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15439",
    "data-name": "Group 15439",
    transform: "translate(-0.001 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15438",
    "data-name": "Group 15438",
    clipPath: "url(#clip-path-339)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32244",
    "data-name": "Path 32244",
    d: "M206.894,68.072l3.317.04-.081,4.135-3.317-.04Z",
    transform: "translate(-207.181 -68.147)",
    fill: "url(#radial-gradient-204)"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15447",
    "data-name": "Group 15447",
    transform: "translate(52.739 52.644)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g137 || (_g137 = /*#__PURE__*/React.createElement("g", {
    id: "Group_15446",
    "data-name": "Group 15446"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15445",
    "data-name": "Group 15445",
    clipPath: "url(#clip-path-340)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15444",
    "data-name": "Group 15444",
    transform: "translate(0 -0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15443",
    "data-name": "Group 15443",
    clipPath: "url(#clip-path-341)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32246",
    "data-name": "Path 32246",
    d: "M228.207,66.617l7.077.086-.143,7.274-7.077-.086Z",
    transform: "translate(-228.242 -66.917)",
    fill: "url(#radial-gradient-205)"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15452",
    "data-name": "Group 15452",
    transform: "translate(57.308 49.583)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g138 || (_g138 = /*#__PURE__*/React.createElement("g", {
    id: "Group_15451",
    "data-name": "Group 15451"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15450",
    "data-name": "Group 15450",
    clipPath: "url(#clip-path-342)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15449",
    "data-name": "Group 15449",
    transform: "translate(-0.001 -0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15448",
    "data-name": "Group 15448",
    clipPath: "url(#clip-path-343)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32248",
    "data-name": "Path 32248",
    d: "M231.636,64.167l9.574.117-.124,6.308-9.574-.117Z",
    transform: "translate(-232.138 -64.335)",
    fill: "url(#radial-gradient-206)"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15457",
    "data-name": "Group 15457",
    transform: "translate(66.2 51.653)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g139 || (_g139 = /*#__PURE__*/React.createElement("g", {
    id: "Group_15456",
    "data-name": "Group 15456"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15455",
    "data-name": "Group 15455",
    clipPath: "url(#clip-path-344)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15454",
    "data-name": "Group 15454",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15453",
    "data-name": "Group 15453",
    clipPath: "url(#clip-path-345)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32250",
    "data-name": "Path 32250",
    d: "M238.938,65.841l5.474.067-.071,3.628-5.474-.067Z",
    transform: "translate(-239.595 -66.079)",
    fill: "url(#radial-gradient-207)"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15462",
    "data-name": "Group 15462",
    transform: "translate(69.33 48.914)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g140 || (_g140 = /*#__PURE__*/React.createElement("g", {
    id: "Group_15461",
    "data-name": "Group 15461"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15460",
    "data-name": "Group 15460",
    clipPath: "url(#clip-path-346)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15459",
    "data-name": "Group 15459",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15458",
    "data-name": "Group 15458",
    clipPath: "url(#clip-path-347)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32252",
    "data-name": "Path 32252",
    d: "M242,63.382l8.788.107-.143,7.256-8.788-.107Z",
    transform: "translate(-242.141 -63.819)",
    fill: "url(#radial-gradient-208)"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15467",
    "data-name": "Group 15467",
    transform: "translate(79.219 51.127)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g141 || (_g141 = /*#__PURE__*/React.createElement("g", {
    id: "Group_15466",
    "data-name": "Group 15466"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15465",
    "data-name": "Group 15465",
    clipPath: "url(#clip-path-348)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15464",
    "data-name": "Group 15464",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15463",
    "data-name": "Group 15463",
    clipPath: "url(#clip-path-349)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32254",
    "data-name": "Path 32254",
    d: "M250.234,65.5l3.192.039-.043,2.193-3.192-.039Z",
    transform: "translate(-250.405 -65.62)",
    fill: "url(#radial-gradient-209)"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15472",
    "data-name": "Group 15472",
    transform: "translate(82.679 49.908)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g142 || (_g142 = /*#__PURE__*/React.createElement("g", {
    id: "Group_15471",
    "data-name": "Group 15471"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15470",
    "data-name": "Group 15470",
    clipPath: "url(#clip-path-350)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15469",
    "data-name": "Group 15469",
    transform: "translate(0.001 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15468",
    "data-name": "Group 15468",
    clipPath: "url(#clip-path-351)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32256",
    "data-name": "Path 32256",
    d: "M253.146,64.328l6.188.075-.123,6.233-6.188-.075Z",
    transform: "translate(-253.313 -64.629)",
    fill: "url(#radial-gradient-210)"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15477",
    "data-name": "Group 15477",
    transform: "translate(89.693 50.2)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g143 || (_g143 = /*#__PURE__*/React.createElement("g", {
    id: "Group_15476",
    "data-name": "Group 15476"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15475",
    "data-name": "Group 15475",
    clipPath: "url(#clip-path-352)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15474",
    "data-name": "Group 15474",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15473",
    "data-name": "Group 15473",
    clipPath: "url(#clip-path-353)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32258",
    "data-name": "Path 32258",
    d: "M259.1,64.711l3.9.047-.063,3.211-3.9-.047Z",
    transform: "translate(-259.154 -64.846)",
    fill: "url(#radial-gradient-211)"
  })))))))))), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    id: "Path_32260",
    "data-name": "Path 32260",
    d: "M247.7,10.434a.469.469,0,0,0-.188-.556l-.044-.025a1.108,1.108,0,0,0-1.252.1c-1.4,1.067-2.8,3.453-2.285,4.993s2.971.911,3.49-.284a5.3,5.3,0,0,0,.192-2.219c0-.674.131-1.339.087-2.01",
    transform: "translate(47.567 1.893)",
    fill: "#b3e23f"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    id: "Path_32261",
    "data-name": "Path 32261",
    d: "M251.106,14.257a2.422,2.422,0,0,0-.947.286c-.253.151-.5.307-.737.472a1.837,1.837,0,0,0-.932,1.4c-.016.553.863.743,1.291.326a1.766,1.766,0,0,1,.173-.152c.079-.062.258-.2.286-.227.065-.056.137-.106.208-.158-.188.133.116-.059.158-.08.177-.1.363-.178.551-.263a1.707,1.707,0,0,0,.668-.575.663.663,0,0,0-.718-1.03",
    transform: "translate(48.478 2.779)",
    fill: "#b3e23f"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    id: "Path_32262",
    "data-name": "Path 32262",
    d: "M257.832,15.18c-.736-.667-2.1-.313-2.995-.116a6.145,6.145,0,0,0-3.6,1.725,1.442,1.442,0,0,0,.645,2.336c1.729.57,3.376-.368,4.544-1.321.749-.611,2.42-1.7,1.4-2.624",
    transform: "translate(48.946 2.886)",
    fill: "#b3e23f"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    id: "Path_32263",
    "data-name": "Path 32263",
    d: "M256.552,19.6a1.333,1.333,0,0,0-.737-.19,1.012,1.012,0,0,0-1.033.541.5.5,0,0,0,.041.474.755.755,0,0,0,.681.268,1.827,1.827,0,0,0,.816-.16.843.843,0,0,0,.379-.388.459.459,0,0,0-.147-.545",
    transform: "translate(49.698 3.785)",
    fill: "#b3e23f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_15483",
    "data-name": "Group 15483",
    transform: "translate(285.076 13.525)",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }, _g144 || (_g144 = /*#__PURE__*/React.createElement("g", {
    id: "Group_15482",
    "data-name": "Group 15482"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15481",
    "data-name": "Group 15481",
    clipPath: "url(#clip-path-354)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32264",
    "data-name": "Path 32264",
    d: "M241.865,13.322c-.048-.57-.638-1.119-1.006-1.6a1.343,1.343,0,0,0-1.648-.229,1,1,0,0,0-.571,1.365,3.533,3.533,0,0,0,.992,1.621,1.534,1.534,0,0,0,1.532.038,1.162,1.162,0,0,0,.7-1.194",
    transform: "translate(-238.539 -11.317)",
    fill: "#cefead"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15486",
    "data-name": "Group 15486",
    transform: "translate(281.71 15.229)",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }, _g145 || (_g145 = /*#__PURE__*/React.createElement("g", {
    id: "Group_15485",
    "data-name": "Group 15485"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15484",
    "data-name": "Group 15484",
    clipPath: "url(#clip-path-355)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32265",
    "data-name": "Path 32265",
    d: "M237.342,13.437a.424.424,0,0,0-.19-.367,2.6,2.6,0,0,0-.492-.28.768.768,0,0,0-.84.247.392.392,0,0,0,.174.633c.065.025.128.051.189.08.01,0,.026.012.041.02a.485.485,0,0,1,.042.025,1.127,1.127,0,0,0,.168.1.749.749,0,0,0,.31.036c.045,0,.09,0,.134,0a.474.474,0,0,0,.462-.38c0-.037,0-.074,0-.111",
    transform: "translate(-235.723 -12.743)",
    fill: "#cefead"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15489",
    "data-name": "Group 15489",
    transform: "translate(281.924 17.291)",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }, _g146 || (_g146 = /*#__PURE__*/React.createElement("g", {
    id: "Group_15488",
    "data-name": "Group 15488"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15487",
    "data-name": "Group 15487",
    clipPath: "url(#clip-path-356)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32266",
    "data-name": "Path 32266",
    d: "M238.172,15.341a.829.829,0,0,0-.339-.479,2.327,2.327,0,0,1-.3-.228.911.911,0,0,0-.639-.163,1.232,1.232,0,0,0-.674.27.8.8,0,0,0-.313.54.54.54,0,0,0,.232.5,3.393,3.393,0,0,0,.478.245,2.013,2.013,0,0,0,.368.121c.06.014.122.016.182.025.556.093,1.133-.4,1.009-.827",
    transform: "translate(-235.902 -14.468)",
    fill: "#cefead"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15494",
    "data-name": "Group 15494",
    transform: "translate(254.608 45.05)",
    opacity: 0.4,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g147 || (_g147 = /*#__PURE__*/React.createElement("g", {
    id: "Group_15493",
    "data-name": "Group 15493"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15492",
    "data-name": "Group 15492",
    clipPath: "url(#clip-path-357)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15491",
    "data-name": "Group 15491",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15490",
    "data-name": "Group 15490",
    clipPath: "url(#clip-path-358)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32267",
    "data-name": "Path 32267",
    d: "M213.059,37.028l44.438.542-.516,26.209-44.438-.542Z",
    transform: "translate(-213.143 -37.827)",
    fill: "url(#radial-gradient-212)"
  }))))))), _g148 || (_g148 = /*#__PURE__*/React.createElement("g", {
    id: "Group_15497",
    "data-name": "Group 15497",
    transform: "translate(205.109 34.462)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15496",
    "data-name": "Group 15496"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15495",
    "data-name": "Group 15495",
    clipPath: "url(#clip-path-359)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32269",
    "data-name": "Path 32269",
    d: "M247.475,58.688a.949.949,0,0,0,.972-1c-.459-2.961-4.213-3.845-7.355-4.87a22.032,22.032,0,0,0,4.437-.632c.71-.223,1.066-.992.33-1.356a15.454,15.454,0,0,0-7.909-1.182c2.292-1.1,4.545-2.287,5.727-4.223.191-.313.166-.832-.411-.871a14.617,14.617,0,0,0-7.523,1.728c1.474-2.553,3.184-6.266.859-6.567a4.347,4.347,0,0,0-2.769.97c.711-1.275,1.281-3.02-.538-3.41-1.689-.361-3.594,1.217-4.669,2.016-.376.281-.742.571-1.1.868a16,16,0,0,0,1.07-3.249,11.371,11.371,0,0,0,.2-3.364,1.715,1.715,0,0,0-.678-1.481c-1.174-.648-2.455.508-3.37,1.818-.157-.831-.592-1.5-1.667-1.409a3.98,3.98,0,0,0-2.324,1.046c.483-1.589.5-3.177-.994-3.362a4.152,4.152,0,0,0-2.58.951,28.939,28.939,0,0,0-3.613,3.153,16.43,16.43,0,0,0-1.156,1.307c0-.027,0-.056.007-.085.108-1.12.631-3.447-.694-4.263-1.695-1.043-3.169,1.287-3.731,2.2a27.989,27.989,0,0,0-2.039,3.761.124.124,0,0,0-.01-.027,17.675,17.675,0,0,0-1.574-3.134A11.014,11.014,0,0,0,198.905,29a2.26,2.26,0,0,0-2.456.458,2.581,2.581,0,0,0-.312,2.194,19.73,19.73,0,0,0,1.451,3.935c.264.63.6,1.317.884,2.014-.392-.307-.76-.639-1.129-.974a5.225,5.225,0,0,0-2.734-1.636c-.6-.075-1.233.347-1.249.825-.006.147,0,.293,0,.44-.461-.351-.915-.709-1.329-1.094a7.636,7.636,0,0,0-2.844-1.889,1.23,1.23,0,0,0-1.335.393,4.117,4.117,0,0,0-.465,1.031l0-.007a11.8,11.8,0,0,0-3.281-4.2,1.278,1.278,0,0,0-1.627.3c-2.593,2.842-1.995,6.409-1,9.629a5.976,5.976,0,0,0-3.557-.376c-.357.109-.757.468-.618.8a7.731,7.731,0,0,0,2.2,2.532c.436.382.88.753,1.329,1.117-.653-.223-1.3-.451-1.972-.632a15.3,15.3,0,0,0-4.805-.632c-.505.027-.9.451-.816.837.277,1.254,1.771,2.07,3.032,2.725.54.282,1.09.574,1.649.858-2.283-.071-4.556.154-6,1.548-.356.343-.458.845.1,1.1,1.518.688,3.616.673,5.319.832a54.786,54.786,0,0,0,6.719.272,37.852,37.852,0,0,0,4.006-.326c-2.446,1.629-4.448,3.62-5.028,5.99a.574.574,0,0,0,.363.766,6.318,6.318,0,0,0,3.785-.446c1.434-.5,2.786-1.147,4.141-1.766.961-.441,1.954-.84,2.946-1.241a7.629,7.629,0,0,0-1.58,3.471c-.05.391.367.635.823.621a9.367,9.367,0,0,0,4.421-1.569c.737-.433,1.469-.871,2.2-1.311a8.432,8.432,0,0,0-.844,3.792.6.6,0,0,0,.587.6,5.349,5.349,0,0,0,2.965-.938c.442-.251.9-.5,1.374-.734-1.235,1.309-2.278,2.722-3.416,4.088a.394.394,0,0,0,.177.641c1.71.442,3.41-.241,4.906-.86q.5-.208,1-.43c-.936,1.1-2.008,2.131-2.143,3.509a.523.523,0,0,0,.372.532c1.53.485,3.245-.409,4.492-1.031.813-.405,1.6-.839,2.385-1.272a26.6,26.6,0,0,1-2.324,2.065c-1.672,1.318-4.017,2.125-5.5,3.582-.31.3-.434.782.091,1,1.975.823,4.563-.051,6.456-.631,1.691-.521,3.51-.931,5.2-1.515a8.606,8.606,0,0,0-1.132,2.621c-.289,1.231-.361,3.745,1.63,4.171.936.2,1.734-.906,2.189-1.338a19,19,0,0,0,2.261-2.74,21.974,21.974,0,0,0,1.785-3,5.3,5.3,0,0,0,.255.833c.378.936,1.042,2.6,2.7,2.149,1.4-.387,1.554-2.1,1.717-3.055.1-.627.159-1.227.2-1.827a19.5,19.5,0,0,0,2.565,2.569c.939.779,3.227,2.431,4.582,1.194,1.248-1.143.32-2.8-.329-4a13.4,13.4,0,0,0-1.661-2.332,9.7,9.7,0,0,0,3.147.771,3.023,3.023,0,0,0,2.926-1.318,19.746,19.746,0,0,0,3.326.611c1.562.142,4.233.428,5.246-.819,1.158-1.426-1.072-2.8-2.348-3.554-.261-.152-.528-.306-.8-.459a22.533,22.533,0,0,0,3.285.218",
    transform: "translate(-171.626 -28.836)",
    fill: "#b4e255"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15500",
    "data-name": "Group 15500",
    transform: "translate(216.492 50.153)",
    opacity: 0.6,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g149 || (_g149 = /*#__PURE__*/React.createElement("g", {
    id: "Group_15499",
    "data-name": "Group 15499"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15498",
    "data-name": "Group 15498",
    clipPath: "url(#clip-path-360)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32270",
    "data-name": "Path 32270",
    d: "M245.617,56.127a.949.949,0,0,0,.972-1c-.459-2.961-4.213-3.845-7.355-4.87a22.032,22.032,0,0,0,4.437-.632c.71-.223,1.066-.992.33-1.356a15.454,15.454,0,0,0-7.909-1.182c2.292-1.1,4.545-2.287,5.727-4.223.191-.313.166-.832-.411-.871a12.14,12.14,0,0,0-3.282.226c-.192,1.606-2.942,2.971-4.638,3.786,1.621.51,1.06,1.968-.405,2.55.919.958,2.207,2.479,1.047,3.531-.63.571-1.569.277-2.427-.214a3.446,3.446,0,0,1,.676,3.106.235.235,0,0,1-.229.133,9.086,9.086,0,0,1-6.524-3.21,5.63,5.63,0,0,1,.492,3.1c-.3,1.76-2.328,1.068-3.595.36-.168.817-.424,2.182-1.372,2.511a1.953,1.953,0,0,1-2.05-.829,4.623,4.623,0,0,1-1.1,3.518,6.477,6.477,0,0,1-3.839,2.009c-2.707.209-2.428-2.65-1.978-4.109-1.231.065-2.592-.167-3.217-1.1a2.637,2.637,0,0,1,.158-2.994c-1.665-.037-3.814-.159-4.985-1.148-1.125-.951-.829-2.186-.235-3.278a20.365,20.365,0,0,1-6.041,2.087c-.575.086-1.489.209-1.808-.3-.278-.451.142-1.05.564-1.524a5.63,5.63,0,0,1-2.263.409c-.318-.032-.911-.241-1.211-.112-.547.238-1.1.472-1.666.687a42.161,42.161,0,0,1-6.269,1.873,8.8,8.8,0,0,1-3.688.437,6.471,6.471,0,0,0-.343,1.009.574.574,0,0,0,.363.766,6.319,6.319,0,0,0,3.785-.446c1.434-.5,2.786-1.147,4.141-1.766.961-.441,1.954-.84,2.946-1.241a7.629,7.629,0,0,0-1.58,3.471c-.05.391.367.635.823.621a9.367,9.367,0,0,0,4.421-1.569c.737-.433,1.469-.871,2.2-1.311a8.432,8.432,0,0,0-.844,3.792.6.6,0,0,0,.587.6,5.349,5.349,0,0,0,2.965-.938c.442-.251.9-.5,1.374-.734-1.235,1.309-2.278,2.722-3.416,4.088a.394.394,0,0,0,.177.641c1.71.442,3.41-.241,4.906-.86q.5-.208,1-.43c-.936,1.1-2.008,2.131-2.143,3.509a.523.523,0,0,0,.372.532c1.53.485,3.245-.409,4.492-1.031.813-.405,1.6-.839,2.385-1.272a26.6,26.6,0,0,1-2.324,2.065c-1.672,1.318-4.017,2.125-5.5,3.582-.31.3-.434.782.091,1,1.975.823,4.563-.051,6.456-.631,1.691-.521,3.51-.931,5.2-1.515a8.606,8.606,0,0,0-1.132,2.621c-.289,1.231-.361,3.745,1.63,4.171.936.2,1.734-.906,2.189-1.338a19,19,0,0,0,2.261-2.74,21.976,21.976,0,0,0,1.785-3,5.3,5.3,0,0,0,.255.833c.378.936,1.042,2.6,2.7,2.149,1.4-.387,1.554-2.1,1.717-3.055.1-.627.159-1.227.2-1.827a19.5,19.5,0,0,0,2.565,2.569c.939.779,3.227,2.431,4.582,1.194,1.248-1.143.32-2.8-.329-4a13.4,13.4,0,0,0-1.661-2.332,9.7,9.7,0,0,0,3.147.771,3.023,3.023,0,0,0,2.926-1.318,19.746,19.746,0,0,0,3.326.611c1.562.142,4.233.428,5.246-.819,1.158-1.426-1.072-2.8-2.348-3.554-.261-.152-.528-.306-.8-.459a22.533,22.533,0,0,0,3.285.218",
    transform: "translate(-181.151 -41.966)",
    fill: "#b4e255"
  }))))), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    id: "Path_32271",
    "data-name": "Path 32271",
    d: "M188.716,47.345c-.375-1.459-2.572-1.525-3.8-.712-.2.063-.412.118-.621.174-.014,0-.029.008-.042.011a1.861,1.861,0,0,0-1.042-1.027,3.081,3.081,0,0,0-.525-.163,2,2,0,0,0,.359-.56c.483-1.208-.562-2.243-2.134-2.193a11.024,11.024,0,0,1-3.782-.712c-.638-.226-1.654.333-1.393.917a6.428,6.428,0,0,0,2.308,2.638c-1.531.111-3.079.216-4.6.189-.939-.014-1.7,1.31-.662,1.64.911.292,1.7.862,2.624,1.187a20.1,20.1,0,0,0,3.093.682c-.505-.086.845.2.845.2.3.055.588.091.889.118l.13.008c-.373.3-.746.6-1.126.893a18.839,18.839,0,0,0-2.78,2.25.818.818,0,0,0,.368,1.328,7.71,7.71,0,0,0,3.963-.12c.718-.149,1.427-.327,2.136-.5.171-.041.276-.067.337-.085l.226-.032a10.051,10.051,0,0,0,1.463-.287c1.9-.566,3.442-2.292,2.917-3.9a1.869,1.869,0,0,0,.851-1.952",
    transform: "translate(33.611 8.216)",
    fill: "#a7e255"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    id: "Path_32272",
    "data-name": "Path 32272",
    d: "M178.191,48.392h0",
    transform: "translate(34.762 9.441)",
    fill: "#a7e255"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    id: "Path_32273",
    "data-name": "Path 32273",
    d: "M210.779,33.953a1.11,1.11,0,0,0-.82.036c.19-1.246-.072-2.651,1.061-3.576.507-.416.147-1.229-.663-.967a6.265,6.265,0,0,0-2.824,2.078,7.993,7.993,0,0,0-1.481,2.263c-.054-.568-.178-1.144-.232-1.695a7.858,7.858,0,0,0-1.039-3.443c-.538-.892-2.22-.149-2.232.637a6.82,6.82,0,0,1-.673,2.647,16.247,16.247,0,0,1-1.822-2.252c-.506-.884-2.265-.019-2,.786.065.2.123.394.179.593a13.419,13.419,0,0,0-1.744-1.024c-.705-.333-2.039-.964-2.881-.686a1.09,1.09,0,0,0-.825.84,5.129,5.129,0,0,0,.611,1.88,13.452,13.452,0,0,1,.551,2.163c-.12-.039-.245-.082-.388-.127a5.878,5.878,0,0,1-1.918-.839,1.311,1.311,0,0,0-1.955.78,3.884,3.884,0,0,0,.751,2.379c.038.053.081.105.124.158a3.815,3.815,0,0,0-.86-.024c.2-.057.118-.094-.256-.106a16.911,16.911,0,0,1-2.384-.766,12.749,12.749,0,0,1-2.283-1.148c-.556-.349-1.689-.9-1.734-1.529-.056-.765-1.242-.649-1.517-.031-.6,1.364.609,3.02,1.405,4.2a9.511,9.511,0,0,0,1.27,1.478c-.2-.053-.39-.108-.58-.171a1.046,1.046,0,0,0-1.352.657l-.128-.013a10.857,10.857,0,0,1-2.895-1.215c-.942-.62-1.635-1.446-2.573-2.054-.745-.484-1.832.17-1.677.865a13.972,13.972,0,0,1,.1,1.466,6.339,6.339,0,0,0,.709,1.965,6.509,6.509,0,0,0,1.158,1.618c.378.4,1.293,1.171,1.442,1.393.014.023.029.043.044.063-.4.308-.617.778-.308,1.15a4.775,4.775,0,0,0,2.047,1.456c.485.195,1,.333,1.512.488l-.011.047a1.691,1.691,0,0,0,.673,1.613c.166.136.338.267.515.394.066.047.11.076.141.1.032.073.061.147.091.219-.055-.02-.109-.043-.163-.066-.014-.006-.035-.017-.057-.029-.059-.036-.118-.074-.174-.112s-.11-.085-.163-.129l-.006-.008a1.533,1.533,0,0,0-1.658-.428c-.712.2-1.448.913-1.2,1.55a3.144,3.144,0,0,0,1.114,1.37,2.756,2.756,0,0,0,1.2.541,3.061,3.061,0,0,0,1.684-.316,1.653,1.653,0,0,0,.509-.417l.027.026a.909.909,0,0,0,.815.182c.405.31.846.6,1.293.919,1.526,1.078,3.16,2.059,5.312,1.549a2.214,2.214,0,0,0,1.843-2.381c-.209-.985-1.11-1.879-1.609-2.785a9.767,9.767,0,0,0-1.423-2.042,2.25,2.25,0,0,0,.262-.415,1.391,1.391,0,0,0,.1-.294,4.505,4.505,0,0,0,1.039,0c1.924-.244,3.279-1.906,2.814-3.138a4.134,4.134,0,0,0,2.42.153c.583-.179,1.126-.636,1.132-1.158.013-.938-1-1.772-1.691-2.482l-.282-.286a2.5,2.5,0,0,0,.278-.2c.037-.031.072-.065.11-.1a4.173,4.173,0,0,0,1.128,1.245,8.586,8.586,0,0,1,.688.6c.1.094.164.151.2.183.02.023.041.049.068.078a9.785,9.785,0,0,0,2.66,2.261,2.286,2.286,0,0,0,2.477-.729,3.381,3.381,0,0,0,.751-1.419,1.339,1.339,0,0,0,1.219.225c1.2-.331,1.389-1.5,1.837-2.307s-1.019-1.219-1.617-.626c-.293.289-.557.593-.828.9-.049.054-.1.108-.148.161.025-.03-.114.111-.136.134-.039.036-.074.071-.111.105.016-.245.021-.484.025-.711a5.852,5.852,0,0,0-.194-1.588,3.58,3.58,0,0,0,.778-.645,2.268,2.268,0,0,0,.463-.768c.263.8,1.377.924,2.329.666a.729.729,0,0,0,.69.635,1.23,1.23,0,0,0,1.27-.664.347.347,0,0,1,.028-.074c0,.006.054-.1.074-.12a.442.442,0,0,1,.031-.036c.011-.01.087-.088.106-.106a3.829,3.829,0,0,0,.607-.668.606.606,0,0,0-.268-.973",
    transform: "translate(34.138 5.51)",
    fill: "#a7e255"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    id: "Path_32274",
    "data-name": "Path 32274",
    d: "M197.879,44.454a1.754,1.754,0,0,0-1.2-1.719c-.388-.159-.78-.3-1.176-.447a4.934,4.934,0,0,1-1.214-.449,1.563,1.563,0,0,0-1.579-.041,1.076,1.076,0,0,0-.613,1.47c.016.033.037.068.054.1.1.692.3,1.352.453,2.042a1.73,1.73,0,0,0,1.154,1.192l.173.049a3.355,3.355,0,0,0,2.516-.206,2.393,2.393,0,0,0,1.431-1.857c0-.045,0-.091,0-.137",
    transform: "translate(37.455 8.117)",
    fill: "#cefe79"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    id: "Path_32275",
    "data-name": "Path 32275",
    d: "M201.7,43.692a6.181,6.181,0,0,0-1.214-.543c-.165-.065-.325-.14-.486-.215l-.227-.112c-.012-.006-.363-.2-.137-.069a1.658,1.658,0,0,0-1.624-.042c-.55.282-1.061,1.009-.631,1.511.264.311.551.609.85.9a3.022,3.022,0,0,0,1.269.845,2.2,2.2,0,0,0,2.048-.384,2.317,2.317,0,0,0,.49-.642,1.008,1.008,0,0,0-.337-1.249",
    transform: "translate(38.476 8.295)",
    fill: "#cefe79"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    id: "Path_32276",
    "data-name": "Path 32276",
    d: "M212.4,33.26a.745.745,0,0,0-.958-.378,3.439,3.439,0,0,0-.664.318,1.838,1.838,0,0,0-.494.381.68.68,0,0,0-.145.417.5.5,0,0,0,.492.507,1.56,1.56,0,0,0,.3,0,1.263,1.263,0,0,0,.6-.241l.091-.067c.021-.017.044-.031.066-.047a2.024,2.024,0,0,1,.269-.136.7.7,0,0,0,.443-.755",
    transform: "translate(40.997 6.406)",
    fill: "#cefe79"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    id: "Path_32277",
    "data-name": "Path 32277",
    d: "M217.378,35.574a1.12,1.12,0,0,0-1.023.18,1.2,1.2,0,0,0,.238-1.2,2.786,2.786,0,0,0-.206-.486c.07.14.073.125.014-.043a1.5,1.5,0,0,1-.047-.566,3.846,3.846,0,0,0,.059-1.256c-.18-.529-.841-.588-1.383-.357a4.214,4.214,0,0,0-1.476,1.405,3.551,3.551,0,0,0-.892,2.019c.024,1.764,2.5,1.628,3.539.641l0,.008c-.11.178-.208.361-.3.544a1.961,1.961,0,0,0-.179.589.467.467,0,0,0,.333.477.948.948,0,0,0,.893-.167,1.844,1.844,0,0,0,.495-.593c.008-.013.035-.061.056-.1.042-.069.084-.139.129-.207a.554.554,0,0,0-.246-.893",
    transform: "translate(41.489 6.189)",
    fill: "#cefe79"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    id: "Path_32278",
    "data-name": "Path 32278",
    d: "M220.72,40.48a10.319,10.319,0,0,1-.4-1.8,15.784,15.784,0,0,0-.106-1.943c-.078-.47-.935-.489-1.246-.167-1.344,1.38-2.675,3.258-2.271,5.056.471,2.1,4.439.7,4.024-1.143",
    transform: "translate(42.261 7.091)",
    fill: "#b3e23f"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    id: "Path_32279",
    "data-name": "Path 32279",
    d: "M222.412,37.528a1.1,1.1,0,0,0-1.182.348c-.2.24-.367.491-.537.745a1.844,1.844,0,0,0-.417.975.833.833,0,0,0,1.31.515,1.865,1.865,0,0,0,.827-.958c.109-.3.2-.6.342-.9a.538.538,0,0,0-.343-.723",
    transform: "translate(42.974 7.31)",
    fill: "#b3e23f"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    id: "Path_32280",
    "data-name": "Path 32280",
    d: "M224.317,39.878a9.185,9.185,0,0,0-3.034,2.261c-.27.4-.472.785-.615,1.016a2.917,2.917,0,0,0-.557,2.1c.142,1.053,1.727,1.417,2.813,1.111a3.7,3.7,0,0,0,2.689-2.946c.258-.925.9-1.711.909-2.679.011-.938-1.234-1.4-2.2-.868",
    transform: "translate(42.936 7.736)",
    fill: "#b3e23f"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    id: "Path_32281",
    "data-name": "Path 32281",
    d: "M224.788,46.6a1.062,1.062,0,0,0-1.319-.183c-.638.393-1.534.795-1.554,1.508a.579.579,0,0,0,.233.507,1.032,1.032,0,0,0,.655.165c.783.01,1.3-.623,1.751-1.048.278-.264.458-.619.234-.949",
    transform: "translate(43.294 9.027)",
    fill: "#b3e23f"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    id: "Path_32282",
    "data-name": "Path 32282",
    d: "M227.174,48.892c-.2.016-.4.036-.59.067a2.54,2.54,0,0,0-.618.17,2.283,2.283,0,0,0-.369.243.6.6,0,0,0,.5,1.078,2.215,2.215,0,0,0,.815-.231c.176-.1.356-.183.539-.264.6-.268.534-1.125-.275-1.062",
    transform: "translate(43.959 9.538)",
    fill: "#b3e23f"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    id: "Path_32283",
    "data-name": "Path 32283",
    d: "M234.626,51.143a7.326,7.326,0,0,0-2.475-.774,2.621,2.621,0,0,0-2.287.925,1.282,1.282,0,0,0,.17,1.856c.779.642,2.13.526,2.922.559,1,.042,2.393.363,2.852-.608.373-.788-.386-1.558-1.181-1.958",
    transform: "translate(44.782 9.826)",
    fill: "#b3e23f"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    id: "Path_32284",
    "data-name": "Path 32284",
    d: "M233.829,54.466a.635.635,0,0,0-.51-.441L233.291,54a.784.784,0,0,0-.274-.17c-.045-.016-.09-.032-.134-.05a1.4,1.4,0,0,0-.929-.039,1.181,1.181,0,0,0-.65.4.829.829,0,0,0-.194.713,1.061,1.061,0,0,0,.368.5,1.39,1.39,0,0,0,.919.233,1.9,1.9,0,0,0,1.126-.386.736.736,0,0,0,.3-.74",
    transform: "translate(45.083 10.473)",
    fill: "#b3e23f"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    id: "Path_32285",
    "data-name": "Path 32285",
    d: "M223.4,59.563a2.055,2.055,0,0,0-.27-.546c-.081-.158-.163-.314-.251-.468a.946.946,0,0,0-1.035-.267.905.905,0,0,0-.751.969,3.067,3.067,0,0,0,.36,1.235.951.951,0,0,0,.871.343,1.8,1.8,0,0,0,.52-.149.989.989,0,0,0,.556-1.116",
    transform: "translate(43.131 11.361)",
    fill: "#b3e23f"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    id: "Path_32286",
    "data-name": "Path 32286",
    d: "M205.643,58.918a11.356,11.356,0,0,0-3.319,1.561c-.455.327-.9.663-1.339,1-.545.416-.85.963-1.356,1.4-.4.349-.135,1.073.565.826.55-.195,1.139-.167,1.7-.323.676-.186,1.352-.378,2-.614a5.905,5.905,0,0,0,3.169-2.385c.495-.789-.146-1.882-1.422-1.47",
    transform: "translate(38.909 11.477)",
    fill: "#b3e23f"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    id: "Path_32287",
    "data-name": "Path 32287",
    d: "M203.8,57.323a1.026,1.026,0,0,0-1.117-.29,6.751,6.751,0,0,0-1.711.767,3.836,3.836,0,0,0-.756.6c-.121.141-.216.327-.408.41a.441.441,0,0,0,.075.868,3.264,3.264,0,0,0,1.776-.258c.325-.125.657-.241.972-.381a4.011,4.011,0,0,0,.925-.728.748.748,0,0,0,.245-.985",
    transform: "translate(38.916 11.116)",
    fill: "#b3e23f"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    id: "Path_32288",
    "data-name": "Path 32288",
    d: "M211.119,31.5a.817.817,0,0,0-.937.076,9.772,9.772,0,0,0-2.175,1.546.537.537,0,0,0-.05.636.837.837,0,0,0,.89.229,4.378,4.378,0,0,0,2.329-1.867.426.426,0,0,0-.057-.621",
    transform: "translate(40.554 6.123)",
    fill: "#cefe79"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    id: "Path_32289",
    "data-name": "Path 32289",
    d: "M184.416,35.56c-.141-.48-.574-.734-.931-1.115-.257-.275-.776-.632-.735-1.009.059-.538-.9-.562-1.148-.148a1.851,1.851,0,0,0,.033,1.815,2.46,2.46,0,0,0,1.627,1.4c.633.141,1.291-.483,1.154-.948",
    transform: "translate(35.385 6.439)",
    fill: "#cefe79"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    id: "Path_32290",
    "data-name": "Path 32290",
    d: "M183.068,38.822a8.234,8.234,0,0,0-3.418-1.365c-.949-.11-2.115.688-1.815,1.487a5.68,5.68,0,0,0,2.1,2.446,2.469,2.469,0,0,0,2.482.065,2.12,2.12,0,0,0,.832-.682c.363-.6.582-1.452-.179-1.95",
    transform: "translate(34.685 7.306)",
    fill: "#cefe79"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    id: "Path_32291",
    "data-name": "Path 32291",
    d: "M180.5,45.243a2.661,2.661,0,0,0-1.695,0l-.342.134c.084-.033.047-.022-.115.037s-.336.11-.507.161a5.621,5.621,0,0,1-1.75.351c-.6-.042-1.284.578-.748.982a5.932,5.932,0,0,0,1.828.762c1.2.354,2.553.589,3.523-.293.645-.586.952-1.74-.2-2.132",
    transform: "translate(34.171 8.799)",
    fill: "#cefe79"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    id: "Path_32292",
    "data-name": "Path 32292",
    d: "M191.958,35.018c-.12-.718-1.312-.984-2.048-1.232-.6-.2-1.16.331-.939.771.061.121.121.24.179.361s.094.2.123.264c.183.415.265.857.849,1.043.984.313,1.966-.425,1.837-1.207",
    transform: "translate(36.857 6.583)",
    fill: "#cefe79"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    id: "Path_32293",
    "data-name": "Path 32293",
    d: "M197.278,36.526a2.5,2.5,0,0,0-2.517-1.152,1.026,1.026,0,0,0-.968.794,2,2,0,0,0,1.18,1.861,5.808,5.808,0,0,0,1.935,1.094.913.913,0,0,0,.937-.49c.294-.693-.172-1.494-.566-2.106",
    transform: "translate(37.806 6.896)",
    fill: "#cefe79"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    id: "Path_32294",
    "data-name": "Path 32294",
    d: "M266.029,27.852c-.227-.208-.728-.516-.774-.675a.61.61,0,0,0-.779-.308,3.142,3.142,0,0,0-1.462,1.042,5.385,5.385,0,0,0-.741,1.027.838.838,0,0,0-.062.085,4.066,4.066,0,0,1-.3.342c-.978,1.086-.318,2.78,1.417,3A3.152,3.152,0,0,0,266.9,30.01a2.655,2.655,0,0,0-.869-2.158",
    transform: "translate(51.007 5.235)",
    fill: "#cefe79"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    id: "Path_32295",
    "data-name": "Path 32295",
    d: "M268.909,28.088a.843.843,0,0,0-.316-.477.965.965,0,0,0-1.125.092.557.557,0,0,0-.133.823l.013.023a.522.522,0,0,0,.065.152.808.808,0,0,0,.192.179.848.848,0,0,0,.991-.08c.065-.066.129-.129.188-.195a.589.589,0,0,0,.124-.517",
    transform: "translate(52.129 5.358)",
    fill: "#cefe79"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    id: "Path_32296",
    "data-name": "Path 32296",
    d: "M282.263,30.129a.658.658,0,0,0-.647-.666,3.387,3.387,0,0,0-3.508,2.457.95.95,0,0,0,.676.973,1.938,1.938,0,0,0,1.826-.342,2.448,2.448,0,0,0,.779-1.325c.017-.072.038-.142.062-.213a.576.576,0,0,1,.047-.1,1,1,0,0,0,.764-.782",
    transform: "translate(54.254 5.745)",
    fill: "#cefe79"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    id: "Path_32297",
    "data-name": "Path 32297",
    d: "M255.916,21.1c-1.739-.292-3.052.648-4.476,1.254-.549.233-.678,1.1.1,1.166.239.02.48.027.718.033-.549.3-.881.914-.633,1.364-1.469-.408-3.292.036-4.8.023-.684-.006-1.132.758-.664,1.146a15.8,15.8,0,0,0,1.441,1.019,6.958,6.958,0,0,0,1.906,1.245,2.944,2.944,0,0,0,3.151-.929,1.487,1.487,0,0,0,0-1.937,4.834,4.834,0,0,0,2.675-.019c.741-.233,1.2-.974.615-1.494a1.82,1.82,0,0,0-.621-.355,2.407,2.407,0,0,0,.773-.319c.914-.584,1.36-1.94-.189-2.2",
    transform: "translate(47.986 4.106)",
    fill: "#cefe79"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_15503",
    "data-name": "Group 15503",
    transform: "translate(229.405 20.023)",
    opacity: 0.4,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }, _g150 || (_g150 = /*#__PURE__*/React.createElement("g", {
    id: "Group_15502",
    "data-name": "Group 15502"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15501",
    "data-name": "Group 15501",
    clipPath: "url(#clip-path-361)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32298",
    "data-name": "Path 32298",
    d: "M196.574,19.155a18.854,18.854,0,0,0-1.405-1.292A13.062,13.062,0,0,1,193.807,17a.9.9,0,0,0-1.318.108c-.964,1.083-.424,2.377.1,3.5a6.01,6.01,0,0,0,4.259,3.34,1.623,1.623,0,0,0,1.843-1.215c.2-1.54-.975-2.464-2.12-3.572",
    transform: "translate(-191.956 -16.754)",
    fill: "#f3fe8b"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15506",
    "data-name": "Group 15506",
    transform: "translate(214.236 18.199)",
    opacity: 0.4,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }, _g151 || (_g151 = /*#__PURE__*/React.createElement("g", {
    id: "Group_15505",
    "data-name": "Group 15505"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15504",
    "data-name": "Group 15504",
    clipPath: "url(#clip-path-362)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32299",
    "data-name": "Path 32299",
    d: "M181.529,15.356a1.692,1.692,0,0,0-2.051.829,3.254,3.254,0,0,0,.073,2.479c.09.239.179.491.278.747a.783.783,0,0,0-.148.54,2.07,2.07,0,0,0,.494,1.06,1.756,1.756,0,0,0,1.372.794,1.41,1.41,0,0,0,.626-.117,2.769,2.769,0,0,0,2.817-1.421c1.074-1.937-1.638-3.922-3.461-4.911",
    transform: "translate(-179.263 -15.228)",
    fill: "#f3fe8b"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15509",
    "data-name": "Group 15509",
    transform: "translate(212.039 24.73)",
    opacity: 0.4,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }, _g152 || (_g152 = /*#__PURE__*/React.createElement("g", {
    id: "Group_15508",
    "data-name": "Group 15508"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15507",
    "data-name": "Group 15507",
    clipPath: "url(#clip-path-363)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32300",
    "data-name": "Path 32300",
    d: "M180.614,21.653a15.01,15.01,0,0,0-1.431-.808c-.668-.382-1.771,0-1.758.7.021,1.123.474,3.1,2.425,2.915a1.836,1.836,0,0,0,1.513-1c.36-.717-.094-1.341-.749-1.811",
    transform: "translate(-177.425 -20.693)",
    fill: "#f3fe8b"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15512",
    "data-name": "Group 15512",
    transform: "translate(208.993 27.665)",
    opacity: 0.4,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }, _g153 || (_g153 = /*#__PURE__*/React.createElement("g", {
    id: "Group_15511",
    "data-name": "Group 15511"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15510",
    "data-name": "Group 15510",
    clipPath: "url(#clip-path-364)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32301",
    "data-name": "Path 32301",
    d: "M176.492,23.874c0-.048.007-.1.013-.145.047-.347-.337-.612-.761-.577a1.072,1.072,0,0,0-.592.235.78.78,0,0,0-.235.31.519.519,0,0,0-.026.326.722.722,0,0,0,.528.7.884.884,0,0,0,.5.012.767.767,0,0,0,.517-.425,1.738,1.738,0,0,0,.071-.257.447.447,0,0,0-.019-.18",
    transform: "translate(-174.876 -23.149)",
    fill: "#f3fe8b"
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg500503);
export default __webpack_public_path__ + "static/media/500 & 503.67872197e431f0355005f7b948942c18.svg";
export { ForwardRef as ReactComponent };